webpackJsonp([2],{

/***/ "+GJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+iw8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsh.2cfbcb6.svg";

/***/ }),

/***/ "/HYd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/LjC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNzEwMzE2ODAyMTIwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEwOTIyIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiPjxwYXRoIGQ9Ik04NzIuNDQ4IDQ2MS44MjRsLTQwMi40MzIgMzk3LjMxMmMtMjQuMDY0IDIzLjU1Mi01NS44MDggMzYuODY0LTg5LjYgMzYuMzUybC0xMjUuOTUyLTAuNTEyQzE4NC4zMiA4OTQuOTc2IDEyOCA4MzguMTQ0IDEyOCA3Njh2LTEyMC4zMmMwLTMzLjc5MiAxMy44MjQtNjYuMDQ4IDM3Ljg4OC05MC4xMTJMNTY4LjMyIDE2MS4yOHM2NC03MC42NTYgMTM1LjE2OCAwIDEwOC41NDQgMTA3LjAwOCAxNjguOTYgMTY2LjkxMmM2MC45MjggNTkuOTA0IDAgMTMzLjYzMiAwIDEzMy42MzJ6IG0tNjE1LjQyNCAzMzIuOGwxMzQuNjU2IDAuNTEyYzIuMDQ4IDAgNC4wOTYtMS4wMjQgNS42MzItMi4wNDggMy4wNzItMy4wNzIgMy4wNzItNy42OCAwLTEwLjc1MmwtMTU1LjEzNi0xNTUuMTM2Yy0zLjA3Mi0zLjA3Mi03LjY4LTMuMDcyLTEwLjc1MiAwLTEuNTM2IDEuNTM2LTIuMDQ4IDMuMDcyLTIuMDQ4IDUuMTJsLTAuNTEyIDEzMy42MzJjMCAxNS44NzIgMTIuMjg4IDI4LjY3MiAyOC4xNiAyOC42NzJ6IG01MDIuMjcyLTQzMC41OTJsLTk5LjMyOC05OS4zMjhjLTIzLjA0LTIzLjA0LTQ3LjEwNC0xOC45NDQtNjQuNTEyLTEuNTM2bC0yODYuMjA4IDI4Ni43MiAxNjUuMzc2IDE2NS44ODggMjg2LjIwOC0yODYuNzJjMTcuNDA4LTE3LjQwOCAyMS41MDQtNDEuOTg0LTEuNTM2LTY1LjAyNHpNODM4LjE0NCA5NDQuNjRoLTI3NC40MzJjLTI2LjYyNCAwLTQ4LjY0LTIyLjAxNi00OC42NC00OC42NHMyMi4wMTYtNDguNjQgNDguNjQtNDguNjRoMjc0LjQzMmMyNi42MjQgMCA0OC42NCAyMi4wMTYgNDguNjQgNDguNjRzLTIxLjUwNCA0OC42NC00OC42NCA0OC42NHoiIHAtaWQ9IjEwOTIzIiBmaWxsPSIjN0Q3RDdEIj48L3BhdGg+PC9zdmc+"

/***/ }),

/***/ "/YBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/wAz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0hov":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/underReview.47806a1.svg";

/***/ }),

/***/ "2FN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NumberInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NumberInput = ({
  name: 'NumberInput',
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 1
    },
    initNum: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      num: this.initNum || this.min
    };
  },

  methods: {
    minus: function minus() {
      if (this.num <= this.min) {
        return;
      }
      this.num = Number(this.num) - 1;
    },
    add: function add() {
      if (this.num >= this.max) {
        return;
      }
      this.num = Number(this.num) + 1;
    },
    blur: function blur() {
      if (!this.num || this.num == 0) {
        this.num = 1;
      }
    }
  },
  watch: {
    num: function num(newNum, oldNum) {
      this.$emit('input', Number(newNum));
      this.$emit('changeHandle');
    },
    initNum: function initNum(newVal) {
      if (newVal !== '') {
        this.num = newVal;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9e0da30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumberInput.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NumberInput"},[_c('span',{class:['minus', { ban: _vm.num <= _vm.min }],on:{"click":_vm.minus}},[_vm._v("-")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.num),expression:"num"}],attrs:{"type":"number","min":_vm.min,"max":_vm.max},domProps:{"value":(_vm.num)},on:{"blur":function($event){return _vm.blur()},"input":function($event){if($event.target.composing){ return; }_vm.num=$event.target.value}}}),_c('span',{class:['add', { ban: _vm.num >= _vm.max }],on:{"click":_vm.add}},[_vm._v("+")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_NumberInput = (esExports);
// CONCATENATED MODULE: ./src/components/NumberInput.vue
function injectStyle (ssrContext) {
  __webpack_require__("STan")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a9e0da30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NumberInput,
  components_NumberInput,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_NumberInput = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ymf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8lGJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9PVX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9S9a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9tdS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AjJ6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNzA4NjY4NTc5MDk2IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQyMTQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PHBhdGggZD0iTTg3Ni44IDM3Ny42bC05Ni04OS42TDUxMiA1NTYuOCAyNDMuMiAyODggMTQ3LjIgMzc3LjYgNTEyIDczNnoiIGZpbGw9IiM4Rjk2QTIiIHAtaWQ9IjQyMTUiPjwvcGF0aD48L3N2Zz4="

/***/ }),

/***/ "CKJ6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBoZWlnaHQ9IjMwMCIgbm9kZS1pZD0iMSIgc2lsbHl2Zz0idHJ1ZSIgdGVtcGxhdGUtaGVpZ2h0PSIzMDAiIHRlbXBsYXRlLXdpZHRoPSI1MDAiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDUwMCAzMDAiIHdpZHRoPSI1MDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzIG5vZGUtaWQ9IjMxIj48bGluZWFyR3JhZGllbnQgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGlkPSLmnKrlkb3lkI3nmoTmuJDlj5hfNTAiIG5vZGUtaWQ9IjUiIHNwcmVhZE1ldGhvZD0icGFkIiB4MT0iMjUwIiB4Mj0iMjUwIiB5MT0iMjg0LjIyIiB5Mj0iMTkxLjIyIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmY5ZWYiIHN0b3Atb3BhY2l0eT0iMCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC4xNyIgc3RvcC1jb2xvcj0iI2ZlZjhlZiIgc3RvcC1vcGFjaXR5PSIwLjAyIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjMyIiBzdG9wLWNvbG9yPSIjZmJmNWVlIiBzdG9wLW9wYWNpdHk9IjAuMDYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNDYiIHN0b3AtY29sb3I9IiNmNWYxZWMiIHN0b3Atb3BhY2l0eT0iMC4xNCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC42IiBzdG9wLWNvbG9yPSIjZWRlYmVhIiBzdG9wLW9wYWNpdHk9IjAuMjYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNzQiIHN0b3AtY29sb3I9IiNlM2UyZTciIHN0b3Atb3BhY2l0eT0iMC40Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjg3IiBzdG9wLWNvbG9yPSIjZDZkOGU0IiBzdG9wLW9wYWNpdHk9IjAuNTgiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuOTkiIHN0b3AtY29sb3I9IiNjOGNkZTAiIHN0b3Atb3BhY2l0eT0iMC43OSI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2M3Y2NlMCIgc3RvcC1vcGFjaXR5PSIwLjgiPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgaWQ9IuacquWRveWQjeeahOa4kOWPmF8zNSIgbm9kZS1pZD0iMTUiIHNwcmVhZE1ldGhvZD0icGFkIiB4MT0iLTI1MC45NDk5OCIgeDI9Ii0xOTUuMTY5OTgiIHkxPSItNTk5LjI4OTkiIHkyPSItNjU1LjA1OTk0Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmY5ZWYiIHN0b3Atb3BhY2l0eT0iMCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC4xNyIgc3RvcC1jb2xvcj0iI2ZlZjhlZiIgc3RvcC1vcGFjaXR5PSIwLjAyIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjMyIiBzdG9wLWNvbG9yPSIjZmJmNWVlIiBzdG9wLW9wYWNpdHk9IjAuMDYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNDYiIHN0b3AtY29sb3I9IiNmNWYxZWMiIHN0b3Atb3BhY2l0eT0iMC4xNCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC42IiBzdG9wLWNvbG9yPSIjZWRlYmVhIiBzdG9wLW9wYWNpdHk9IjAuMjYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNzQiIHN0b3AtY29sb3I9IiNlM2UyZTciIHN0b3Atb3BhY2l0eT0iMC40Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjg3IiBzdG9wLWNvbG9yPSIjZDZkOGU0IiBzdG9wLW9wYWNpdHk9IjAuNTgiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuOTkiIHN0b3AtY29sb3I9IiNjOGNkZTAiIHN0b3Atb3BhY2l0eT0iMC43OSI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2M3Y2NlMCIgc3RvcC1vcGFjaXR5PSIwLjgiPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgaWQ9IuacquWRveWQjeeahOa4kOWPmF8zNS0yIiBub2RlLWlkPSIxNiIgc3ByZWFkTWV0aG9kPSJwYWQiIHgxPSIyNy42NDk5OTgiIHgyPSI4My40Mjk5OSIgeTE9Ii03OTQuNDQ5OTUiIHkyPSItODUwLjIxOTkiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmZjllZiIgc3RvcC1vcGFjaXR5PSIwIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjE3IiBzdG9wLWNvbG9yPSIjZmVmOGVmIiBzdG9wLW9wYWNpdHk9IjAuMDIiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuMzIiIHN0b3AtY29sb3I9IiNmYmY1ZWUiIHN0b3Atb3BhY2l0eT0iMC4wNiI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC40NiIgc3RvcC1jb2xvcj0iI2Y1ZjFlYyIgc3RvcC1vcGFjaXR5PSIwLjE0Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjYiIHN0b3AtY29sb3I9IiNlZGViZWEiIHN0b3Atb3BhY2l0eT0iMC4yNiI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC43NCIgc3RvcC1jb2xvcj0iI2UzZTJlNyIgc3RvcC1vcGFjaXR5PSIwLjQiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuODciIHN0b3AtY29sb3I9IiNkNmQ4ZTQiIHN0b3Atb3BhY2l0eT0iMC41OCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC45OSIgc3RvcC1jb2xvcj0iI2M4Y2RlMCIgc3RvcC1vcGFjaXR5PSIwLjc5Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjYzdjY2UwIiBzdG9wLW9wYWNpdHk9IjAuOCI+PC9zdG9wPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBpZD0i5pyq5ZG95ZCN55qE5riQ5Y+YXzM1LTMiIG5vZGUtaWQ9IjE3IiBzcHJlYWRNZXRob2Q9InBhZCIgeDE9Ii01MC44Mjk5OTgiIHgyPSI0LjkzOTk5OTYiIHkxPSItODk4LjM4OTk1IiB5Mj0iLTk1NC4xNjk5Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmY5ZWYiIHN0b3Atb3BhY2l0eT0iMCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC4xNyIgc3RvcC1jb2xvcj0iI2ZlZjhlZiIgc3RvcC1vcGFjaXR5PSIwLjAyIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjMyIiBzdG9wLWNvbG9yPSIjZmJmNWVlIiBzdG9wLW9wYWNpdHk9IjAuMDYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNDYiIHN0b3AtY29sb3I9IiNmNWYxZWMiIHN0b3Atb3BhY2l0eT0iMC4xNCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC42IiBzdG9wLWNvbG9yPSIjZWRlYmVhIiBzdG9wLW9wYWNpdHk9IjAuMjYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNzQiIHN0b3AtY29sb3I9IiNlM2UyZTciIHN0b3Atb3BhY2l0eT0iMC40Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjg3IiBzdG9wLWNvbG9yPSIjZDZkOGU0IiBzdG9wLW9wYWNpdHk9IjAuNTgiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuOTkiIHN0b3AtY29sb3I9IiNjOGNkZTAiIHN0b3Atb3BhY2l0eT0iMC43OSI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2M3Y2NlMCIgc3RvcC1vcGFjaXR5PSIwLjgiPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBkPSJNIDM5Ni4wMCAyMzcuNzIgQyAzOTYuMDAgMjYzLjQwIDMzMC42MyAyODQuMjIgMjUwLjAwIDI4NC4yMiBDIDE2OS4zNyAyODQuMjIgMTA0LjAwIDI2My40MCAxMDQuMDAgMjM3LjcyIEMgMTA0LjAwIDIxMi4wNCAxNjkuMzcgMTkxLjIyIDI1MC4wMCAxOTEuMjIgQyAzMzAuNjMgMTkxLjIyIDM5Ni4wMCAyMTIuMDQgMzk2LjAwIDIzNy43MiBaIiBmaWxsPSJ1cmwoI+acquWRveWQjeeahOa4kOWPmF81MCkiIGZpbGwtcnVsZT0ibm9uemVybyIgbm9kZS1pZD0iMTE0IiBzdHJva2U9Im5vbmUiIHRhcmdldC1oZWlnaHQ9IjkzIiB0YXJnZXQtd2lkdGg9IjI5MiIgdGFyZ2V0LXg9IjEwNCIgdGFyZ2V0LXk9IjE5MS4yMiI+PC9wYXRoPjxnIG5vZGUtaWQ9IjE0MyI+PHBhdGggZD0iTSAxMDguODUgODkuODYgTCAxMDguODUgODkuODYgTCAxMTAuNDkgOTEuODQgTCAxMTEuNzAgOTMuOTQgTCAxMTIuNTAgOTYuMjEgTCAxMTIuOTAgOTguNTggTCAxMTIuOTAgMTAwLjk0IEwgMTEyLjUwIDEwMy4zMSBMIDExMS43MCAxMDUuNTggTCAxMTAuNDkgMTA3LjY4IEwgMTA4Ljg1IDEwOS42NiBMIDU3Ljk0IDE2MC41NyBMIDU1Ljk3IDE2Mi4yMSBMIDUzLjg2IDE2My40MSBMIDUxLjU5IDE2NC4yMiBMIDQ5LjIyIDE2NC42MiBMIDQ2Ljg2IDE2NC42MiBMIDQ0LjQ5IDE2NC4yMiBMIDQyLjIzIDE2My40MSBMIDQwLjEyIDE2Mi4yMSBMIDM4LjE0IDE2MC41NyBMIDM4LjE0IDE2MC41NyBMIDM2LjUwIDE1OC42MCBMIDM1LjMwIDE1Ni40OSBMIDM0LjUwIDE1NC4yMiBMIDM0LjA5IDE1MS44NSBMIDM0LjA5IDE0OS40OSBMIDM0LjUwIDE0Ny4xMiBMIDM1LjMwIDE0NC44NSBMIDM2LjUwIDE0Mi43NSBMIDM4LjE0IDE0MC43NyBMIDg5LjA1IDg5Ljg2IEwgOTEuMDMgODguMjIgTCA5My4xNCA4Ny4wMiBMIDk1LjQwIDg2LjIyIEwgOTcuNzggODUuODEgTCAxMDAuMTMgODUuODEgTCAxMDIuNTEgODYuMjIgTCAxMDQuNzcgODcuMDIgTCAxMDYuODggODguMjIgTCAxMDguODUgODkuODYgWiIgZmlsbD0idXJsKCPmnKrlkb3lkI3nmoTmuJDlj5hfMzUpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIxIiBub2RlLWlkPSIxMTgiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iNzguODExMzciIHRhcmdldC13aWR0aD0iNzguODExMzg2IiB0YXJnZXQteD0iMzQuMDkyNzQzIiB0YXJnZXQteT0iODUuODEwNTYiPjwvcGF0aD48L2c+PGcgbm9kZS1pZD0iMTQ0Ij48cGF0aCBkPSJNIDQ0My44NiAxNDguODYgTCA0NDMuODYgMTQ4Ljg2IEwgNDQ1LjQ5IDE1MC44NCBMIDQ0Ni43MCAxNTIuOTQgTCA0NDcuNTAgMTU1LjIxIEwgNDQ3LjkxIDE1Ny41OCBMIDQ0Ny45MSAxNTkuOTQgTCA0NDcuNTAgMTYyLjMxIEwgNDQ2LjcwIDE2NC41OCBMIDQ0NS40OSAxNjYuNjggTCA0NDMuODYgMTY4LjY2IEwgMzkyLjk0IDIxOS41NyBMIDM5MC45NyAyMjEuMjEgTCAzODguODYgMjIyLjQxIEwgMzg2LjYwIDIyMy4yMiBMIDM4NC4yMiAyMjMuNjIgTCAzODEuODcgMjIzLjYyIEwgMzc5LjQ5IDIyMy4yMiBMIDM3Ny4yMyAyMjIuNDEgTCAzNzUuMTIgMjIxLjIxIEwgMzczLjE0IDIxOS41NyBMIDM3My4xNCAyMTkuNTcgTCAzNzEuNTEgMjE3LjYwIEwgMzcwLjMwIDIxNS40OSBMIDM2OS41MCAyMTMuMjIgTCAzNjkuMDkgMjEwLjg1IEwgMzY5LjA5IDIwOC40OSBMIDM2OS41MCAyMDYuMTIgTCAzNzAuMzAgMjAzLjg2IEwgMzcxLjUxIDIwMS43NSBMIDM3My4xNCAxOTkuNzcgTCA0MjQuMDYgMTQ4Ljg2IEwgNDI2LjAzIDE0Ny4yMiBMIDQyOC4xNCAxNDYuMDIgTCA0MzAuNDAgMTQ1LjIyIEwgNDMyLjc4IDE0NC44MSBMIDQzNS4xMyAxNDQuODEgTCA0MzcuNTEgMTQ1LjIyIEwgNDM5Ljc3IDE0Ni4wMiBMIDQ0MS44OCAxNDcuMjIgTCA0NDMuODYgMTQ4Ljg2IFoiIGZpbGw9InVybCgj5pyq5ZG95ZCN55qE5riQ5Y+YXzM1LTIpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIyIiBub2RlLWlkPSIxMjMiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iNzguODExNDMiIHRhcmdldC13aWR0aD0iNzguODExNCIgdGFyZ2V0LXg9IjM2OS4wOTQxOCIgdGFyZ2V0LXk9IjE0NC44MTA2MSI+PC9wYXRoPjwvZz48ZyBub2RlLWlkPSIxNDUiPjxwYXRoIGQ9Ik0gNDYxLjg2IDE5Ljg2IEwgNDYxLjg2IDE5Ljg2IEwgNDYzLjUwIDIxLjg0IEwgNDY0LjcwIDIzLjk0IEwgNDY1LjUwIDI2LjIxIEwgNDY1LjkxIDI4LjU4IEwgNDY1LjkxIDMwLjk0IEwgNDY1LjUwIDMzLjMxIEwgNDY0LjcwIDM1LjU4IEwgNDYzLjUwIDM3LjY5IEwgNDYxLjg2IDM5LjY2IEwgNDEwLjk1IDkwLjU3IEwgNDA4Ljk3IDkyLjIxIEwgNDA2Ljg3IDkzLjQyIEwgNDA0LjYwIDk0LjIyIEwgNDAyLjIzIDk0LjYyIEwgMzk5Ljg3IDk0LjYyIEwgMzk3LjUwIDk0LjIyIEwgMzk1LjIzIDkzLjQyIEwgMzkzLjEyIDkyLjIxIEwgMzkxLjE1IDkwLjU3IEwgMzkxLjE1IDkwLjU3IEwgMzg5LjUxIDg4LjYwIEwgMzg4LjMxIDg2LjQ5IEwgMzg3LjUwIDg0LjIyIEwgMzg3LjEwIDgxLjg1IEwgMzg3LjEwIDc5LjQ5IEwgMzg3LjUwIDc3LjEyIEwgMzg4LjMxIDc0Ljg2IEwgMzg5LjUxIDcyLjc1IEwgMzkxLjE1IDcwLjc3IEwgNDQyLjA2IDE5Ljg2IEwgNDQ0LjA0IDE4LjIyIEwgNDQ2LjE0IDE3LjAyIEwgNDQ4LjQxIDE2LjIyIEwgNDUwLjc4IDE1LjgxIEwgNDUzLjE0IDE1LjgxIEwgNDU1LjUxIDE2LjIyIEwgNDU3Ljc4IDE3LjAyIEwgNDU5Ljg4IDE4LjIyIEwgNDYxLjg2IDE5Ljg2IFoiIGZpbGw9InVybCgj5pyq5ZG95ZCN55qE5riQ5Y+YXzM1LTMpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIzIiBub2RlLWlkPSIxMjgiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iNzguODExMzciIHRhcmdldC13aWR0aD0iNzguODExNCIgdGFyZ2V0LXg9IjM4Ny4wOTg4OCIgdGFyZ2V0LXk9IjE1LjgxMTc2OCI+PC9wYXRoPjwvZz48cGF0aCBkPSJNIDMwMS44NSA2OC4wNiBMIDI3NS4yNiA2OS4wNiBDIDI3NS4yOSA2OC43MyAyNzUuMzEgNjguMzkgMjc1LjMxIDY4LjA2IEwgMjc1LjMxIDY4LjA2IEMgMjc1LjMxIDY1LjMzIDI3NC4yMiA2Mi43MSAyNzIuMjkgNjAuNzcgQyAyNzAuMzYgNTguODQgMjY3LjczIDU3Ljc2IDI2NS4wMCA1Ny43NiBMIDI2Mi40MiA1Ny43NiBDIDI2Mi40MiA1MC42MyAyNTYuNjQgNDQuODUgMjQ5LjUxIDQ0Ljg1IEMgMjQyLjM5IDQ0Ljg1IDIzNi42MSA1MC42MyAyMzYuNjEgNTcuNzYgTCAyMzQuMDAgNTcuNzYgQyAyMjguMzMgNTcuNzYgMjIzLjczIDYyLjMzIDIyMy43MCA2OC4wMCBMIDIyMy43MCA2OC4wMCBDIDIyMy43MCA2OC45OSAyMjMuODUgNjkuOTcgMjI0LjE0IDcwLjkxIEwgMTk5LjAwIDcxLjgxIEMgMTk2LjE3IDcxLjgwIDE5My44NiA3NC4wOSAxOTMuODQgNzYuOTIgTCAxOTAuMDYgMjE2LjgwIEMgMTkwLjA2IDIxOS42MSAxOTAuNzcgMjI1LjMzIDE5OS4wNiAyMjQuOTggTCAzMDQuODQgMjI0Ljk4IEMgMzA3LjY3IDIyNC45OSAzMDkuOTggMjIyLjcwIDMxMC4wMCAyMTkuODcgTCAzMTAuMDAgNzYuODcgQyAzMTAuMDQgNzIuMjQgMzA2LjQ3IDY4LjM4IDMwMS44NSA2OC4wNiBaIE0gMjQ5LjUwIDUwLjA2IEMgMjUzLjcyIDUwLjEwIDI1Ny4xMSA1My41NSAyNTcuMDggNTcuNzcgQyAyNTcuMDUgNjEuOTkgMjUzLjYxIDY1LjM5IDI0OS4zOSA2NS4zOCBDIDI0NS4xNyA2NS4zNiAyNDEuNzYgNjEuOTQgMjQxLjc2IDU3LjcyIEMgMjQxLjgxIDUzLjQ4IDI0NS4yNyA1MC4wOCAyNDkuNTEgNTAuMTEgWiIgZmlsbD0iI2M3Y2NlMCIgZmlsbC1ydWxlPSJub256ZXJvIiBub2RlLWlkPSIxMzEiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMTgwLjQ3NSIgdGFyZ2V0LXdpZHRoPSIxMTkuOTc3NjYiIHRhcmdldC14PSIxOTAuMDYiIHRhcmdldC15PSI0NC44NTUiPjwvcGF0aD48cGF0aCBkPSJNIDMwMS4wMCA2OC4wMCBMIDI3Mi43NCA2OC4wMCBDIDI3Mi42OSA2Mi4zNCAyNjguMDggNTcuNzggMjYyLjQyIDU3Ljc5IEwgMjU5Ljg0IDU3Ljc5IEMgMjU5Ljg0IDUwLjY2IDI1NC4wNiA0NC44OCAyNDYuOTQgNDQuODggQyAyMzkuODEgNDQuODggMjM0LjAzIDUwLjY2IDIzNC4wMyA1Ny43OSBMIDIzMS40NSA1Ny43OSBDIDIyNS43OCA1Ny43NyAyMjEuMTcgNjIuMzMgMjIxLjEyIDY4LjAwIEwgMTk1LjEyIDY4LjAwIEMgMTkyLjMxIDY4LjAyIDE5MC4wNCA3MC4yNyAxOTAuMDAgNzMuMDggTCAxOTAuMDAgMjE2LjAwIEMgMTkwLjAyIDIxOC44MyAxOTIuMzMgMjIxLjEyIDE5NS4xNiAyMjEuMTEgTCAzMDEuMDAgMjIxLjExIEMgMzAzLjgzIDIyMS4xMiAzMDYuMTQgMjE4LjgzIDMwNi4xNiAyMTYuMDAgTCAzMDYuMTYgNzMuMDAgQyAzMDYuMDggNzAuMjEgMzAzLjc5IDY3Ljk5IDMwMS4wMCA2OC4wMCBaIE0gMjQ3LjAwIDUwLjEzIEMgMjUxLjIyIDUwLjE3IDI1NC42MSA1My42MiAyNTQuNTggNTcuODQgQyAyNTQuNTUgNjIuMDYgMjUxLjExIDY1LjQ2IDI0Ni44OSA2NS40NSBDIDI0Mi42NyA2NS40MyAyMzkuMjYgNjIuMDEgMjM5LjI2IDU3Ljc5IEMgMjM5LjI3IDUzLjU2IDI0Mi43MCA1MC4xMyAyNDYuOTMgNTAuMTEgWiIgZmlsbD0iI2UyZTRlZCIgZmlsbC1ydWxlPSJub256ZXJvIiBub2RlLWlkPSIxMzMiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMTc2LjIzMDU5IiB0YXJnZXQtd2lkdGg9IjExNi4xNiIgdGFyZ2V0LXg9IjE5MCIgdGFyZ2V0LXk9IjQ0Ljg4NSI+PC9wYXRoPjxwYXRoIGQ9Ik0gMjAwLjQ1IDc2LjQ5IEwgMjk1LjY4IDc2LjQ5IEMgMjk3Ljg5IDc2LjQ5IDI5OS42OCA3OC4yOCAyOTkuNjggODAuNDkgTCAyOTkuNjggMjA4LjY1IEMgMjk5LjY4IDIxMC44NiAyOTcuODkgMjEyLjY1IDI5NS42OCAyMTIuNjUgTCAyMDAuNDUgMjEyLjY1IEMgMTk4LjI0IDIxMi42NSAxOTYuNDUgMjEwLjg2IDE5Ni40NSAyMDguNjUgTCAxOTYuNDUgODAuNDkgQyAxOTYuNDUgNzguMjggMTk4LjI0IDc2LjQ5IDIwMC40NSA3Ni40OSBaIiBmaWxsPSIjZmZmZmZmIiBmaWxsLXJ1bGU9Im5vbnplcm8iIG5vZGUtaWQ9IjEzNSIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSIxMzYuMTYiIHRhcmdldC13aWR0aD0iMTAzLjIyOTk5NiIgdGFyZ2V0LXg9IjE5Ni40NSIgdGFyZ2V0LXk9Ijc2LjQ5Ij48L3BhdGg+PHBhdGggZD0iTSAyMTguMjcgOTkuNTIgTCAyNzcuODcgOTkuNTIgQyAyNzkuMjMgOTkuNTIgMjgwLjMzIDEwMC42MiAyODAuMzMgMTAxLjk4IEwgMjgwLjMzIDEwMy40NCBDIDI4MC4zMyAxMDQuODAgMjc5LjIzIDEwNS45MCAyNzcuODcgMTA1LjkwIEwgMjE4LjI3IDEwNS45MCBDIDIxNi45MSAxMDUuOTAgMjE1LjgxIDEwNC44MCAyMTUuODEgMTAzLjQ0IEwgMjE1LjgxIDEwMS45OCBDIDIxNS44MSAxMDAuNjIgMjE2LjkxIDk5LjUyIDIxOC4yNyA5OS41MiBaIiBmaWxsPSIjYzdjY2UwIiBmaWxsLXJ1bGU9Im5vbnplcm8iIG5vZGUtaWQ9IjEzNyIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSI2LjM4MDAwNSIgdGFyZ2V0LXdpZHRoPSI2NC41MTk5OSIgdGFyZ2V0LXg9IjIxNS44MSIgdGFyZ2V0LXk9Ijk5LjUyIj48L3BhdGg+PHBhdGggZD0iTSAyMTguMjcgMTIxLjIyIEwgMjc3Ljg3IDEyMS4yMiBDIDI3OS4yMyAxMjEuMjIgMjgwLjMzIDEyMi4zMiAyODAuMzMgMTIzLjY4IEwgMjgwLjMzIDEyNS4xNCBDIDI4MC4zMyAxMjYuNTAgMjc5LjIzIDEyNy42MCAyNzcuODcgMTI3LjYwIEwgMjE4LjI3IDEyNy42MCBDIDIxNi45MSAxMjcuNjAgMjE1LjgxIDEyNi41MCAyMTUuODEgMTI1LjE0IEwgMjE1LjgxIDEyMy42OCBDIDIxNS44MSAxMjIuMzIgMjE2LjkxIDEyMS4yMiAyMTguMjcgMTIxLjIyIFoiIGZpbGw9IiNjN2NjZTAiIGZpbGwtcnVsZT0ibm9uemVybyIgbm9kZS1pZD0iMTM5IiBzdHJva2U9Im5vbmUiIHRhcmdldC1oZWlnaHQ9IjYuMzc5OTk3MyIgdGFyZ2V0LXdpZHRoPSI2NC41MTk5OSIgdGFyZ2V0LXg9IjIxNS44MSIgdGFyZ2V0LXk9IjEyMS4yMiI+PC9wYXRoPjxwYXRoIGQ9Ik0gMjE4LjI3IDE0Mi45MiBMIDI3Ny44NyAxNDIuOTIgQyAyNzkuMjMgMTQyLjkyIDI4MC4zMyAxNDQuMDIgMjgwLjMzIDE0NS4zOCBMIDI4MC4zMyAxNDYuODQgQyAyODAuMzMgMTQ4LjIwIDI3OS4yMyAxNDkuMzAgMjc3Ljg3IDE0OS4zMCBMIDIxOC4yNyAxNDkuMzAgQyAyMTYuOTEgMTQ5LjMwIDIxNS44MSAxNDguMjAgMjE1LjgxIDE0Ni44NCBMIDIxNS44MSAxNDUuMzggQyAyMTUuODEgMTQ0LjAyIDIxNi45MSAxNDIuOTIgMjE4LjI3IDE0Mi45MiBaIiBmaWxsPSIjYzdjY2UwIiBmaWxsLXJ1bGU9Im5vbnplcm8iIG5vZGUtaWQ9IjE0MSIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSI2LjM4MDAwNSIgdGFyZ2V0LXdpZHRoPSI2NC41MTk5OSIgdGFyZ2V0LXg9IjIxNS44MSIgdGFyZ2V0LXk9IjE0Mi45MiI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),

/***/ "DJMQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dgxh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_ADMIN_TOKEN */
/* unused harmony export SET_ADMIN_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CLIENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CLIENT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_LOGOUT; });
var SET_ADMIN_TOKEN = 'SET_ADMIN_TOKEN';
var SET_ADMIN_NAME = 'SET_ADMIN_NAME';
var ADMIN_LOGOUT = 'ADMIN_LOGOUT';

var SET_CLIENT_TOKEN = 'SET_CLIENT_TOKEN';
var SET_CLIENT_NAME = 'SET_CLIENT_NAME';
var CLIENT_LOGOUT = 'CLIENT_LOGOUT';

/***/ }),

/***/ "Duuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/util/util.js
var util = __webpack_require__("yt7g");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ErrorPage.vue
//
//
//
//
//
//
//


/* harmony default export */ var ErrorPage = ({
  name: 'ErrorPage',
  computed: {
    width: function width() {
      return Object(util["b" /* getClientSize */])().width;
    },
    height: function height() {
      return Object(util["b" /* getClientSize */])().height;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ca5be6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ErrorPage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ErrorPage",style:({width:_vm.width+'px',height:_vm.height+'px'})},[_c('h3',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("抱歉，您访问的页面跑丢了~")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_ErrorPage = (esExports);
// CONCATENATED MODULE: ./src/pages/ErrorPage.vue
function injectStyle (ssrContext) {
  __webpack_require__("cbiT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16ca5be6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ErrorPage,
  pages_ErrorPage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_ErrorPage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E6M5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yqx.1e4d613.svg";

/***/ }),

/***/ "Et7L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success.644acaf.svg";

/***/ }),

/***/ "Ex6y":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FPOz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fail.e9aad90.svg";

/***/ }),

/***/ "FWeZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyANCiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiDQogd2lkdGg9IjE5cHgiIGhlaWdodD0iMThweCI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiICBmaWxsPSJyZ2IoMjIyLCA4MywgMjkpIg0KIGQ9Ik0xOC45NDcsNS4yODEgTDE3LjEzNywxMC4xNTcgQzE2Ljk1NiwxMC44MzIgMTYuMzM2LDExLjMwNSAxNS42MzAsMTEuMzA1IEw2LjI0OCwxMS4zMDUgTDYuNzQxLDEzLjEyMCBMMTUuNTgyLDEzLjEyMCBDMTYuMDgyLDEzLjEyMCAxNi40ODksMTMuNTIzIDE2LjQ4OSwxNC4wMTcgQzE2LjQ4OSwxNC41MTMgMTYuMDgyLDE0LjkxNSAxNS41ODIsMTQuOTE1IEw2LjU0NiwxNC45MTUgQzUuODQyLDE0LjkxNSA1LjIyMywxNC40NDUgNS4wNDAsMTMuNzczIEwxLjgwMSwxLjc5NSBMMC45MDcsMS43OTUgQzAuNDA3LDEuNzk1IC0wLjAwMCwxLjM5MiAtMC4wMDAsMC44OTcgQy0wLjAwMCwwLjQwMiAwLjQwNywtMC4wMDEgMC45MDcsLTAuMDAxIEwxLjk5NiwtMC4wMDEgQzIuNzAwLC0wLjAwMSAzLjMxOSwwLjQ2OSAzLjUwMSwxLjE0MiBMNC4wOTksMy4zNDMgTDE3LjQ0MCwzLjM0MyBDMTcuOTI4LDMuMzQzIDE4LjM3OCwzLjU2MiAxOC42NzUsMy45NDUgQzE4Ljk3Myw0LjMyNyAxOS4wNzIsNC44MTUgMTguOTQ3LDUuMjgxIFpNNC41ODYsNS4xMzggTDUuNzYxLDkuNTA5IEwxNS40MzQsOS41MDkgTDE3LjEwOSw1LjEzOCBMNC41ODYsNS4xMzggWk04LjU5NiwxNS41NTkgQzkuMjc2LDE1LjU1OSA5LjgyOSwxNi4xMDYgOS44MjksMTYuNzc5IEM5LjgyOSwxNy40NTIgOS4yNzYsMTguMDAwIDguNTk2LDE4LjAwMCBDNy45MTYsMTguMDAwIDcuMzYzLDE3LjQ1MiA3LjM2MywxNi43NzkgQzcuMzYzLDE2LjEwNiA3LjkxNiwxNS41NTkgOC41OTYsMTUuNTU5IFpNMTMuODEyLDE1LjU1OSBDMTQuNDkyLDE1LjU1OSAxNS4wNDUsMTYuMTA2IDE1LjA0NSwxNi43NzkgQzE1LjA0NSwxNy40NTIgMTQuNDkyLDE4LjAwMCAxMy44MTIsMTguMDAwIEMxMy4xMzIsMTguMDAwIDEyLjU3OSwxNy40NTIgMTIuNTc5LDE2Ljc3OSBDMTIuNTc5LDE2LjEwNiAxMy4xMzIsMTUuNTU5IDEzLjgxMiwxNS41NTkgWiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "H/82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions_namespaceObject = {};
__webpack_require__.d(actions_namespaceObject, "getCartQuantity", function() { return actions_getCartQuantity; });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "adminToken", function() { return adminToken; });
__webpack_require__.d(getters_namespaceObject, "clientToken", function() { return getters_clientToken; });

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/api/platform.js + 1 modules
var platform = __webpack_require__("zqHT");

// CONCATENATED MODULE: ./src/store/actions.js


// import * as types from './mutation-types';

/*export const setNewsCacheByType = function({commit},{type,data}){
	commit(types.SET_CACHE_NEWS,type,data)
}*/

var actions_getCartQuantity = function getCartQuantity(_ref, data) {
	var _this = this;

	var commit = _ref.commit,
	    state = _ref.state;

	setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
		var _ref3, result, total;

		return regenerator_default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return Object(platform["n" /* online */])({
							page: 1,
							limit: 100,
							keyword: '',
							select_option: '',
							form_head_uuid: 'a6cf518450fb43289af179b8beb4b943'
						});

					case 2:
						_ref3 = _context.sent;
						result = _ref3.result;
						total = 0;

						result.map(function (el) {
							return total += el.tbdn8rpen3ijbiv2;
						});
						state.cartNum = total;

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, _this);
	})), 500);
};
// CONCATENATED MODULE: ./src/store/getters.js
var adminToken = function adminToken(state) {
  return state.adminToken;
};
var getters_clientToken = function clientToken(state) {
  return state.clientToken;
};
// EXTERNAL MODULE: ./src/util/util.js
var util = __webpack_require__("yt7g");

// CONCATENATED MODULE: ./src/store/state.js

var state_state = {
  temporarilyToke: '',
  //后台管理
  adminToken: Object(util["c" /* getLocalItem */])('adminToken') ? Object(util["c" /* getLocalItem */])('adminToken') : null,
  adminName: Object(util["c" /* getLocalItem */])('adminName') ? Object(util["c" /* getLocalItem */])('adminName') : '',

  //客户商城
  clientName: Object(util["c" /* getLocalItem */])('clientName') ? Object(util["c" /* getLocalItem */])('clientName') : '',
  clientToken: Object(util["c" /* getLocalItem */])('clientToken') ? Object(util["c" /* getLocalItem */])('clientToken') : null,
  cartNum: 0,
  form_head_uuid: ''
};

/* harmony default export */ var store_state = (state_state);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/store/mutation-types.js
var mutation_types = __webpack_require__("Du/2");

// CONCATENATED MODULE: ./src/store/mutations.js


var _mutations;




var mutations = (_mutations = {}, defineProperty_default()(_mutations, mutation_types["d" /* SET_CLIENT_TOKEN */], function (state, clientToken) {
	state.clientToken = clientToken;
	Object(util["e" /* setLocalItem */])('clientToken', clientToken);
}), defineProperty_default()(_mutations, mutation_types["c" /* SET_CLIENT_NAME */], function (state, name) {
	state.clientName = name;
	Object(util["e" /* setLocalItem */])('clientName', name);
}), defineProperty_default()(_mutations, mutation_types["b" /* CLIENT_LOGOUT */], function (state) {
	state.clientToken = null;
	state.clientName = '';
	localStorage.removeItem('clientToken', 'clientName');
}), defineProperty_default()(_mutations, 'setData', function setData(state, data) {
	for (var key in data) {
		state[key] = data[key];
	}
}), _mutations);

/* harmony default export */ var store_mutations = (mutations);
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
	actions: actions_namespaceObject,
	getters: getters_namespaceObject,
	state: store_state,
	mutations: store_mutations
}));

/***/ }),

/***/ "KctQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shz.2c9be9b.svg";

/***/ }),

/***/ "KhYh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KkVO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "LD89":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dfh.6281ad9.svg";

/***/ }),

/***/ "Lr6H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.6fe05b0.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//

// import { login } from "./api/platform";
/* harmony default export */ var App = ({
  name: "app",
  data: function data() {
    return {
      token: ""
    };
  },
  created: function created() {},

  computed: {
    viewKey: function viewKey() {
      // 每次都根据 key 判断是否刷新组件
      return this.$route.meta._pageKey || this.$route.fullPath;
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569b80a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.viewKey}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.viewKey}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("5ymf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-569b80a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NGzo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_client__ = __webpack_require__("RSUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_common_less__ = __webpack_require__("KhYh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_font_iconfont_css__ = __webpack_require__("/wAz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_font_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_font_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);








// import './elementui-css/index.css'

// import "./assets/elementui-css/index.css";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router_client__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "OG1+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "P4Qa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "PugO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QHj+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QtbZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R37o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cart.e929452.svg";

/***/ }),

/***/ "RSUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/store/index.js + 4 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NoticeList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NoticeList = ({
  name: 'NoticeList',
  props: {
    notices: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      top: 0,
      height: 40,
      animateTime: 1
    };
  },
  mounted: function mounted() {
    setInterval(this.topAnimate, 3000);
  },
  destroyed: function destroyed() {
    clearInterval(this.topAnimate);
  },

  methods: {
    topAnimate: function topAnimate() {
      if (this.top <= -this.notices.length * this.height) {
        this.top = 0;
        this.animateTime = 0;
        return;
      }
      this.animateTime = 1;
      this.top -= this.height;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d70b2e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoticeList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoticeListBox"},[_c('ul',{staticClass:"noticeList",style:({top:_vm.top+'px',transition:("top " + _vm.animateTime + "s")})},[_vm._l((_vm.notices),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.notices[0]))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_NoticeList = (esExports);
// CONCATENATED MODULE: ./src/components/NoticeList.vue
function injectStyle (ssrContext) {
  __webpack_require__("9tdS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d70b2e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NoticeList,
  components_NoticeList,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_NoticeList = (Component.exports);

// EXTERNAL MODULE: ./src/util/util.js
var util = __webpack_require__("yt7g");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TipsInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TipsInput = ({
  name: "TipsInput",
  computed: {
    tipsShow: function tipsShow() {
      if (this.inputText.trim().length > 0 && this.inputBoxFocus) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      inputText: "",
      inputBoxFocus: false,
      tips: []
    };
  },
  mounted: function mounted() {
    document.addEventListener("click", this.documentClickHandle, false);
  },
  destroyed: function destroyed() {
    document.removeEventListener("click", this.documentClickHandle, false);
  },

  methods: {
    tipsClickHandle: function tipsClickHandle(tip) {
      this.$emit("tipsChosen", tip);
    },
    documentClickHandle: function documentClickHandle(e) {
      if (e.target.className.includes("tipsEle")) {
        this.inputBoxFocus = true;
      } else {
        this.inputBoxFocus = false;
      }
    },
    handleEnter: function handleEnter() {
      this.$emit("handleEnter");
    }
  },
  watch: {
    inputText: function inputText(newVal, oldVal) {
      this.$emit("input", newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-332ab7c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipsInput.vue
var TipsInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TipsInput tipsEle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputText),expression:"inputText"}],ref:"input",staticClass:"tipsEle",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.inputText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.inputText=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipsShow),expression:"tipsShow"}],staticClass:"tipsBox tipsEle"},_vm._l((_vm.tips),function(item,index){return _c('li',{key:index,staticClass:"tipsEle",on:{"click":function($event){return _vm.tipsClickHandle(item)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])}
var TipsInput_staticRenderFns = []
var TipsInput_esExports = { render: TipsInput_render, staticRenderFns: TipsInput_staticRenderFns }
/* harmony default export */ var components_TipsInput = (TipsInput_esExports);
// CONCATENATED MODULE: ./src/components/TipsInput.vue
function TipsInput_injectStyle (ssrContext) {
  __webpack_require__("+GJn")
}
var TipsInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TipsInput___vue_template_functional__ = false
/* styles */
var TipsInput___vue_styles__ = TipsInput_injectStyle
/* scopeId */
var TipsInput___vue_scopeId__ = "data-v-332ab7c2"
/* moduleIdentifier (server only) */
var TipsInput___vue_module_identifier__ = null
var TipsInput_Component = TipsInput_normalizeComponent(
  TipsInput,
  components_TipsInput,
  TipsInput___vue_template_functional__,
  TipsInput___vue_styles__,
  TipsInput___vue_scopeId__,
  TipsInput___vue_module_identifier__
)

/* harmony default export */ var src_components_TipsInput = (TipsInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Category.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Category = ({
  props: {
    hierarchyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      id: '',
      children: [],
      show: false
    };
  },

  components: {},
  created: function created() {},

  computed: {},
  mounted: function mounted() {},

  methods: {
    popoverShow: function popoverShow() {
      this.show = true;
      if (this.hierarchyList && this.hierarchyList.length > 0) {
        this.id = this.hierarchyList[0].id;
        this.children = this.hierarchyList[0].children;
      }
    },
    changeChildren: function changeChildren(data) {
      this.id = data.id;
      this.children = data.children;
    },
    handleChildren: function handleChildren(item) {
      this.show = false;
      this.$router.push('/mall/show/goodsList/1/all?sort=' + item.id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bab71c9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
var Category_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Category"},[_c('el-popover',{attrs:{"placement":"bottom-start","append-to-body":false,"trigger":"click"},on:{"show":_vm.popoverShow},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"sort"},[_c('el-scrollbar',{staticClass:"list"},_vm._l((_vm.hierarchyList),function(item,index){return _c('div',{key:index,class:_vm.id === item.id ? 'active' : '',on:{"click":function($event){return _vm.changeChildren(item)}}},[_vm._v("\n          "+_vm._s(item.value)+"\n        ")])}),0),_vm._v(" "),_c('div',{staticClass:"right"},_vm._l((_vm.children),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('span',{staticClass:"name",on:{"click":function($event){return _vm.handleChildren(item)}}},[_vm._v("\n            "+_vm._s(item.value)+"\n          ")])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"title",attrs:{"slot":"reference"},slot:"reference"},[_c('img',{attrs:{"src":__webpack_require__("wEm3"),"alt":""}}),_vm._v("\n      商品分类\n    ")])])],1)}
var Category_staticRenderFns = []
var Category_esExports = { render: Category_render, staticRenderFns: Category_staticRenderFns }
/* harmony default export */ var components_Category = (Category_esExports);
// CONCATENATED MODULE: ./src/components/Category.vue
function Category_injectStyle (ssrContext) {
  __webpack_require__("QtbZ")
}
var Category_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Category___vue_template_functional__ = false
/* styles */
var Category___vue_styles__ = Category_injectStyle
/* scopeId */
var Category___vue_scopeId__ = "data-v-bab71c9c"
/* moduleIdentifier (server only) */
var Category___vue_module_identifier__ = null
var Category_Component = Category_normalizeComponent(
  Category,
  components_Category,
  Category___vue_template_functional__,
  Category___vue_styles__,
  Category___vue_scopeId__,
  Category___vue_module_identifier__
)

/* harmony default export */ var src_components_Category = (Category_Component.exports);

// EXTERNAL MODULE: ./src/api/platform.js + 1 modules
var platform = __webpack_require__("zqHT");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Mall.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Mall = ({
  name: "Mall",
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken", "clientName"]), {
    route: function route() {
      return this.$route.name;
    },
    curPath: function curPath() {
      return this.$route.path;
    },
    cartNum: function cartNum() {
      return this.$store.state.cartNum;
    }
  }),
  components: {
    NoticeList: src_components_NoticeList,
    TipsInput: src_components_TipsInput,
    Category: src_components_Category
  },
  data: function data() {
    return {
      clientHeight: Object(util["b" /* getClientSize */])().height,
      shouldShowBT: false,
      searchText: "",
      typeList: [{ id: -1, name: "首页" }, { id: 1, name: "全部商品" }],
      hierarchyList: [],
      key: ''
    };
  },
  mounted: function mounted() {
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
    }
    if (this.clientToken) {
      this.getHierarchyList();
      this.$store.dispatch("getCartQuantity");
    } else {
      this.$store.commit("setData", {
        cartNum: 0
      });
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])({
    clientLogout: "CLIENT_LOGOUT"
  }), {
    // 生成二维码
    getHierarchyList: function getHierarchyList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: "850556846c4643ebbd8c24741481c3e0"
                });

              case 2:
                _ref = _context.sent;
                result = _ref.result;

                console.log('result', result);

                _this.hierarchyList = result;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    judgeCurPath: function judgeCurPath(typeId) {
      if (typeId === -1) {
        if (this.curPath.indexOf("/show/index") > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.curPath.indexOf("/show/goodsList/" + typeId) > -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },
    logout: function logout() {
      localStorage.clear();
      this.navTo("/login");
    },
    backToTop: function backToTop() {
      Object(util["a" /* backToTop */])();
    },
    searchTip: function searchTip(tip) {
      alert(tip);
    },
    searchConfirm: function searchConfirm() {
      if (this.searchText) {
        if (this.$route.query.searchText === this.searchText) {
          this.key = Math.random();
        } else {
          this.navTo("/mall/show/goodsList/0/1?searchText=" + this.searchText);
        }
      } else {
        this.navTo("/mall/show/goodsList/1/all");
      }
    },
    selectType: function selectType(typeId) {
      //首页
      if (typeId === -1) {
        this.navTo("/mall/show/index");
      } else {
        this.navTo("/mall/show/goodsList/" + typeId + "/all");
      }
    },
    handleToPaas: function handleToPaas() {
      Object(util["d" /* otherSystemGetLoginToMeUrl */])("a29fd212e51c11eeb53b0242ac150003", "dCOsnTCUsE2p5xVI");
    }
  }),
  beforeDestroyed: function beforeDestroyed() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2506e95b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Mall.vue
var Mall_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Mall"},[_c('header',{style:({
      borderBottom: ['Cart', 'RegularPurchaseList'].includes(_vm.route)
        ? ''
        : '2px solid #f24f18'
    })},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"left"},[_c('span',[_vm._v("您好，欢迎"+_vm._s(_vm.clientName)+"来到科普特 ")]),_vm._v(" "),(!_vm.clientToken)?_c('span',{on:{"click":_vm.logout}},[_vm._v("请登录")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{on:{"click":function($event){return _vm.navTo('/mall/personal/myAddress')}}},[_vm._v("个人中心")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.navTo('/mall/personal/myOrder')}}},[_vm._v("我的订单")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.navTo('/mall/cart')}}},[_c('img',{attrs:{"src":__webpack_require__("dxNk"),"alt":""}}),_vm._v(" 购物车\n          ")]),_vm._v(" "),(_vm.clientToken)?_c('span',{on:{"click":_vm.handleToPaas}},[_vm._v("跳转到后台")]):_vm._e(),_vm._v(" "),(_vm.clientToken)?_c('span',{on:{"click":_vm.logout}},[_vm._v("退出登录")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logo w-full"},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("eOq7"),"alt":""},on:{"click":function($event){return _vm.navTo('/mall')}}}),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"input"},[_c('el-input',{attrs:{"type":"text"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchConfirm.apply(null, arguments)}},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}}),_vm._v(" "),_c('div',{staticClass:"search",on:{"click":function($event){return _vm.searchConfirm()}}},[_c('img',{attrs:{"src":__webpack_require__("nqGY"),"alt":""}})])],1),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.navTo('/mall/cart')}}},[_c('img',{attrs:{"src":__webpack_require__("FWeZ"),"alt":""}}),_vm._v("\n          购物车\n          "),_c('el-badge',{staticClass:"item",staticStyle:{"margin-left":"5px"},attrs:{"value":_vm.cartNum,"max":99}})],1),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.navTo('/mall/regularPurchaseList')}}},[_c('img',{attrs:{"src":__webpack_require__("Ex6y"),"alt":""}}),_vm._v("\n          常购清单\n        ")])])]),_vm._v(" "),(!['Cart', 'RegularPurchaseList'].includes(_vm.route))?_c('div',{staticClass:"typeList w-full"},[_c('Category',{attrs:{"hierarchyList":_vm.hierarchyList}}),_vm._v(" "),_c('ul',_vm._l((_vm.typeList),function(item){return _c('li',{key:'type' + item.id,class:{ selected: _vm.judgeCurPath(item.id) },on:{"click":function($event){return _vm.selectType(item.id)}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}),0),_vm._v(" "),_c('div',[_vm._v("杭州科普特电子有限公司")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content",style:({
      background: [
        'Cart',
        'GoodsDetail',
        'CreateOrder',
        'OrderDetail',
        'RegularPurchaseList'
      ].includes(_vm.route)
        ? '#fff'
        : '#f4f4f4'
    })},[_c('div',{staticClass:"container",style:({ minHeight: _vm.clientHeight + 'px' })},[_c('router-view',{key:_vm.key})],1)]),_vm._v(" "),_vm._m(0)])}
var Mall_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"footerTop"},[_c('li',[_c('img',{attrs:{"src":__webpack_require__("P4Qa"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("正品行货资质齐全")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("eXGj"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("15天无理由退货")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("T8fr"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("预约维护服务")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("KkVO"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("0元包邮")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":__webpack_require__("o6eR"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("全国均可配送")])])]),_vm._v(" "),_c('div',{staticClass:"footerBottom"},[_c('p',[_vm._v("\n          Copyright © 2004 All Rights Reserved. 版权所有 备案号：\n          "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("\n            浙ICP备2024060952号-1\n          ")])]),_vm._v(" "),_c('p',[_vm._v("\n          服务电话 "),_c('span',[_vm._v("4008165908")]),_vm._v(" 投诉电话 "),_c('span',[_vm._v("13758224489")])])])])])}]
var Mall_esExports = { render: Mall_render, staticRenderFns: Mall_staticRenderFns }
/* harmony default export */ var client_Mall = (Mall_esExports);
// CONCATENATED MODULE: ./src/pages/client/Mall.vue
function Mall_injectStyle (ssrContext) {
  __webpack_require__("NGzo")
}
var Mall_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Mall___vue_template_functional__ = false
/* styles */
var Mall___vue_styles__ = Mall_injectStyle
/* scopeId */
var Mall___vue_scopeId__ = "data-v-2506e95b"
/* moduleIdentifier (server only) */
var Mall___vue_module_identifier__ = null
var Mall_Component = Mall_normalizeComponent(
  Mall,
  client_Mall,
  Mall___vue_template_functional__,
  Mall___vue_styles__,
  Mall___vue_scopeId__,
  Mall___vue_module_identifier__
)

/* harmony default export */ var pages_client_Mall = (Mall_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/MallShow.vue
//
//
//
//
//
//

/* harmony default export */ var MallShow = ({
  name: "MallShow",
  components: {},
  computed: {},
  data: function data() {
    return {};
  },


  methods: {
    navTo: function navTo(route) {
      this.$router.push(route);
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2032a0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/MallShow.vue
var MallShow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MallShow"},[_c('router-view')],1)}
var MallShow_staticRenderFns = []
var MallShow_esExports = { render: MallShow_render, staticRenderFns: MallShow_staticRenderFns }
/* harmony default export */ var client_MallShow = (MallShow_esExports);
// CONCATENATED MODULE: ./src/pages/client/MallShow.vue
function MallShow_injectStyle (ssrContext) {
  __webpack_require__("jQEI")
}
var MallShow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MallShow___vue_template_functional__ = false
/* styles */
var MallShow___vue_styles__ = MallShow_injectStyle
/* scopeId */
var MallShow___vue_scopeId__ = "data-v-b2032a0e"
/* moduleIdentifier (server only) */
var MallShow___vue_module_identifier__ = null
var MallShow_Component = MallShow_normalizeComponent(
  MallShow,
  client_MallShow,
  MallShow___vue_template_functional__,
  MallShow___vue_styles__,
  MallShow___vue_scopeId__,
  MallShow___vue_module_identifier__
)

/* harmony default export */ var pages_client_MallShow = (MallShow_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionHeader.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SectionHeader = ({
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    moreText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c14ad028","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionHeader.vue
var SectionHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"SectionHeader"},[_c('div',{staticClass:"left"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tips))])]),_vm._v(" "),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.moreText))])])}
var SectionHeader_staticRenderFns = []
var SectionHeader_esExports = { render: SectionHeader_render, staticRenderFns: SectionHeader_staticRenderFns }
/* harmony default export */ var components_SectionHeader = (SectionHeader_esExports);
// CONCATENATED MODULE: ./src/components/SectionHeader.vue
function SectionHeader_injectStyle (ssrContext) {
  __webpack_require__("/YBC")
}
var SectionHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SectionHeader___vue_template_functional__ = false
/* styles */
var SectionHeader___vue_styles__ = SectionHeader_injectStyle
/* scopeId */
var SectionHeader___vue_scopeId__ = "data-v-c14ad028"
/* moduleIdentifier (server only) */
var SectionHeader___vue_module_identifier__ = null
var SectionHeader_Component = SectionHeader_normalizeComponent(
  SectionHeader,
  components_SectionHeader,
  SectionHeader___vue_template_functional__,
  SectionHeader___vue_styles__,
  SectionHeader___vue_scopeId__,
  SectionHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_SectionHeader = (SectionHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ZoomImg.vue
//
//
//
//
//
//
//

/* harmony default export */ var ZoomImg = ({
  name: 'ZoomImg',
  props: {
    imgSrc: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fa6413","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZoomImg.vue
var ZoomImg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ZoomImg"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"otherEle"},[_vm._t("otherEle")],2)])}
var ZoomImg_staticRenderFns = []
var ZoomImg_esExports = { render: ZoomImg_render, staticRenderFns: ZoomImg_staticRenderFns }
/* harmony default export */ var components_ZoomImg = (ZoomImg_esExports);
// CONCATENATED MODULE: ./src/components/ZoomImg.vue
function ZoomImg_injectStyle (ssrContext) {
  __webpack_require__("s78B")
}
var ZoomImg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZoomImg___vue_template_functional__ = false
/* styles */
var ZoomImg___vue_styles__ = ZoomImg_injectStyle
/* scopeId */
var ZoomImg___vue_scopeId__ = "data-v-53fa6413"
/* moduleIdentifier (server only) */
var ZoomImg___vue_module_identifier__ = null
var ZoomImg_Component = ZoomImg_normalizeComponent(
  ZoomImg,
  components_ZoomImg,
  ZoomImg___vue_template_functional__,
  ZoomImg___vue_styles__,
  ZoomImg___vue_scopeId__,
  ZoomImg___vue_module_identifier__
)

/* harmony default export */ var src_components_ZoomImg = (ZoomImg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GoodsItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var GoodsItem = ({
  name: "GoodsItem",
  props: {
    id: {
      type: [Number, String],
      default: function _default() {
        return "";
      }
    },
    img: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    name: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    price: {
      type: [Number, String],
      default: function _default() {
        return "";
      }
    },
    section: {
      type: [Number, String, Array],
      default: function _default() {
        return "";
      }
    },
    sku: {
      type: [Number, String, Array],
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    navTo: function navTo(route) {
      this.$router.push(route);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d0330e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodsItem.vue
var GoodsItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"GoodsItem"},[_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":_vm.img,"alt":"商品图片"},on:{"click":function($event){return _vm.navTo('/mall/goods/' + _vm.id)}}})]),_vm._v(" "),_c('div',{staticClass:"goodsInfo"},[_c('span',{staticClass:"goodsName ellipsis-two",on:{"click":function($event){return _vm.navTo('/mall/goods/' + _vm.id)}}},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(_vm._s('¥' + _vm.price))]),_vm._v(" "),_c('span',{staticClass:"goodsName"},[_vm._v("\n      "+_vm._s(_vm.section.map(function (el) { return el.value; }).join('-'))+"\n    ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.sku))])])])}
var GoodsItem_staticRenderFns = []
var GoodsItem_esExports = { render: GoodsItem_render, staticRenderFns: GoodsItem_staticRenderFns }
/* harmony default export */ var components_GoodsItem = (GoodsItem_esExports);
// CONCATENATED MODULE: ./src/components/GoodsItem.vue
function GoodsItem_injectStyle (ssrContext) {
  __webpack_require__("s8b1")
}
var GoodsItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GoodsItem___vue_template_functional__ = false
/* styles */
var GoodsItem___vue_styles__ = GoodsItem_injectStyle
/* scopeId */
var GoodsItem___vue_scopeId__ = "data-v-66d0330e"
/* moduleIdentifier (server only) */
var GoodsItem___vue_module_identifier__ = null
var GoodsItem_Component = GoodsItem_normalizeComponent(
  GoodsItem,
  components_GoodsItem,
  GoodsItem___vue_template_functional__,
  GoodsItem___vue_styles__,
  GoodsItem___vue_scopeId__,
  GoodsItem___vue_module_identifier__
)

/* harmony default export */ var src_components_GoodsItem = (GoodsItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Slick.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Slick = ({
  name: 'Slick',
  props: {
    ulWidth: {
      type: Number,
      default: 0
    },
    showWidth: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  computed: {
    pageNum: function pageNum() {
      return Math.ceil(this.ulWidth / this.showWidth);
    },
    translateX: function translateX() {
      return -(this.curPage - 1) * this.showWidth;
    }
  },
  data: function data() {
    return {
      btnWidth: 40,
      curPage: 1
    };
  },

  methods: {
    prev: function prev() {
      if (this.curPage <= 1) {
        return;
      }
      this.curPage -= 1;
    },
    next: function next() {
      if (this.curPage >= this.pageNum) {
        return;
      }
      this.curPage += 1;
    }
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80be3fb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slick.vue
var Slick_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Slick",style:({width:(_vm.showWidth+_vm.btnWidth*2+20)+'px',height:_vm.height+'px'})},[_c('div',{staticClass:"prev",style:({width:_vm.btnWidth+'px',height:_vm.btnWidth+'px',lineHeight:_vm.btnWidth+'px',opacity:_vm.curPage<=1?0.3:1}),on:{"click":_vm.prev}},[_c('i',{staticClass:"iconfont icon-return"})]),_c('div',{staticClass:"listWrapper",style:({width:_vm.showWidth+'px',height:_vm.height+'px'})},[_c('div',{staticClass:"animateList",style:({width:_vm.ulWidth+'px',transform:("translate3d(" + _vm.translateX + "px,0,0)")})},[_vm._t("list")],2)]),_c('div',{staticClass:"next",style:({width:_vm.btnWidth+'px',height:_vm.btnWidth+'px',lineHeight:_vm.btnWidth+'px',opacity:_vm.curPage>=_vm.pageNum?0.3:1}),on:{"click":_vm.next}},[_c('i',{staticClass:"iconfont icon-enter"})])])}
var Slick_staticRenderFns = []
var Slick_esExports = { render: Slick_render, staticRenderFns: Slick_staticRenderFns }
/* harmony default export */ var components_Slick = (Slick_esExports);
// CONCATENATED MODULE: ./src/components/Slick.vue
function Slick_injectStyle (ssrContext) {
  __webpack_require__("Vh3w")
}
var Slick_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Slick___vue_template_functional__ = false
/* styles */
var Slick___vue_styles__ = Slick_injectStyle
/* scopeId */
var Slick___vue_scopeId__ = "data-v-80be3fb8"
/* moduleIdentifier (server only) */
var Slick___vue_module_identifier__ = null
var Slick_Component = Slick_normalizeComponent(
  Slick,
  components_Slick,
  Slick___vue_template_functional__,
  Slick___vue_styles__,
  Slick___vue_scopeId__,
  Slick___vue_module_identifier__
)

/* harmony default export */ var src_components_Slick = (Slick_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FadeSwiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FadeSwiper = ({
  name: "FadeSwiper",
  props: {
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    }
  },
  computed: {},
  data: function data() {
    return {
      len: keys_default()(this.$slots).length,
      curIndex: 0,
      timer: null
    };
  },

  methods: {
    prev: function prev() {
      if (this.curIndex <= 0) {
        this.curIndex = this.len - 1;
        return;
      }
      this.curIndex = this.curIndex - 1;
    },
    next: function next() {
      if (this.curIndex >= this.len - 1) {
        this.curIndex = 0;
        return;
      }
      this.curIndex = this.curIndex + 1;
    },
    selectPage: function selectPage(index) {
      this.curIndex = index;
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    setTimer: function setTimer() {
      this.timer = setInterval(this.next, 5000);
    }
  },
  mounted: function mounted() {
    this.setTimer();
  },
  beforeDestroyed: function beforeDestroyed() {
    this.clearTimer();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2055095e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FadeSwiper.vue
var FadeSwiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FadeSwiper",style:({ width: _vm.width, height: _vm.height }),on:{"mouseover":function($event){$event.stopPropagation();return _vm.clearTimer.apply(null, arguments)},"mouseout":function($event){$event.stopPropagation();return _vm.setTimer.apply(null, arguments)}}},[_c('div',{staticClass:"swiperWrapper"},_vm._l((_vm.len),function(item,index){return _c('div',{key:index,staticClass:"swiperItem",style:({ opacity: _vm.curIndex === index ? 1 : 0 })},[_vm._t('item' + (index + 1))],2)}),0),_vm._v(" "),_c('div',{staticClass:"prev arrow",on:{"click":_vm.prev}},[_c('i',{staticClass:"iconfont icon-return"})]),_vm._v(" "),_c('div',{staticClass:"next arrow",on:{"click":_vm.next}},[_c('i',{staticClass:"iconfont icon-enter"})]),_vm._v(" "),_c('div',{staticClass:"circles"},_vm._l((_vm.len),function(item,index){return _c('span',{key:index,class:_vm.curIndex === index ? 'selected' : '',on:{"click":function($event){return _vm.selectPage(index)}}})}),0)])}
var FadeSwiper_staticRenderFns = []
var FadeSwiper_esExports = { render: FadeSwiper_render, staticRenderFns: FadeSwiper_staticRenderFns }
/* harmony default export */ var components_FadeSwiper = (FadeSwiper_esExports);
// CONCATENATED MODULE: ./src/components/FadeSwiper.vue
function FadeSwiper_injectStyle (ssrContext) {
  __webpack_require__("DJMQ")
}
var FadeSwiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FadeSwiper___vue_template_functional__ = false
/* styles */
var FadeSwiper___vue_styles__ = FadeSwiper_injectStyle
/* scopeId */
var FadeSwiper___vue_scopeId__ = "data-v-2055095e"
/* moduleIdentifier (server only) */
var FadeSwiper___vue_module_identifier__ = null
var FadeSwiper_Component = FadeSwiper_normalizeComponent(
  FadeSwiper,
  components_FadeSwiper,
  FadeSwiper___vue_template_functional__,
  FadeSwiper___vue_styles__,
  FadeSwiper___vue_scopeId__,
  FadeSwiper___vue_module_identifier__
)

/* harmony default export */ var src_components_FadeSwiper = (FadeSwiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/MallIndex.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {getTypes,getGoodsList} from '../../api/client';






/* harmony default export */ var MallIndex = ({
  name: "MallIndex",
  components: {
    SectionHeader: src_components_SectionHeader,
    ZoomImg: src_components_ZoomImg,
    GoodsItem: src_components_GoodsItem,
    Slick: src_components_Slick,
    FadeSwiper: src_components_FadeSwiper
  },
  computed: {},
  data: function data() {
    return {
      typeList: [],
      goodsList: [],
      initTimestamp: 0,
      newTimestamp: 0,
      timer: null,
      h: 0,
      m: 0,
      s: 0,
      clientWidth: "",
      bannerList: [],
      form_head_uuid: "b39c66e39ef54c5ba5925f692af96e69",
      hierarchyList: [],
      props: {
        value: 'id',
        label: 'bvnmpzigqwuyexo7',
        expandTrigger: 'hover'
      },
      noticeBar: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var clientToken;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(_this.$store.state);
              clientToken = _this.$store.state.clientToken;

              console.log(111);

              if (!clientToken) {
                _context.next = 14;
                break;
              }

              _context.next = 6;
              return _this.banner();

            case 6:
              _context.next = 8;
              return _this.getNoticeBar();

            case 8:
              _context.next = 10;
              return _this.getHierarchyList();

            case 10:
              _context.next = 12;
              return _this.getRecommendedProducts();

            case 12:
              _context.next = 15;
              break;

            case 14:
              _this.$router.push('/login');

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: defineProperty_default()({
    // async getUToken () {
    //   const { result } = await getUToken({
    //     applicationId: '270ab0c29e5411ee9b8b0242321230b4',
    //     appkey: '3d8a7459b781c2cc637eddf020ce7f5c',
    //     appsecret: '4886eaa91e7a7412d384a1042064cc74',
    //     username: '19988888888',
    //   })
    //   this.$store.commit('setData', {
    //     temporarilyToken: result.token, // 临时token
    //   });
    // },
    getHierarchyList: function getHierarchyList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: '850556846c4643ebbd8c24741481c3e0'
                });

              case 2:
                _ref = _context2.sent;
                result = _ref.result;

                _this2.hierarchyList = result;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterGoodsByType: function filterGoodsByType(typeid) {
      return this.goodsList.filter(function (item) {
        return item.typeId === typeid;
      });
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },
    selectType: function selectType(typeId) {
      if (typeId == -1) {
        return;
      }
      this.navTo("/mall/show/goodsList/" + typeId + "/all");
    },
    getNoticeBar: function getNoticeBar() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref2, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: 'bf7a80f39ecf4ae1b19bffb4f299e925',
                  page: 1,
                  limit: 20,
                  keyword: "",
                  select_option: ""
                });

              case 2:
                _ref2 = _context3.sent;
                result = _ref2.result;

                _this3.noticeBar = result;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    // 获取banner图
    banner: function banner() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref3, result;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(platform["n" /* online */])({
                  page: 1,
                  limit: 20,
                  form_head_uuid: "12b59f8a4698486784979d7416071d3e"
                });

              case 2:
                _ref3 = _context4.sent;
                result = _ref3.result;

                if (result.length > 0) {
                  _this4.bannerList = result.map(function (el) {
                    return el["8dzgbn9fg4vlyagl"][0];
                  });
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },


    // 推荐商品
    getRecommendedProducts: function getRecommendedProducts() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var form_head_uuid, _ref4, result;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                form_head_uuid = _this5.form_head_uuid;
                _context5.next = 3;
                return Object(platform["n" /* online */])({
                  page: 1,
                  limit: 20,
                  keyword: "",
                  select_option: "",
                  form_head_uuid: form_head_uuid
                });

              case 3:
                _ref4 = _context5.sent;
                result = _ref4.result;

                _this5.goodsList = result;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    searchTip: function searchTip(tip) {
      alert(tip);
    },
    inputTextChange: function inputTextChange(text) {},
    scrollHandle: function scrollHandle() {
      var top = this.$refs.typeList.getBoundingClientRect().top;
      //还未到顶
      if (top > 0) {
        this.navShouldFixed = false;
      } else {
        //已经到顶
        this.navShouldFixed = true;
      }
    },
    handleItem: function handleItem(_ref5) {
      var id = _ref5.id;

      this.navTo("/mall/show/goodsList/1/all?id=" + id);
    }
  }, "navTo", function navTo(route) {
    this.$router.push(route);
  }),

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b923e80e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/MallIndex.vue
var MallIndex_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MallIndex"},[_c('div',{staticClass:"swiperBox"},[_c('el-carousel',{attrs:{"height":"500px"}},_vm._l((_vm.bannerList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"banner",attrs:{"src":item.url}})])}),1)],1),_vm._v(" "),(_vm.noticeBar && _vm.noticeBar.length > 0)?_c('div',{staticClass:"notice-bar"},[_c('div',[_vm._v(_vm._s(_vm.noticeBar[0]['7mhpyoswctp8w2ko']))])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"recommendedGoods section"},[_c('SectionHeader',{attrs:{"title":"产品推荐"}}),_vm._v(" "),_c('ul',{staticClass:"goodsList",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.goodsList),function(item,index){return _c('GoodsItem',{key:index,attrs:{"id":item.id,"img":item.rguiigpafo0pe0my && item.rguiigpafo0pe0my.length > 0
            ? item.rguiigpafo0pe0my[0].url
            : '',"name":item.avdrlfwlhg7kywxn,"price":item.f93blbqlvdtdt65v,"section":item.dzornqdwofgytboq,"sku":item.levmoblohezp7y50}})}),1)],1)])}
var MallIndex_staticRenderFns = []
var MallIndex_esExports = { render: MallIndex_render, staticRenderFns: MallIndex_staticRenderFns }
/* harmony default export */ var client_MallIndex = (MallIndex_esExports);
// CONCATENATED MODULE: ./src/pages/client/MallIndex.vue
function MallIndex_injectStyle (ssrContext) {
  __webpack_require__("ZOCR")
}
var MallIndex_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MallIndex___vue_template_functional__ = false
/* styles */
var MallIndex___vue_styles__ = MallIndex_injectStyle
/* scopeId */
var MallIndex___vue_scopeId__ = "data-v-b923e80e"
/* moduleIdentifier (server only) */
var MallIndex___vue_module_identifier__ = null
var MallIndex_Component = MallIndex_normalizeComponent(
  MallIndex,
  client_MallIndex,
  MallIndex___vue_template_functional__,
  MallIndex___vue_styles__,
  MallIndex___vue_scopeId__,
  MallIndex___vue_module_identifier__
)

/* harmony default export */ var pages_client_MallIndex = (MallIndex_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/MallLogin.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MallLogin = ({
  name: "ClientLogin",
  computed: {},
  data: function data() {
    return {
      curIndex: 0
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])({
    setClientName: "SET_CLIENT_NAME",
    setClientToken: "SET_CLIENT_TOKEN"
  }), {
    setIndex: function setIndex(index) {
      if (index === this.curIndex) {
        return;
      }
      this.curIndex = index;
    },
    login: function login() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var username, password, _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                username = _this.$refs.username.value;
                password = _this.$refs.password.value;
                _context.next = 4;
                return Object(platform["m" /* login */])({
                  username: username,
                  password: password
                });

              case 4:
                _ref = _context.sent;
                result = _ref.result;


                _this.setClientToken(result.token);
                _this.setClientName(result.name);
                localStorage.setItem("user", stringify_default()(result));
                _this.$router.push("/");

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    signup: function signup() {}
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b09a154","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/MallLogin.vue
var MallLogin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ClientLogin"},[_c('img',{staticClass:"bg",attrs:{"src":__webpack_require__("Lr6H"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h3',[_vm._v("登录入口")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curIndex === 0),expression:"curIndex === 0"}],staticClass:"formBox"},[_c('input',{ref:"username",attrs:{"type":"text","placeholder":"账号"}}),_vm._v(" "),_c('input',{ref:"password",attrs:{"type":"password","placeholder":"密码"}}),_vm._v(" "),_c('button',{on:{"click":_vm.login}},[_vm._v("登录")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.curIndex === 1),expression:"curIndex === 1"}],staticClass:"formBox"},[_c('input',{ref:"signEmail",attrs:{"type":"text","placeholder":"请输入注册的邮箱"}}),_vm._v(" "),_c('input',{ref:"signName",attrs:{"type":"text","placeholder":"请输入昵称"}}),_vm._v(" "),_c('input',{ref:"signPwd",attrs:{"type":"password","placeholder":"请输入密码"}}),_vm._v(" "),_c('input',{ref:"signRecipient",attrs:{"type":"text","placeholder":"请输入收件人姓名"}}),_vm._v(" "),_c('input',{ref:"signAddress",attrs:{"type":"text","placeholder":"请输入收件地址"}}),_vm._v(" "),_c('input',{ref:"signPhone",attrs:{"type":"text","placeholder":"请输入联系电话"}}),_vm._v(" "),_c('button',{on:{"click":_vm.signup}},[_vm._v("注册")])])])])}
var MallLogin_staticRenderFns = []
var MallLogin_esExports = { render: MallLogin_render, staticRenderFns: MallLogin_staticRenderFns }
/* harmony default export */ var client_MallLogin = (MallLogin_esExports);
// CONCATENATED MODULE: ./src/pages/client/MallLogin.vue
function MallLogin_injectStyle (ssrContext) {
  __webpack_require__("fEcW")
}
var MallLogin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MallLogin___vue_template_functional__ = false
/* styles */
var MallLogin___vue_styles__ = MallLogin_injectStyle
/* scopeId */
var MallLogin___vue_scopeId__ = "data-v-5b09a154"
/* moduleIdentifier (server only) */
var MallLogin___vue_module_identifier__ = null
var MallLogin_Component = MallLogin_normalizeComponent(
  MallLogin,
  client_MallLogin,
  MallLogin___vue_template_functional__,
  MallLogin___vue_styles__,
  MallLogin___vue_scopeId__,
  MallLogin___vue_module_identifier__
)

/* harmony default export */ var pages_client_MallLogin = (MallLogin_Component.exports);

// EXTERNAL MODULE: ./src/components/NumberInput.vue + 2 modules
var NumberInput = __webpack_require__("2FN2");

// EXTERNAL MODULE: ./src/components/Radio.vue + 2 modules
var Radio = __webpack_require__("uPNt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/GoodsDetail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var GoodsDetail = ({
  name: "GoodsDetail",
  components: {
    NumberInput: NumberInput["a" /* default */],
    Radio: Radio["a" /* default */],
    GoodsItem: src_components_GoodsItem
  },
  computed: {
    id: function id() {
      return this.$route.params.id;
    }
  },
  data: function data() {
    return {
      goodsImg: "",
      goodsName: "",
      goodsDesc: "",
      specs: [],
      typeId: "",
      temSpecId: 0,
      num: 1,
      msgList: [],
      askContent: "",
      tagList: ["商品介绍", "规格型号", "供货商"],
      curIndex: 0,
      rate: "",
      commentList: [],
      goodsList: [],
      detail: {},
      dialogVisible: false, //分组弹窗
      groupList: [], //分组列表
      group: '' // 分组id
    };
  },
  mounted: function mounted() {
    this.detailOnline(this.id);
    this.getGroupList();
  },

  methods: {
    detailOnline: function detailOnline(id) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(platform["g" /* detailOnline */])({
                  id: id,
                  form_head_uuid: "4b9b935758484c01bb3d8e2d1e08211f"
                });

              case 2:
                _ref = _context.sent;
                result = _ref.result;

                _this.detail = result;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 获取分组列表
    getGroupList: function getGroupList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: 'fde4a97f88444d9599a9bbf4778a2767',
                  page: 1,
                  limit: 1000,
                  keyword: "",
                  select_option: ""
                });

              case 2:
                _ref2 = _context2.sent;
                result = _ref2.result;

                _this2.groupList = result;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    // 展示分组管理弹窗
    showDialogVisible: function showDialogVisible() {
      this.dialogVisible = true;
      this.group = '';
    },
    changeIndex: function changeIndex(i) {
      this.curIndex = i;
    },

    // 加入购物车
    addToCart: function addToCart() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(platform["p" /* relationFieldButtonExc */])({
                  data: { bhekk5pld5l117tl: _this3.num },
                  button_uuid: "e3bd545a-7298-4a1c-9441-6a69d58cc092",
                  ids: [_this3.detail.id],
                  form_head_uuid: "4b9b935758484c01bb3d8e2d1e08211f"
                });

              case 2:
                _this3.$notify({
                  title: "提示",
                  message: "商品已成功加入购物车",
                  type: "success"
                });
                _this3.num = 1;
                _this3.$store.dispatch('getCartQuantity');

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addGroup: function addGroup() {
      var _this4 = this;

      this.$prompt('分组名称', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(_ref4) {
          var value = _ref4.value;
          return regenerator_default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!value) {
                    _context4.next = 5;
                    break;
                  }

                  _context4.next = 3;
                  return Object(platform["o" /* postOnline */])({
                    form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
                    izclrsecwsxu9yfg: value
                  });

                case 3:
                  _this4.$message({
                    type: 'success',
                    message: '创建成功'
                  });
                  _this4.getGroupList();

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, _this4);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },

    // 加入常购清单
    addToFrequentPurchaseList: function addToFrequentPurchaseList() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(platform["p" /* relationFieldButtonExc */])({
                  data: { abv2ns1jpglwrhpt: _this5.group, cqciysjw6yzbccda: _this5.num },
                  button_uuid: "4aeb190e-43e6-4ed3-99aa-33d7d1bc24aa",
                  ids: [_this5.detail.id],
                  form_head_uuid: "1906dfc5e0ce4e7cb7d6324b06e6d470"
                });

              case 2:
                _this5.$notify({
                  title: "提示",
                  message: "商品已成功加入常购清单",
                  type: "success"
                });
                _this5.dialogVisible = false;
                _this5.num = 1;

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },

    // 立即购买
    buy: function buy() {
      this.$store.commit('setData', {
        commodityList: [this.detail],
        number: this.num
      });
      this.$router.push('/mall/createOrder?form=detail');
    }
  },
  watch: {
    $route: function $route(to, from) {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19739a1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/GoodsDetail.vue
var GoodsDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GoodsDetail"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"goodsInfo"},[_c('el-carousel',{staticClass:"infoLeft",attrs:{"height":"400px","arrow":"never"}},_vm._l((_vm.detail.rguiigpafo0pe0my),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.url,"alt":""}})])}),1),_vm._v(" "),_c('div',{staticClass:"infoRight"},[_c('div',{staticClass:"infoBox"},[_c('h3',{staticClass:"name"},[_vm._v(_vm._s(_vm.detail.avdrlfwlhg7kywxn))])]),_vm._v(" "),_c('div',{staticClass:"infoBox"},[_c('p',[_vm._v(_vm._s(_vm.detail.levmoblohezp7y50 || ''))])]),_vm._v(" "),_c('div',{staticClass:"infoBox"},[_c('h3',{staticClass:"price"},[_vm._v("¥"+_vm._s(_vm.detail.f93blbqlvdtdt65v || 0))])]),_vm._v(" "),_c('div',{staticClass:"infoBox"},[_c('span',[_vm._v("单位：")]),_vm._v(_vm._s(_vm.detail.y8cegh2yyvvqbzwo || '')+"\n        ")]),_vm._v(" "),(
            _vm.detail['2ubunrqlyoz3re9q'] !==
            '00bd865a-258c-4cf7-a79a-10124f2396e2'
          )?[_c('div',{staticClass:"infoBox"},[_c('span',[_vm._v("数量：")]),_vm._v(" "),_c('NumberInput',{attrs:{"min":1,"max":999999},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}})],1),_vm._v(" "),_c('button',{staticClass:"buyBtn",on:{"click":_vm.buy}},[_vm._v("立即购买")]),_vm._v(" "),_c('button',{on:{"click":_vm.addToCart}},[_c('img',{attrs:{"src":__webpack_require__("iWlE"),"alt":""}}),_vm._v("\n            加入购物车\n          ")]),_vm._v(" "),_c('button',{staticClass:"buyBtn",attrs:{"type":"text"},on:{"click":_vm.showDialogVisible}},[_vm._v("\n            加入常购清单\n          ")])]:_vm._e()],2)],1),_vm._v(" "),_c('section',{staticClass:"msgBox"},[_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.curIndex === index },on:{"click":function($event){return _vm.changeIndex(index)}}},[_vm._v("\n          "+_vm._s(item)+"\n        ")])}),0),_vm._v(" "),(_vm.curIndex === 0)?_c('div',{staticClass:"commentBody"},[(_vm.detail.tucgev7e0xvjfgij && _vm.detail.tucgev7e0xvjfgij.length)?_c('div',_vm._l((_vm.detail.tucgev7e0xvjfgij),function(item,index){return _c('img',{key:index,staticClass:"img",attrs:{"src":item.url,"alt":""}})}),0):(
            _vm.detail.xwkkrha3mtpeybgy &&
            _vm.detail.xwkkrha3mtpeybgy !== '<p><br></p>'
          )?_c('div',{staticClass:"richtext",domProps:{"innerHTML":_vm._s(_vm.detail.xwkkrha3mtpeybgy)}}):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("kvyp"),"alt":""}})])]):(_vm.curIndex === 1)?_c('div',{staticClass:"msgBody"},[(
            _vm.detail.se3jrkgoqrxa6sgt &&
            _vm.detail.se3jrkgoqrxa6sgt !== '<p><br></p>'
          )?_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.se3jrkgoqrxa6sgt)}}):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("kvyp"),"alt":""}})])]):_c('div',{staticClass:"msgBody"},[(_vm.detail.g9rqvy80zjwm73qh && _vm.detail.g9rqvy80zjwm73qh.length > 0)?_c('div',[_vm._v("\n          "+_vm._s(_vm.detail.g9rqvy80zjwm73qh[0].value)+"\n        ")]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("kvyp"),"alt":""}})])])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"分组管理","visible":_vm.dialogVisible,"width":"30%","show-close":false,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}},_vm._l((_vm.groupList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.izclrsecwsxu9yfg,"value":item.id}})}),1),_vm._v(" "),_c('el-link',{attrs:{"type":"primary","underline":false},on:{"click":_vm.addGroup}},[_vm._v("\n      新增分组\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addToFrequentPurchaseList()}}},[_vm._v("\n        确定\n      ")])],1)],1)],1)}
var GoodsDetail_staticRenderFns = []
var GoodsDetail_esExports = { render: GoodsDetail_render, staticRenderFns: GoodsDetail_staticRenderFns }
/* harmony default export */ var client_GoodsDetail = (GoodsDetail_esExports);
// CONCATENATED MODULE: ./src/pages/client/GoodsDetail.vue
function GoodsDetail_injectStyle (ssrContext) {
  __webpack_require__("ouXj")
}
var GoodsDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GoodsDetail___vue_template_functional__ = false
/* styles */
var GoodsDetail___vue_styles__ = GoodsDetail_injectStyle
/* scopeId */
var GoodsDetail___vue_scopeId__ = "data-v-19739a1e"
/* moduleIdentifier (server only) */
var GoodsDetail___vue_module_identifier__ = null
var GoodsDetail_Component = GoodsDetail_normalizeComponent(
  GoodsDetail,
  client_GoodsDetail,
  GoodsDetail___vue_template_functional__,
  GoodsDetail___vue_styles__,
  GoodsDetail___vue_scopeId__,
  GoodsDetail___vue_module_identifier__
)

/* harmony default export */ var pages_client_GoodsDetail = (GoodsDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/GoodsList.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GoodsList = ({
  name: "GoodsList",
  components: {
    GoodsItem: src_components_GoodsItem
  },
  computed: {
    isSearchPage: function isSearchPage() {
      return Number(this.typeId) === 0 ? true : false;
    },
    typeId: function typeId() {
      return this.$route.params.typeId || 0;
    },
    keyword: function keyword() {
      return this.$route.query.searchText || "";
    }
  },
  data: function data() {
    return {
      goodsList: [],
      brandId: "",
      page: 1, // 页数
      limit: 20,
      total: 0,
      form_head_uuid: "1906dfc5e0ce4e7cb7d6324b06e6d470",
      more: false,
      brandList: [],
      id: ''
    };
  },


  methods: {
    getListBrands: function getListBrands() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(platform["q" /* relationOptions */])({
                  field_uuid: "bf20183860ca4e23ba2e301d49be629d",
                  form_head_uuid: "bdc9ab24525d43818588fa136d5cd3da",
                  keyword: "",
                  type: "quick_screen"
                });

              case 2:
                _ref = _context.sent;
                result = _ref.result;

                _this.brandList = result;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getGoodsList: function getGoodsList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var page, form_head_uuid, brandId, limit, _ref2, meta, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = _this2.page, form_head_uuid = _this2.form_head_uuid, brandId = _this2.brandId, limit = _this2.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  page: page,
                  limit: limit,
                  keyword: _this2.keyword,
                  select_option: "",
                  form_head_uuid: form_head_uuid,
                  lkru2wjadtwwzlh8: brandId ? [brandId] : "",
                  '8ufiw69wm435kw5j': _this2.id || _this2.$route.query.sort ? [_this2.id || _this2.$route.query.sort] : ''
                });

              case 3:
                _ref2 = _context2.sent;
                meta = _ref2.meta;
                result = _ref2.result;

                _this2.goodsList = result;
                _this2.total = meta ? meta.total : 0;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeBrand: function changeBrand(e) {
      this.page = 1;
      this.brandId = this.brandId === e ? "" : e;
      this.getGoodsList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getGoodsList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getGoodsList();
    },
    changeSortMode: function changeSortMode(mode) {
      if (mode === 3) {
        this.sortMode = this.sortMode === 1 ? 2 : 1;
      } else {
        this.sortMode = 0;
      }
    }
  },

  mounted: function mounted() {
    if (this.$route.query) this.id = this.$route.query.id;
    // 品牌列表
    this.getListBrands();
    //类别页
    if (!this.isSearchPage) {
      this.getGoodsList();
    } else {
      //搜索结果页
      this.page = 1;
      this.getGoodsList();
    }
  },


  watch: {
    $route: function $route(to, from) {
      console.log(to);
      this.sortMode = 0;
      if (to.query.sort) {
        this.page = 1;
        this.getGoodsList();
      } else if (!this.isSearchPage) {
        this.getGoodsList();
      } else {
        this.page = 1;
        this.getGoodsList(to.query.searchText);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f30376","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/GoodsList.vue
var GoodsList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GoodsList"},[_c('div',{staticClass:"screen"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"label"},[_vm._v("品牌")]),_vm._v(" "),_c('div',{staticClass:"value",style:({ height: _vm.more ? 'auto' : '50px' })},_vm._l((_vm.brandList),function(item,index){return _c('div',{key:index,class:_vm.brandId === item.id ? 'active' : '',on:{"click":function($event){return _vm.changeBrand(item.id)}}},[_vm._v("\n          "+_vm._s(item.value)+"\n        ")])}),0),_vm._v(" "),_c('div',{staticClass:"more",on:{"click":function($event){_vm.more = !_vm.more}}},[_vm._v("\n        "+_vm._s(!_vm.more ? '更多' : '收起')+"\n        "),_c('img',{class:_vm.more ? 'rotated' : '',attrs:{"src":__webpack_require__("AjJ6"),"alt":""}})])])]),_vm._v(" "),(_vm.goodsList.length > 0)?[_c('ul',{staticClass:"goodsList"},_vm._l((_vm.goodsList),function(item,index){return _c('GoodsItem',{key:index,attrs:{"id":item.id,"img":item.rguiigpafo0pe0my && item.rguiigpafo0pe0my.length > 0
            ? item.rguiigpafo0pe0my[0].url
            : '',"name":item.avdrlfwlhg7kywxn,"price":item.f93blbqlvdtdt65v,"section":item.dzornqdwofgytboq,"sku":item.levmoblohezp7y50}})}),1),_vm._v(" "),(_vm.goodsList && _vm.goodsList.length > 0)?_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1):_vm._e()]:_c('p',{staticClass:"noGoods"},[_c('img',{attrs:{"src":__webpack_require__("mLep"),"alt":""}})])],2)}
var GoodsList_staticRenderFns = []
var GoodsList_esExports = { render: GoodsList_render, staticRenderFns: GoodsList_staticRenderFns }
/* harmony default export */ var client_GoodsList = (GoodsList_esExports);
// CONCATENATED MODULE: ./src/pages/client/GoodsList.vue
function GoodsList_injectStyle (ssrContext) {
  __webpack_require__("SQjz")
}
var GoodsList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GoodsList___vue_template_functional__ = false
/* styles */
var GoodsList___vue_styles__ = GoodsList_injectStyle
/* scopeId */
var GoodsList___vue_scopeId__ = "data-v-81f30376"
/* moduleIdentifier (server only) */
var GoodsList___vue_module_identifier__ = null
var GoodsList_Component = GoodsList_normalizeComponent(
  GoodsList,
  client_GoodsList,
  GoodsList___vue_template_functional__,
  GoodsList___vue_styles__,
  GoodsList___vue_scopeId__,
  GoodsList___vue_module_identifier__
)

/* harmony default export */ var pages_client_GoodsList = (GoodsList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Personal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Personal = ({
  name: "Personal",
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken", "clientName"]), {
    form_head_uuid: function form_head_uuid() {
      return this.$store.state.form_head_uuid;
    }
  }),
  data: function data() {
    return {
      curPath: this.$route.path
    };
  },


  methods: {
    navTo: function navTo(route) {
      this.$router.push(route);
    }
  },

  mounted: function mounted() {},


  watch: {
    $route: function $route(to, from) {
      this.curPath = to.path;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e78d512","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Personal.vue
var Personal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Personal"},[_c('ul',{staticClass:"titleList"},[_c('li',{staticClass:"title"},[_vm._v("我的管理")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/myAddress' },on:{"click":function($event){return _vm.navTo('/mall/personal/myAddress')}}},[_vm._v("\n      收货地址\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/changePwd' },on:{"click":function($event){return _vm.navTo('/mall/personal/changePwd')}}},[_vm._v("\n      修改密码\n    ")]),_vm._v(" "),_c('li',{staticClass:"title"},[_vm._v("订单中心")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/myOrder' },on:{"click":function($event){return _vm.navTo('/mall/personal/myOrder')}}},[_vm._v("\n      我的订单\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/Shelves' },on:{"click":function($event){return _vm.navTo('/mall/personal/Shelves')}}},[_vm._v("\n      上架审核\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/Purchase' },on:{"click":function($event){return _vm.navTo('/mall/personal/Purchase')}}},[_vm._v("\n      采购审核\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/returnGoods' },on:{"click":function($event){return _vm.navTo('/mall/personal/returnGoods')}}},[_vm._v("\n      退货申请\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/barter' },on:{"click":function($event){return _vm.navTo('/mall/personal/barter')}}},[_vm._v("\n      换货申请\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/repair' },on:{"click":function($event){return _vm.navTo('/mall/personal/repair')}}},[_vm._v("\n      维修申请\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/extraStandard' },on:{"click":function($event){return _vm.navTo('/mall/personal/extraStandard')}}},[_vm._v("\n      标外维修\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/commodityApplication' },on:{"click":function($event){return _vm.navTo('/mall/personal/commodityApplication')}}},[_vm._v("\n      标外商品申请\n    ")]),_vm._v(" "),_c('li',{staticClass:"title"},[_vm._v("更多")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/satisfaction' },on:{"click":function($event){return _vm.navTo('/mall/personal/satisfaction')}}},[_vm._v("\n      满意度评测\n    ")]),_vm._v(" "),_c('li',{class:{ selected: _vm.curPath === '/mall/personal/wechat' },on:{"click":function($event){return _vm.navTo('/mall/personal/wechat')}}},[_vm._v("\n      微信客服\n    ")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view')],1)])}
var Personal_staticRenderFns = []
var Personal_esExports = { render: Personal_render, staticRenderFns: Personal_staticRenderFns }
/* harmony default export */ var client_Personal = (Personal_esExports);
// CONCATENATED MODULE: ./src/pages/client/Personal.vue
function Personal_injectStyle (ssrContext) {
  __webpack_require__("ajUH")
}
var Personal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Personal___vue_template_functional__ = false
/* styles */
var Personal___vue_styles__ = Personal_injectStyle
/* scopeId */
var Personal___vue_scopeId__ = "data-v-4e78d512"
/* moduleIdentifier (server only) */
var Personal___vue_module_identifier__ = null
var Personal_Component = Personal_normalizeComponent(
  Personal,
  client_Personal,
  Personal___vue_template_functional__,
  Personal___vue_styles__,
  Personal___vue_scopeId__,
  Personal___vue_module_identifier__
)

/* harmony default export */ var pages_client_Personal = (Personal_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/components/Popup.vue + 2 modules
var Popup = __webpack_require__("kfLN");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ApprovalList.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ApprovalList = ({
  props: {
    form_head_uuid: {
      type: String,
      default: ""
    },
    form_id: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      orderList: [],
      page: 1,
      total: 0,
      limit: 20,
      application_id: "270ab0c29e5411ee9b8b0242321230b4",
      checkList: [],
      loadingInstance: null,
      timer: null,
      show: true
    };
  },
  created: function created() {
    this.todolist();
  },

  methods: {
    checkItem: function checkItem(value) {
      var i = this.checkList.findIndex(function (el) {
        return el.id === value.id;
      });
      return i !== -1;
    },
    handleAllCheck: function handleAllCheck() {
      this.checkList = this.orderList;
    },
    handleCheck: function handleCheck(value) {
      if (this.form_head_uuid !== "403e15205bc248f48d8a3626571c4e56") return;
      var i = this.checkList.findIndex(function (el) {
        return el.id === value.id;
      });
      if (i !== -1) {
        this.checkList.splice(i, 1);
      } else {
        this.checkList.push(value);
      }
    },
    todolist: function todolist() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var obj, _ref, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.show = false;
                obj = {
                  application_id: _this.application_id,
                  form_head_uuid: _this.form_id,
                  keywords: "",
                  page: _this.page,
                  pagesize: _this.limit
                };

                if (_this.form_head_uuid === "403e15205bc248f48d8a3626571c4e56") {
                  obj.type = 1;
                } else if (_this.form_head_uuid === "91e9bb4eac0a48b38e8327cc9c6c23de") {
                  obj.type = 2;
                  obj.process_status = 2;
                } else {
                  obj.type = 2;
                  obj.process_status = 99;
                }
                _context2.next = 5;
                return Object(platform["t" /* todolist */])(obj);

              case 5:
                _ref = _context2.sent;
                result = _ref.result;

                _this.total = result.allcount;
                _context2.next = 10;
                return promise_default.a.all(result.list.map(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(el) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = extends_default.a;
                            _context.t1 = {};
                            _context.t2 = el;
                            _context.next = 5;
                            return _this.todolistShow(el.id, el.node_uuid, el.work_flows_uuid);

                          case 5:
                            _context.t3 = _context.sent;
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t3));

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 10:
                _this.orderList = _context2.sent;

                _this.show = true;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    todolistShow: function todolistShow(id, node_uuid, work_flows_uuid) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(platform["u" /* todolistShow */])({
                  application_id: _this2.application_id,
                  id: id,
                  node_uuid: node_uuid,
                  work_flows_uuid: work_flows_uuid
                });

              case 2:
                _ref3 = _context3.sent;
                result = _ref3.result;
                return _context3.abrupt("return", {
                  fields_value_json_show: result.basicinfo.fields_value_json_show,
                  form_head_uuid: result.basicinfo.form_head_uuid
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.todolist();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.todolist();
    },
    navTo: function navTo(route) {
      this.$store.commit("setData", {
        form_head_uuid: this.form_head_uuid
      });
      this.$router.push(route);
    },

    // 审批通过
    handleApproval: function handleApproval(value, status) {
      var _this3 = this;

      console.log(value);
      var id = value.id,
          node_uuid = value.node_uuid,
          todo_id = value.todo_id,
          work_flows_uuid = value.work_flows_uuid,
          fields_value_json_show = value.fields_value_json_show;

      this.$confirm(status === 1 ? "确认审批通过？" : "确认审批驳回？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(platform["c" /* checktodo */])({
                  application_id: _this3.application_id,
                  approve_upload_file: [],
                  content: "",
                  data: {
                    id: fields_value_json_show.id
                  },
                  editjson: {},
                  id: id,
                  isedit: 0,
                  node_uuid: node_uuid,
                  rejectinfo: {},
                  signature_file: "",
                  todo_id: todo_id,
                  status: status,
                  work_flows_uuid: work_flows_uuid
                });

              case 2:
                _this3.$message({
                  type: "success",
                  message: status === 1 ? "审批成功!" : "审批已驳回!"
                });
                _this3.page = 1;
                _this3.todolist();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))).catch(function () {});
    },

    // 批量审批
    handleBatchApproval: function handleBatchApproval(status) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var batch_info, _ref5, result;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                batch_info = _this4.checkList.map(function (el) {
                  var id = el.id,
                      node_uuid = el.node_uuid,
                      todo_id = el.todo_id,
                      work_flows_uuid = el.work_flows_uuid,
                      fields_value_json_show = el.fields_value_json_show;

                  return {
                    application_id: _this4.application_id,
                    approve_upload_file: [],
                    content: "",
                    data: {
                      id: fields_value_json_show.id
                    },
                    editjson: {},
                    id: id,
                    isedit: 0,
                    node_uuid: node_uuid,
                    rejectinfo: {},
                    signature_file: "",
                    todo_id: todo_id,
                    status: status,
                    work_flows_uuid: work_flows_uuid
                  };
                });
                _context5.next = 3;
                return Object(platform["a" /* approveAllowApprovalBatchAction */])({
                  batch_info: batch_info
                });

              case 3:
                _ref5 = _context5.sent;
                result = _ref5.result;

                _this4.getQueueText(result.queue_code);
                _this4.timer = setInterval(function () {
                  _this4.getQueueText(result.queue_code);
                }, 1000);
                _this4.checkList = [];
                // 显示加载提示
                _this4.loadingInstance = _this4.$loading({
                  lock: true,
                  text: "正在审批中...",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    getQueueText: function getQueueText(queue_code) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _ref6, result, status;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(platform["l" /* getQueueText */])({
                  queue_code: queue_code
                });

              case 2:
                _ref6 = _context6.sent;
                result = _ref6.result;
                status = result.data.status;

                if (status === "success") {
                  // 关闭加载提示
                  _this5.loadingInstance.close();
                  clearInterval(_this5.timer);
                  // 显示成功提示
                  _this5.$notify({
                    title: "提示",
                    message: result.data.message,
                    type: "success"
                  });
                  _this5.page = 1;
                  _this5.todolist();
                } else if (status === "running") {
                  _this5.loadingInstance.text = result.data.message;
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf9983a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApprovalList.vue
var ApprovalList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.form_head_uuid === '403e15205bc248f48d8a3626571c4e56' &&
      _vm.orderList.length > 0
    )?_c('div',{staticClass:"batchBtn"},[(_vm.checkList.length > 0)?[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleBatchApproval(1)}}},[_vm._v("\n        批量通过\n      ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.handleBatchApproval(2)}}},[_vm._v("批量驳回")])]:[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleAllCheck()}}},[_vm._v(" 全选 ")])]],2):_vm._e(),_vm._v(" "),(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[(item.form_head_uuid === '436ae44d1c60475a9b4009ca40edc11e')?[_c('div',{staticClass:"orderHeader",on:{"click":function($event){return _vm.handleCheck(item)}}},[_c('div',[_c('span',{staticClass:"orderTime"},[_vm._v("\n                "+_vm._s(item.name)+"\n              ")])]),_vm._v(" "),(_vm.form_head_uuid === '403e15205bc248f48d8a3626571c4e56')?_c('el-checkbox',{attrs:{"value":_vm.checkItem(item)},on:{"change":function($event){return _vm.handleCheck(item)}}}):_vm._e()],1),_vm._v(" "),_vm._l((item.fields_value_json_show
              .cpimejxmehpaxrrz),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[_c('img',{attrs:{"src":order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                  ? order.mnkt8dkjryhvdej3[0].url
                  : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
                  order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4.length > 0
                )?_c('p',{on:{"click":function($event){$event.stopPropagation();return _vm.navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)}}},[_vm._v("\n                "+_vm._s(order.whfmbyuc1i2pavi4[0].value)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n              "+_vm._s('￥' + (order.rojkudmmvpzinpar || 0))+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n              "+_vm._s(order.mcuilzaudpe3shlc)+"\n              "+_vm._s(order.kq1qbbk7dulmlghs ? ("(" + (order.kq1qbbk7dulmlghs) + ")") : '')+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v(_vm._s('￥' + order.nvbfzg88gv88hnt9))])])})]:(
            item.form_head_uuid === '4b9b935758484c01bb3d8e2d1e08211f'
          )?[_c('div',{staticClass:"orderHeader",on:{"click":function($event){return _vm.handleCheck(item)}}},[_c('div',[_c('span',{staticClass:"orderTime"},[_vm._v("\n                "+_vm._s(item.fields_value_json_show.created_at)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n                "+_vm._s('单位商品唯一编码：' +
                  item.fields_value_json_show['cl0aot0gizkouc7p'])+"\n              ")])]),_vm._v(" "),(_vm.form_head_uuid === '403e15205bc248f48d8a3626571c4e56')?_c('el-checkbox',{attrs:{"value":_vm.checkItem(item)},on:{"change":function($event){return _vm.handleCheck(item)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"orderDetail"},[_c('img',{attrs:{"src":item.fields_value_json_show.in7kxcfnzrfwav2r &&
                item.fields_value_json_show.in7kxcfnzrfwav2r.length > 0
                  ? item.fields_value_json_show.in7kxcfnzrfwav2r[0].url
                  : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[_c('p',{on:{"click":function($event){$event.stopPropagation();return _vm.navTo('/mall/goods/' + item.fields_value_json_show.id)}}},[_vm._v("\n                "+_vm._s(item.fields_value_json_show['6qujfllbbkwsj6t1'].length >
                    0 && item.fields_value_json_show['6qujfllbbkwsj6t1'][0]
                    ? item.fields_value_json_show['6qujfllbbkwsj6t1'][0].value
                    : '')+"\n              ")])]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n              "+_vm._s('￥' + (item.fields_value_json_show.f93blbqlvdtdt65v || 0))+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n              1\n              "+_vm._s(item.fields_value_json_show.y8cegh2yyvvqbzwo
                  ? ("(" + (item.fields_value_json_show.y8cegh2yyvvqbzwo) + ")")
                  : '')+"\n            ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"orderfooter"},[(item.fields_value_json_show.p6zxciihiw61mebe)?_c('div',[[_vm._v("\n              总金额："+_vm._s('￥' + item.fields_value_json_show.p6zxciihiw61mebe)+"\n            ")]],2):_vm._e(),_vm._v(" "),_c('div',[(_vm.form_head_uuid === '403e15205bc248f48d8a3626571c4e56')?[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleApproval(item, 1)}}},[_vm._v("\n                通过\n              ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.handleApproval(item, 2)}}},[_vm._v(" 驳回 ")])]:_vm._e()],2)])],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])])}
var ApprovalList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("数量")]),_vm._v(" "),_c('span',[_vm._v("总价")])])}]
var ApprovalList_esExports = { render: ApprovalList_render, staticRenderFns: ApprovalList_staticRenderFns }
/* harmony default export */ var components_ApprovalList = (ApprovalList_esExports);
// CONCATENATED MODULE: ./src/components/ApprovalList.vue
function ApprovalList_injectStyle (ssrContext) {
  __webpack_require__("9S9a")
}
var ApprovalList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ApprovalList___vue_template_functional__ = false
/* styles */
var ApprovalList___vue_styles__ = ApprovalList_injectStyle
/* scopeId */
var ApprovalList___vue_scopeId__ = "data-v-0cf9983a"
/* moduleIdentifier (server only) */
var ApprovalList___vue_module_identifier__ = null
var ApprovalList_Component = ApprovalList_normalizeComponent(
  ApprovalList,
  components_ApprovalList,
  ApprovalList___vue_template_functional__,
  ApprovalList___vue_styles__,
  ApprovalList___vue_scopeId__,
  ApprovalList___vue_module_identifier__
)

/* harmony default export */ var src_components_ApprovalList = (ApprovalList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/MyOrder.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MyOrder = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */],
    ApprovalList: src_components_ApprovalList
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{ name: "全部订单", form_head_uuid: "58a2be48484e436dbbb28fd778406de6" }, { name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" }, { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de" }, { name: "审核失败", form_head_uuid: "33d336e546644de7afb25e1989757d93" }, { name: "待发货", form_head_uuid: "42c3b2c71c83420095614efde43e4cea" }, { name: "待收货", form_head_uuid: "7713093266f64911bb3ef4b14c58affc" }, { name: "已完成", form_head_uuid: "e9667bbbf7d942cea48e531fd58b7142" }],
      status: [{
        color: "#B5BAC2",
        label: "待审批",
        value: "989059b3-6972-4174-8f34-cdc5699bcb8f",
        front_color: "#fff"
      }, {
        color: "#629FF1",
        label: "审批中",
        value: "02c5ca9e-3252-456e-8d51-6ff370f4b2c8",
        front_color: "#fff"
      }, {
        color: "#76D375",
        label: "审批成功",
        value: "bf8f4aa2-016c-488f-9732-5ab12d354d69",
        front_color: "#fff"
      }, {
        color: "#FA7066",
        label: "审批驳回",
        value: "8abf497b-d388-4ea5-a2f2-2813578853f9",
        front_color: "#fff"
      }, {
        color: "#F7C844",
        label: "待总集确认",
        value: "adb2fb19-66e7-4445-918e-5da857fb474c",
        front_color: "#fff"
      }, {
        color: "#FFE5B1",
        label: "总集已确认",
        value: "a225c470-4d40-4c37-9870-09726155a478",
        front_color: "#fff"
      }],
      form_head_uuid: "58a2be48484e436dbbb28fd778406de6",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      show: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getOrderList();
  },

  methods: {
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, page, limit, _ref, meta, result, list;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this.form_head_uuid, page = _this.page, limit = _this.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: page,
                  limit: limit,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref = _context2.sent;
                meta = _ref.meta;
                result = _ref.result;
                _context2.next = 8;
                return promise_default.a.all(result.map(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(el) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = extends_default.a;
                            _context.t1 = {};
                            _context.t2 = el;
                            _context.next = 5;
                            return _this.children(el.id);

                          case 5:
                            _context.t3 = _context.sent;
                            _context.t4 = {
                              cpimejxmehpaxrrz: _context.t3
                            };
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t4));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 8:
                list = _context2.sent;

                _this.orderList = list;
                _this.total = meta.total;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },

    // 获取子表数据
    children: function children(record_id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid, _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;
                _context3.next = 3;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 100,
                  field_uuid: "00f98dceac054e8fb727092a99fc5a3d",
                  form_head_uuid: form_head_uuid,
                  record_id: record_id
                });

              case 3:
                _ref3 = _context3.sent;
                result = _ref3.result;
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex: function changeIndex(form_head_uuid) {
      var _this3 = this;

      this.page = 1;
      this.form_head_uuid = form_head_uuid;

      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        setTimeout(function () {
          _this3.show = true;
        }, 300);
      } else {
        this.show = true;
        this.getOrderList();
      }
    },
    navTo: function navTo(route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid
      });
    },


    // 确认收货
    confirmReceiptGoods: function confirmReceiptGoods(_ref4) {
      var _this4 = this;

      var id = _ref4.id;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "ab6a5764-7f39-43d9-b4f9-6d47a3ea30b8",
                  form_head_uuid: "7713093266f64911bb3ef4b14c58affc",
                  id: id,
                  type: 2
                });

              case 2:
                _this4.page = 1;
                _this4.$notify({
                  title: "提示",
                  message: "收货成功",
                  type: "success"
                });
                setTimeout(function () {
                  _this4.getOrderList();
                }, 2000);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    initiateAudit: function initiateAudit(_ref5) {
      var _this5 = this;

      var id = _ref5.id;

      this.$confirm("确认要重新发起审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "e5740381-1dae-49c4-aaa9-5f35f8df10c6",
                  form_head_uuid: "7713093266f64911bb3ef4b14c58affc",
                  id: id,
                  type: 2
                });

              case 2:
                _this5.$notify({
                  title: "提示",
                  message: "发起成功",
                  type: "success"
                });
                _this5.page = 1;
                setTimeout(function () {
                  _this5.getOrderList();
                }, 2000);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))).catch(function () {});
    },

    // 取消订单
    cancelAnOrder: function cancelAnOrder(_ref7) {
      var _this6 = this;

      var id = _ref7.id;

      this.$confirm("确认要取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "7b388e44-8bfb-4fb7-b312-a03a1bca2369",
                  form_head_uuid: _this6.form_head_uuid,
                  id: id,
                  type: 2
                });

              case 2:
                _this6.$notify({
                  title: "提示",
                  message: "取消订单成功",
                  type: "success"
                });
                setTimeout(function () {
                  _this6.getOrderList();
                  _this6.getFormRowApproveList(id);
                }, 2000);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      })));
    },
    getFormRowApproveList: function getFormRowApproveList(form_row_uuid) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _ref9, result;

        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(platform["i" /* getFormRowApproveList */])({
                  applicationid: '270ab0c29e5411ee9b8b0242321230b4',
                  form_uuid: '436ae44d1c60475a9b4009ca40edc11e',
                  form_row_uuid: form_row_uuid
                });

              case 2:
                _ref9 = _context7.sent;
                result = _ref9.result;

                if (result.data && result.data.list && result.data.list.length > 0) {
                  _this7.setApproveClose(result.data.list[0].id);
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    setApproveClose: function setApproveClose(approve_id) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(platform["r" /* setApproveClose */])({
                  applicationid: '270ab0c29e5411ee9b8b0242321230b4',
                  approve_id: approve_id
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ddb39a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/MyOrder.vue
var MyOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.show)?[(
        [
          '403e15205bc248f48d8a3626571c4e56',
          '91e9bb4eac0a48b38e8327cc9c6c23de',
          '33d336e546644de7afb25e1989757d93'
        ].includes(_vm.form_head_uuid)
      )?_c('ApprovalList',{attrs:{"form_head_uuid":_vm.form_head_uuid}}):[(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("数量")]),_vm._v(" "),_c('span',[_vm._v("总价")])]),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderHeader"},[_c('span',{staticClass:"orderTime"},[_vm._v(_vm._s(item.l0u3cwjsdrbnhuth))]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n                "+_vm._s('订单号：' + item['5rh34ajk852uufsx'])+"\n              ")])]),_vm._v(" "),_vm._l((item.cpimejxmehpaxrrz),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[_c('img',{attrs:{"src":order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                    ? order.mnkt8dkjryhvdej3[0].url
                    : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
                    order.whfmbyuc1i2pavi4 &&
                    order.whfmbyuc1i2pavi4.length > 0
                  )?_c('p',{on:{"click":function($event){$event.stopPropagation();return _vm.navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)}}},[_vm._v("\n                  "+_vm._s(order.whfmbyuc1i2pavi4[0].value)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n                "+_vm._s('￥' + (order.rojkudmmvpzinpar || 0))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n                "+_vm._s(order.mcuilzaudpe3shlc)+"\n                "+_vm._s(order.kq1qbbk7dulmlghs ? ("(" + (order.kq1qbbk7dulmlghs) + ")") : '')+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v(_vm._s('￥' + order.nvbfzg88gv88hnt9))]),_vm._v(" "),(idx === 0)?_c('span',{staticClass:"status"},[(
                    item.skwyvudrzzk6oljg ===
                    '6773a3b6-26c8-41d9-a2fe-26d73f0fa8f8'
                  )?_c('img',{attrs:{"src":__webpack_require__("LD89"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    'ed990658-9190-491e-bc87-8311a7dcb31c'
                  )?_c('img',{attrs:{"src":__webpack_require__("g/q1"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    'a84d211b-2bc0-4c24-8a45-01fc249e5a5a'
                  )?_c('img',{attrs:{"src":__webpack_require__("KctQ"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'
                  )?_c('img',{attrs:{"src":__webpack_require__("+iw8"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    '898c47e2-acdc-41a7-b63b-c42cc1eda346'
                  )?_c('img',{attrs:{"src":__webpack_require__("RtwJ"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    'b2434af8-3618-4a37-aeb2-55aea65f3bb6'
                  )?_c('img',{attrs:{"src":__webpack_require__("E6M5"),"alt":""}}):(
                    item.lzmpjqms8ynktnxi ===
                    '02c5ca9e-3252-456e-8d51-6ff370f4b2c8'
                  )?_c('img',{attrs:{"src":__webpack_require__("0hov"),"alt":""}}):(
                    item.lzmpjqms8ynktnxi ===
                    'bf8f4aa2-016c-488f-9732-5ab12d354d69'
                  )?_c('img',{attrs:{"src":__webpack_require__("Et7L"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                  )?_c('img',{attrs:{"src":__webpack_require__("FPOz"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(idx === 0)?[(
                    item.lzmpjqms8ynktnxi ===
                    '8abf497b-d388-4ea5-a2f2-2813578853f9'
                  )?_c('button',{on:{"click":function($event){return _vm.initiateAudit(item)}}},[_vm._v("\n                  发起审核\n                ")]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),_c('div',{staticClass:"orderfooter"},[_c('div',[[_vm._v("\n                  总金额："+_vm._s('￥' + item.p6zxciihiw61mebe)+"\n                ")]],2),_vm._v(" "),_c('div',[(
                    item.skwyvudrzzk6oljg ===
                    '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'
                  )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.confirmReceiptGoods(item)}}},[_vm._v("\n                  确认收货\n                ")]):_vm._e(),_vm._v(" "),(
                    item.skwyvudrzzk6oljg ===
                    '898c47e2-acdc-41a7-b63b-c42cc1eda346'
                  )?[(
                      item.b8lqe9bvzid6twwc !==
                        'f16a9ec4-ef71-4b9c-aa85-f02d1b440226' &&
                      (item.aliweixqekq3uo2s !==
                        '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' ||
                        item.kgwambu2gnj2clcn ===
                          'fa090b14-a3ee-4eac-89c2-32cfc12c5619')
                    )?_c('el-button',{on:{"click":function($event){return _vm.navTo(("/mall/orderDetail/" + (item.id) + "?type=returnGoods"))}}},[_vm._v("\n                    退货\n                  ")]):_vm._e(),_vm._v(" "),(
                      item.aliweixqekq3uo2s !==
                        '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' &&
                      item.b8lqe9bvzid6twwc !==
                        'f16a9ec4-ef71-4b9c-aa85-f02d1b440226'
                    )?_c('el-button',{on:{"click":function($event){return _vm.navTo(("/mall/orderDetail/" + (item.id) + "?type=barter"))}}},[_vm._v("\n                    换货\n                  ")]):_vm._e()]:_vm._e(),_vm._v(" "),(
                    [
                      'a84d211b-2bc0-4c24-8a45-01fc249e5a5a',
                      'ed990658-9190-491e-bc87-8311a7dcb31c',
                      '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                    ].includes(item.skwyvudrzzk6oljg)
                  )?_c('el-button',{on:{"click":function($event){return _vm.cancelAnOrder(item)}}},[_vm._v("\n                  取消订单 "+_vm._s(item.lzmpjqms8ynktnxi)+"\n                ")]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.navTo('/mall/orderDetail/' + item.id)}}},[_vm._v("\n                  查看详情\n                ")])],2)])],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])]]:_vm._e()],2)}
var MyOrder_staticRenderFns = []
var MyOrder_esExports = { render: MyOrder_render, staticRenderFns: MyOrder_staticRenderFns }
/* harmony default export */ var client_MyOrder = (MyOrder_esExports);
// CONCATENATED MODULE: ./src/pages/client/MyOrder.vue
function MyOrder_injectStyle (ssrContext) {
  __webpack_require__("p35m")
}
var MyOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MyOrder___vue_template_functional__ = false
/* styles */
var MyOrder___vue_styles__ = MyOrder_injectStyle
/* scopeId */
var MyOrder___vue_scopeId__ = "data-v-2ddb39a0"
/* moduleIdentifier (server only) */
var MyOrder___vue_module_identifier__ = null
var MyOrder_Component = MyOrder_normalizeComponent(
  MyOrder,
  client_MyOrder,
  MyOrder___vue_template_functional__,
  MyOrder___vue_styles__,
  MyOrder___vue_scopeId__,
  MyOrder___vue_module_identifier__
)

/* harmony default export */ var pages_client_MyOrder = (MyOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Shelves.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Shelves = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */],
    ApprovalList: src_components_ApprovalList
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{ name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" }, { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de" }, { name: "审核失败", form_head_uuid: "33d336e546644de7afb25e1989757d93" }],
      status: [{
        color: "#B5BAC2",
        label: "待审批",
        value: "989059b3-6972-4174-8f34-cdc5699bcb8f",
        front_color: "#fff"
      }, {
        color: "#629FF1",
        label: "审批中",
        value: "02c5ca9e-3252-456e-8d51-6ff370f4b2c8",
        front_color: "#fff"
      }, {
        color: "#76D375",
        label: "审批成功",
        value: "bf8f4aa2-016c-488f-9732-5ab12d354d69",
        front_color: "#fff"
      }, {
        color: "#FA7066",
        label: "审批驳回",
        value: "8abf497b-d388-4ea5-a2f2-2813578853f9",
        front_color: "#fff"
      }, {
        color: "#F7C844",
        label: "待总集确认",
        value: "adb2fb19-66e7-4445-918e-5da857fb474c",
        front_color: "#fff"
      }, {
        color: "#FFE5B1",
        label: "总集已确认",
        value: "a225c470-4d40-4c37-9870-09726155a478",
        front_color: "#fff"
      }],
      form_head_uuid: "403e15205bc248f48d8a3626571c4e56",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      show: true
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    changeIndex: function changeIndex(form_head_uuid) {
      var _this = this;

      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        setTimeout(function () {
          _this.show = true;
        }, 300);
      }
    },
    navTo: function navTo(route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5751e68e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Shelves.vue
var Shelves_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.show)?[(
        [
          '403e15205bc248f48d8a3626571c4e56',
          '91e9bb4eac0a48b38e8327cc9c6c23de',
          '33d336e546644de7afb25e1989757d93'
        ].includes(_vm.form_head_uuid)
      )?_c('ApprovalList',{attrs:{"form_id":"4b9b935758484c01bb3d8e2d1e08211f","form_head_uuid":_vm.form_head_uuid}}):[(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("数量")])]),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderHeader"},[_c('span',{staticClass:"orderTime"},[_vm._v(_vm._s(item.l0u3cwjsdrbnhuth))]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n                "+_vm._s('订单号：' + item['5rh34ajk852uufsx'])+"\n              ")])]),_vm._v(" "),_vm._l((item.cpimejxmehpaxrrz),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[_c('img',{attrs:{"src":order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                    ? order.mnkt8dkjryhvdej3[0].url
                    : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
                    order.whfmbyuc1i2pavi4 &&
                    order.whfmbyuc1i2pavi4.length > 0
                  )?_c('p',{on:{"click":function($event){$event.stopPropagation();return _vm.navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)}}},[_vm._v("\n                  "+_vm._s(order.whfmbyuc1i2pavi4[0].value)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n                "+_vm._s('￥' + (order.rojkudmmvpzinpar || 0))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n                "+_vm._s(order.mcuilzaudpe3shlc)+"\n                "+_vm._s(order.kq1qbbk7dulmlghs ? ("(" + (order.kq1qbbk7dulmlghs) + ")") : '')+"\n              ")]),_vm._v(" "),(idx === 0)?_c('span',{staticClass:"status"},[(
                    item.skwyvudrzzk6oljg ===
                    '6773a3b6-26c8-41d9-a2fe-26d73f0fa8f8'
                  )?_c('img',{attrs:{"src":__webpack_require__("LD89"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    'ed990658-9190-491e-bc87-8311a7dcb31c'
                  )?_c('img',{attrs:{"src":__webpack_require__("g/q1"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    'a84d211b-2bc0-4c24-8a45-01fc249e5a5a'
                  )?_c('img',{attrs:{"src":__webpack_require__("KctQ"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'
                  )?_c('img',{attrs:{"src":__webpack_require__("+iw8"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    '898c47e2-acdc-41a7-b63b-c42cc1eda346'
                  )?_c('img',{attrs:{"src":__webpack_require__("RtwJ"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    'b2434af8-3618-4a37-aeb2-55aea65f3bb6'
                  )?_c('img',{attrs:{"src":__webpack_require__("E6M5"),"alt":""}}):(
                    item.lzmpjqms8ynktnxi ===
                    '02c5ca9e-3252-456e-8d51-6ff370f4b2c8'
                  )?_c('img',{attrs:{"src":__webpack_require__("0hov"),"alt":""}}):(
                    item.lzmpjqms8ynktnxi ===
                    'bf8f4aa2-016c-488f-9732-5ab12d354d69'
                  )?_c('img',{attrs:{"src":__webpack_require__("Et7L"),"alt":""}}):(
                    item.skwyvudrzzk6oljg ===
                    '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                  )?_c('img',{attrs:{"src":__webpack_require__("FPOz"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(idx === 0)?[(
                    item.lzmpjqms8ynktnxi ===
                    '8abf497b-d388-4ea5-a2f2-2813578853f9'
                  )?_c('button',{on:{"click":function($event){return _vm.initiateAudit(item)}}},[_vm._v("\n                  发起审核\n                ")]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),_c('div',{staticClass:"orderfooter"},[(
                  item.skwyvudrzzk6oljg ===
                  '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'
                )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.confirmReceiptGoods(item)}}},[_vm._v("\n                确认收货\n              ")]):_vm._e(),_vm._v(" "),(
                  item.skwyvudrzzk6oljg ===
                  '898c47e2-acdc-41a7-b63b-c42cc1eda346'
                )?[(
                    item.b8lqe9bvzid6twwc !==
                      'f16a9ec4-ef71-4b9c-aa85-f02d1b440226' &&
                    (item.aliweixqekq3uo2s !==
                      '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' ||
                      item.kgwambu2gnj2clcn ===
                        'fa090b14-a3ee-4eac-89c2-32cfc12c5619')
                  )?_c('el-button',{on:{"click":function($event){return _vm.navTo(("/mall/orderDetail/" + (item.id) + "?type=returnGoods"))}}},[_vm._v("\n                  退货\n                ")]):_vm._e(),_vm._v(" "),(
                    item.aliweixqekq3uo2s !==
                      '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' &&
                    item.b8lqe9bvzid6twwc !==
                      'f16a9ec4-ef71-4b9c-aa85-f02d1b440226'
                  )?_c('el-button',{on:{"click":function($event){return _vm.navTo(("/mall/orderDetail/" + (item.id) + "?type=barter"))}}},[_vm._v("\n                  换货\n                ")]):_vm._e()]:_vm._e(),_vm._v(" "),(
                  [
                    'a84d211b-2bc0-4c24-8a45-01fc249e5a5a',
                    'ed990658-9190-491e-bc87-8311a7dcb31c',
                    '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                  ].includes(item.skwyvudrzzk6oljg)
                )?_c('el-button',{on:{"click":function($event){return _vm.cancelAnOrder(item)}}},[_vm._v("\n                取消订单 "+_vm._s(item.lzmpjqms8ynktnxi)+"\n              ")]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.navTo('/mall/orderDetail/' + item.id)}}},[_vm._v("\n                查看详情\n              ")])],2)],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])]]:_vm._e()],2)}
var Shelves_staticRenderFns = []
var Shelves_esExports = { render: Shelves_render, staticRenderFns: Shelves_staticRenderFns }
/* harmony default export */ var client_Shelves = (Shelves_esExports);
// CONCATENATED MODULE: ./src/pages/client/Shelves.vue
function Shelves_injectStyle (ssrContext) {
  __webpack_require__("b9+s")
}
var Shelves_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Shelves___vue_template_functional__ = false
/* styles */
var Shelves___vue_styles__ = Shelves_injectStyle
/* scopeId */
var Shelves___vue_scopeId__ = "data-v-5751e68e"
/* moduleIdentifier (server only) */
var Shelves___vue_module_identifier__ = null
var Shelves_Component = Shelves_normalizeComponent(
  Shelves,
  client_Shelves,
  Shelves___vue_template_functional__,
  Shelves___vue_styles__,
  Shelves___vue_scopeId__,
  Shelves___vue_module_identifier__
)

/* harmony default export */ var pages_client_Shelves = (Shelves_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Purchase.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Purchase = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */],
    ApprovalList: src_components_ApprovalList
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{ name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" }, { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de" }, { name: "审核失败", form_head_uuid: "33d336e546644de7afb25e1989757d93" }],
      form_head_uuid: "403e15205bc248f48d8a3626571c4e56",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      show: true
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    changeIndex: function changeIndex(form_head_uuid) {
      var _this = this;

      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        setTimeout(function () {
          _this.show = true;
        }, 300);
      }
    },
    navTo: function navTo(route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4e5234","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Purchase.vue
var Purchase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.show)?[(
        [
          '403e15205bc248f48d8a3626571c4e56',
          '91e9bb4eac0a48b38e8327cc9c6c23de',
          '33d336e546644de7afb25e1989757d93'
        ].includes(_vm.form_head_uuid)
      )?_c('ApprovalList',{attrs:{"form_id":"436ae44d1c60475a9b4009ca40edc11e","form_head_uuid":_vm.form_head_uuid}}):_vm._e()]:_vm._e()],2)}
var Purchase_staticRenderFns = []
var Purchase_esExports = { render: Purchase_render, staticRenderFns: Purchase_staticRenderFns }
/* harmony default export */ var client_Purchase = (Purchase_esExports);
// CONCATENATED MODULE: ./src/pages/client/Purchase.vue
function Purchase_injectStyle (ssrContext) {
  __webpack_require__("yLoF")
}
var Purchase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Purchase___vue_template_functional__ = false
/* styles */
var Purchase___vue_styles__ = Purchase_injectStyle
/* scopeId */
var Purchase___vue_scopeId__ = "data-v-7e4e5234"
/* moduleIdentifier (server only) */
var Purchase___vue_module_identifier__ = null
var Purchase_Component = Purchase_normalizeComponent(
  Purchase,
  client_Purchase,
  Purchase___vue_template_functional__,
  Purchase___vue_styles__,
  Purchase___vue_scopeId__,
  Purchase___vue_module_identifier__
)

/* harmony default export */ var pages_client_Purchase = (Purchase_Component.exports);

// CONCATENATED MODULE: ./src/util/city.js
/* eslint-disable */
var city = [{
	"id": 110,
	"name": "北京市",
	"children": [{
		"id": 110000,
		"name": "北京市",
		"parentId": 110,
		"children": [{
			"id": 110101,
			"name": "东城区",
			"parentId": 110000
		}, {
			"id": 110102,
			"name": "西城区",
			"parentId": 110000
		}, {
			"id": 110105,
			"name": "朝阳区",
			"parentId": 110000
		}, {
			"id": 110106,
			"name": "丰台区",
			"parentId": 110000
		}, {
			"id": 110107,
			"name": "石景山区",
			"parentId": 110000
		}, {
			"id": 110108,
			"name": "海淀区",
			"parentId": 110000
		}, {
			"id": 110109,
			"name": "门头沟区",
			"parentId": 110000
		}, {
			"id": 110111,
			"name": "房山区",
			"parentId": 110000
		}, {
			"id": 110112,
			"name": "通州区",
			"parentId": 110000
		}, {
			"id": 110113,
			"name": "顺义区",
			"parentId": 110000
		}, {
			"id": 110114,
			"name": "昌平区",
			"parentId": 110000
		}, {
			"id": 110115,
			"name": "大兴区",
			"parentId": 110000
		}, {
			"id": 110116,
			"name": "怀柔区",
			"parentId": 110000
		}, {
			"id": 110117,
			"name": "平谷区",
			"parentId": 110000
		}, {
			"id": 110118,
			"name": "密云区",
			"parentId": 110000
		}, {
			"id": 110119,
			"name": "延庆区",
			"parentId": 110000
		}]
	}]
}, {
	"id": 120,
	"name": "天津市",
	"children": [{
		"id": 120000,
		"name": "天津市",
		"parentId": 120,
		"children": [{
			"id": 120101,
			"name": "和平区",
			"parentId": 120000
		}, {
			"id": 120102,
			"name": "河东区",
			"parentId": 120000
		}, {
			"id": 120103,
			"name": "河西区",
			"parentId": 120000
		}, {
			"id": 120104,
			"name": "南开区",
			"parentId": 120000
		}, {
			"id": 120105,
			"name": "河北区",
			"parentId": 120000
		}, {
			"id": 120106,
			"name": "红桥区",
			"parentId": 120000
		}, {
			"id": 120110,
			"name": "东丽区",
			"parentId": 120000
		}, {
			"id": 120111,
			"name": "西青区",
			"parentId": 120000
		}, {
			"id": 120112,
			"name": "津南区",
			"parentId": 120000
		}, {
			"id": 120113,
			"name": "北辰区",
			"parentId": 120000
		}, {
			"id": 120114,
			"name": "武清区",
			"parentId": 120000
		}, {
			"id": 120115,
			"name": "宝坻区",
			"parentId": 120000
		}, {
			"id": 120116,
			"name": "滨海新区",
			"parentId": 120000
		}, {
			"id": 120117,
			"name": "宁河区",
			"parentId": 120000
		}, {
			"id": 120118,
			"name": "静海区",
			"parentId": 120000
		}, {
			"id": 120119,
			"name": "蓟州区",
			"parentId": 120000
		}]
	}]
}, {
	"id": 130,
	"name": "河北省",
	"children": [{
		"id": 130100,
		"name": "石家庄市",
		"parentId": 130,
		"children": [{
			"id": 130102,
			"name": "长安区",
			"parentId": 130100
		}, {
			"id": 130104,
			"name": "桥西区",
			"parentId": 130100
		}, {
			"id": 130105,
			"name": "新华区",
			"parentId": 130100
		}, {
			"id": 130107,
			"name": "井陉矿区",
			"parentId": 130100
		}, {
			"id": 130108,
			"name": "裕华区",
			"parentId": 130100
		}, {
			"id": 130109,
			"name": "藁城区",
			"parentId": 130100
		}, {
			"id": 130110,
			"name": "鹿泉区",
			"parentId": 130100
		}, {
			"id": 130111,
			"name": "栾城区",
			"parentId": 130100
		}, {
			"id": 130121,
			"name": "井陉县",
			"parentId": 130100
		}, {
			"id": 130123,
			"name": "正定县",
			"parentId": 130100
		}, {
			"id": 130125,
			"name": "行唐县",
			"parentId": 130100
		}, {
			"id": 130126,
			"name": "灵寿县",
			"parentId": 130100
		}, {
			"id": 130127,
			"name": "高邑县",
			"parentId": 130100
		}, {
			"id": 130128,
			"name": "深泽县",
			"parentId": 130100
		}, {
			"id": 130129,
			"name": "赞皇县",
			"parentId": 130100
		}, {
			"id": 130130,
			"name": "无极县",
			"parentId": 130100
		}, {
			"id": 130131,
			"name": "平山县",
			"parentId": 130100
		}, {
			"id": 130132,
			"name": "元氏县",
			"parentId": 130100
		}, {
			"id": 130133,
			"name": "赵县",
			"parentId": 130100
		}, {
			"id": 130183,
			"name": "晋州市",
			"parentId": 130100
		}, {
			"id": 130184,
			"name": "新乐市",
			"parentId": 130100
		}]
	}, {
		"id": 130200,
		"name": "唐山市",
		"parentId": 130,
		"children": [{
			"id": 130202,
			"name": "路南区",
			"parentId": 130200
		}, {
			"id": 130203,
			"name": "路北区",
			"parentId": 130200
		}, {
			"id": 130204,
			"name": "古冶区",
			"parentId": 130200
		}, {
			"id": 130205,
			"name": "开平区",
			"parentId": 130200
		}, {
			"id": 130207,
			"name": "丰南区",
			"parentId": 130200
		}, {
			"id": 130208,
			"name": "丰润区",
			"parentId": 130200
		}, {
			"id": 130209,
			"name": "曹妃甸区",
			"parentId": 130200
		}, {
			"id": 130223,
			"name": "滦县",
			"parentId": 130200
		}, {
			"id": 130224,
			"name": "滦南县",
			"parentId": 130200
		}, {
			"id": 130225,
			"name": "乐亭县",
			"parentId": 130200
		}, {
			"id": 130227,
			"name": "迁西县",
			"parentId": 130200
		}, {
			"id": 130229,
			"name": "玉田县",
			"parentId": 130200
		}, {
			"id": 130281,
			"name": "遵化市",
			"parentId": 130200
		}, {
			"id": 130283,
			"name": "迁安市",
			"parentId": 130200
		}]
	}, {
		"id": 130300,
		"name": "秦皇岛市",
		"parentId": 130,
		"children": [{
			"id": 130302,
			"name": "海港区",
			"parentId": 130300
		}, {
			"id": 130303,
			"name": "山海关区",
			"parentId": 130300
		}, {
			"id": 130304,
			"name": "北戴河区",
			"parentId": 130300
		}, {
			"id": 130306,
			"name": "抚宁区",
			"parentId": 130300
		}, {
			"id": 130321,
			"name": "青龙满族自治县",
			"parentId": 130300
		}, {
			"id": 130322,
			"name": "昌黎县",
			"parentId": 130300
		}, {
			"id": 130324,
			"name": "卢龙县",
			"parentId": 130300
		}]
	}, {
		"id": 130400,
		"name": "邯郸市",
		"parentId": 130,
		"children": [{
			"id": 130402,
			"name": "邯山区",
			"parentId": 130400
		}, {
			"id": 130403,
			"name": "丛台区",
			"parentId": 130400
		}, {
			"id": 130404,
			"name": "复兴区",
			"parentId": 130400
		}, {
			"id": 130406,
			"name": "峰峰矿区",
			"parentId": 130400
		}, {
			"id": 130407,
			"name": "肥乡区",
			"parentId": 130400
		}, {
			"id": 130408,
			"name": "永年区",
			"parentId": 130400
		}, {
			"id": 130423,
			"name": "临漳县",
			"parentId": 130400
		}, {
			"id": 130424,
			"name": "成安县",
			"parentId": 130400
		}, {
			"id": 130425,
			"name": "大名县",
			"parentId": 130400
		}, {
			"id": 130426,
			"name": "涉县",
			"parentId": 130400
		}, {
			"id": 130427,
			"name": "磁县",
			"parentId": 130400
		}, {
			"id": 130430,
			"name": "邱县",
			"parentId": 130400
		}, {
			"id": 130431,
			"name": "鸡泽县",
			"parentId": 130400
		}, {
			"id": 130432,
			"name": "广平县",
			"parentId": 130400
		}, {
			"id": 130433,
			"name": "馆陶县",
			"parentId": 130400
		}, {
			"id": 130434,
			"name": "魏县",
			"parentId": 130400
		}, {
			"id": 130435,
			"name": "曲周县",
			"parentId": 130400
		}, {
			"id": 130481,
			"name": "武安市",
			"parentId": 130400
		}]
	}, {
		"id": 130500,
		"name": "邢台市",
		"parentId": 130,
		"children": [{
			"id": 130502,
			"name": "桥东区",
			"parentId": 130500
		}, {
			"id": 130503,
			"name": "桥西区",
			"parentId": 130500
		}, {
			"id": 130521,
			"name": "邢台县",
			"parentId": 130500
		}, {
			"id": 130522,
			"name": "临城县",
			"parentId": 130500
		}, {
			"id": 130523,
			"name": "内丘县",
			"parentId": 130500
		}, {
			"id": 130524,
			"name": "柏乡县",
			"parentId": 130500
		}, {
			"id": 130525,
			"name": "隆尧县",
			"parentId": 130500
		}, {
			"id": 130526,
			"name": "任县",
			"parentId": 130500
		}, {
			"id": 130527,
			"name": "南和县",
			"parentId": 130500
		}, {
			"id": 130528,
			"name": "宁晋县",
			"parentId": 130500
		}, {
			"id": 130529,
			"name": "巨鹿县",
			"parentId": 130500
		}, {
			"id": 130530,
			"name": "新河县",
			"parentId": 130500
		}, {
			"id": 130531,
			"name": "广宗县",
			"parentId": 130500
		}, {
			"id": 130532,
			"name": "平乡县",
			"parentId": 130500
		}, {
			"id": 130533,
			"name": "威县",
			"parentId": 130500
		}, {
			"id": 130534,
			"name": "清河县",
			"parentId": 130500
		}, {
			"id": 130535,
			"name": "临西县",
			"parentId": 130500
		}, {
			"id": 130581,
			"name": "南宫市",
			"parentId": 130500
		}, {
			"id": 130582,
			"name": "沙河市",
			"parentId": 130500
		}]
	}, {
		"id": 130600,
		"name": "保定市",
		"parentId": 130,
		"children": [{
			"id": 130602,
			"name": "竞秀区",
			"parentId": 130600
		}, {
			"id": 130606,
			"name": "莲池区",
			"parentId": 130600
		}, {
			"id": 130607,
			"name": "满城区",
			"parentId": 130600
		}, {
			"id": 130608,
			"name": "清苑区",
			"parentId": 130600
		}, {
			"id": 130609,
			"name": "徐水区",
			"parentId": 130600
		}, {
			"id": 130623,
			"name": "涞水县",
			"parentId": 130600
		}, {
			"id": 130624,
			"name": "阜平县",
			"parentId": 130600
		}, {
			"id": 130626,
			"name": "定兴县",
			"parentId": 130600
		}, {
			"id": 130627,
			"name": "唐县",
			"parentId": 130600
		}, {
			"id": 130628,
			"name": "高阳县",
			"parentId": 130600
		}, {
			"id": 130629,
			"name": "容城县",
			"parentId": 130600
		}, {
			"id": 130630,
			"name": "涞源县",
			"parentId": 130600
		}, {
			"id": 130631,
			"name": "望都县",
			"parentId": 130600
		}, {
			"id": 130632,
			"name": "安新县",
			"parentId": 130600
		}, {
			"id": 130633,
			"name": "易县",
			"parentId": 130600
		}, {
			"id": 130634,
			"name": "曲阳县",
			"parentId": 130600
		}, {
			"id": 130635,
			"name": "蠡县",
			"parentId": 130600
		}, {
			"id": 130636,
			"name": "顺平县",
			"parentId": 130600
		}, {
			"id": 130637,
			"name": "博野县",
			"parentId": 130600
		}, {
			"id": 130638,
			"name": "雄县",
			"parentId": 130600
		}, {
			"id": 130681,
			"name": "涿州市",
			"parentId": 130600
		}, {
			"id": 130683,
			"name": "安国市",
			"parentId": 130600
		}, {
			"id": 130684,
			"name": "高碑店市",
			"parentId": 130600
		}]
	}, {
		"id": 130700,
		"name": "张家口市",
		"parentId": 130,
		"children": [{
			"id": 130702,
			"name": "桥东区",
			"parentId": 130700
		}, {
			"id": 130703,
			"name": "桥西区",
			"parentId": 130700
		}, {
			"id": 130705,
			"name": "宣化区",
			"parentId": 130700
		}, {
			"id": 130706,
			"name": "下花园区",
			"parentId": 130700
		}, {
			"id": 130708,
			"name": "万全区",
			"parentId": 130700
		}, {
			"id": 130709,
			"name": "崇礼区",
			"parentId": 130700
		}, {
			"id": 130722,
			"name": "张北县",
			"parentId": 130700
		}, {
			"id": 130723,
			"name": "康保县",
			"parentId": 130700
		}, {
			"id": 130724,
			"name": "沽源县",
			"parentId": 130700
		}, {
			"id": 130725,
			"name": "尚义县",
			"parentId": 130700
		}, {
			"id": 130726,
			"name": "蔚县",
			"parentId": 130700
		}, {
			"id": 130727,
			"name": "阳原县",
			"parentId": 130700
		}, {
			"id": 130728,
			"name": "怀安县",
			"parentId": 130700
		}, {
			"id": 130730,
			"name": "怀来县",
			"parentId": 130700
		}, {
			"id": 130731,
			"name": "涿鹿县",
			"parentId": 130700
		}, {
			"id": 130732,
			"name": "赤城县",
			"parentId": 130700
		}]
	}, {
		"id": 130800,
		"name": "承德市",
		"parentId": 130,
		"children": [{
			"id": 130802,
			"name": "双桥区",
			"parentId": 130800
		}, {
			"id": 130803,
			"name": "双滦区",
			"parentId": 130800
		}, {
			"id": 130804,
			"name": "鹰手营子矿区",
			"parentId": 130800
		}, {
			"id": 130821,
			"name": "承德县",
			"parentId": 130800
		}, {
			"id": 130822,
			"name": "兴隆县",
			"parentId": 130800
		}, {
			"id": 130824,
			"name": "滦平县",
			"parentId": 130800
		}, {
			"id": 130825,
			"name": "隆化县",
			"parentId": 130800
		}, {
			"id": 130826,
			"name": "丰宁满族自治县",
			"parentId": 130800
		}, {
			"id": 130827,
			"name": "宽城满族自治县",
			"parentId": 130800
		}, {
			"id": 130828,
			"name": "围场满族蒙古族自治县",
			"parentId": 130800
		}, {
			"id": 130881,
			"name": "平泉市",
			"parentId": 130800
		}]
	}, {
		"id": 130900,
		"name": "沧州市",
		"parentId": 130,
		"children": [{
			"id": 130902,
			"name": "新华区",
			"parentId": 130900
		}, {
			"id": 130903,
			"name": "运河区",
			"parentId": 130900
		}, {
			"id": 130921,
			"name": "沧县",
			"parentId": 130900
		}, {
			"id": 130922,
			"name": "青县",
			"parentId": 130900
		}, {
			"id": 130923,
			"name": "东光县",
			"parentId": 130900
		}, {
			"id": 130924,
			"name": "海兴县",
			"parentId": 130900
		}, {
			"id": 130925,
			"name": "盐山县",
			"parentId": 130900
		}, {
			"id": 130926,
			"name": "肃宁县",
			"parentId": 130900
		}, {
			"id": 130927,
			"name": "南皮县",
			"parentId": 130900
		}, {
			"id": 130928,
			"name": "吴桥县",
			"parentId": 130900
		}, {
			"id": 130929,
			"name": "献县",
			"parentId": 130900
		}, {
			"id": 130930,
			"name": "孟村回族自治县",
			"parentId": 130900
		}, {
			"id": 130981,
			"name": "泊头市",
			"parentId": 130900
		}, {
			"id": 130982,
			"name": "任丘市",
			"parentId": 130900
		}, {
			"id": 130983,
			"name": "黄骅市",
			"parentId": 130900
		}, {
			"id": 130984,
			"name": "河间市",
			"parentId": 130900
		}]
	}, {
		"id": 131000,
		"name": "廊坊市",
		"parentId": 130,
		"children": [{
			"id": 131002,
			"name": "安次区",
			"parentId": 131000
		}, {
			"id": 131003,
			"name": "广阳区",
			"parentId": 131000
		}, {
			"id": 131022,
			"name": "固安县",
			"parentId": 131000
		}, {
			"id": 131023,
			"name": "永清县",
			"parentId": 131000
		}, {
			"id": 131024,
			"name": "香河县",
			"parentId": 131000
		}, {
			"id": 131025,
			"name": "大城县",
			"parentId": 131000
		}, {
			"id": 131026,
			"name": "文安县",
			"parentId": 131000
		}, {
			"id": 131028,
			"name": "大厂回族自治县",
			"parentId": 131000
		}, {
			"id": 131081,
			"name": "霸州市",
			"parentId": 131000
		}, {
			"id": 131082,
			"name": "三河市",
			"parentId": 131000
		}]
	}, {
		"id": 131100,
		"name": "衡水市",
		"parentId": 130,
		"children": [{
			"id": 131102,
			"name": "桃城区",
			"parentId": 131100
		}, {
			"id": 131103,
			"name": "冀州区",
			"parentId": 131100
		}, {
			"id": 131121,
			"name": "枣强县",
			"parentId": 131100
		}, {
			"id": 131122,
			"name": "武邑县",
			"parentId": 131100
		}, {
			"id": 131123,
			"name": "武强县",
			"parentId": 131100
		}, {
			"id": 131124,
			"name": "饶阳县",
			"parentId": 131100
		}, {
			"id": 131125,
			"name": "安平县",
			"parentId": 131100
		}, {
			"id": 131126,
			"name": "故城县",
			"parentId": 131100
		}, {
			"id": 131127,
			"name": "景县",
			"parentId": 131100
		}, {
			"id": 131128,
			"name": "阜城县",
			"parentId": 131100
		}, {
			"id": 131182,
			"name": "深州市",
			"parentId": 131100
		}]
	}, {
		"id": 139001,
		"name": "定州市",
		"parentId": 130,
		"children": []
	}, {
		"id": 139002,
		"name": "辛集市",
		"parentId": 130,
		"children": []
	}]
}, {
	"id": 140,
	"name": "山西省",
	"children": [{
		"id": 140100,
		"name": "太原市",
		"parentId": 140,
		"children": [{
			"id": 140105,
			"name": "小店区",
			"parentId": 140100
		}, {
			"id": 140106,
			"name": "迎泽区",
			"parentId": 140100
		}, {
			"id": 140107,
			"name": "杏花岭区",
			"parentId": 140100
		}, {
			"id": 140108,
			"name": "尖草坪区",
			"parentId": 140100
		}, {
			"id": 140109,
			"name": "万柏林区",
			"parentId": 140100
		}, {
			"id": 140110,
			"name": "晋源区",
			"parentId": 140100
		}, {
			"id": 140121,
			"name": "清徐县",
			"parentId": 140100
		}, {
			"id": 140122,
			"name": "阳曲县",
			"parentId": 140100
		}, {
			"id": 140123,
			"name": "娄烦县",
			"parentId": 140100
		}, {
			"id": 140181,
			"name": "古交市",
			"parentId": 140100
		}]
	}, {
		"id": 140200,
		"name": "大同市",
		"parentId": 140,
		"children": [{
			"id": 140202,
			"name": "城区",
			"parentId": 140200
		}, {
			"id": 140203,
			"name": "矿区",
			"parentId": 140200
		}, {
			"id": 140211,
			"name": "南郊区",
			"parentId": 140200
		}, {
			"id": 140212,
			"name": "新荣区",
			"parentId": 140200
		}, {
			"id": 140221,
			"name": "阳高县",
			"parentId": 140200
		}, {
			"id": 140222,
			"name": "天镇县",
			"parentId": 140200
		}, {
			"id": 140223,
			"name": "广灵县",
			"parentId": 140200
		}, {
			"id": 140224,
			"name": "灵丘县",
			"parentId": 140200
		}, {
			"id": 140225,
			"name": "浑源县",
			"parentId": 140200
		}, {
			"id": 140226,
			"name": "左云县",
			"parentId": 140200
		}, {
			"id": 140227,
			"name": "大同县",
			"parentId": 140200
		}]
	}, {
		"id": 140300,
		"name": "阳泉市",
		"parentId": 140,
		"children": [{
			"id": 140302,
			"name": "城区",
			"parentId": 140300
		}, {
			"id": 140303,
			"name": "矿区",
			"parentId": 140300
		}, {
			"id": 140311,
			"name": "郊区",
			"parentId": 140300
		}, {
			"id": 140321,
			"name": "平定县",
			"parentId": 140300
		}, {
			"id": 140322,
			"name": "盂县",
			"parentId": 140300
		}]
	}, {
		"id": 140400,
		"name": "长治市",
		"parentId": 140,
		"children": [{
			"id": 140402,
			"name": "城区",
			"parentId": 140400
		}, {
			"id": 140411,
			"name": "郊区",
			"parentId": 140400
		}, {
			"id": 140421,
			"name": "长治县",
			"parentId": 140400
		}, {
			"id": 140423,
			"name": "襄垣县",
			"parentId": 140400
		}, {
			"id": 140424,
			"name": "屯留县",
			"parentId": 140400
		}, {
			"id": 140425,
			"name": "平顺县",
			"parentId": 140400
		}, {
			"id": 140426,
			"name": "黎城县",
			"parentId": 140400
		}, {
			"id": 140427,
			"name": "壶关县",
			"parentId": 140400
		}, {
			"id": 140428,
			"name": "长子县",
			"parentId": 140400
		}, {
			"id": 140429,
			"name": "武乡县",
			"parentId": 140400
		}, {
			"id": 140430,
			"name": "沁县",
			"parentId": 140400
		}, {
			"id": 140431,
			"name": "沁源县",
			"parentId": 140400
		}, {
			"id": 140481,
			"name": "潞城市",
			"parentId": 140400
		}]
	}, {
		"id": 140500,
		"name": "晋城市",
		"parentId": 140,
		"children": [{
			"id": 140502,
			"name": "城区",
			"parentId": 140500
		}, {
			"id": 140521,
			"name": "沁水县",
			"parentId": 140500
		}, {
			"id": 140522,
			"name": "阳城县",
			"parentId": 140500
		}, {
			"id": 140524,
			"name": "陵川县",
			"parentId": 140500
		}, {
			"id": 140525,
			"name": "泽州县",
			"parentId": 140500
		}, {
			"id": 140581,
			"name": "高平市",
			"parentId": 140500
		}]
	}, {
		"id": 140600,
		"name": "朔州市",
		"parentId": 140,
		"children": [{
			"id": 140602,
			"name": "朔城区",
			"parentId": 140600
		}, {
			"id": 140603,
			"name": "平鲁区",
			"parentId": 140600
		}, {
			"id": 140621,
			"name": "山阴县",
			"parentId": 140600
		}, {
			"id": 140622,
			"name": "应县",
			"parentId": 140600
		}, {
			"id": 140623,
			"name": "右玉县",
			"parentId": 140600
		}, {
			"id": 140624,
			"name": "怀仁县",
			"parentId": 140600
		}]
	}, {
		"id": 140700,
		"name": "晋中市",
		"parentId": 140,
		"children": [{
			"id": 140702,
			"name": "榆次区",
			"parentId": 140700
		}, {
			"id": 140721,
			"name": "榆社县",
			"parentId": 140700
		}, {
			"id": 140722,
			"name": "左权县",
			"parentId": 140700
		}, {
			"id": 140723,
			"name": "和顺县",
			"parentId": 140700
		}, {
			"id": 140724,
			"name": "昔阳县",
			"parentId": 140700
		}, {
			"id": 140725,
			"name": "寿阳县",
			"parentId": 140700
		}, {
			"id": 140726,
			"name": "太谷县",
			"parentId": 140700
		}, {
			"id": 140727,
			"name": "祁县",
			"parentId": 140700
		}, {
			"id": 140728,
			"name": "平遥县",
			"parentId": 140700
		}, {
			"id": 140729,
			"name": "灵石县",
			"parentId": 140700
		}, {
			"id": 140781,
			"name": "介休市",
			"parentId": 140700
		}]
	}, {
		"id": 140800,
		"name": "运城市",
		"parentId": 140,
		"children": [{
			"id": 140802,
			"name": "盐湖区",
			"parentId": 140800
		}, {
			"id": 140821,
			"name": "临猗县",
			"parentId": 140800
		}, {
			"id": 140822,
			"name": "万荣县",
			"parentId": 140800
		}, {
			"id": 140823,
			"name": "闻喜县",
			"parentId": 140800
		}, {
			"id": 140824,
			"name": "稷山县",
			"parentId": 140800
		}, {
			"id": 140825,
			"name": "新绛县",
			"parentId": 140800
		}, {
			"id": 140826,
			"name": "绛县",
			"parentId": 140800
		}, {
			"id": 140827,
			"name": "垣曲县",
			"parentId": 140800
		}, {
			"id": 140828,
			"name": "夏县",
			"parentId": 140800
		}, {
			"id": 140829,
			"name": "平陆县",
			"parentId": 140800
		}, {
			"id": 140830,
			"name": "芮城县",
			"parentId": 140800
		}, {
			"id": 140881,
			"name": "永济市",
			"parentId": 140800
		}, {
			"id": 140882,
			"name": "河津市",
			"parentId": 140800
		}]
	}, {
		"id": 140900,
		"name": "忻州市",
		"parentId": 140,
		"children": [{
			"id": 140902,
			"name": "忻府区",
			"parentId": 140900
		}, {
			"id": 140921,
			"name": "定襄县",
			"parentId": 140900
		}, {
			"id": 140922,
			"name": "五台县",
			"parentId": 140900
		}, {
			"id": 140923,
			"name": "代县",
			"parentId": 140900
		}, {
			"id": 140924,
			"name": "繁峙县",
			"parentId": 140900
		}, {
			"id": 140925,
			"name": "宁武县",
			"parentId": 140900
		}, {
			"id": 140926,
			"name": "静乐县",
			"parentId": 140900
		}, {
			"id": 140927,
			"name": "神池县",
			"parentId": 140900
		}, {
			"id": 140928,
			"name": "五寨县",
			"parentId": 140900
		}, {
			"id": 140929,
			"name": "岢岚县",
			"parentId": 140900
		}, {
			"id": 140930,
			"name": "河曲县",
			"parentId": 140900
		}, {
			"id": 140931,
			"name": "保德县",
			"parentId": 140900
		}, {
			"id": 140932,
			"name": "偏关县",
			"parentId": 140900
		}, {
			"id": 140981,
			"name": "原平市",
			"parentId": 140900
		}]
	}, {
		"id": 141000,
		"name": "临汾市",
		"parentId": 140,
		"children": [{
			"id": 141002,
			"name": "尧都区",
			"parentId": 141000
		}, {
			"id": 141021,
			"name": "曲沃县",
			"parentId": 141000
		}, {
			"id": 141022,
			"name": "翼城县",
			"parentId": 141000
		}, {
			"id": 141023,
			"name": "襄汾县",
			"parentId": 141000
		}, {
			"id": 141024,
			"name": "洪洞县",
			"parentId": 141000
		}, {
			"id": 141025,
			"name": "古县",
			"parentId": 141000
		}, {
			"id": 141026,
			"name": "安泽县",
			"parentId": 141000
		}, {
			"id": 141027,
			"name": "浮山县",
			"parentId": 141000
		}, {
			"id": 141028,
			"name": "吉县",
			"parentId": 141000
		}, {
			"id": 141029,
			"name": "乡宁县",
			"parentId": 141000
		}, {
			"id": 141030,
			"name": "大宁县",
			"parentId": 141000
		}, {
			"id": 141031,
			"name": "隰县",
			"parentId": 141000
		}, {
			"id": 141032,
			"name": "永和县",
			"parentId": 141000
		}, {
			"id": 141033,
			"name": "蒲县",
			"parentId": 141000
		}, {
			"id": 141034,
			"name": "汾西县",
			"parentId": 141000
		}, {
			"id": 141081,
			"name": "侯马市",
			"parentId": 141000
		}, {
			"id": 141082,
			"name": "霍州市",
			"parentId": 141000
		}]
	}, {
		"id": 141100,
		"name": "吕梁市",
		"parentId": 140,
		"children": [{
			"id": 141102,
			"name": "离石区",
			"parentId": 141100
		}, {
			"id": 141121,
			"name": "文水县",
			"parentId": 141100
		}, {
			"id": 141122,
			"name": "交城县",
			"parentId": 141100
		}, {
			"id": 141123,
			"name": "兴县",
			"parentId": 141100
		}, {
			"id": 141124,
			"name": "临县",
			"parentId": 141100
		}, {
			"id": 141125,
			"name": "柳林县",
			"parentId": 141100
		}, {
			"id": 141126,
			"name": "石楼县",
			"parentId": 141100
		}, {
			"id": 141127,
			"name": "岚县",
			"parentId": 141100
		}, {
			"id": 141128,
			"name": "方山县",
			"parentId": 141100
		}, {
			"id": 141129,
			"name": "中阳县",
			"parentId": 141100
		}, {
			"id": 141130,
			"name": "交口县",
			"parentId": 141100
		}, {
			"id": 141181,
			"name": "孝义市",
			"parentId": 141100
		}, {
			"id": 141182,
			"name": "汾阳市",
			"parentId": 141100
		}]
	}]
}, {
	"id": 150,
	"name": "内蒙古自治区",
	"children": [{
		"id": 150100,
		"name": "呼和浩特市",
		"parentId": 150,
		"children": [{
			"id": 150102,
			"name": "新城区",
			"parentId": 150100
		}, {
			"id": 150103,
			"name": "回民区",
			"parentId": 150100
		}, {
			"id": 150104,
			"name": "玉泉区",
			"parentId": 150100
		}, {
			"id": 150105,
			"name": "赛罕区",
			"parentId": 150100
		}, {
			"id": 150121,
			"name": "土默特左旗",
			"parentId": 150100
		}, {
			"id": 150122,
			"name": "托克托县",
			"parentId": 150100
		}, {
			"id": 150123,
			"name": "和林格尔县",
			"parentId": 150100
		}, {
			"id": 150124,
			"name": "清水河县",
			"parentId": 150100
		}, {
			"id": 150125,
			"name": "武川县",
			"parentId": 150100
		}]
	}, {
		"id": 150200,
		"name": "包头市",
		"parentId": 150,
		"children": [{
			"id": 150202,
			"name": "东河区",
			"parentId": 150200
		}, {
			"id": 150203,
			"name": "昆都仑区",
			"parentId": 150200
		}, {
			"id": 150204,
			"name": "青山区",
			"parentId": 150200
		}, {
			"id": 150205,
			"name": "石拐区",
			"parentId": 150200
		}, {
			"id": 150206,
			"name": "白云鄂博矿区",
			"parentId": 150200
		}, {
			"id": 150207,
			"name": "九原区",
			"parentId": 150200
		}, {
			"id": 150221,
			"name": "土默特右旗",
			"parentId": 150200
		}, {
			"id": 150222,
			"name": "固阳县",
			"parentId": 150200
		}, {
			"id": 150223,
			"name": "达尔罕茂明安联合旗",
			"parentId": 150200
		}]
	}, {
		"id": 150300,
		"name": "乌海市",
		"parentId": 150,
		"children": [{
			"id": 150302,
			"name": "海勃湾区",
			"parentId": 150300
		}, {
			"id": 150303,
			"name": "海南区",
			"parentId": 150300
		}, {
			"id": 150304,
			"name": "乌达区",
			"parentId": 150300
		}]
	}, {
		"id": 150400,
		"name": "赤峰市",
		"parentId": 150,
		"children": [{
			"id": 150402,
			"name": "红山区",
			"parentId": 150400
		}, {
			"id": 150403,
			"name": "元宝山区",
			"parentId": 150400
		}, {
			"id": 150404,
			"name": "松山区",
			"parentId": 150400
		}, {
			"id": 150421,
			"name": "阿鲁科尔沁旗",
			"parentId": 150400
		}, {
			"id": 150422,
			"name": "巴林左旗",
			"parentId": 150400
		}, {
			"id": 150423,
			"name": "巴林右旗",
			"parentId": 150400
		}, {
			"id": 150424,
			"name": "林西县",
			"parentId": 150400
		}, {
			"id": 150425,
			"name": "克什克腾旗",
			"parentId": 150400
		}, {
			"id": 150426,
			"name": "翁牛特旗",
			"parentId": 150400
		}, {
			"id": 150428,
			"name": "喀喇沁旗",
			"parentId": 150400
		}, {
			"id": 150429,
			"name": "宁城县",
			"parentId": 150400
		}, {
			"id": 150430,
			"name": "敖汉旗",
			"parentId": 150400
		}]
	}, {
		"id": 150500,
		"name": "通辽市",
		"parentId": 150,
		"children": [{
			"id": 150502,
			"name": "科尔沁区",
			"parentId": 150500
		}, {
			"id": 150521,
			"name": "科尔沁左翼中旗",
			"parentId": 150500
		}, {
			"id": 150522,
			"name": "科尔沁左翼后旗",
			"parentId": 150500
		}, {
			"id": 150523,
			"name": "开鲁县",
			"parentId": 150500
		}, {
			"id": 150524,
			"name": "库伦旗",
			"parentId": 150500
		}, {
			"id": 150525,
			"name": "奈曼旗",
			"parentId": 150500
		}, {
			"id": 150526,
			"name": "扎鲁特旗",
			"parentId": 150500
		}, {
			"id": 150581,
			"name": "霍林郭勒市",
			"parentId": 150500
		}]
	}, {
		"id": 150600,
		"name": "鄂尔多斯市",
		"parentId": 150,
		"children": [{
			"id": 150602,
			"name": "东胜区",
			"parentId": 150600
		}, {
			"id": 150603,
			"name": "康巴什区",
			"parentId": 150600
		}, {
			"id": 150621,
			"name": "达拉特旗",
			"parentId": 150600
		}, {
			"id": 150622,
			"name": "准格尔旗",
			"parentId": 150600
		}, {
			"id": 150623,
			"name": "鄂托克前旗",
			"parentId": 150600
		}, {
			"id": 150624,
			"name": "鄂托克旗",
			"parentId": 150600
		}, {
			"id": 150625,
			"name": "杭锦旗",
			"parentId": 150600
		}, {
			"id": 150626,
			"name": "乌审旗",
			"parentId": 150600
		}, {
			"id": 150627,
			"name": "伊金霍洛旗",
			"parentId": 150600
		}]
	}, {
		"id": 150700,
		"name": "呼伦贝尔市",
		"parentId": 150,
		"children": [{
			"id": 150702,
			"name": "海拉尔区",
			"parentId": 150700
		}, {
			"id": 150703,
			"name": "扎赉诺尔区",
			"parentId": 150700
		}, {
			"id": 150721,
			"name": "阿荣旗",
			"parentId": 150700
		}, {
			"id": 150722,
			"name": "莫力达瓦达斡尔族自治旗",
			"parentId": 150700
		}, {
			"id": 150723,
			"name": "鄂伦春自治旗",
			"parentId": 150700
		}, {
			"id": 150724,
			"name": "鄂温克族自治旗",
			"parentId": 150700
		}, {
			"id": 150725,
			"name": "陈巴尔虎旗",
			"parentId": 150700
		}, {
			"id": 150726,
			"name": "新巴尔虎左旗",
			"parentId": 150700
		}, {
			"id": 150727,
			"name": "新巴尔虎右旗",
			"parentId": 150700
		}, {
			"id": 150781,
			"name": "满洲里市",
			"parentId": 150700
		}, {
			"id": 150782,
			"name": "牙克石市",
			"parentId": 150700
		}, {
			"id": 150783,
			"name": "扎兰屯市",
			"parentId": 150700
		}, {
			"id": 150784,
			"name": "额尔古纳市",
			"parentId": 150700
		}, {
			"id": 150785,
			"name": "根河市",
			"parentId": 150700
		}]
	}, {
		"id": 150800,
		"name": "巴彦淖尔市",
		"parentId": 150,
		"children": [{
			"id": 150802,
			"name": "临河区",
			"parentId": 150800
		}, {
			"id": 150821,
			"name": "五原县",
			"parentId": 150800
		}, {
			"id": 150822,
			"name": "磴口县",
			"parentId": 150800
		}, {
			"id": 150823,
			"name": "乌拉特前旗",
			"parentId": 150800
		}, {
			"id": 150824,
			"name": "乌拉特中旗",
			"parentId": 150800
		}, {
			"id": 150825,
			"name": "乌拉特后旗",
			"parentId": 150800
		}, {
			"id": 150826,
			"name": "杭锦后旗",
			"parentId": 150800
		}]
	}, {
		"id": 150900,
		"name": "乌兰察布市",
		"parentId": 150,
		"children": [{
			"id": 150902,
			"name": "集宁区",
			"parentId": 150900
		}, {
			"id": 150921,
			"name": "卓资县",
			"parentId": 150900
		}, {
			"id": 150922,
			"name": "化德县",
			"parentId": 150900
		}, {
			"id": 150923,
			"name": "商都县",
			"parentId": 150900
		}, {
			"id": 150924,
			"name": "兴和县",
			"parentId": 150900
		}, {
			"id": 150925,
			"name": "凉城县",
			"parentId": 150900
		}, {
			"id": 150926,
			"name": "察哈尔右翼前旗",
			"parentId": 150900
		}, {
			"id": 150927,
			"name": "察哈尔右翼中旗",
			"parentId": 150900
		}, {
			"id": 150928,
			"name": "察哈尔右翼后旗",
			"parentId": 150900
		}, {
			"id": 150929,
			"name": "四子王旗",
			"parentId": 150900
		}, {
			"id": 150981,
			"name": "丰镇市",
			"parentId": 150900
		}]
	}, {
		"id": 152200,
		"name": "兴安盟",
		"parentId": 150,
		"children": [{
			"id": 152201,
			"name": "乌兰浩特市",
			"parentId": 152200
		}, {
			"id": 152202,
			"name": "阿尔山市",
			"parentId": 152200
		}, {
			"id": 152221,
			"name": "科尔沁右翼前旗",
			"parentId": 152200
		}, {
			"id": 152222,
			"name": "科尔沁右翼中旗",
			"parentId": 152200
		}, {
			"id": 152223,
			"name": "扎赉特旗",
			"parentId": 152200
		}, {
			"id": 152224,
			"name": "突泉县",
			"parentId": 152200
		}]
	}, {
		"id": 152500,
		"name": "锡林郭勒盟",
		"parentId": 150,
		"children": [{
			"id": 152501,
			"name": "二连浩特市",
			"parentId": 152500
		}, {
			"id": 152502,
			"name": "锡林浩特市",
			"parentId": 152500
		}, {
			"id": 152522,
			"name": "阿巴嘎旗",
			"parentId": 152500
		}, {
			"id": 152523,
			"name": "苏尼特左旗",
			"parentId": 152500
		}, {
			"id": 152524,
			"name": "苏尼特右旗",
			"parentId": 152500
		}, {
			"id": 152525,
			"name": "东乌珠穆沁旗",
			"parentId": 152500
		}, {
			"id": 152526,
			"name": "西乌珠穆沁旗",
			"parentId": 152500
		}, {
			"id": 152527,
			"name": "太仆寺旗",
			"parentId": 152500
		}, {
			"id": 152528,
			"name": "镶黄旗",
			"parentId": 152500
		}, {
			"id": 152529,
			"name": "正镶白旗",
			"parentId": 152500
		}, {
			"id": 152530,
			"name": "正蓝旗",
			"parentId": 152500
		}, {
			"id": 152531,
			"name": "多伦县",
			"parentId": 152500
		}]
	}, {
		"id": 152900,
		"name": "阿拉善盟",
		"parentId": 150,
		"children": [{
			"id": 152921,
			"name": "阿拉善左旗",
			"parentId": 152900
		}, {
			"id": 152922,
			"name": "阿拉善右旗",
			"parentId": 152900
		}, {
			"id": 152923,
			"name": "额济纳旗",
			"parentId": 152900
		}]
	}]
}, {
	"id": 210,
	"name": "辽宁省",
	"children": [{
		"id": 210100,
		"name": "沈阳市",
		"parentId": 210,
		"children": [{
			"id": 210102,
			"name": "和平区",
			"parentId": 210100
		}, {
			"id": 210103,
			"name": "沈河区",
			"parentId": 210100
		}, {
			"id": 210104,
			"name": "大东区",
			"parentId": 210100
		}, {
			"id": 210105,
			"name": "皇姑区",
			"parentId": 210100
		}, {
			"id": 210106,
			"name": "铁西区",
			"parentId": 210100
		}, {
			"id": 210111,
			"name": "苏家屯区",
			"parentId": 210100
		}, {
			"id": 210112,
			"name": "浑南区",
			"parentId": 210100
		}, {
			"id": 210113,
			"name": "沈北新区",
			"parentId": 210100
		}, {
			"id": 210114,
			"name": "于洪区",
			"parentId": 210100
		}, {
			"id": 210115,
			"name": "辽中区",
			"parentId": 210100
		}, {
			"id": 210123,
			"name": "康平县",
			"parentId": 210100
		}, {
			"id": 210124,
			"name": "法库县",
			"parentId": 210100
		}, {
			"id": 210181,
			"name": "新民市",
			"parentId": 210100
		}]
	}, {
		"id": 210200,
		"name": "大连市",
		"parentId": 210,
		"children": [{
			"id": 210202,
			"name": "中山区",
			"parentId": 210200
		}, {
			"id": 210203,
			"name": "西岗区",
			"parentId": 210200
		}, {
			"id": 210204,
			"name": "沙河口区",
			"parentId": 210200
		}, {
			"id": 210211,
			"name": "甘井子区",
			"parentId": 210200
		}, {
			"id": 210212,
			"name": "旅顺口区",
			"parentId": 210200
		}, {
			"id": 210213,
			"name": "金州区",
			"parentId": 210200
		}, {
			"id": 210214,
			"name": "普兰店区",
			"parentId": 210200
		}, {
			"id": 210224,
			"name": "长海县",
			"parentId": 210200
		}, {
			"id": 210281,
			"name": "瓦房店市",
			"parentId": 210200
		}, {
			"id": 210283,
			"name": "庄河市",
			"parentId": 210200
		}]
	}, {
		"id": 210300,
		"name": "鞍山市",
		"parentId": 210,
		"children": [{
			"id": 210302,
			"name": "铁东区",
			"parentId": 210300
		}, {
			"id": 210303,
			"name": "铁西区",
			"parentId": 210300
		}, {
			"id": 210304,
			"name": "立山区",
			"parentId": 210300
		}, {
			"id": 210311,
			"name": "千山区",
			"parentId": 210300
		}, {
			"id": 210321,
			"name": "台安县",
			"parentId": 210300
		}, {
			"id": 210323,
			"name": "岫岩满族自治县",
			"parentId": 210300
		}, {
			"id": 210381,
			"name": "海城市",
			"parentId": 210300
		}]
	}, {
		"id": 210400,
		"name": "抚顺市",
		"parentId": 210,
		"children": [{
			"id": 210402,
			"name": "新抚区",
			"parentId": 210400
		}, {
			"id": 210403,
			"name": "东洲区",
			"parentId": 210400
		}, {
			"id": 210404,
			"name": "望花区",
			"parentId": 210400
		}, {
			"id": 210411,
			"name": "顺城区",
			"parentId": 210400
		}, {
			"id": 210421,
			"name": "抚顺县",
			"parentId": 210400
		}, {
			"id": 210422,
			"name": "新宾满族自治县",
			"parentId": 210400
		}, {
			"id": 210423,
			"name": "清原满族自治县",
			"parentId": 210400
		}]
	}, {
		"id": 210500,
		"name": "本溪市",
		"parentId": 210,
		"children": [{
			"id": 210502,
			"name": "平山区",
			"parentId": 210500
		}, {
			"id": 210503,
			"name": "溪湖区",
			"parentId": 210500
		}, {
			"id": 210504,
			"name": "明山区",
			"parentId": 210500
		}, {
			"id": 210505,
			"name": "南芬区",
			"parentId": 210500
		}, {
			"id": 210521,
			"name": "本溪满族自治县",
			"parentId": 210500
		}, {
			"id": 210522,
			"name": "桓仁满族自治县",
			"parentId": 210500
		}]
	}, {
		"id": 210600,
		"name": "丹东市",
		"parentId": 210,
		"children": [{
			"id": 210602,
			"name": "元宝区",
			"parentId": 210600
		}, {
			"id": 210603,
			"name": "振兴区",
			"parentId": 210600
		}, {
			"id": 210604,
			"name": "振安区",
			"parentId": 210600
		}, {
			"id": 210624,
			"name": "宽甸满族自治县",
			"parentId": 210600
		}, {
			"id": 210681,
			"name": "东港市",
			"parentId": 210600
		}, {
			"id": 210682,
			"name": "凤城市",
			"parentId": 210600
		}]
	}, {
		"id": 210700,
		"name": "锦州市",
		"parentId": 210,
		"children": [{
			"id": 210702,
			"name": "古塔区",
			"parentId": 210700
		}, {
			"id": 210703,
			"name": "凌河区",
			"parentId": 210700
		}, {
			"id": 210711,
			"name": "太和区",
			"parentId": 210700
		}, {
			"id": 210726,
			"name": "黑山县",
			"parentId": 210700
		}, {
			"id": 210727,
			"name": "义县",
			"parentId": 210700
		}, {
			"id": 210781,
			"name": "凌海市",
			"parentId": 210700
		}, {
			"id": 210782,
			"name": "北镇市",
			"parentId": 210700
		}]
	}, {
		"id": 210800,
		"name": "营口市",
		"parentId": 210,
		"children": [{
			"id": 210802,
			"name": "站前区",
			"parentId": 210800
		}, {
			"id": 210803,
			"name": "西市区",
			"parentId": 210800
		}, {
			"id": 210804,
			"name": "鲅鱼圈区",
			"parentId": 210800
		}, {
			"id": 210811,
			"name": "老边区",
			"parentId": 210800
		}, {
			"id": 210881,
			"name": "盖州市",
			"parentId": 210800
		}, {
			"id": 210882,
			"name": "大石桥市",
			"parentId": 210800
		}]
	}, {
		"id": 210900,
		"name": "阜新市",
		"parentId": 210,
		"children": [{
			"id": 210902,
			"name": "海州区",
			"parentId": 210900
		}, {
			"id": 210903,
			"name": "新邱区",
			"parentId": 210900
		}, {
			"id": 210904,
			"name": "太平区",
			"parentId": 210900
		}, {
			"id": 210905,
			"name": "清河门区",
			"parentId": 210900
		}, {
			"id": 210911,
			"name": "细河区",
			"parentId": 210900
		}, {
			"id": 210921,
			"name": "阜新蒙古族自治县",
			"parentId": 210900
		}, {
			"id": 210922,
			"name": "彰武县",
			"parentId": 210900
		}]
	}, {
		"id": 211000,
		"name": "辽阳市",
		"parentId": 210,
		"children": [{
			"id": 211002,
			"name": "白塔区",
			"parentId": 211000
		}, {
			"id": 211003,
			"name": "文圣区",
			"parentId": 211000
		}, {
			"id": 211004,
			"name": "宏伟区",
			"parentId": 211000
		}, {
			"id": 211005,
			"name": "弓长岭区",
			"parentId": 211000
		}, {
			"id": 211011,
			"name": "太子河区",
			"parentId": 211000
		}, {
			"id": 211021,
			"name": "辽阳县",
			"parentId": 211000
		}, {
			"id": 211081,
			"name": "灯塔市",
			"parentId": 211000
		}]
	}, {
		"id": 211100,
		"name": "盘锦市",
		"parentId": 210,
		"children": [{
			"id": 211102,
			"name": "双台子区",
			"parentId": 211100
		}, {
			"id": 211103,
			"name": "兴隆台区",
			"parentId": 211100
		}, {
			"id": 211104,
			"name": "大洼区",
			"parentId": 211100
		}, {
			"id": 211122,
			"name": "盘山县",
			"parentId": 211100
		}]
	}, {
		"id": 211200,
		"name": "铁岭市",
		"parentId": 210,
		"children": [{
			"id": 211202,
			"name": "银州区",
			"parentId": 211200
		}, {
			"id": 211204,
			"name": "清河区",
			"parentId": 211200
		}, {
			"id": 211221,
			"name": "铁岭县",
			"parentId": 211200
		}, {
			"id": 211223,
			"name": "西丰县",
			"parentId": 211200
		}, {
			"id": 211224,
			"name": "昌图县",
			"parentId": 211200
		}, {
			"id": 211281,
			"name": "调兵山市",
			"parentId": 211200
		}, {
			"id": 211282,
			"name": "开原市",
			"parentId": 211200
		}]
	}, {
		"id": 211300,
		"name": "朝阳市",
		"parentId": 210,
		"children": [{
			"id": 211302,
			"name": "双塔区",
			"parentId": 211300
		}, {
			"id": 211303,
			"name": "龙城区",
			"parentId": 211300
		}, {
			"id": 211321,
			"name": "朝阳县",
			"parentId": 211300
		}, {
			"id": 211322,
			"name": "建平县",
			"parentId": 211300
		}, {
			"id": 211324,
			"name": "喀喇沁左翼蒙古族自治县",
			"parentId": 211300
		}, {
			"id": 211381,
			"name": "北票市",
			"parentId": 211300
		}, {
			"id": 211382,
			"name": "凌源市",
			"parentId": 211300
		}]
	}, {
		"id": 211400,
		"name": "葫芦岛市",
		"parentId": 210,
		"children": [{
			"id": 211402,
			"name": "连山区",
			"parentId": 211400
		}, {
			"id": 211403,
			"name": "龙港区",
			"parentId": 211400
		}, {
			"id": 211404,
			"name": "南票区",
			"parentId": 211400
		}, {
			"id": 211421,
			"name": "绥中县",
			"parentId": 211400
		}, {
			"id": 211422,
			"name": "建昌县",
			"parentId": 211400
		}, {
			"id": 211481,
			"name": "兴城市",
			"parentId": 211400
		}]
	}]
}, {
	"id": 220,
	"name": "吉林省",
	"children": [{
		"id": 220100,
		"name": "长春市",
		"parentId": 220,
		"children": [{
			"id": 220102,
			"name": "南关区",
			"parentId": 220100
		}, {
			"id": 220103,
			"name": "宽城区",
			"parentId": 220100
		}, {
			"id": 220104,
			"name": "朝阳区",
			"parentId": 220100
		}, {
			"id": 220105,
			"name": "二道区",
			"parentId": 220100
		}, {
			"id": 220106,
			"name": "绿园区",
			"parentId": 220100
		}, {
			"id": 220112,
			"name": "双阳区",
			"parentId": 220100
		}, {
			"id": 220113,
			"name": "九台区",
			"parentId": 220100
		}, {
			"id": 220122,
			"name": "农安县",
			"parentId": 220100
		}, {
			"id": 220182,
			"name": "榆树市",
			"parentId": 220100
		}, {
			"id": 220183,
			"name": "德惠市",
			"parentId": 220100
		}]
	}, {
		"id": 220200,
		"name": "吉林市",
		"parentId": 220,
		"children": [{
			"id": 220202,
			"name": "昌邑区",
			"parentId": 220200
		}, {
			"id": 220203,
			"name": "龙潭区",
			"parentId": 220200
		}, {
			"id": 220204,
			"name": "船营区",
			"parentId": 220200
		}, {
			"id": 220211,
			"name": "丰满区",
			"parentId": 220200
		}, {
			"id": 220221,
			"name": "永吉县",
			"parentId": 220200
		}, {
			"id": 220281,
			"name": "蛟河市",
			"parentId": 220200
		}, {
			"id": 220282,
			"name": "桦甸市",
			"parentId": 220200
		}, {
			"id": 220283,
			"name": "舒兰市",
			"parentId": 220200
		}, {
			"id": 220284,
			"name": "磐石市",
			"parentId": 220200
		}]
	}, {
		"id": 220300,
		"name": "四平市",
		"parentId": 220,
		"children": [{
			"id": 220302,
			"name": "铁西区",
			"parentId": 220300
		}, {
			"id": 220303,
			"name": "铁东区",
			"parentId": 220300
		}, {
			"id": 220322,
			"name": "梨树县",
			"parentId": 220300
		}, {
			"id": 220323,
			"name": "伊通满族自治县",
			"parentId": 220300
		}, {
			"id": 220381,
			"name": "公主岭市",
			"parentId": 220300
		}, {
			"id": 220382,
			"name": "双辽市",
			"parentId": 220300
		}]
	}, {
		"id": 220400,
		"name": "辽源市",
		"parentId": 220,
		"children": [{
			"id": 220402,
			"name": "龙山区",
			"parentId": 220400
		}, {
			"id": 220403,
			"name": "西安区",
			"parentId": 220400
		}, {
			"id": 220421,
			"name": "东丰县",
			"parentId": 220400
		}, {
			"id": 220422,
			"name": "东辽县",
			"parentId": 220400
		}]
	}, {
		"id": 220500,
		"name": "通化市",
		"parentId": 220,
		"children": [{
			"id": 220502,
			"name": "东昌区",
			"parentId": 220500
		}, {
			"id": 220503,
			"name": "二道江区",
			"parentId": 220500
		}, {
			"id": 220521,
			"name": "通化县",
			"parentId": 220500
		}, {
			"id": 220523,
			"name": "辉南县",
			"parentId": 220500
		}, {
			"id": 220524,
			"name": "柳河县",
			"parentId": 220500
		}, {
			"id": 220581,
			"name": "梅河口市",
			"parentId": 220500
		}, {
			"id": 220582,
			"name": "集安市",
			"parentId": 220500
		}]
	}, {
		"id": 220600,
		"name": "白山市",
		"parentId": 220,
		"children": [{
			"id": 220602,
			"name": "浑江区",
			"parentId": 220600
		}, {
			"id": 220605,
			"name": "江源区",
			"parentId": 220600
		}, {
			"id": 220621,
			"name": "抚松县",
			"parentId": 220600
		}, {
			"id": 220622,
			"name": "靖宇县",
			"parentId": 220600
		}, {
			"id": 220623,
			"name": "长白朝鲜族自治县",
			"parentId": 220600
		}, {
			"id": 220681,
			"name": "临江市",
			"parentId": 220600
		}]
	}, {
		"id": 220700,
		"name": "松原市",
		"parentId": 220,
		"children": [{
			"id": 220702,
			"name": "宁江区",
			"parentId": 220700
		}, {
			"id": 220721,
			"name": "前郭尔罗斯蒙古族自治县",
			"parentId": 220700
		}, {
			"id": 220722,
			"name": "长岭县",
			"parentId": 220700
		}, {
			"id": 220723,
			"name": "乾安县",
			"parentId": 220700
		}, {
			"id": 220781,
			"name": "扶余市",
			"parentId": 220700
		}]
	}, {
		"id": 220800,
		"name": "白城市",
		"parentId": 220,
		"children": [{
			"id": 220802,
			"name": "洮北区",
			"parentId": 220800
		}, {
			"id": 220821,
			"name": "镇赉县",
			"parentId": 220800
		}, {
			"id": 220822,
			"name": "通榆县",
			"parentId": 220800
		}, {
			"id": 220881,
			"name": "洮南市",
			"parentId": 220800
		}, {
			"id": 220882,
			"name": "大安市",
			"parentId": 220800
		}]
	}, {
		"id": 222400,
		"name": "延边朝鲜族自治州",
		"parentId": 220,
		"children": [{
			"id": 222401,
			"name": "延吉市",
			"parentId": 222400
		}, {
			"id": 222402,
			"name": "图们市",
			"parentId": 222400
		}, {
			"id": 222403,
			"name": "敦化市",
			"parentId": 222400
		}, {
			"id": 222404,
			"name": "珲春市",
			"parentId": 222400
		}, {
			"id": 222405,
			"name": "龙井市",
			"parentId": 222400
		}, {
			"id": 222406,
			"name": "和龙市",
			"parentId": 222400
		}, {
			"id": 222424,
			"name": "汪清县",
			"parentId": 222400
		}, {
			"id": 222426,
			"name": "安图县",
			"parentId": 222400
		}]
	}]
}, {
	"id": 230,
	"name": "黑龙江省",
	"children": [{
		"id": 230100,
		"name": "哈尔滨市",
		"parentId": 230,
		"children": [{
			"id": 230102,
			"name": "道里区",
			"parentId": 230100
		}, {
			"id": 230103,
			"name": "南岗区",
			"parentId": 230100
		}, {
			"id": 230104,
			"name": "道外区",
			"parentId": 230100
		}, {
			"id": 230108,
			"name": "平房区",
			"parentId": 230100
		}, {
			"id": 230109,
			"name": "松北区",
			"parentId": 230100
		}, {
			"id": 230110,
			"name": "香坊区",
			"parentId": 230100
		}, {
			"id": 230111,
			"name": "呼兰区",
			"parentId": 230100
		}, {
			"id": 230112,
			"name": "阿城区",
			"parentId": 230100
		}, {
			"id": 230113,
			"name": "双城区",
			"parentId": 230100
		}, {
			"id": 230123,
			"name": "依兰县",
			"parentId": 230100
		}, {
			"id": 230124,
			"name": "方正县",
			"parentId": 230100
		}, {
			"id": 230125,
			"name": "宾县",
			"parentId": 230100
		}, {
			"id": 230126,
			"name": "巴彦县",
			"parentId": 230100
		}, {
			"id": 230127,
			"name": "木兰县",
			"parentId": 230100
		}, {
			"id": 230128,
			"name": "通河县",
			"parentId": 230100
		}, {
			"id": 230129,
			"name": "延寿县",
			"parentId": 230100
		}, {
			"id": 230183,
			"name": "尚志市",
			"parentId": 230100
		}, {
			"id": 230184,
			"name": "五常市",
			"parentId": 230100
		}]
	}, {
		"id": 230200,
		"name": "齐齐哈尔市",
		"parentId": 230,
		"children": [{
			"id": 230202,
			"name": "龙沙区",
			"parentId": 230200
		}, {
			"id": 230203,
			"name": "建华区",
			"parentId": 230200
		}, {
			"id": 230204,
			"name": "铁锋区",
			"parentId": 230200
		}, {
			"id": 230205,
			"name": "昂昂溪区",
			"parentId": 230200
		}, {
			"id": 230206,
			"name": "富拉尔基区",
			"parentId": 230200
		}, {
			"id": 230207,
			"name": "碾子山区",
			"parentId": 230200
		}, {
			"id": 230208,
			"name": "梅里斯达斡尔族区",
			"parentId": 230200
		}, {
			"id": 230221,
			"name": "龙江县",
			"parentId": 230200
		}, {
			"id": 230223,
			"name": "依安县",
			"parentId": 230200
		}, {
			"id": 230224,
			"name": "泰来县",
			"parentId": 230200
		}, {
			"id": 230225,
			"name": "甘南县",
			"parentId": 230200
		}, {
			"id": 230227,
			"name": "富裕县",
			"parentId": 230200
		}, {
			"id": 230229,
			"name": "克山县",
			"parentId": 230200
		}, {
			"id": 230230,
			"name": "克东县",
			"parentId": 230200
		}, {
			"id": 230231,
			"name": "拜泉县",
			"parentId": 230200
		}, {
			"id": 230281,
			"name": "讷河市",
			"parentId": 230200
		}]
	}, {
		"id": 230300,
		"name": "鸡西市",
		"parentId": 230,
		"children": [{
			"id": 230302,
			"name": "鸡冠区",
			"parentId": 230300
		}, {
			"id": 230303,
			"name": "恒山区",
			"parentId": 230300
		}, {
			"id": 230304,
			"name": "滴道区",
			"parentId": 230300
		}, {
			"id": 230305,
			"name": "梨树区",
			"parentId": 230300
		}, {
			"id": 230306,
			"name": "城子河区",
			"parentId": 230300
		}, {
			"id": 230307,
			"name": "麻山区",
			"parentId": 230300
		}, {
			"id": 230321,
			"name": "鸡东县",
			"parentId": 230300
		}, {
			"id": 230381,
			"name": "虎林市",
			"parentId": 230300
		}, {
			"id": 230382,
			"name": "密山市",
			"parentId": 230300
		}]
	}, {
		"id": 230400,
		"name": "鹤岗市",
		"parentId": 230,
		"children": [{
			"id": 230402,
			"name": "向阳区",
			"parentId": 230400
		}, {
			"id": 230403,
			"name": "工农区",
			"parentId": 230400
		}, {
			"id": 230404,
			"name": "南山区",
			"parentId": 230400
		}, {
			"id": 230405,
			"name": "兴安区",
			"parentId": 230400
		}, {
			"id": 230406,
			"name": "东山区",
			"parentId": 230400
		}, {
			"id": 230407,
			"name": "兴山区",
			"parentId": 230400
		}, {
			"id": 230421,
			"name": "萝北县",
			"parentId": 230400
		}, {
			"id": 230422,
			"name": "绥滨县",
			"parentId": 230400
		}]
	}, {
		"id": 230500,
		"name": "双鸭山市",
		"parentId": 230,
		"children": [{
			"id": 230502,
			"name": "尖山区",
			"parentId": 230500
		}, {
			"id": 230503,
			"name": "岭东区",
			"parentId": 230500
		}, {
			"id": 230505,
			"name": "四方台区",
			"parentId": 230500
		}, {
			"id": 230506,
			"name": "宝山区",
			"parentId": 230500
		}, {
			"id": 230521,
			"name": "集贤县",
			"parentId": 230500
		}, {
			"id": 230522,
			"name": "友谊县",
			"parentId": 230500
		}, {
			"id": 230523,
			"name": "宝清县",
			"parentId": 230500
		}, {
			"id": 230524,
			"name": "饶河县",
			"parentId": 230500
		}]
	}, {
		"id": 230600,
		"name": "大庆市",
		"parentId": 230,
		"children": [{
			"id": 230602,
			"name": "萨尔图区",
			"parentId": 230600
		}, {
			"id": 230603,
			"name": "龙凤区",
			"parentId": 230600
		}, {
			"id": 230604,
			"name": "让胡路区",
			"parentId": 230600
		}, {
			"id": 230605,
			"name": "红岗区",
			"parentId": 230600
		}, {
			"id": 230606,
			"name": "大同区",
			"parentId": 230600
		}, {
			"id": 230621,
			"name": "肇州县",
			"parentId": 230600
		}, {
			"id": 230622,
			"name": "肇源县",
			"parentId": 230600
		}, {
			"id": 230623,
			"name": "林甸县",
			"parentId": 230600
		}, {
			"id": 230624,
			"name": "杜尔伯特蒙古族自治县",
			"parentId": 230600
		}]
	}, {
		"id": 230700,
		"name": "伊春市",
		"parentId": 230,
		"children": [{
			"id": 230702,
			"name": "伊春区",
			"parentId": 230700
		}, {
			"id": 230703,
			"name": "南岔区",
			"parentId": 230700
		}, {
			"id": 230704,
			"name": "友好区",
			"parentId": 230700
		}, {
			"id": 230705,
			"name": "西林区",
			"parentId": 230700
		}, {
			"id": 230706,
			"name": "翠峦区",
			"parentId": 230700
		}, {
			"id": 230707,
			"name": "新青区",
			"parentId": 230700
		}, {
			"id": 230708,
			"name": "美溪区",
			"parentId": 230700
		}, {
			"id": 230709,
			"name": "金山屯区",
			"parentId": 230700
		}, {
			"id": 230710,
			"name": "五营区",
			"parentId": 230700
		}, {
			"id": 230711,
			"name": "乌马河区",
			"parentId": 230700
		}, {
			"id": 230712,
			"name": "汤旺河区",
			"parentId": 230700
		}, {
			"id": 230713,
			"name": "带岭区",
			"parentId": 230700
		}, {
			"id": 230714,
			"name": "乌伊岭区",
			"parentId": 230700
		}, {
			"id": 230715,
			"name": "红星区",
			"parentId": 230700
		}, {
			"id": 230716,
			"name": "上甘岭区",
			"parentId": 230700
		}, {
			"id": 230722,
			"name": "嘉荫县",
			"parentId": 230700
		}, {
			"id": 230781,
			"name": "铁力市",
			"parentId": 230700
		}]
	}, {
		"id": 230800,
		"name": "佳木斯市",
		"parentId": 230,
		"children": [{
			"id": 230803,
			"name": "向阳区",
			"parentId": 230800
		}, {
			"id": 230804,
			"name": "前进区",
			"parentId": 230800
		}, {
			"id": 230805,
			"name": "东风区",
			"parentId": 230800
		}, {
			"id": 230811,
			"name": "郊区",
			"parentId": 230800
		}, {
			"id": 230822,
			"name": "桦南县",
			"parentId": 230800
		}, {
			"id": 230826,
			"name": "桦川县",
			"parentId": 230800
		}, {
			"id": 230828,
			"name": "汤原县",
			"parentId": 230800
		}, {
			"id": 230881,
			"name": "同江市",
			"parentId": 230800
		}, {
			"id": 230882,
			"name": "富锦市",
			"parentId": 230800
		}, {
			"id": 230883,
			"name": "抚远市",
			"parentId": 230800
		}]
	}, {
		"id": 230900,
		"name": "七台河市",
		"parentId": 230,
		"children": [{
			"id": 230902,
			"name": "新兴区",
			"parentId": 230900
		}, {
			"id": 230903,
			"name": "桃山区",
			"parentId": 230900
		}, {
			"id": 230904,
			"name": "茄子河区",
			"parentId": 230900
		}, {
			"id": 230921,
			"name": "勃利县",
			"parentId": 230900
		}]
	}, {
		"id": 231000,
		"name": "牡丹江市",
		"parentId": 230,
		"children": [{
			"id": 231002,
			"name": "东安区",
			"parentId": 231000
		}, {
			"id": 231003,
			"name": "阳明区",
			"parentId": 231000
		}, {
			"id": 231004,
			"name": "爱民区",
			"parentId": 231000
		}, {
			"id": 231005,
			"name": "西安区",
			"parentId": 231000
		}, {
			"id": 231025,
			"name": "林口县",
			"parentId": 231000
		}, {
			"id": 231081,
			"name": "绥芬河市",
			"parentId": 231000
		}, {
			"id": 231083,
			"name": "海林市",
			"parentId": 231000
		}, {
			"id": 231084,
			"name": "宁安市",
			"parentId": 231000
		}, {
			"id": 231085,
			"name": "穆棱市",
			"parentId": 231000
		}, {
			"id": 231086,
			"name": "东宁市",
			"parentId": 231000
		}]
	}, {
		"id": 231100,
		"name": "黑河市",
		"parentId": 230,
		"children": [{
			"id": 231102,
			"name": "爱辉区",
			"parentId": 231100
		}, {
			"id": 231121,
			"name": "嫩江县",
			"parentId": 231100
		}, {
			"id": 231123,
			"name": "逊克县",
			"parentId": 231100
		}, {
			"id": 231124,
			"name": "孙吴县",
			"parentId": 231100
		}, {
			"id": 231181,
			"name": "北安市",
			"parentId": 231100
		}, {
			"id": 231182,
			"name": "五大连池市",
			"parentId": 231100
		}]
	}, {
		"id": 231200,
		"name": "绥化市",
		"parentId": 230,
		"children": [{
			"id": 231202,
			"name": "北林区",
			"parentId": 231200
		}, {
			"id": 231221,
			"name": "望奎县",
			"parentId": 231200
		}, {
			"id": 231222,
			"name": "兰西县",
			"parentId": 231200
		}, {
			"id": 231223,
			"name": "青冈县",
			"parentId": 231200
		}, {
			"id": 231224,
			"name": "庆安县",
			"parentId": 231200
		}, {
			"id": 231225,
			"name": "明水县",
			"parentId": 231200
		}, {
			"id": 231226,
			"name": "绥棱县",
			"parentId": 231200
		}, {
			"id": 231281,
			"name": "安达市",
			"parentId": 231200
		}, {
			"id": 231282,
			"name": "肇东市",
			"parentId": 231200
		}, {
			"id": 231283,
			"name": "海伦市",
			"parentId": 231200
		}]
	}, {
		"id": 232700,
		"name": "大兴安岭地区",
		"parentId": 230,
		"children": [{
			"id": 232701,
			"name": "加格达奇区",
			"parentId": 232700
		}, {
			"id": 232721,
			"name": "呼玛县",
			"parentId": 232700
		}, {
			"id": 232722,
			"name": "塔河县",
			"parentId": 232700
		}, {
			"id": 232723,
			"name": "漠河县",
			"parentId": 232700
		}]
	}]
}, {
	"id": 310,
	"name": "上海市",
	"children": [{
		"id": 310000,
		"name": "上海市",
		"parentId": 310,
		"children": [{
			"id": 310101,
			"name": "黄浦区",
			"parentId": 310000
		}, {
			"id": 310104,
			"name": "徐汇区",
			"parentId": 310000
		}, {
			"id": 310105,
			"name": "长宁区",
			"parentId": 310000
		}, {
			"id": 310106,
			"name": "静安区",
			"parentId": 310000
		}, {
			"id": 310107,
			"name": "普陀区",
			"parentId": 310000
		}, {
			"id": 310109,
			"name": "虹口区",
			"parentId": 310000
		}, {
			"id": 310110,
			"name": "杨浦区",
			"parentId": 310000
		}, {
			"id": 310112,
			"name": "闵行区",
			"parentId": 310000
		}, {
			"id": 310113,
			"name": "宝山区",
			"parentId": 310000
		}, {
			"id": 310114,
			"name": "嘉定区",
			"parentId": 310000
		}, {
			"id": 310115,
			"name": "浦东新区",
			"parentId": 310000
		}, {
			"id": 310116,
			"name": "金山区",
			"parentId": 310000
		}, {
			"id": 310117,
			"name": "松江区",
			"parentId": 310000
		}, {
			"id": 310118,
			"name": "青浦区",
			"parentId": 310000
		}, {
			"id": 310120,
			"name": "奉贤区",
			"parentId": 310000
		}, {
			"id": 310151,
			"name": "崇明区",
			"parentId": 310000
		}]
	}]
}, {
	"id": 320,
	"name": "江苏省",
	"children": [{
		"id": 320100,
		"name": "南京市",
		"parentId": 320,
		"children": [{
			"id": 320102,
			"name": "玄武区",
			"parentId": 320100
		}, {
			"id": 320104,
			"name": "秦淮区",
			"parentId": 320100
		}, {
			"id": 320105,
			"name": "建邺区",
			"parentId": 320100
		}, {
			"id": 320106,
			"name": "鼓楼区",
			"parentId": 320100
		}, {
			"id": 320111,
			"name": "浦口区",
			"parentId": 320100
		}, {
			"id": 320113,
			"name": "栖霞区",
			"parentId": 320100
		}, {
			"id": 320114,
			"name": "雨花台区",
			"parentId": 320100
		}, {
			"id": 320115,
			"name": "江宁区",
			"parentId": 320100
		}, {
			"id": 320116,
			"name": "六合区",
			"parentId": 320100
		}, {
			"id": 320117,
			"name": "溧水区",
			"parentId": 320100
		}, {
			"id": 320118,
			"name": "高淳区",
			"parentId": 320100
		}]
	}, {
		"id": 320200,
		"name": "无锡市",
		"parentId": 320,
		"children": [{
			"id": 320205,
			"name": "锡山区",
			"parentId": 320200
		}, {
			"id": 320206,
			"name": "惠山区",
			"parentId": 320200
		}, {
			"id": 320211,
			"name": "滨湖区",
			"parentId": 320200
		}, {
			"id": 320213,
			"name": "梁溪区",
			"parentId": 320200
		}, {
			"id": 320214,
			"name": "新吴区",
			"parentId": 320200
		}, {
			"id": 320281,
			"name": "江阴市",
			"parentId": 320200
		}, {
			"id": 320282,
			"name": "宜兴市",
			"parentId": 320200
		}]
	}, {
		"id": 320300,
		"name": "徐州市",
		"parentId": 320,
		"children": [{
			"id": 320302,
			"name": "鼓楼区",
			"parentId": 320300
		}, {
			"id": 320303,
			"name": "云龙区",
			"parentId": 320300
		}, {
			"id": 320305,
			"name": "贾汪区",
			"parentId": 320300
		}, {
			"id": 320311,
			"name": "泉山区",
			"parentId": 320300
		}, {
			"id": 320312,
			"name": "铜山区",
			"parentId": 320300
		}, {
			"id": 320321,
			"name": "丰县",
			"parentId": 320300
		}, {
			"id": 320322,
			"name": "沛县",
			"parentId": 320300
		}, {
			"id": 320324,
			"name": "睢宁县",
			"parentId": 320300
		}, {
			"id": 320381,
			"name": "新沂市",
			"parentId": 320300
		}, {
			"id": 320382,
			"name": "邳州市",
			"parentId": 320300
		}]
	}, {
		"id": 320400,
		"name": "常州市",
		"parentId": 320,
		"children": [{
			"id": 320402,
			"name": "天宁区",
			"parentId": 320400
		}, {
			"id": 320404,
			"name": "钟楼区",
			"parentId": 320400
		}, {
			"id": 320411,
			"name": "新北区",
			"parentId": 320400
		}, {
			"id": 320412,
			"name": "武进区",
			"parentId": 320400
		}, {
			"id": 320413,
			"name": "金坛区",
			"parentId": 320400
		}, {
			"id": 320481,
			"name": "溧阳市",
			"parentId": 320400
		}]
	}, {
		"id": 320500,
		"name": "苏州市",
		"parentId": 320,
		"children": [{
			"id": 320505,
			"name": "虎丘区",
			"parentId": 320500
		}, {
			"id": 320506,
			"name": "吴中区",
			"parentId": 320500
		}, {
			"id": 320507,
			"name": "相城区",
			"parentId": 320500
		}, {
			"id": 320508,
			"name": "姑苏区",
			"parentId": 320500
		}, {
			"id": 320509,
			"name": "吴江区",
			"parentId": 320500
		}, {
			"id": 320581,
			"name": "常熟市",
			"parentId": 320500
		}, {
			"id": 320582,
			"name": "张家港市",
			"parentId": 320500
		}, {
			"id": 320583,
			"name": "昆山市",
			"parentId": 320500
		}, {
			"id": 320585,
			"name": "太仓市",
			"parentId": 320500
		}]
	}, {
		"id": 320600,
		"name": "南通市",
		"parentId": 320,
		"children": [{
			"id": 320602,
			"name": "崇川区",
			"parentId": 320600
		}, {
			"id": 320611,
			"name": "港闸区",
			"parentId": 320600
		}, {
			"id": 320612,
			"name": "通州区",
			"parentId": 320600
		}, {
			"id": 320621,
			"name": "海安县",
			"parentId": 320600
		}, {
			"id": 320623,
			"name": "如东县",
			"parentId": 320600
		}, {
			"id": 320681,
			"name": "启东市",
			"parentId": 320600
		}, {
			"id": 320682,
			"name": "如皋市",
			"parentId": 320600
		}, {
			"id": 320684,
			"name": "海门市",
			"parentId": 320600
		}]
	}, {
		"id": 320700,
		"name": "连云港市",
		"parentId": 320,
		"children": [{
			"id": 320703,
			"name": "连云区",
			"parentId": 320700
		}, {
			"id": 320706,
			"name": "海州区",
			"parentId": 320700
		}, {
			"id": 320707,
			"name": "赣榆区",
			"parentId": 320700
		}, {
			"id": 320722,
			"name": "东海县",
			"parentId": 320700
		}, {
			"id": 320723,
			"name": "灌云县",
			"parentId": 320700
		}, {
			"id": 320724,
			"name": "灌南县",
			"parentId": 320700
		}]
	}, {
		"id": 320800,
		"name": "淮安市",
		"parentId": 320,
		"children": [{
			"id": 320803,
			"name": "淮安区",
			"parentId": 320800
		}, {
			"id": 320804,
			"name": "淮阴区",
			"parentId": 320800
		}, {
			"id": 320812,
			"name": "清江浦区",
			"parentId": 320800
		}, {
			"id": 320813,
			"name": "洪泽区",
			"parentId": 320800
		}, {
			"id": 320826,
			"name": "涟水县",
			"parentId": 320800
		}, {
			"id": 320830,
			"name": "盱眙县",
			"parentId": 320800
		}, {
			"id": 320831,
			"name": "金湖县",
			"parentId": 320800
		}]
	}, {
		"id": 320900,
		"name": "盐城市",
		"parentId": 320,
		"children": [{
			"id": 320902,
			"name": "亭湖区",
			"parentId": 320900
		}, {
			"id": 320903,
			"name": "盐都区",
			"parentId": 320900
		}, {
			"id": 320904,
			"name": "大丰区",
			"parentId": 320900
		}, {
			"id": 320921,
			"name": "响水县",
			"parentId": 320900
		}, {
			"id": 320922,
			"name": "滨海县",
			"parentId": 320900
		}, {
			"id": 320923,
			"name": "阜宁县",
			"parentId": 320900
		}, {
			"id": 320924,
			"name": "射阳县",
			"parentId": 320900
		}, {
			"id": 320925,
			"name": "建湖县",
			"parentId": 320900
		}, {
			"id": 320981,
			"name": "东台市",
			"parentId": 320900
		}]
	}, {
		"id": 321000,
		"name": "扬州市",
		"parentId": 320,
		"children": [{
			"id": 321002,
			"name": "广陵区",
			"parentId": 321000
		}, {
			"id": 321003,
			"name": "邗江区",
			"parentId": 321000
		}, {
			"id": 321012,
			"name": "江都区",
			"parentId": 321000
		}, {
			"id": 321023,
			"name": "宝应县",
			"parentId": 321000
		}, {
			"id": 321081,
			"name": "仪征市",
			"parentId": 321000
		}, {
			"id": 321084,
			"name": "高邮市",
			"parentId": 321000
		}]
	}, {
		"id": 321100,
		"name": "镇江市",
		"parentId": 320,
		"children": [{
			"id": 321102,
			"name": "京口区",
			"parentId": 321100
		}, {
			"id": 321111,
			"name": "润州区",
			"parentId": 321100
		}, {
			"id": 321112,
			"name": "丹徒区",
			"parentId": 321100
		}, {
			"id": 321181,
			"name": "丹阳市",
			"parentId": 321100
		}, {
			"id": 321182,
			"name": "扬中市",
			"parentId": 321100
		}, {
			"id": 321183,
			"name": "句容市",
			"parentId": 321100
		}]
	}, {
		"id": 321200,
		"name": "泰州市",
		"parentId": 320,
		"children": [{
			"id": 321202,
			"name": "海陵区",
			"parentId": 321200
		}, {
			"id": 321203,
			"name": "高港区",
			"parentId": 321200
		}, {
			"id": 321204,
			"name": "姜堰区",
			"parentId": 321200
		}, {
			"id": 321281,
			"name": "兴化市",
			"parentId": 321200
		}, {
			"id": 321282,
			"name": "靖江市",
			"parentId": 321200
		}, {
			"id": 321283,
			"name": "泰兴市",
			"parentId": 321200
		}]
	}, {
		"id": 321300,
		"name": "宿迁市",
		"parentId": 320,
		"children": [{
			"id": 321302,
			"name": "宿城区",
			"parentId": 321300
		}, {
			"id": 321311,
			"name": "宿豫区",
			"parentId": 321300
		}, {
			"id": 321322,
			"name": "沭阳县",
			"parentId": 321300
		}, {
			"id": 321323,
			"name": "泗阳县",
			"parentId": 321300
		}, {
			"id": 321324,
			"name": "泗洪县",
			"parentId": 321300
		}]
	}]
}, {
	"id": 330,
	"name": "浙江省",
	"children": [{
		"id": 330100,
		"name": "杭州市",
		"parentId": 330,
		"children": [{
			"id": 330102,
			"name": "上城区",
			"parentId": 330100
		}, {
			"id": 330103,
			"name": "下城区",
			"parentId": 330100
		}, {
			"id": 330104,
			"name": "江干区",
			"parentId": 330100
		}, {
			"id": 330105,
			"name": "拱墅区",
			"parentId": 330100
		}, {
			"id": 330106,
			"name": "西湖区",
			"parentId": 330100
		}, {
			"id": 330108,
			"name": "滨江区",
			"parentId": 330100
		}, {
			"id": 330109,
			"name": "萧山区",
			"parentId": 330100
		}, {
			"id": 330110,
			"name": "余杭区",
			"parentId": 330100
		}, {
			"id": 330111,
			"name": "富阳区",
			"parentId": 330100
		}, {
			"id": 330112,
			"name": "临安市",
			"parentId": 330100
		}, {
			"id": 330122,
			"name": "桐庐县",
			"parentId": 330100
		}, {
			"id": 330127,
			"name": "淳安县",
			"parentId": 330100
		}, {
			"id": 330182,
			"name": "建德市",
			"parentId": 330100
		}]
	}, {
		"id": 330200,
		"name": "宁波市",
		"parentId": 330,
		"children": [{
			"id": 330203,
			"name": "海曙区",
			"parentId": 330200
		}, {
			"id": 330205,
			"name": "江北区",
			"parentId": 330200
		}, {
			"id": 330206,
			"name": "北仑区",
			"parentId": 330200
		}, {
			"id": 330211,
			"name": "镇海区",
			"parentId": 330200
		}, {
			"id": 330212,
			"name": "鄞州区",
			"parentId": 330200
		}, {
			"id": 330213,
			"name": "奉化区",
			"parentId": 330200
		}, {
			"id": 330225,
			"name": "象山县",
			"parentId": 330200
		}, {
			"id": 330226,
			"name": "宁海县",
			"parentId": 330200
		}, {
			"id": 330281,
			"name": "余姚市",
			"parentId": 330200
		}, {
			"id": 330282,
			"name": "慈溪市",
			"parentId": 330200
		}]
	}, {
		"id": 330300,
		"name": "温州市",
		"parentId": 330,
		"children": [{
			"id": 330302,
			"name": "鹿城区",
			"parentId": 330300
		}, {
			"id": 330303,
			"name": "龙湾区",
			"parentId": 330300
		}, {
			"id": 330304,
			"name": "瓯海区",
			"parentId": 330300
		}, {
			"id": 330305,
			"name": "洞头区",
			"parentId": 330300
		}, {
			"id": 330324,
			"name": "永嘉县",
			"parentId": 330300
		}, {
			"id": 330326,
			"name": "平阳县",
			"parentId": 330300
		}, {
			"id": 330327,
			"name": "苍南县",
			"parentId": 330300
		}, {
			"id": 330328,
			"name": "文成县",
			"parentId": 330300
		}, {
			"id": 330329,
			"name": "泰顺县",
			"parentId": 330300
		}, {
			"id": 330381,
			"name": "瑞安市",
			"parentId": 330300
		}, {
			"id": 330382,
			"name": "乐清市",
			"parentId": 330300
		}]
	}, {
		"id": 330400,
		"name": "嘉兴市",
		"parentId": 330,
		"children": [{
			"id": 330402,
			"name": "南湖区",
			"parentId": 330400
		}, {
			"id": 330411,
			"name": "秀洲区",
			"parentId": 330400
		}, {
			"id": 330421,
			"name": "嘉善县",
			"parentId": 330400
		}, {
			"id": 330424,
			"name": "海盐县",
			"parentId": 330400
		}, {
			"id": 330481,
			"name": "海宁市",
			"parentId": 330400
		}, {
			"id": 330482,
			"name": "平湖市",
			"parentId": 330400
		}, {
			"id": 330483,
			"name": "桐乡市",
			"parentId": 330400
		}]
	}, {
		"id": 330500,
		"name": "湖州市",
		"parentId": 330,
		"children": [{
			"id": 330502,
			"name": "吴兴区",
			"parentId": 330500
		}, {
			"id": 330503,
			"name": "南浔区",
			"parentId": 330500
		}, {
			"id": 330521,
			"name": "德清县",
			"parentId": 330500
		}, {
			"id": 330522,
			"name": "长兴县",
			"parentId": 330500
		}, {
			"id": 330523,
			"name": "安吉县",
			"parentId": 330500
		}]
	}, {
		"id": 330600,
		"name": "绍兴市",
		"parentId": 330,
		"children": [{
			"id": 330602,
			"name": "越城区",
			"parentId": 330600
		}, {
			"id": 330603,
			"name": "柯桥区",
			"parentId": 330600
		}, {
			"id": 330604,
			"name": "上虞区",
			"parentId": 330600
		}, {
			"id": 330624,
			"name": "新昌县",
			"parentId": 330600
		}, {
			"id": 330681,
			"name": "诸暨市",
			"parentId": 330600
		}, {
			"id": 330683,
			"name": "嵊州市",
			"parentId": 330600
		}]
	}, {
		"id": 330700,
		"name": "金华市",
		"parentId": 330,
		"children": [{
			"id": 330702,
			"name": "婺城区",
			"parentId": 330700
		}, {
			"id": 330703,
			"name": "金东区",
			"parentId": 330700
		}, {
			"id": 330723,
			"name": "武义县",
			"parentId": 330700
		}, {
			"id": 330726,
			"name": "浦江县",
			"parentId": 330700
		}, {
			"id": 330727,
			"name": "磐安县",
			"parentId": 330700
		}, {
			"id": 330781,
			"name": "兰溪市",
			"parentId": 330700
		}, {
			"id": 330782,
			"name": "义乌市",
			"parentId": 330700
		}, {
			"id": 330783,
			"name": "东阳市",
			"parentId": 330700
		}, {
			"id": 330784,
			"name": "永康市",
			"parentId": 330700
		}]
	}, {
		"id": 330800,
		"name": "衢州市",
		"parentId": 330,
		"children": [{
			"id": 330802,
			"name": "柯城区",
			"parentId": 330800
		}, {
			"id": 330803,
			"name": "衢江区",
			"parentId": 330800
		}, {
			"id": 330822,
			"name": "常山县",
			"parentId": 330800
		}, {
			"id": 330824,
			"name": "开化县",
			"parentId": 330800
		}, {
			"id": 330825,
			"name": "龙游县",
			"parentId": 330800
		}, {
			"id": 330881,
			"name": "江山市",
			"parentId": 330800
		}]
	}, {
		"id": 330900,
		"name": "舟山市",
		"parentId": 330,
		"children": [{
			"id": 330902,
			"name": "定海区",
			"parentId": 330900
		}, {
			"id": 330903,
			"name": "普陀区",
			"parentId": 330900
		}, {
			"id": 330921,
			"name": "岱山县",
			"parentId": 330900
		}, {
			"id": 330922,
			"name": "嵊泗县",
			"parentId": 330900
		}]
	}, {
		"id": 331000,
		"name": "台州市",
		"parentId": 330,
		"children": [{
			"id": 331002,
			"name": "椒江区",
			"parentId": 331000
		}, {
			"id": 331003,
			"name": "黄岩区",
			"parentId": 331000
		}, {
			"id": 331004,
			"name": "路桥区",
			"parentId": 331000
		}, {
			"id": 331022,
			"name": "三门县",
			"parentId": 331000
		}, {
			"id": 331023,
			"name": "天台县",
			"parentId": 331000
		}, {
			"id": 331024,
			"name": "仙居县",
			"parentId": 331000
		}, {
			"id": 331081,
			"name": "温岭市",
			"parentId": 331000
		}, {
			"id": 331082,
			"name": "临海市",
			"parentId": 331000
		}, {
			"id": 331083,
			"name": "玉环市",
			"parentId": 331000
		}]
	}, {
		"id": 331100,
		"name": "丽水市",
		"parentId": 330,
		"children": [{
			"id": 331102,
			"name": "莲都区",
			"parentId": 331100
		}, {
			"id": 331121,
			"name": "青田县",
			"parentId": 331100
		}, {
			"id": 331122,
			"name": "缙云县",
			"parentId": 331100
		}, {
			"id": 331123,
			"name": "遂昌县",
			"parentId": 331100
		}, {
			"id": 331124,
			"name": "松阳县",
			"parentId": 331100
		}, {
			"id": 331125,
			"name": "云和县",
			"parentId": 331100
		}, {
			"id": 331126,
			"name": "庆元县",
			"parentId": 331100
		}, {
			"id": 331127,
			"name": "景宁畲族自治县",
			"parentId": 331100
		}, {
			"id": 331181,
			"name": "龙泉市",
			"parentId": 331100
		}]
	}]
}, {
	"id": 340,
	"name": "安徽省",
	"children": [{
		"id": 340100,
		"name": "合肥市",
		"parentId": 340,
		"children": [{
			"id": 340102,
			"name": "瑶海区",
			"parentId": 340100
		}, {
			"id": 340103,
			"name": "庐阳区",
			"parentId": 340100
		}, {
			"id": 340104,
			"name": "蜀山区",
			"parentId": 340100
		}, {
			"id": 340111,
			"name": "包河区",
			"parentId": 340100
		}, {
			"id": 340121,
			"name": "长丰县",
			"parentId": 340100
		}, {
			"id": 340122,
			"name": "肥东县",
			"parentId": 340100
		}, {
			"id": 340123,
			"name": "肥西县",
			"parentId": 340100
		}, {
			"id": 340124,
			"name": "庐江县",
			"parentId": 340100
		}, {
			"id": 340181,
			"name": "巢湖市",
			"parentId": 340100
		}]
	}, {
		"id": 340200,
		"name": "芜湖市",
		"parentId": 340,
		"children": [{
			"id": 340202,
			"name": "镜湖区",
			"parentId": 340200
		}, {
			"id": 340203,
			"name": "弋江区",
			"parentId": 340200
		}, {
			"id": 340207,
			"name": "鸠江区",
			"parentId": 340200
		}, {
			"id": 340208,
			"name": "三山区",
			"parentId": 340200
		}, {
			"id": 340221,
			"name": "芜湖县",
			"parentId": 340200
		}, {
			"id": 340222,
			"name": "繁昌县",
			"parentId": 340200
		}, {
			"id": 340223,
			"name": "南陵县",
			"parentId": 340200
		}, {
			"id": 340225,
			"name": "无为县",
			"parentId": 340200
		}]
	}, {
		"id": 340300,
		"name": "蚌埠市",
		"parentId": 340,
		"children": [{
			"id": 340302,
			"name": "龙子湖区",
			"parentId": 340300
		}, {
			"id": 340303,
			"name": "蚌山区",
			"parentId": 340300
		}, {
			"id": 340304,
			"name": "禹会区",
			"parentId": 340300
		}, {
			"id": 340311,
			"name": "淮上区",
			"parentId": 340300
		}, {
			"id": 340321,
			"name": "怀远县",
			"parentId": 340300
		}, {
			"id": 340322,
			"name": "五河县",
			"parentId": 340300
		}, {
			"id": 340323,
			"name": "固镇县",
			"parentId": 340300
		}]
	}, {
		"id": 340400,
		"name": "淮南市",
		"parentId": 340,
		"children": [{
			"id": 340402,
			"name": "大通区",
			"parentId": 340400
		}, {
			"id": 340403,
			"name": "田家庵区",
			"parentId": 340400
		}, {
			"id": 340404,
			"name": "谢家集区",
			"parentId": 340400
		}, {
			"id": 340405,
			"name": "八公山区",
			"parentId": 340400
		}, {
			"id": 340406,
			"name": "潘集区",
			"parentId": 340400
		}, {
			"id": 340421,
			"name": "凤台县",
			"parentId": 340400
		}, {
			"id": 340422,
			"name": "寿县",
			"parentId": 340400
		}]
	}, {
		"id": 340500,
		"name": "马鞍山市",
		"parentId": 340,
		"children": [{
			"id": 340503,
			"name": "花山区",
			"parentId": 340500
		}, {
			"id": 340504,
			"name": "雨山区",
			"parentId": 340500
		}, {
			"id": 340506,
			"name": "博望区",
			"parentId": 340500
		}, {
			"id": 340521,
			"name": "当涂县",
			"parentId": 340500
		}, {
			"id": 340522,
			"name": "含山县",
			"parentId": 340500
		}, {
			"id": 340523,
			"name": "和县",
			"parentId": 340500
		}]
	}, {
		"id": 340600,
		"name": "淮北市",
		"parentId": 340,
		"children": [{
			"id": 340602,
			"name": "杜集区",
			"parentId": 340600
		}, {
			"id": 340603,
			"name": "相山区",
			"parentId": 340600
		}, {
			"id": 340604,
			"name": "烈山区",
			"parentId": 340600
		}, {
			"id": 340621,
			"name": "濉溪县",
			"parentId": 340600
		}]
	}, {
		"id": 340700,
		"name": "铜陵市",
		"parentId": 340,
		"children": [{
			"id": 340705,
			"name": "铜官区",
			"parentId": 340700
		}, {
			"id": 340706,
			"name": "义安区",
			"parentId": 340700
		}, {
			"id": 340711,
			"name": "郊区",
			"parentId": 340700
		}, {
			"id": 340722,
			"name": "枞阳县",
			"parentId": 340700
		}]
	}, {
		"id": 340800,
		"name": "安庆市",
		"parentId": 340,
		"children": [{
			"id": 340802,
			"name": "迎江区",
			"parentId": 340800
		}, {
			"id": 340803,
			"name": "大观区",
			"parentId": 340800
		}, {
			"id": 340811,
			"name": "宜秀区",
			"parentId": 340800
		}, {
			"id": 340822,
			"name": "怀宁县",
			"parentId": 340800
		}, {
			"id": 340824,
			"name": "潜山县",
			"parentId": 340800
		}, {
			"id": 340825,
			"name": "太湖县",
			"parentId": 340800
		}, {
			"id": 340826,
			"name": "宿松县",
			"parentId": 340800
		}, {
			"id": 340827,
			"name": "望江县",
			"parentId": 340800
		}, {
			"id": 340828,
			"name": "岳西县",
			"parentId": 340800
		}, {
			"id": 340881,
			"name": "桐城市",
			"parentId": 340800
		}]
	}, {
		"id": 341000,
		"name": "黄山市",
		"parentId": 340,
		"children": [{
			"id": 341002,
			"name": "屯溪区",
			"parentId": 341000
		}, {
			"id": 341003,
			"name": "黄山区",
			"parentId": 341000
		}, {
			"id": 341004,
			"name": "徽州区",
			"parentId": 341000
		}, {
			"id": 341021,
			"name": "歙县",
			"parentId": 341000
		}, {
			"id": 341022,
			"name": "休宁县",
			"parentId": 341000
		}, {
			"id": 341023,
			"name": "黟县",
			"parentId": 341000
		}, {
			"id": 341024,
			"name": "祁门县",
			"parentId": 341000
		}]
	}, {
		"id": 341100,
		"name": "滁州市",
		"parentId": 340,
		"children": [{
			"id": 341102,
			"name": "琅琊区",
			"parentId": 341100
		}, {
			"id": 341103,
			"name": "南谯区",
			"parentId": 341100
		}, {
			"id": 341122,
			"name": "来安县",
			"parentId": 341100
		}, {
			"id": 341124,
			"name": "全椒县",
			"parentId": 341100
		}, {
			"id": 341125,
			"name": "定远县",
			"parentId": 341100
		}, {
			"id": 341126,
			"name": "凤阳县",
			"parentId": 341100
		}, {
			"id": 341181,
			"name": "天长市",
			"parentId": 341100
		}, {
			"id": 341182,
			"name": "明光市",
			"parentId": 341100
		}]
	}, {
		"id": 341200,
		"name": "阜阳市",
		"parentId": 340,
		"children": [{
			"id": 341202,
			"name": "颍州区",
			"parentId": 341200
		}, {
			"id": 341203,
			"name": "颍东区",
			"parentId": 341200
		}, {
			"id": 341204,
			"name": "颍泉区",
			"parentId": 341200
		}, {
			"id": 341221,
			"name": "临泉县",
			"parentId": 341200
		}, {
			"id": 341222,
			"name": "太和县",
			"parentId": 341200
		}, {
			"id": 341225,
			"name": "阜南县",
			"parentId": 341200
		}, {
			"id": 341226,
			"name": "颍上县",
			"parentId": 341200
		}, {
			"id": 341282,
			"name": "界首市",
			"parentId": 341200
		}]
	}, {
		"id": 341300,
		"name": "宿州市",
		"parentId": 340,
		"children": [{
			"id": 341302,
			"name": "埇桥区",
			"parentId": 341300
		}, {
			"id": 341321,
			"name": "砀山县",
			"parentId": 341300
		}, {
			"id": 341322,
			"name": "萧县",
			"parentId": 341300
		}, {
			"id": 341323,
			"name": "灵璧县",
			"parentId": 341300
		}, {
			"id": 341324,
			"name": "泗县",
			"parentId": 341300
		}]
	}, {
		"id": 341500,
		"name": "六安市",
		"parentId": 340,
		"children": [{
			"id": 341502,
			"name": "金安区",
			"parentId": 341500
		}, {
			"id": 341503,
			"name": "裕安区",
			"parentId": 341500
		}, {
			"id": 341504,
			"name": "叶集区",
			"parentId": 341500
		}, {
			"id": 341522,
			"name": "霍邱县",
			"parentId": 341500
		}, {
			"id": 341523,
			"name": "舒城县",
			"parentId": 341500
		}, {
			"id": 341524,
			"name": "金寨县",
			"parentId": 341500
		}, {
			"id": 341525,
			"name": "霍山县",
			"parentId": 341500
		}]
	}, {
		"id": 341600,
		"name": "亳州市",
		"parentId": 340,
		"children": [{
			"id": 341602,
			"name": "谯城区",
			"parentId": 341600
		}, {
			"id": 341621,
			"name": "涡阳县",
			"parentId": 341600
		}, {
			"id": 341622,
			"name": "蒙城县",
			"parentId": 341600
		}, {
			"id": 341623,
			"name": "利辛县",
			"parentId": 341600
		}]
	}, {
		"id": 341700,
		"name": "池州市",
		"parentId": 340,
		"children": [{
			"id": 341702,
			"name": "贵池区",
			"parentId": 341700
		}, {
			"id": 341721,
			"name": "东至县",
			"parentId": 341700
		}, {
			"id": 341722,
			"name": "石台县",
			"parentId": 341700
		}, {
			"id": 341723,
			"name": "青阳县",
			"parentId": 341700
		}]
	}, {
		"id": 341800,
		"name": "宣城市",
		"parentId": 340,
		"children": [{
			"id": 341802,
			"name": "宣州区",
			"parentId": 341800
		}, {
			"id": 341821,
			"name": "郎溪县",
			"parentId": 341800
		}, {
			"id": 341822,
			"name": "广德县",
			"parentId": 341800
		}, {
			"id": 341823,
			"name": "泾县",
			"parentId": 341800
		}, {
			"id": 341824,
			"name": "绩溪县",
			"parentId": 341800
		}, {
			"id": 341825,
			"name": "旌德县",
			"parentId": 341800
		}, {
			"id": 341881,
			"name": "宁国市",
			"parentId": 341800
		}]
	}]
}, {
	"id": 350,
	"name": "福建省",
	"children": [{
		"id": 350100,
		"name": "福州市",
		"parentId": 350,
		"children": [{
			"id": 350102,
			"name": "鼓楼区",
			"parentId": 350100
		}, {
			"id": 350103,
			"name": "台江区",
			"parentId": 350100
		}, {
			"id": 350104,
			"name": "仓山区",
			"parentId": 350100
		}, {
			"id": 350105,
			"name": "马尾区",
			"parentId": 350100
		}, {
			"id": 350111,
			"name": "晋安区",
			"parentId": 350100
		}, {
			"id": 350121,
			"name": "闽侯县",
			"parentId": 350100
		}, {
			"id": 350122,
			"name": "连江县",
			"parentId": 350100
		}, {
			"id": 350123,
			"name": "罗源县",
			"parentId": 350100
		}, {
			"id": 350124,
			"name": "闽清县",
			"parentId": 350100
		}, {
			"id": 350125,
			"name": "永泰县",
			"parentId": 350100
		}, {
			"id": 350128,
			"name": "平潭县",
			"parentId": 350100
		}, {
			"id": 350181,
			"name": "福清市",
			"parentId": 350100
		}, {
			"id": 350182,
			"name": "长乐市",
			"parentId": 350100
		}]
	}, {
		"id": 350200,
		"name": "厦门市",
		"parentId": 350,
		"children": [{
			"id": 350203,
			"name": "思明区",
			"parentId": 350200
		}, {
			"id": 350205,
			"name": "海沧区",
			"parentId": 350200
		}, {
			"id": 350206,
			"name": "湖里区",
			"parentId": 350200
		}, {
			"id": 350211,
			"name": "集美区",
			"parentId": 350200
		}, {
			"id": 350212,
			"name": "同安区",
			"parentId": 350200
		}, {
			"id": 350213,
			"name": "翔安区",
			"parentId": 350200
		}]
	}, {
		"id": 350300,
		"name": "莆田市",
		"parentId": 350,
		"children": [{
			"id": 350302,
			"name": "城厢区",
			"parentId": 350300
		}, {
			"id": 350303,
			"name": "涵江区",
			"parentId": 350300
		}, {
			"id": 350304,
			"name": "荔城区",
			"parentId": 350300
		}, {
			"id": 350305,
			"name": "秀屿区",
			"parentId": 350300
		}, {
			"id": 350322,
			"name": "仙游县",
			"parentId": 350300
		}]
	}, {
		"id": 350400,
		"name": "三明市",
		"parentId": 350,
		"children": [{
			"id": 350402,
			"name": "梅列区",
			"parentId": 350400
		}, {
			"id": 350403,
			"name": "三元区",
			"parentId": 350400
		}, {
			"id": 350421,
			"name": "明溪县",
			"parentId": 350400
		}, {
			"id": 350423,
			"name": "清流县",
			"parentId": 350400
		}, {
			"id": 350424,
			"name": "宁化县",
			"parentId": 350400
		}, {
			"id": 350425,
			"name": "大田县",
			"parentId": 350400
		}, {
			"id": 350426,
			"name": "尤溪县",
			"parentId": 350400
		}, {
			"id": 350427,
			"name": "沙县",
			"parentId": 350400
		}, {
			"id": 350428,
			"name": "将乐县",
			"parentId": 350400
		}, {
			"id": 350429,
			"name": "泰宁县",
			"parentId": 350400
		}, {
			"id": 350430,
			"name": "建宁县",
			"parentId": 350400
		}, {
			"id": 350481,
			"name": "永安市",
			"parentId": 350400
		}]
	}, {
		"id": 350500,
		"name": "泉州市",
		"parentId": 350,
		"children": [{
			"id": 350502,
			"name": "鲤城区",
			"parentId": 350500
		}, {
			"id": 350503,
			"name": "丰泽区",
			"parentId": 350500
		}, {
			"id": 350504,
			"name": "洛江区",
			"parentId": 350500
		}, {
			"id": 350505,
			"name": "泉港区",
			"parentId": 350500
		}, {
			"id": 350521,
			"name": "惠安县",
			"parentId": 350500
		}, {
			"id": 350524,
			"name": "安溪县",
			"parentId": 350500
		}, {
			"id": 350525,
			"name": "永春县",
			"parentId": 350500
		}, {
			"id": 350526,
			"name": "德化县",
			"parentId": 350500
		}, {
			"id": 350527,
			"name": "金门县",
			"parentId": 350500
		}, {
			"id": 350581,
			"name": "石狮市",
			"parentId": 350500
		}, {
			"id": 350582,
			"name": "晋江市",
			"parentId": 350500
		}, {
			"id": 350583,
			"name": "南安市",
			"parentId": 350500
		}]
	}, {
		"id": 350600,
		"name": "漳州市",
		"parentId": 350,
		"children": [{
			"id": 350602,
			"name": "芗城区",
			"parentId": 350600
		}, {
			"id": 350603,
			"name": "龙文区",
			"parentId": 350600
		}, {
			"id": 350622,
			"name": "云霄县",
			"parentId": 350600
		}, {
			"id": 350623,
			"name": "漳浦县",
			"parentId": 350600
		}, {
			"id": 350624,
			"name": "诏安县",
			"parentId": 350600
		}, {
			"id": 350625,
			"name": "长泰县",
			"parentId": 350600
		}, {
			"id": 350626,
			"name": "东山县",
			"parentId": 350600
		}, {
			"id": 350627,
			"name": "南靖县",
			"parentId": 350600
		}, {
			"id": 350628,
			"name": "平和县",
			"parentId": 350600
		}, {
			"id": 350629,
			"name": "华安县",
			"parentId": 350600
		}, {
			"id": 350681,
			"name": "龙海市",
			"parentId": 350600
		}]
	}, {
		"id": 350700,
		"name": "南平市",
		"parentId": 350,
		"children": [{
			"id": 350702,
			"name": "延平区",
			"parentId": 350700
		}, {
			"id": 350703,
			"name": "建阳区",
			"parentId": 350700
		}, {
			"id": 350721,
			"name": "顺昌县",
			"parentId": 350700
		}, {
			"id": 350722,
			"name": "浦城县",
			"parentId": 350700
		}, {
			"id": 350723,
			"name": "光泽县",
			"parentId": 350700
		}, {
			"id": 350724,
			"name": "松溪县",
			"parentId": 350700
		}, {
			"id": 350725,
			"name": "政和县",
			"parentId": 350700
		}, {
			"id": 350781,
			"name": "邵武市",
			"parentId": 350700
		}, {
			"id": 350782,
			"name": "武夷山市",
			"parentId": 350700
		}, {
			"id": 350783,
			"name": "建瓯市",
			"parentId": 350700
		}]
	}, {
		"id": 350800,
		"name": "龙岩市",
		"parentId": 350,
		"children": [{
			"id": 350802,
			"name": "新罗区",
			"parentId": 350800
		}, {
			"id": 350803,
			"name": "永定区",
			"parentId": 350800
		}, {
			"id": 350821,
			"name": "长汀县",
			"parentId": 350800
		}, {
			"id": 350823,
			"name": "上杭县",
			"parentId": 350800
		}, {
			"id": 350824,
			"name": "武平县",
			"parentId": 350800
		}, {
			"id": 350825,
			"name": "连城县",
			"parentId": 350800
		}, {
			"id": 350881,
			"name": "漳平市",
			"parentId": 350800
		}]
	}, {
		"id": 350900,
		"name": "宁德市",
		"parentId": 350,
		"children": [{
			"id": 350902,
			"name": "蕉城区",
			"parentId": 350900
		}, {
			"id": 350921,
			"name": "霞浦县",
			"parentId": 350900
		}, {
			"id": 350922,
			"name": "古田县",
			"parentId": 350900
		}, {
			"id": 350923,
			"name": "屏南县",
			"parentId": 350900
		}, {
			"id": 350924,
			"name": "寿宁县",
			"parentId": 350900
		}, {
			"id": 350925,
			"name": "周宁县",
			"parentId": 350900
		}, {
			"id": 350926,
			"name": "柘荣县",
			"parentId": 350900
		}, {
			"id": 350981,
			"name": "福安市",
			"parentId": 350900
		}, {
			"id": 350982,
			"name": "福鼎市",
			"parentId": 350900
		}]
	}]
}, {
	"id": 360,
	"name": "江西省",
	"children": [{
		"id": 360100,
		"name": "南昌市",
		"parentId": 360,
		"children": [{
			"id": 360102,
			"name": "东湖区",
			"parentId": 360100
		}, {
			"id": 360103,
			"name": "西湖区",
			"parentId": 360100
		}, {
			"id": 360104,
			"name": "青云谱区",
			"parentId": 360100
		}, {
			"id": 360105,
			"name": "湾里区",
			"parentId": 360100
		}, {
			"id": 360111,
			"name": "青山湖区",
			"parentId": 360100
		}, {
			"id": 360112,
			"name": "新建区",
			"parentId": 360100
		}, {
			"id": 360121,
			"name": "南昌县",
			"parentId": 360100
		}, {
			"id": 360123,
			"name": "安义县",
			"parentId": 360100
		}, {
			"id": 360124,
			"name": "进贤县",
			"parentId": 360100
		}]
	}, {
		"id": 360200,
		"name": "景德镇市",
		"parentId": 360,
		"children": [{
			"id": 360202,
			"name": "昌江区",
			"parentId": 360200
		}, {
			"id": 360203,
			"name": "珠山区",
			"parentId": 360200
		}, {
			"id": 360222,
			"name": "浮梁县",
			"parentId": 360200
		}, {
			"id": 360281,
			"name": "乐平市",
			"parentId": 360200
		}]
	}, {
		"id": 360300,
		"name": "萍乡市",
		"parentId": 360,
		"children": [{
			"id": 360302,
			"name": "安源区",
			"parentId": 360300
		}, {
			"id": 360313,
			"name": "湘东区",
			"parentId": 360300
		}, {
			"id": 360321,
			"name": "莲花县",
			"parentId": 360300
		}, {
			"id": 360322,
			"name": "上栗县",
			"parentId": 360300
		}, {
			"id": 360323,
			"name": "芦溪县",
			"parentId": 360300
		}]
	}, {
		"id": 360400,
		"name": "九江市",
		"parentId": 360,
		"children": [{
			"id": 360402,
			"name": "濂溪区",
			"parentId": 360400
		}, {
			"id": 360403,
			"name": "浔阳区",
			"parentId": 360400
		}, {
			"id": 360421,
			"name": "九江县",
			"parentId": 360400
		}, {
			"id": 360423,
			"name": "武宁县",
			"parentId": 360400
		}, {
			"id": 360424,
			"name": "修水县",
			"parentId": 360400
		}, {
			"id": 360425,
			"name": "永修县",
			"parentId": 360400
		}, {
			"id": 360426,
			"name": "德安县",
			"parentId": 360400
		}, {
			"id": 360428,
			"name": "都昌县",
			"parentId": 360400
		}, {
			"id": 360429,
			"name": "湖口县",
			"parentId": 360400
		}, {
			"id": 360430,
			"name": "彭泽县",
			"parentId": 360400
		}, {
			"id": 360481,
			"name": "瑞昌市",
			"parentId": 360400
		}, {
			"id": 360482,
			"name": "共青城市",
			"parentId": 360400
		}, {
			"id": 360483,
			"name": "庐山市",
			"parentId": 360400
		}]
	}, {
		"id": 360500,
		"name": "新余市",
		"parentId": 360,
		"children": [{
			"id": 360502,
			"name": "渝水区",
			"parentId": 360500
		}, {
			"id": 360521,
			"name": "分宜县",
			"parentId": 360500
		}]
	}, {
		"id": 360600,
		"name": "鹰潭市",
		"parentId": 360,
		"children": [{
			"id": 360602,
			"name": "月湖区",
			"parentId": 360600
		}, {
			"id": 360622,
			"name": "余江县",
			"parentId": 360600
		}, {
			"id": 360681,
			"name": "贵溪市",
			"parentId": 360600
		}]
	}, {
		"id": 360700,
		"name": "赣州市",
		"parentId": 360,
		"children": [{
			"id": 360702,
			"name": "章贡区",
			"parentId": 360700
		}, {
			"id": 360703,
			"name": "南康区",
			"parentId": 360700
		}, {
			"id": 360704,
			"name": "赣县区",
			"parentId": 360700
		}, {
			"id": 360722,
			"name": "信丰县",
			"parentId": 360700
		}, {
			"id": 360723,
			"name": "大余县",
			"parentId": 360700
		}, {
			"id": 360724,
			"name": "上犹县",
			"parentId": 360700
		}, {
			"id": 360725,
			"name": "崇义县",
			"parentId": 360700
		}, {
			"id": 360726,
			"name": "安远县",
			"parentId": 360700
		}, {
			"id": 360727,
			"name": "龙南县",
			"parentId": 360700
		}, {
			"id": 360728,
			"name": "定南县",
			"parentId": 360700
		}, {
			"id": 360729,
			"name": "全南县",
			"parentId": 360700
		}, {
			"id": 360730,
			"name": "宁都县",
			"parentId": 360700
		}, {
			"id": 360731,
			"name": "于都县",
			"parentId": 360700
		}, {
			"id": 360732,
			"name": "兴国县",
			"parentId": 360700
		}, {
			"id": 360733,
			"name": "会昌县",
			"parentId": 360700
		}, {
			"id": 360734,
			"name": "寻乌县",
			"parentId": 360700
		}, {
			"id": 360735,
			"name": "石城县",
			"parentId": 360700
		}, {
			"id": 360781,
			"name": "瑞金市",
			"parentId": 360700
		}]
	}, {
		"id": 360800,
		"name": "吉安市",
		"parentId": 360,
		"children": [{
			"id": 360802,
			"name": "吉州区",
			"parentId": 360800
		}, {
			"id": 360803,
			"name": "青原区",
			"parentId": 360800
		}, {
			"id": 360821,
			"name": "吉安县",
			"parentId": 360800
		}, {
			"id": 360822,
			"name": "吉水县",
			"parentId": 360800
		}, {
			"id": 360823,
			"name": "峡江县",
			"parentId": 360800
		}, {
			"id": 360824,
			"name": "新干县",
			"parentId": 360800
		}, {
			"id": 360825,
			"name": "永丰县",
			"parentId": 360800
		}, {
			"id": 360826,
			"name": "泰和县",
			"parentId": 360800
		}, {
			"id": 360827,
			"name": "遂川县",
			"parentId": 360800
		}, {
			"id": 360828,
			"name": "万安县",
			"parentId": 360800
		}, {
			"id": 360829,
			"name": "安福县",
			"parentId": 360800
		}, {
			"id": 360830,
			"name": "永新县",
			"parentId": 360800
		}, {
			"id": 360881,
			"name": "井冈山市",
			"parentId": 360800
		}]
	}, {
		"id": 360900,
		"name": "宜春市",
		"parentId": 360,
		"children": [{
			"id": 360902,
			"name": "袁州区",
			"parentId": 360900
		}, {
			"id": 360921,
			"name": "奉新县",
			"parentId": 360900
		}, {
			"id": 360922,
			"name": "万载县",
			"parentId": 360900
		}, {
			"id": 360923,
			"name": "上高县",
			"parentId": 360900
		}, {
			"id": 360924,
			"name": "宜丰县",
			"parentId": 360900
		}, {
			"id": 360925,
			"name": "靖安县",
			"parentId": 360900
		}, {
			"id": 360926,
			"name": "铜鼓县",
			"parentId": 360900
		}, {
			"id": 360981,
			"name": "丰城市",
			"parentId": 360900
		}, {
			"id": 360982,
			"name": "樟树市",
			"parentId": 360900
		}, {
			"id": 360983,
			"name": "高安市",
			"parentId": 360900
		}]
	}, {
		"id": 361000,
		"name": "抚州市",
		"parentId": 360,
		"children": [{
			"id": 361002,
			"name": "临川区",
			"parentId": 361000
		}, {
			"id": 361003,
			"name": "东乡区",
			"parentId": 361000
		}, {
			"id": 361021,
			"name": "南城县",
			"parentId": 361000
		}, {
			"id": 361022,
			"name": "黎川县",
			"parentId": 361000
		}, {
			"id": 361023,
			"name": "南丰县",
			"parentId": 361000
		}, {
			"id": 361024,
			"name": "崇仁县",
			"parentId": 361000
		}, {
			"id": 361025,
			"name": "乐安县",
			"parentId": 361000
		}, {
			"id": 361026,
			"name": "宜黄县",
			"parentId": 361000
		}, {
			"id": 361027,
			"name": "金溪县",
			"parentId": 361000
		}, {
			"id": 361028,
			"name": "资溪县",
			"parentId": 361000
		}, {
			"id": 361030,
			"name": "广昌县",
			"parentId": 361000
		}]
	}, {
		"id": 361100,
		"name": "上饶市",
		"parentId": 360,
		"children": [{
			"id": 361102,
			"name": "信州区",
			"parentId": 361100
		}, {
			"id": 361103,
			"name": "广丰区",
			"parentId": 361100
		}, {
			"id": 361121,
			"name": "上饶县",
			"parentId": 361100
		}, {
			"id": 361123,
			"name": "玉山县",
			"parentId": 361100
		}, {
			"id": 361124,
			"name": "铅山县",
			"parentId": 361100
		}, {
			"id": 361125,
			"name": "横峰县",
			"parentId": 361100
		}, {
			"id": 361126,
			"name": "弋阳县",
			"parentId": 361100
		}, {
			"id": 361127,
			"name": "余干县",
			"parentId": 361100
		}, {
			"id": 361128,
			"name": "鄱阳县",
			"parentId": 361100
		}, {
			"id": 361129,
			"name": "万年县",
			"parentId": 361100
		}, {
			"id": 361130,
			"name": "婺源县",
			"parentId": 361100
		}, {
			"id": 361181,
			"name": "德兴市",
			"parentId": 361100
		}]
	}]
}, {
	"id": 370,
	"name": "山东省",
	"children": [{
		"id": 370100,
		"name": "济南市",
		"parentId": 370,
		"children": [{
			"id": 370102,
			"name": "历下区",
			"parentId": 370100
		}, {
			"id": 370103,
			"name": "市中区",
			"parentId": 370100
		}, {
			"id": 370104,
			"name": "槐荫区",
			"parentId": 370100
		}, {
			"id": 370105,
			"name": "天桥区",
			"parentId": 370100
		}, {
			"id": 370112,
			"name": "历城区",
			"parentId": 370100
		}, {
			"id": 370113,
			"name": "长清区",
			"parentId": 370100
		}, {
			"id": 370114,
			"name": "章丘区",
			"parentId": 370100
		}, {
			"id": 370124,
			"name": "平阴县",
			"parentId": 370100
		}, {
			"id": 370125,
			"name": "济阳县",
			"parentId": 370100
		}, {
			"id": 370126,
			"name": "商河县",
			"parentId": 370100
		}]
	}, {
		"id": 370200,
		"name": "青岛市",
		"parentId": 370,
		"children": [{
			"id": 370202,
			"name": "市南区",
			"parentId": 370200
		}, {
			"id": 370203,
			"name": "市北区",
			"parentId": 370200
		}, {
			"id": 370211,
			"name": "黄岛区",
			"parentId": 370200
		}, {
			"id": 370212,
			"name": "崂山区",
			"parentId": 370200
		}, {
			"id": 370213,
			"name": "李沧区",
			"parentId": 370200
		}, {
			"id": 370214,
			"name": "城阳区",
			"parentId": 370200
		}, {
			"id": 370281,
			"name": "胶州市",
			"parentId": 370200
		}, {
			"id": 370282,
			"name": "即墨市",
			"parentId": 370200
		}, {
			"id": 370283,
			"name": "平度市",
			"parentId": 370200
		}, {
			"id": 370285,
			"name": "莱西市",
			"parentId": 370200
		}]
	}, {
		"id": 370300,
		"name": "淄博市",
		"parentId": 370,
		"children": [{
			"id": 370302,
			"name": "淄川区",
			"parentId": 370300
		}, {
			"id": 370303,
			"name": "张店区",
			"parentId": 370300
		}, {
			"id": 370304,
			"name": "博山区",
			"parentId": 370300
		}, {
			"id": 370305,
			"name": "临淄区",
			"parentId": 370300
		}, {
			"id": 370306,
			"name": "周村区",
			"parentId": 370300
		}, {
			"id": 370321,
			"name": "桓台县",
			"parentId": 370300
		}, {
			"id": 370322,
			"name": "高青县",
			"parentId": 370300
		}, {
			"id": 370323,
			"name": "沂源县",
			"parentId": 370300
		}]
	}, {
		"id": 370400,
		"name": "枣庄市",
		"parentId": 370,
		"children": [{
			"id": 370402,
			"name": "市中区",
			"parentId": 370400
		}, {
			"id": 370403,
			"name": "薛城区",
			"parentId": 370400
		}, {
			"id": 370404,
			"name": "峄城区",
			"parentId": 370400
		}, {
			"id": 370405,
			"name": "台儿庄区",
			"parentId": 370400
		}, {
			"id": 370406,
			"name": "山亭区",
			"parentId": 370400
		}, {
			"id": 370481,
			"name": "滕州市",
			"parentId": 370400
		}]
	}, {
		"id": 370500,
		"name": "东营市",
		"parentId": 370,
		"children": [{
			"id": 370502,
			"name": "东营区",
			"parentId": 370500
		}, {
			"id": 370503,
			"name": "河口区",
			"parentId": 370500
		}, {
			"id": 370505,
			"name": "垦利区",
			"parentId": 370500
		}, {
			"id": 370522,
			"name": "利津县",
			"parentId": 370500
		}, {
			"id": 370523,
			"name": "广饶县",
			"parentId": 370500
		}]
	}, {
		"id": 370600,
		"name": "烟台市",
		"parentId": 370,
		"children": [{
			"id": 370602,
			"name": "芝罘区",
			"parentId": 370600
		}, {
			"id": 370611,
			"name": "福山区",
			"parentId": 370600
		}, {
			"id": 370612,
			"name": "牟平区",
			"parentId": 370600
		}, {
			"id": 370613,
			"name": "莱山区",
			"parentId": 370600
		}, {
			"id": 370634,
			"name": "长岛县",
			"parentId": 370600
		}, {
			"id": 370681,
			"name": "龙口市",
			"parentId": 370600
		}, {
			"id": 370682,
			"name": "莱阳市",
			"parentId": 370600
		}, {
			"id": 370683,
			"name": "莱州市",
			"parentId": 370600
		}, {
			"id": 370684,
			"name": "蓬莱市",
			"parentId": 370600
		}, {
			"id": 370685,
			"name": "招远市",
			"parentId": 370600
		}, {
			"id": 370686,
			"name": "栖霞市",
			"parentId": 370600
		}, {
			"id": 370687,
			"name": "海阳市",
			"parentId": 370600
		}]
	}, {
		"id": 370700,
		"name": "潍坊市",
		"parentId": 370,
		"children": [{
			"id": 370702,
			"name": "潍城区",
			"parentId": 370700
		}, {
			"id": 370703,
			"name": "寒亭区",
			"parentId": 370700
		}, {
			"id": 370704,
			"name": "坊子区",
			"parentId": 370700
		}, {
			"id": 370705,
			"name": "奎文区",
			"parentId": 370700
		}, {
			"id": 370724,
			"name": "临朐县",
			"parentId": 370700
		}, {
			"id": 370725,
			"name": "昌乐县",
			"parentId": 370700
		}, {
			"id": 370781,
			"name": "青州市",
			"parentId": 370700
		}, {
			"id": 370782,
			"name": "诸城市",
			"parentId": 370700
		}, {
			"id": 370783,
			"name": "寿光市",
			"parentId": 370700
		}, {
			"id": 370784,
			"name": "安丘市",
			"parentId": 370700
		}, {
			"id": 370785,
			"name": "高密市",
			"parentId": 370700
		}, {
			"id": 370786,
			"name": "昌邑市",
			"parentId": 370700
		}]
	}, {
		"id": 370800,
		"name": "济宁市",
		"parentId": 370,
		"children": [{
			"id": 370811,
			"name": "任城区",
			"parentId": 370800
		}, {
			"id": 370812,
			"name": "兖州区",
			"parentId": 370800
		}, {
			"id": 370826,
			"name": "微山县",
			"parentId": 370800
		}, {
			"id": 370827,
			"name": "鱼台县",
			"parentId": 370800
		}, {
			"id": 370828,
			"name": "金乡县",
			"parentId": 370800
		}, {
			"id": 370829,
			"name": "嘉祥县",
			"parentId": 370800
		}, {
			"id": 370830,
			"name": "汶上县",
			"parentId": 370800
		}, {
			"id": 370831,
			"name": "泗水县",
			"parentId": 370800
		}, {
			"id": 370832,
			"name": "梁山县",
			"parentId": 370800
		}, {
			"id": 370881,
			"name": "曲阜市",
			"parentId": 370800
		}, {
			"id": 370883,
			"name": "邹城市",
			"parentId": 370800
		}]
	}, {
		"id": 370900,
		"name": "泰安市",
		"parentId": 370,
		"children": [{
			"id": 370902,
			"name": "泰山区",
			"parentId": 370900
		}, {
			"id": 370911,
			"name": "岱岳区",
			"parentId": 370900
		}, {
			"id": 370921,
			"name": "宁阳县",
			"parentId": 370900
		}, {
			"id": 370923,
			"name": "东平县",
			"parentId": 370900
		}, {
			"id": 370982,
			"name": "新泰市",
			"parentId": 370900
		}, {
			"id": 370983,
			"name": "肥城市",
			"parentId": 370900
		}]
	}, {
		"id": 371000,
		"name": "威海市",
		"parentId": 370,
		"children": [{
			"id": 371002,
			"name": "环翠区",
			"parentId": 371000
		}, {
			"id": 371003,
			"name": "文登区",
			"parentId": 371000
		}, {
			"id": 371082,
			"name": "荣成市",
			"parentId": 371000
		}, {
			"id": 371083,
			"name": "乳山市",
			"parentId": 371000
		}]
	}, {
		"id": 371100,
		"name": "日照市",
		"parentId": 370,
		"children": [{
			"id": 371102,
			"name": "东港区",
			"parentId": 371100
		}, {
			"id": 371103,
			"name": "岚山区",
			"parentId": 371100
		}, {
			"id": 371121,
			"name": "五莲县",
			"parentId": 371100
		}, {
			"id": 371122,
			"name": "莒县",
			"parentId": 371100
		}]
	}, {
		"id": 371200,
		"name": "莱芜市",
		"parentId": 370,
		"children": [{
			"id": 371202,
			"name": "莱城区",
			"parentId": 371200
		}, {
			"id": 371203,
			"name": "钢城区",
			"parentId": 371200
		}]
	}, {
		"id": 371300,
		"name": "临沂市",
		"parentId": 370,
		"children": [{
			"id": 371302,
			"name": "兰山区",
			"parentId": 371300
		}, {
			"id": 371311,
			"name": "罗庄区",
			"parentId": 371300
		}, {
			"id": 371312,
			"name": "河东区",
			"parentId": 371300
		}, {
			"id": 371321,
			"name": "沂南县",
			"parentId": 371300
		}, {
			"id": 371322,
			"name": "郯城县",
			"parentId": 371300
		}, {
			"id": 371323,
			"name": "沂水县",
			"parentId": 371300
		}, {
			"id": 371324,
			"name": "兰陵县",
			"parentId": 371300
		}, {
			"id": 371325,
			"name": "费县",
			"parentId": 371300
		}, {
			"id": 371326,
			"name": "平邑县",
			"parentId": 371300
		}, {
			"id": 371327,
			"name": "莒南县",
			"parentId": 371300
		}, {
			"id": 371328,
			"name": "蒙阴县",
			"parentId": 371300
		}, {
			"id": 371329,
			"name": "临沭县",
			"parentId": 371300
		}]
	}, {
		"id": 371400,
		"name": "德州市",
		"parentId": 370,
		"children": [{
			"id": 371402,
			"name": "德城区",
			"parentId": 371400
		}, {
			"id": 371403,
			"name": "陵城区",
			"parentId": 371400
		}, {
			"id": 371422,
			"name": "宁津县",
			"parentId": 371400
		}, {
			"id": 371423,
			"name": "庆云县",
			"parentId": 371400
		}, {
			"id": 371424,
			"name": "临邑县",
			"parentId": 371400
		}, {
			"id": 371425,
			"name": "齐河县",
			"parentId": 371400
		}, {
			"id": 371426,
			"name": "平原县",
			"parentId": 371400
		}, {
			"id": 371427,
			"name": "夏津县",
			"parentId": 371400
		}, {
			"id": 371428,
			"name": "武城县",
			"parentId": 371400
		}, {
			"id": 371481,
			"name": "乐陵市",
			"parentId": 371400
		}, {
			"id": 371482,
			"name": "禹城市",
			"parentId": 371400
		}]
	}, {
		"id": 371500,
		"name": "聊城市",
		"parentId": 370,
		"children": [{
			"id": 371502,
			"name": "东昌府区",
			"parentId": 371500
		}, {
			"id": 371521,
			"name": "阳谷县",
			"parentId": 371500
		}, {
			"id": 371522,
			"name": "莘县",
			"parentId": 371500
		}, {
			"id": 371523,
			"name": "茌平县",
			"parentId": 371500
		}, {
			"id": 371524,
			"name": "东阿县",
			"parentId": 371500
		}, {
			"id": 371525,
			"name": "冠县",
			"parentId": 371500
		}, {
			"id": 371526,
			"name": "高唐县",
			"parentId": 371500
		}, {
			"id": 371581,
			"name": "临清市",
			"parentId": 371500
		}]
	}, {
		"id": 371600,
		"name": "滨州市",
		"parentId": 370,
		"children": [{
			"id": 371602,
			"name": "滨城区",
			"parentId": 371600
		}, {
			"id": 371603,
			"name": "沾化区",
			"parentId": 371600
		}, {
			"id": 371621,
			"name": "惠民县",
			"parentId": 371600
		}, {
			"id": 371622,
			"name": "阳信县",
			"parentId": 371600
		}, {
			"id": 371623,
			"name": "无棣县",
			"parentId": 371600
		}, {
			"id": 371625,
			"name": "博兴县",
			"parentId": 371600
		}, {
			"id": 371626,
			"name": "邹平县",
			"parentId": 371600
		}]
	}, {
		"id": 371700,
		"name": "菏泽市",
		"parentId": 370,
		"children": [{
			"id": 371702,
			"name": "牡丹区",
			"parentId": 371700
		}, {
			"id": 371703,
			"name": "定陶区",
			"parentId": 371700
		}, {
			"id": 371721,
			"name": "曹县",
			"parentId": 371700
		}, {
			"id": 371722,
			"name": "单县",
			"parentId": 371700
		}, {
			"id": 371723,
			"name": "成武县",
			"parentId": 371700
		}, {
			"id": 371724,
			"name": "巨野县",
			"parentId": 371700
		}, {
			"id": 371725,
			"name": "郓城县",
			"parentId": 371700
		}, {
			"id": 371726,
			"name": "鄄城县",
			"parentId": 371700
		}, {
			"id": 371728,
			"name": "东明县",
			"parentId": 371700
		}]
	}]
}, {
	"id": 410,
	"name": "河南省",
	"children": [{
		"id": 410100,
		"name": "郑州市",
		"parentId": 410,
		"children": [{
			"id": 410102,
			"name": "中原区",
			"parentId": 410100
		}, {
			"id": 410103,
			"name": "二七区",
			"parentId": 410100
		}, {
			"id": 410104,
			"name": "管城回族区",
			"parentId": 410100
		}, {
			"id": 410105,
			"name": "金水区",
			"parentId": 410100
		}, {
			"id": 410106,
			"name": "上街区",
			"parentId": 410100
		}, {
			"id": 410108,
			"name": "惠济区",
			"parentId": 410100
		}, {
			"id": 410122,
			"name": "中牟县",
			"parentId": 410100
		}, {
			"id": 410181,
			"name": "巩义市",
			"parentId": 410100
		}, {
			"id": 410182,
			"name": "荥阳市",
			"parentId": 410100
		}, {
			"id": 410183,
			"name": "新密市",
			"parentId": 410100
		}, {
			"id": 410184,
			"name": "新郑市",
			"parentId": 410100
		}, {
			"id": 410185,
			"name": "登封市",
			"parentId": 410100
		}]
	}, {
		"id": 410200,
		"name": "开封市",
		"parentId": 410,
		"children": [{
			"id": 410202,
			"name": "龙亭区",
			"parentId": 410200
		}, {
			"id": 410203,
			"name": "顺河回族区",
			"parentId": 410200
		}, {
			"id": 410204,
			"name": "鼓楼区",
			"parentId": 410200
		}, {
			"id": 410205,
			"name": "禹王台区",
			"parentId": 410200
		}, {
			"id": 410212,
			"name": "祥符区",
			"parentId": 410200
		}, {
			"id": 410221,
			"name": "杞县",
			"parentId": 410200
		}, {
			"id": 410222,
			"name": "通许县",
			"parentId": 410200
		}, {
			"id": 410223,
			"name": "尉氏县",
			"parentId": 410200
		}, {
			"id": 410225,
			"name": "兰考县",
			"parentId": 410200
		}]
	}, {
		"id": 410300,
		"name": "洛阳市",
		"parentId": 410,
		"children": [{
			"id": 410302,
			"name": "老城区",
			"parentId": 410300
		}, {
			"id": 410303,
			"name": "西工区",
			"parentId": 410300
		}, {
			"id": 410304,
			"name": "瀍河回族区",
			"parentId": 410300
		}, {
			"id": 410305,
			"name": "涧西区",
			"parentId": 410300
		}, {
			"id": 410306,
			"name": "吉利区",
			"parentId": 410300
		}, {
			"id": 410311,
			"name": "洛龙区",
			"parentId": 410300
		}, {
			"id": 410322,
			"name": "孟津县",
			"parentId": 410300
		}, {
			"id": 410323,
			"name": "新安县",
			"parentId": 410300
		}, {
			"id": 410324,
			"name": "栾川县",
			"parentId": 410300
		}, {
			"id": 410325,
			"name": "嵩县",
			"parentId": 410300
		}, {
			"id": 410326,
			"name": "汝阳县",
			"parentId": 410300
		}, {
			"id": 410327,
			"name": "宜阳县",
			"parentId": 410300
		}, {
			"id": 410328,
			"name": "洛宁县",
			"parentId": 410300
		}, {
			"id": 410329,
			"name": "伊川县",
			"parentId": 410300
		}, {
			"id": 410381,
			"name": "偃师市",
			"parentId": 410300
		}]
	}, {
		"id": 410400,
		"name": "平顶山市",
		"parentId": 410,
		"children": [{
			"id": 410402,
			"name": "新华区",
			"parentId": 410400
		}, {
			"id": 410403,
			"name": "卫东区",
			"parentId": 410400
		}, {
			"id": 410404,
			"name": "石龙区",
			"parentId": 410400
		}, {
			"id": 410411,
			"name": "湛河区",
			"parentId": 410400
		}, {
			"id": 410421,
			"name": "宝丰县",
			"parentId": 410400
		}, {
			"id": 410422,
			"name": "叶县",
			"parentId": 410400
		}, {
			"id": 410423,
			"name": "鲁山县",
			"parentId": 410400
		}, {
			"id": 410425,
			"name": "郏县",
			"parentId": 410400
		}, {
			"id": 410481,
			"name": "舞钢市",
			"parentId": 410400
		}, {
			"id": 410482,
			"name": "汝州市",
			"parentId": 410400
		}]
	}, {
		"id": 410500,
		"name": "安阳市",
		"parentId": 410,
		"children": [{
			"id": 410502,
			"name": "文峰区",
			"parentId": 410500
		}, {
			"id": 410503,
			"name": "北关区",
			"parentId": 410500
		}, {
			"id": 410505,
			"name": "殷都区",
			"parentId": 410500
		}, {
			"id": 410506,
			"name": "龙安区",
			"parentId": 410500
		}, {
			"id": 410522,
			"name": "安阳县",
			"parentId": 410500
		}, {
			"id": 410523,
			"name": "汤阴县",
			"parentId": 410500
		}, {
			"id": 410526,
			"name": "滑县",
			"parentId": 410500
		}, {
			"id": 410527,
			"name": "内黄县",
			"parentId": 410500
		}, {
			"id": 410581,
			"name": "林州市",
			"parentId": 410500
		}]
	}, {
		"id": 410600,
		"name": "鹤壁市",
		"parentId": 410,
		"children": [{
			"id": 410602,
			"name": "鹤山区",
			"parentId": 410600
		}, {
			"id": 410603,
			"name": "山城区",
			"parentId": 410600
		}, {
			"id": 410611,
			"name": "淇滨区",
			"parentId": 410600
		}, {
			"id": 410621,
			"name": "浚县",
			"parentId": 410600
		}, {
			"id": 410622,
			"name": "淇县",
			"parentId": 410600
		}]
	}, {
		"id": 410700,
		"name": "新乡市",
		"parentId": 410,
		"children": [{
			"id": 410702,
			"name": "红旗区",
			"parentId": 410700
		}, {
			"id": 410703,
			"name": "卫滨区",
			"parentId": 410700
		}, {
			"id": 410704,
			"name": "凤泉区",
			"parentId": 410700
		}, {
			"id": 410711,
			"name": "牧野区",
			"parentId": 410700
		}, {
			"id": 410721,
			"name": "新乡县",
			"parentId": 410700
		}, {
			"id": 410724,
			"name": "获嘉县",
			"parentId": 410700
		}, {
			"id": 410725,
			"name": "原阳县",
			"parentId": 410700
		}, {
			"id": 410726,
			"name": "延津县",
			"parentId": 410700
		}, {
			"id": 410727,
			"name": "封丘县",
			"parentId": 410700
		}, {
			"id": 410728,
			"name": "长垣县",
			"parentId": 410700
		}, {
			"id": 410781,
			"name": "卫辉市",
			"parentId": 410700
		}, {
			"id": 410782,
			"name": "辉县市",
			"parentId": 410700
		}]
	}, {
		"id": 410800,
		"name": "焦作市",
		"parentId": 410,
		"children": [{
			"id": 410802,
			"name": "解放区",
			"parentId": 410800
		}, {
			"id": 410803,
			"name": "中站区",
			"parentId": 410800
		}, {
			"id": 410804,
			"name": "马村区",
			"parentId": 410800
		}, {
			"id": 410811,
			"name": "山阳区",
			"parentId": 410800
		}, {
			"id": 410821,
			"name": "修武县",
			"parentId": 410800
		}, {
			"id": 410822,
			"name": "博爱县",
			"parentId": 410800
		}, {
			"id": 410823,
			"name": "武陟县",
			"parentId": 410800
		}, {
			"id": 410825,
			"name": "温县",
			"parentId": 410800
		}, {
			"id": 410882,
			"name": "沁阳市",
			"parentId": 410800
		}, {
			"id": 410883,
			"name": "孟州市",
			"parentId": 410800
		}]
	}, {
		"id": 410900,
		"name": "濮阳市",
		"parentId": 410,
		"children": [{
			"id": 410902,
			"name": "华龙区",
			"parentId": 410900
		}, {
			"id": 410922,
			"name": "清丰县",
			"parentId": 410900
		}, {
			"id": 410923,
			"name": "南乐县",
			"parentId": 410900
		}, {
			"id": 410926,
			"name": "范县",
			"parentId": 410900
		}, {
			"id": 410927,
			"name": "台前县",
			"parentId": 410900
		}, {
			"id": 410928,
			"name": "濮阳县",
			"parentId": 410900
		}]
	}, {
		"id": 411000,
		"name": "许昌市",
		"parentId": 410,
		"children": [{
			"id": 411002,
			"name": "魏都区",
			"parentId": 411000
		}, {
			"id": 411003,
			"name": "建安区",
			"parentId": 411000
		}, {
			"id": 411024,
			"name": "鄢陵县",
			"parentId": 411000
		}, {
			"id": 411025,
			"name": "襄城县",
			"parentId": 411000
		}, {
			"id": 411081,
			"name": "禹州市",
			"parentId": 411000
		}, {
			"id": 411082,
			"name": "长葛市",
			"parentId": 411000
		}]
	}, {
		"id": 411100,
		"name": "漯河市",
		"parentId": 410,
		"children": [{
			"id": 411102,
			"name": "源汇区",
			"parentId": 411100
		}, {
			"id": 411103,
			"name": "郾城区",
			"parentId": 411100
		}, {
			"id": 411104,
			"name": "召陵区",
			"parentId": 411100
		}, {
			"id": 411121,
			"name": "舞阳县",
			"parentId": 411100
		}, {
			"id": 411122,
			"name": "临颍县",
			"parentId": 411100
		}]
	}, {
		"id": 411200,
		"name": "三门峡市",
		"parentId": 410,
		"children": [{
			"id": 411202,
			"name": "湖滨区",
			"parentId": 411200
		}, {
			"id": 411203,
			"name": "陕州区",
			"parentId": 411200
		}, {
			"id": 411221,
			"name": "渑池县",
			"parentId": 411200
		}, {
			"id": 411224,
			"name": "卢氏县",
			"parentId": 411200
		}, {
			"id": 411281,
			"name": "义马市",
			"parentId": 411200
		}, {
			"id": 411282,
			"name": "灵宝市",
			"parentId": 411200
		}]
	}, {
		"id": 411300,
		"name": "南阳市",
		"parentId": 410,
		"children": [{
			"id": 411302,
			"name": "宛城区",
			"parentId": 411300
		}, {
			"id": 411303,
			"name": "卧龙区",
			"parentId": 411300
		}, {
			"id": 411321,
			"name": "南召县",
			"parentId": 411300
		}, {
			"id": 411322,
			"name": "方城县",
			"parentId": 411300
		}, {
			"id": 411323,
			"name": "西峡县",
			"parentId": 411300
		}, {
			"id": 411324,
			"name": "镇平县",
			"parentId": 411300
		}, {
			"id": 411325,
			"name": "内乡县",
			"parentId": 411300
		}, {
			"id": 411326,
			"name": "淅川县",
			"parentId": 411300
		}, {
			"id": 411327,
			"name": "社旗县",
			"parentId": 411300
		}, {
			"id": 411328,
			"name": "唐河县",
			"parentId": 411300
		}, {
			"id": 411329,
			"name": "新野县",
			"parentId": 411300
		}, {
			"id": 411330,
			"name": "桐柏县",
			"parentId": 411300
		}, {
			"id": 411381,
			"name": "邓州市",
			"parentId": 411300
		}]
	}, {
		"id": 411400,
		"name": "商丘市",
		"parentId": 410,
		"children": [{
			"id": 411402,
			"name": "梁园区",
			"parentId": 411400
		}, {
			"id": 411403,
			"name": "睢阳区",
			"parentId": 411400
		}, {
			"id": 411421,
			"name": "民权县",
			"parentId": 411400
		}, {
			"id": 411422,
			"name": "睢县",
			"parentId": 411400
		}, {
			"id": 411423,
			"name": "宁陵县",
			"parentId": 411400
		}, {
			"id": 411424,
			"name": "柘城县",
			"parentId": 411400
		}, {
			"id": 411425,
			"name": "虞城县",
			"parentId": 411400
		}, {
			"id": 411426,
			"name": "夏邑县",
			"parentId": 411400
		}, {
			"id": 411481,
			"name": "永城市",
			"parentId": 411400
		}]
	}, {
		"id": 411500,
		"name": "信阳市",
		"parentId": 410,
		"children": [{
			"id": 411502,
			"name": "浉河区",
			"parentId": 411500
		}, {
			"id": 411503,
			"name": "平桥区",
			"parentId": 411500
		}, {
			"id": 411521,
			"name": "罗山县",
			"parentId": 411500
		}, {
			"id": 411522,
			"name": "光山县",
			"parentId": 411500
		}, {
			"id": 411523,
			"name": "新县",
			"parentId": 411500
		}, {
			"id": 411524,
			"name": "商城县",
			"parentId": 411500
		}, {
			"id": 411525,
			"name": "固始县",
			"parentId": 411500
		}, {
			"id": 411526,
			"name": "潢川县",
			"parentId": 411500
		}, {
			"id": 411527,
			"name": "淮滨县",
			"parentId": 411500
		}, {
			"id": 411528,
			"name": "息县",
			"parentId": 411500
		}]
	}, {
		"id": 411600,
		"name": "周口市",
		"parentId": 410,
		"children": [{
			"id": 411602,
			"name": "川汇区",
			"parentId": 411600
		}, {
			"id": 411621,
			"name": "扶沟县",
			"parentId": 411600
		}, {
			"id": 411622,
			"name": "西华县",
			"parentId": 411600
		}, {
			"id": 411623,
			"name": "商水县",
			"parentId": 411600
		}, {
			"id": 411624,
			"name": "沈丘县",
			"parentId": 411600
		}, {
			"id": 411625,
			"name": "郸城县",
			"parentId": 411600
		}, {
			"id": 411626,
			"name": "淮阳县",
			"parentId": 411600
		}, {
			"id": 411627,
			"name": "太康县",
			"parentId": 411600
		}, {
			"id": 411628,
			"name": "鹿邑县",
			"parentId": 411600
		}, {
			"id": 411681,
			"name": "项城市",
			"parentId": 411600
		}]
	}, {
		"id": 411700,
		"name": "驻马店市",
		"parentId": 410,
		"children": [{
			"id": 411702,
			"name": "驿城区",
			"parentId": 411700
		}, {
			"id": 411721,
			"name": "西平县",
			"parentId": 411700
		}, {
			"id": 411722,
			"name": "上蔡县",
			"parentId": 411700
		}, {
			"id": 411723,
			"name": "平舆县",
			"parentId": 411700
		}, {
			"id": 411724,
			"name": "正阳县",
			"parentId": 411700
		}, {
			"id": 411725,
			"name": "确山县",
			"parentId": 411700
		}, {
			"id": 411726,
			"name": "泌阳县",
			"parentId": 411700
		}, {
			"id": 411727,
			"name": "汝南县",
			"parentId": 411700
		}, {
			"id": 411728,
			"name": "遂平县",
			"parentId": 411700
		}, {
			"id": 411729,
			"name": "新蔡县",
			"parentId": 411700
		}]
	}, {
		"id": 419001,
		"name": "济源市",
		"parentId": 410,
		"children": []
	}]
}, {
	"id": 420,
	"name": "湖北省",
	"children": [{
		"id": 420100,
		"name": "武汉市",
		"parentId": 420,
		"children": [{
			"id": 420102,
			"name": "江岸区",
			"parentId": 420100
		}, {
			"id": 420103,
			"name": "江汉区",
			"parentId": 420100
		}, {
			"id": 420104,
			"name": "硚口区",
			"parentId": 420100
		}, {
			"id": 420105,
			"name": "汉阳区",
			"parentId": 420100
		}, {
			"id": 420106,
			"name": "武昌区",
			"parentId": 420100
		}, {
			"id": 420107,
			"name": "青山区",
			"parentId": 420100
		}, {
			"id": 420111,
			"name": "洪山区",
			"parentId": 420100
		}, {
			"id": 420112,
			"name": "东西湖区",
			"parentId": 420100
		}, {
			"id": 420113,
			"name": "汉南区",
			"parentId": 420100
		}, {
			"id": 420114,
			"name": "蔡甸区",
			"parentId": 420100
		}, {
			"id": 420115,
			"name": "江夏区",
			"parentId": 420100
		}, {
			"id": 420116,
			"name": "黄陂区",
			"parentId": 420100
		}, {
			"id": 420117,
			"name": "新洲区",
			"parentId": 420100
		}]
	}, {
		"id": 420200,
		"name": "黄石市",
		"parentId": 420,
		"children": [{
			"id": 420202,
			"name": "黄石港区",
			"parentId": 420200
		}, {
			"id": 420203,
			"name": "西塞山区",
			"parentId": 420200
		}, {
			"id": 420204,
			"name": "下陆区",
			"parentId": 420200
		}, {
			"id": 420205,
			"name": "铁山区",
			"parentId": 420200
		}, {
			"id": 420222,
			"name": "阳新县",
			"parentId": 420200
		}, {
			"id": 420281,
			"name": "大冶市",
			"parentId": 420200
		}]
	}, {
		"id": 420300,
		"name": "十堰市",
		"parentId": 420,
		"children": [{
			"id": 420302,
			"name": "茅箭区",
			"parentId": 420300
		}, {
			"id": 420303,
			"name": "张湾区",
			"parentId": 420300
		}, {
			"id": 420304,
			"name": "郧阳区",
			"parentId": 420300
		}, {
			"id": 420322,
			"name": "郧西县",
			"parentId": 420300
		}, {
			"id": 420323,
			"name": "竹山县",
			"parentId": 420300
		}, {
			"id": 420324,
			"name": "竹溪县",
			"parentId": 420300
		}, {
			"id": 420325,
			"name": "房县",
			"parentId": 420300
		}, {
			"id": 420381,
			"name": "丹江口市",
			"parentId": 420300
		}]
	}, {
		"id": 420500,
		"name": "宜昌市",
		"parentId": 420,
		"children": [{
			"id": 420502,
			"name": "西陵区",
			"parentId": 420500
		}, {
			"id": 420503,
			"name": "伍家岗区",
			"parentId": 420500
		}, {
			"id": 420504,
			"name": "点军区",
			"parentId": 420500
		}, {
			"id": 420505,
			"name": "猇亭区",
			"parentId": 420500
		}, {
			"id": 420506,
			"name": "夷陵区",
			"parentId": 420500
		}, {
			"id": 420525,
			"name": "远安县",
			"parentId": 420500
		}, {
			"id": 420526,
			"name": "兴山县",
			"parentId": 420500
		}, {
			"id": 420527,
			"name": "秭归县",
			"parentId": 420500
		}, {
			"id": 420528,
			"name": "长阳土家族自治县",
			"parentId": 420500
		}, {
			"id": 420529,
			"name": "五峰土家族自治县",
			"parentId": 420500
		}, {
			"id": 420581,
			"name": "宜都市",
			"parentId": 420500
		}, {
			"id": 420582,
			"name": "当阳市",
			"parentId": 420500
		}, {
			"id": 420583,
			"name": "枝江市",
			"parentId": 420500
		}]
	}, {
		"id": 420600,
		"name": "襄阳市",
		"parentId": 420,
		"children": [{
			"id": 420602,
			"name": "襄城区",
			"parentId": 420600
		}, {
			"id": 420606,
			"name": "樊城区",
			"parentId": 420600
		}, {
			"id": 420607,
			"name": "襄州区",
			"parentId": 420600
		}, {
			"id": 420624,
			"name": "南漳县",
			"parentId": 420600
		}, {
			"id": 420625,
			"name": "谷城县",
			"parentId": 420600
		}, {
			"id": 420626,
			"name": "保康县",
			"parentId": 420600
		}, {
			"id": 420682,
			"name": "老河口市",
			"parentId": 420600
		}, {
			"id": 420683,
			"name": "枣阳市",
			"parentId": 420600
		}, {
			"id": 420684,
			"name": "宜城市",
			"parentId": 420600
		}]
	}, {
		"id": 420700,
		"name": "鄂州市",
		"parentId": 420,
		"children": [{
			"id": 420702,
			"name": "梁子湖区",
			"parentId": 420700
		}, {
			"id": 420703,
			"name": "华容区",
			"parentId": 420700
		}, {
			"id": 420704,
			"name": "鄂城区",
			"parentId": 420700
		}]
	}, {
		"id": 420800,
		"name": "荆门市",
		"parentId": 420,
		"children": [{
			"id": 420802,
			"name": "东宝区",
			"parentId": 420800
		}, {
			"id": 420804,
			"name": "掇刀区",
			"parentId": 420800
		}, {
			"id": 420821,
			"name": "京山县",
			"parentId": 420800
		}, {
			"id": 420822,
			"name": "沙洋县",
			"parentId": 420800
		}, {
			"id": 420881,
			"name": "钟祥市",
			"parentId": 420800
		}]
	}, {
		"id": 420900,
		"name": "孝感市",
		"parentId": 420,
		"children": [{
			"id": 420902,
			"name": "孝南区",
			"parentId": 420900
		}, {
			"id": 420921,
			"name": "孝昌县",
			"parentId": 420900
		}, {
			"id": 420922,
			"name": "大悟县",
			"parentId": 420900
		}, {
			"id": 420923,
			"name": "云梦县",
			"parentId": 420900
		}, {
			"id": 420981,
			"name": "应城市",
			"parentId": 420900
		}, {
			"id": 420982,
			"name": "安陆市",
			"parentId": 420900
		}, {
			"id": 420984,
			"name": "汉川市",
			"parentId": 420900
		}]
	}, {
		"id": 421000,
		"name": "荆州市",
		"parentId": 420,
		"children": [{
			"id": 421002,
			"name": "沙市区",
			"parentId": 421000
		}, {
			"id": 421003,
			"name": "荆州区",
			"parentId": 421000
		}, {
			"id": 421022,
			"name": "公安县",
			"parentId": 421000
		}, {
			"id": 421023,
			"name": "监利县",
			"parentId": 421000
		}, {
			"id": 421024,
			"name": "江陵县",
			"parentId": 421000
		}, {
			"id": 421081,
			"name": "石首市",
			"parentId": 421000
		}, {
			"id": 421083,
			"name": "洪湖市",
			"parentId": 421000
		}, {
			"id": 421087,
			"name": "松滋市",
			"parentId": 421000
		}]
	}, {
		"id": 421100,
		"name": "黄冈市",
		"parentId": 420,
		"children": [{
			"id": 421102,
			"name": "黄州区",
			"parentId": 421100
		}, {
			"id": 421121,
			"name": "团风县",
			"parentId": 421100
		}, {
			"id": 421122,
			"name": "红安县",
			"parentId": 421100
		}, {
			"id": 421123,
			"name": "罗田县",
			"parentId": 421100
		}, {
			"id": 421124,
			"name": "英山县",
			"parentId": 421100
		}, {
			"id": 421125,
			"name": "浠水县",
			"parentId": 421100
		}, {
			"id": 421126,
			"name": "蕲春县",
			"parentId": 421100
		}, {
			"id": 421127,
			"name": "黄梅县",
			"parentId": 421100
		}, {
			"id": 421181,
			"name": "麻城市",
			"parentId": 421100
		}, {
			"id": 421182,
			"name": "武穴市",
			"parentId": 421100
		}]
	}, {
		"id": 421200,
		"name": "咸宁市",
		"parentId": 420,
		"children": [{
			"id": 421202,
			"name": "咸安区",
			"parentId": 421200
		}, {
			"id": 421221,
			"name": "嘉鱼县",
			"parentId": 421200
		}, {
			"id": 421222,
			"name": "通城县",
			"parentId": 421200
		}, {
			"id": 421223,
			"name": "崇阳县",
			"parentId": 421200
		}, {
			"id": 421224,
			"name": "通山县",
			"parentId": 421200
		}, {
			"id": 421281,
			"name": "赤壁市",
			"parentId": 421200
		}]
	}, {
		"id": 421300,
		"name": "随州市",
		"parentId": 420,
		"children": [{
			"id": 421303,
			"name": "曾都区",
			"parentId": 421300
		}, {
			"id": 421321,
			"name": "随县",
			"parentId": 421300
		}, {
			"id": 421381,
			"name": "广水市",
			"parentId": 421300
		}]
	}, {
		"id": 422800,
		"name": "恩施土家族苗族自治州",
		"parentId": 420,
		"children": [{
			"id": 422801,
			"name": "恩施市",
			"parentId": 422800
		}, {
			"id": 422802,
			"name": "利川市",
			"parentId": 422800
		}, {
			"id": 422822,
			"name": "建始县",
			"parentId": 422800
		}, {
			"id": 422823,
			"name": "巴东县",
			"parentId": 422800
		}, {
			"id": 422825,
			"name": "宣恩县",
			"parentId": 422800
		}, {
			"id": 422826,
			"name": "咸丰县",
			"parentId": 422800
		}, {
			"id": 422827,
			"name": "来凤县",
			"parentId": 422800
		}, {
			"id": 422828,
			"name": "鹤峰县",
			"parentId": 422800
		}]
	}, {
		"id": 429004,
		"name": "仙桃市",
		"parentId": 420,
		"children": []
	}, {
		"id": 429005,
		"name": "潜江市",
		"parentId": 420,
		"children": []
	}, {
		"id": 429006,
		"name": "天门市",
		"parentId": 420,
		"children": []
	}, {
		"id": 429021,
		"name": "神农架林区",
		"parentId": 420,
		"children": []
	}]
}, {
	"id": 430,
	"name": "湖南省",
	"children": [{
		"id": 430100,
		"name": "长沙市",
		"parentId": 430,
		"children": [{
			"id": 430102,
			"name": "芙蓉区",
			"parentId": 430100
		}, {
			"id": 430103,
			"name": "天心区",
			"parentId": 430100
		}, {
			"id": 430104,
			"name": "岳麓区",
			"parentId": 430100
		}, {
			"id": 430105,
			"name": "开福区",
			"parentId": 430100
		}, {
			"id": 430111,
			"name": "雨花区",
			"parentId": 430100
		}, {
			"id": 430112,
			"name": "望城区",
			"parentId": 430100
		}, {
			"id": 430121,
			"name": "长沙县",
			"parentId": 430100
		}, {
			"id": 430181,
			"name": "浏阳市",
			"parentId": 430100
		}, {
			"id": 430182,
			"name": "宁乡市",
			"parentId": 430100
		}]
	}, {
		"id": 430200,
		"name": "株洲市",
		"parentId": 430,
		"children": [{
			"id": 430202,
			"name": "荷塘区",
			"parentId": 430200
		}, {
			"id": 430203,
			"name": "芦淞区",
			"parentId": 430200
		}, {
			"id": 430204,
			"name": "石峰区",
			"parentId": 430200
		}, {
			"id": 430211,
			"name": "天元区",
			"parentId": 430200
		}, {
			"id": 430221,
			"name": "株洲县",
			"parentId": 430200
		}, {
			"id": 430223,
			"name": "攸县",
			"parentId": 430200
		}, {
			"id": 430224,
			"name": "茶陵县",
			"parentId": 430200
		}, {
			"id": 430225,
			"name": "炎陵县",
			"parentId": 430200
		}, {
			"id": 430281,
			"name": "醴陵市",
			"parentId": 430200
		}]
	}, {
		"id": 430300,
		"name": "湘潭市",
		"parentId": 430,
		"children": [{
			"id": 430302,
			"name": "雨湖区",
			"parentId": 430300
		}, {
			"id": 430304,
			"name": "岳塘区",
			"parentId": 430300
		}, {
			"id": 430321,
			"name": "湘潭县",
			"parentId": 430300
		}, {
			"id": 430381,
			"name": "湘乡市",
			"parentId": 430300
		}, {
			"id": 430382,
			"name": "韶山市",
			"parentId": 430300
		}]
	}, {
		"id": 430400,
		"name": "衡阳市",
		"parentId": 430,
		"children": [{
			"id": 430405,
			"name": "珠晖区",
			"parentId": 430400
		}, {
			"id": 430406,
			"name": "雁峰区",
			"parentId": 430400
		}, {
			"id": 430407,
			"name": "石鼓区",
			"parentId": 430400
		}, {
			"id": 430408,
			"name": "蒸湘区",
			"parentId": 430400
		}, {
			"id": 430412,
			"name": "南岳区",
			"parentId": 430400
		}, {
			"id": 430421,
			"name": "衡阳县",
			"parentId": 430400
		}, {
			"id": 430422,
			"name": "衡南县",
			"parentId": 430400
		}, {
			"id": 430423,
			"name": "衡山县",
			"parentId": 430400
		}, {
			"id": 430424,
			"name": "衡东县",
			"parentId": 430400
		}, {
			"id": 430426,
			"name": "祁东县",
			"parentId": 430400
		}, {
			"id": 430481,
			"name": "耒阳市",
			"parentId": 430400
		}, {
			"id": 430482,
			"name": "常宁市",
			"parentId": 430400
		}]
	}, {
		"id": 430500,
		"name": "邵阳市",
		"parentId": 430,
		"children": [{
			"id": 430502,
			"name": "双清区",
			"parentId": 430500
		}, {
			"id": 430503,
			"name": "大祥区",
			"parentId": 430500
		}, {
			"id": 430511,
			"name": "北塔区",
			"parentId": 430500
		}, {
			"id": 430521,
			"name": "邵东县",
			"parentId": 430500
		}, {
			"id": 430522,
			"name": "新邵县",
			"parentId": 430500
		}, {
			"id": 430523,
			"name": "邵阳县",
			"parentId": 430500
		}, {
			"id": 430524,
			"name": "隆回县",
			"parentId": 430500
		}, {
			"id": 430525,
			"name": "洞口县",
			"parentId": 430500
		}, {
			"id": 430527,
			"name": "绥宁县",
			"parentId": 430500
		}, {
			"id": 430528,
			"name": "新宁县",
			"parentId": 430500
		}, {
			"id": 430529,
			"name": "城步苗族自治县",
			"parentId": 430500
		}, {
			"id": 430581,
			"name": "武冈市",
			"parentId": 430500
		}]
	}, {
		"id": 430600,
		"name": "岳阳市",
		"parentId": 430,
		"children": [{
			"id": 430602,
			"name": "岳阳楼区",
			"parentId": 430600
		}, {
			"id": 430603,
			"name": "云溪区",
			"parentId": 430600
		}, {
			"id": 430611,
			"name": "君山区",
			"parentId": 430600
		}, {
			"id": 430621,
			"name": "岳阳县",
			"parentId": 430600
		}, {
			"id": 430623,
			"name": "华容县",
			"parentId": 430600
		}, {
			"id": 430624,
			"name": "湘阴县",
			"parentId": 430600
		}, {
			"id": 430626,
			"name": "平江县",
			"parentId": 430600
		}, {
			"id": 430681,
			"name": "汨罗市",
			"parentId": 430600
		}, {
			"id": 430682,
			"name": "临湘市",
			"parentId": 430600
		}]
	}, {
		"id": 430700,
		"name": "常德市",
		"parentId": 430,
		"children": [{
			"id": 430702,
			"name": "武陵区",
			"parentId": 430700
		}, {
			"id": 430703,
			"name": "鼎城区",
			"parentId": 430700
		}, {
			"id": 430721,
			"name": "安乡县",
			"parentId": 430700
		}, {
			"id": 430722,
			"name": "汉寿县",
			"parentId": 430700
		}, {
			"id": 430723,
			"name": "澧县",
			"parentId": 430700
		}, {
			"id": 430724,
			"name": "临澧县",
			"parentId": 430700
		}, {
			"id": 430725,
			"name": "桃源县",
			"parentId": 430700
		}, {
			"id": 430726,
			"name": "石门县",
			"parentId": 430700
		}, {
			"id": 430781,
			"name": "津市市",
			"parentId": 430700
		}]
	}, {
		"id": 430800,
		"name": "张家界市",
		"parentId": 430,
		"children": [{
			"id": 430802,
			"name": "永定区",
			"parentId": 430800
		}, {
			"id": 430811,
			"name": "武陵源区",
			"parentId": 430800
		}, {
			"id": 430821,
			"name": "慈利县",
			"parentId": 430800
		}, {
			"id": 430822,
			"name": "桑植县",
			"parentId": 430800
		}]
	}, {
		"id": 430900,
		"name": "益阳市",
		"parentId": 430,
		"children": [{
			"id": 430902,
			"name": "资阳区",
			"parentId": 430900
		}, {
			"id": 430903,
			"name": "赫山区",
			"parentId": 430900
		}, {
			"id": 430921,
			"name": "南县",
			"parentId": 430900
		}, {
			"id": 430922,
			"name": "桃江县",
			"parentId": 430900
		}, {
			"id": 430923,
			"name": "安化县",
			"parentId": 430900
		}, {
			"id": 430981,
			"name": "沅江市",
			"parentId": 430900
		}]
	}, {
		"id": 431000,
		"name": "郴州市",
		"parentId": 430,
		"children": [{
			"id": 431002,
			"name": "北湖区",
			"parentId": 431000
		}, {
			"id": 431003,
			"name": "苏仙区",
			"parentId": 431000
		}, {
			"id": 431021,
			"name": "桂阳县",
			"parentId": 431000
		}, {
			"id": 431022,
			"name": "宜章县",
			"parentId": 431000
		}, {
			"id": 431023,
			"name": "永兴县",
			"parentId": 431000
		}, {
			"id": 431024,
			"name": "嘉禾县",
			"parentId": 431000
		}, {
			"id": 431025,
			"name": "临武县",
			"parentId": 431000
		}, {
			"id": 431026,
			"name": "汝城县",
			"parentId": 431000
		}, {
			"id": 431027,
			"name": "桂东县",
			"parentId": 431000
		}, {
			"id": 431028,
			"name": "安仁县",
			"parentId": 431000
		}, {
			"id": 431081,
			"name": "资兴市",
			"parentId": 431000
		}]
	}, {
		"id": 431100,
		"name": "永州市",
		"parentId": 430,
		"children": [{
			"id": 431102,
			"name": "零陵区",
			"parentId": 431100
		}, {
			"id": 431103,
			"name": "冷水滩区",
			"parentId": 431100
		}, {
			"id": 431121,
			"name": "祁阳县",
			"parentId": 431100
		}, {
			"id": 431122,
			"name": "东安县",
			"parentId": 431100
		}, {
			"id": 431123,
			"name": "双牌县",
			"parentId": 431100
		}, {
			"id": 431124,
			"name": "道县",
			"parentId": 431100
		}, {
			"id": 431125,
			"name": "江永县",
			"parentId": 431100
		}, {
			"id": 431126,
			"name": "宁远县",
			"parentId": 431100
		}, {
			"id": 431127,
			"name": "蓝山县",
			"parentId": 431100
		}, {
			"id": 431128,
			"name": "新田县",
			"parentId": 431100
		}, {
			"id": 431129,
			"name": "江华瑶族自治县",
			"parentId": 431100
		}]
	}, {
		"id": 431200,
		"name": "怀化市",
		"parentId": 430,
		"children": [{
			"id": 431202,
			"name": "鹤城区",
			"parentId": 431200
		}, {
			"id": 431221,
			"name": "中方县",
			"parentId": 431200
		}, {
			"id": 431222,
			"name": "沅陵县",
			"parentId": 431200
		}, {
			"id": 431223,
			"name": "辰溪县",
			"parentId": 431200
		}, {
			"id": 431224,
			"name": "溆浦县",
			"parentId": 431200
		}, {
			"id": 431225,
			"name": "会同县",
			"parentId": 431200
		}, {
			"id": 431226,
			"name": "麻阳苗族自治县",
			"parentId": 431200
		}, {
			"id": 431227,
			"name": "新晃侗族自治县",
			"parentId": 431200
		}, {
			"id": 431228,
			"name": "芷江侗族自治县",
			"parentId": 431200
		}, {
			"id": 431229,
			"name": "靖州苗族侗族自治县",
			"parentId": 431200
		}, {
			"id": 431230,
			"name": "通道侗族自治县",
			"parentId": 431200
		}, {
			"id": 431281,
			"name": "洪江市",
			"parentId": 431200
		}]
	}, {
		"id": 431300,
		"name": "娄底市",
		"parentId": 430,
		"children": [{
			"id": 431302,
			"name": "娄星区",
			"parentId": 431300
		}, {
			"id": 431321,
			"name": "双峰县",
			"parentId": 431300
		}, {
			"id": 431322,
			"name": "新化县",
			"parentId": 431300
		}, {
			"id": 431381,
			"name": "冷水江市",
			"parentId": 431300
		}, {
			"id": 431382,
			"name": "涟源市",
			"parentId": 431300
		}]
	}, {
		"id": 433100,
		"name": "湘西土家族苗族自治州",
		"parentId": 430,
		"children": [{
			"id": 433101,
			"name": "吉首市",
			"parentId": 433100
		}, {
			"id": 433122,
			"name": "泸溪县",
			"parentId": 433100
		}, {
			"id": 433123,
			"name": "凤凰县",
			"parentId": 433100
		}, {
			"id": 433124,
			"name": "花垣县",
			"parentId": 433100
		}, {
			"id": 433125,
			"name": "保靖县",
			"parentId": 433100
		}, {
			"id": 433126,
			"name": "古丈县",
			"parentId": 433100
		}, {
			"id": 433127,
			"name": "永顺县",
			"parentId": 433100
		}, {
			"id": 433130,
			"name": "龙山县",
			"parentId": 433100
		}]
	}]
}, {
	"id": 440,
	"name": "广东省",
	"children": [{
		"id": 440100,
		"name": "广州市",
		"parentId": 440,
		"children": [{
			"id": 440103,
			"name": "荔湾区",
			"parentId": 440100
		}, {
			"id": 440104,
			"name": "越秀区",
			"parentId": 440100
		}, {
			"id": 440105,
			"name": "海珠区",
			"parentId": 440100
		}, {
			"id": 440106,
			"name": "天河区",
			"parentId": 440100
		}, {
			"id": 440111,
			"name": "白云区",
			"parentId": 440100
		}, {
			"id": 440112,
			"name": "黄埔区",
			"parentId": 440100
		}, {
			"id": 440113,
			"name": "番禺区",
			"parentId": 440100
		}, {
			"id": 440114,
			"name": "花都区",
			"parentId": 440100
		}, {
			"id": 440115,
			"name": "南沙区",
			"parentId": 440100
		}, {
			"id": 440117,
			"name": "从化区",
			"parentId": 440100
		}, {
			"id": 440118,
			"name": "增城区",
			"parentId": 440100
		}]
	}, {
		"id": 440200,
		"name": "韶关市",
		"parentId": 440,
		"children": [{
			"id": 440203,
			"name": "武江区",
			"parentId": 440200
		}, {
			"id": 440204,
			"name": "浈江区",
			"parentId": 440200
		}, {
			"id": 440205,
			"name": "曲江区",
			"parentId": 440200
		}, {
			"id": 440222,
			"name": "始兴县",
			"parentId": 440200
		}, {
			"id": 440224,
			"name": "仁化县",
			"parentId": 440200
		}, {
			"id": 440229,
			"name": "翁源县",
			"parentId": 440200
		}, {
			"id": 440232,
			"name": "乳源瑶族自治县",
			"parentId": 440200
		}, {
			"id": 440233,
			"name": "新丰县",
			"parentId": 440200
		}, {
			"id": 440281,
			"name": "乐昌市",
			"parentId": 440200
		}, {
			"id": 440282,
			"name": "南雄市",
			"parentId": 440200
		}]
	}, {
		"id": 440300,
		"name": "深圳市",
		"parentId": 440,
		"children": [{
			"id": 440303,
			"name": "罗湖区",
			"parentId": 440300
		}, {
			"id": 440304,
			"name": "福田区",
			"parentId": 440300
		}, {
			"id": 440305,
			"name": "南山区",
			"parentId": 440300
		}, {
			"id": 440306,
			"name": "宝安区",
			"parentId": 440300
		}, {
			"id": 440307,
			"name": "龙岗区",
			"parentId": 440300
		}, {
			"id": 440308,
			"name": "盐田区",
			"parentId": 440300
		}, {
			"id": 440309,
			"name": "龙华区",
			"parentId": 440300
		}, {
			"id": 440310,
			"name": "坪山区",
			"parentId": 440300
		}]
	}, {
		"id": 440400,
		"name": "珠海市",
		"parentId": 440,
		"children": [{
			"id": 440402,
			"name": "香洲区",
			"parentId": 440400
		}, {
			"id": 440403,
			"name": "斗门区",
			"parentId": 440400
		}, {
			"id": 440404,
			"name": "金湾区",
			"parentId": 440400
		}, {
			"id": 440499,
			"name": "香洲区(由澳门特别行政区实施管辖)",
			"parentId": 440400
		}]
	}, {
		"id": 440500,
		"name": "汕头市",
		"parentId": 440,
		"children": [{
			"id": 440507,
			"name": "龙湖区",
			"parentId": 440500
		}, {
			"id": 440511,
			"name": "金平区",
			"parentId": 440500
		}, {
			"id": 440512,
			"name": "濠江区",
			"parentId": 440500
		}, {
			"id": 440513,
			"name": "潮阳区",
			"parentId": 440500
		}, {
			"id": 440514,
			"name": "潮南区",
			"parentId": 440500
		}, {
			"id": 440515,
			"name": "澄海区",
			"parentId": 440500
		}, {
			"id": 440523,
			"name": "南澳县",
			"parentId": 440500
		}]
	}, {
		"id": 440600,
		"name": "佛山市",
		"parentId": 440,
		"children": [{
			"id": 440604,
			"name": "禅城区",
			"parentId": 440600
		}, {
			"id": 440605,
			"name": "南海区",
			"parentId": 440600
		}, {
			"id": 440606,
			"name": "顺德区",
			"parentId": 440600
		}, {
			"id": 440607,
			"name": "三水区",
			"parentId": 440600
		}, {
			"id": 440608,
			"name": "高明区",
			"parentId": 440600
		}]
	}, {
		"id": 440700,
		"name": "江门市",
		"parentId": 440,
		"children": [{
			"id": 440703,
			"name": "蓬江区",
			"parentId": 440700
		}, {
			"id": 440704,
			"name": "江海区",
			"parentId": 440700
		}, {
			"id": 440705,
			"name": "新会区",
			"parentId": 440700
		}, {
			"id": 440781,
			"name": "台山市",
			"parentId": 440700
		}, {
			"id": 440783,
			"name": "开平市",
			"parentId": 440700
		}, {
			"id": 440784,
			"name": "鹤山市",
			"parentId": 440700
		}, {
			"id": 440785,
			"name": "恩平市",
			"parentId": 440700
		}]
	}, {
		"id": 440800,
		"name": "湛江市",
		"parentId": 440,
		"children": [{
			"id": 440802,
			"name": "赤坎区",
			"parentId": 440800
		}, {
			"id": 440803,
			"name": "霞山区",
			"parentId": 440800
		}, {
			"id": 440804,
			"name": "坡头区",
			"parentId": 440800
		}, {
			"id": 440811,
			"name": "麻章区",
			"parentId": 440800
		}, {
			"id": 440823,
			"name": "遂溪县",
			"parentId": 440800
		}, {
			"id": 440825,
			"name": "徐闻县",
			"parentId": 440800
		}, {
			"id": 440881,
			"name": "廉江市",
			"parentId": 440800
		}, {
			"id": 440882,
			"name": "雷州市",
			"parentId": 440800
		}, {
			"id": 440883,
			"name": "吴川市",
			"parentId": 440800
		}]
	}, {
		"id": 440900,
		"name": "茂名市",
		"parentId": 440,
		"children": [{
			"id": 440902,
			"name": "茂南区",
			"parentId": 440900
		}, {
			"id": 440904,
			"name": "电白区",
			"parentId": 440900
		}, {
			"id": 440981,
			"name": "高州市",
			"parentId": 440900
		}, {
			"id": 440982,
			"name": "化州市",
			"parentId": 440900
		}, {
			"id": 440983,
			"name": "信宜市",
			"parentId": 440900
		}]
	}, {
		"id": 441200,
		"name": "肇庆市",
		"parentId": 440,
		"children": [{
			"id": 441202,
			"name": "端州区",
			"parentId": 441200
		}, {
			"id": 441203,
			"name": "鼎湖区",
			"parentId": 441200
		}, {
			"id": 441204,
			"name": "高要区",
			"parentId": 441200
		}, {
			"id": 441223,
			"name": "广宁县",
			"parentId": 441200
		}, {
			"id": 441224,
			"name": "怀集县",
			"parentId": 441200
		}, {
			"id": 441225,
			"name": "封开县",
			"parentId": 441200
		}, {
			"id": 441226,
			"name": "德庆县",
			"parentId": 441200
		}, {
			"id": 441284,
			"name": "四会市",
			"parentId": 441200
		}]
	}, {
		"id": 441300,
		"name": "惠州市",
		"parentId": 440,
		"children": [{
			"id": 441302,
			"name": "惠城区",
			"parentId": 441300
		}, {
			"id": 441303,
			"name": "惠阳区",
			"parentId": 441300
		}, {
			"id": 441322,
			"name": "博罗县",
			"parentId": 441300
		}, {
			"id": 441323,
			"name": "惠东县",
			"parentId": 441300
		}, {
			"id": 441324,
			"name": "龙门县",
			"parentId": 441300
		}]
	}, {
		"id": 441400,
		"name": "梅州市",
		"parentId": 440,
		"children": [{
			"id": 441402,
			"name": "梅江区",
			"parentId": 441400
		}, {
			"id": 441403,
			"name": "梅县区",
			"parentId": 441400
		}, {
			"id": 441422,
			"name": "大埔县",
			"parentId": 441400
		}, {
			"id": 441423,
			"name": "丰顺县",
			"parentId": 441400
		}, {
			"id": 441424,
			"name": "五华县",
			"parentId": 441400
		}, {
			"id": 441426,
			"name": "平远县",
			"parentId": 441400
		}, {
			"id": 441427,
			"name": "蕉岭县",
			"parentId": 441400
		}, {
			"id": 441481,
			"name": "兴宁市",
			"parentId": 441400
		}]
	}, {
		"id": 441500,
		"name": "汕尾市",
		"parentId": 440,
		"children": [{
			"id": 441502,
			"name": "城区",
			"parentId": 441500
		}, {
			"id": 441521,
			"name": "海丰县",
			"parentId": 441500
		}, {
			"id": 441523,
			"name": "陆河县",
			"parentId": 441500
		}, {
			"id": 441581,
			"name": "陆丰市",
			"parentId": 441500
		}]
	}, {
		"id": 441600,
		"name": "河源市",
		"parentId": 440,
		"children": [{
			"id": 441602,
			"name": "源城区",
			"parentId": 441600
		}, {
			"id": 441621,
			"name": "紫金县",
			"parentId": 441600
		}, {
			"id": 441622,
			"name": "龙川县",
			"parentId": 441600
		}, {
			"id": 441623,
			"name": "连平县",
			"parentId": 441600
		}, {
			"id": 441624,
			"name": "和平县",
			"parentId": 441600
		}, {
			"id": 441625,
			"name": "东源县",
			"parentId": 441600
		}]
	}, {
		"id": 441700,
		"name": "阳江市",
		"parentId": 440,
		"children": [{
			"id": 441702,
			"name": "江城区",
			"parentId": 441700
		}, {
			"id": 441704,
			"name": "阳东区",
			"parentId": 441700
		}, {
			"id": 441721,
			"name": "阳西县",
			"parentId": 441700
		}, {
			"id": 441781,
			"name": "阳春市",
			"parentId": 441700
		}]
	}, {
		"id": 441800,
		"name": "清远市",
		"parentId": 440,
		"children": [{
			"id": 441802,
			"name": "清城区",
			"parentId": 441800
		}, {
			"id": 441803,
			"name": "清新区",
			"parentId": 441800
		}, {
			"id": 441821,
			"name": "佛冈县",
			"parentId": 441800
		}, {
			"id": 441823,
			"name": "阳山县",
			"parentId": 441800
		}, {
			"id": 441825,
			"name": "连山壮族瑶族自治县",
			"parentId": 441800
		}, {
			"id": 441826,
			"name": "连南瑶族自治县",
			"parentId": 441800
		}, {
			"id": 441881,
			"name": "英德市",
			"parentId": 441800
		}, {
			"id": 441882,
			"name": "连州市",
			"parentId": 441800
		}]
	}, {
		"id": 441900,
		"name": "东莞市",
		"parentId": 440,
		"children": []
	}, {
		"id": 442000,
		"name": "中山市",
		"parentId": 440,
		"children": []
	}, {
		"id": 445100,
		"name": "潮州市",
		"parentId": 440,
		"children": [{
			"id": 445102,
			"name": "湘桥区",
			"parentId": 445100
		}, {
			"id": 445103,
			"name": "潮安区",
			"parentId": 445100
		}, {
			"id": 445122,
			"name": "饶平县",
			"parentId": 445100
		}]
	}, {
		"id": 445200,
		"name": "揭阳市",
		"parentId": 440,
		"children": [{
			"id": 445202,
			"name": "榕城区",
			"parentId": 445200
		}, {
			"id": 445203,
			"name": "揭东区",
			"parentId": 445200
		}, {
			"id": 445222,
			"name": "揭西县",
			"parentId": 445200
		}, {
			"id": 445224,
			"name": "惠来县",
			"parentId": 445200
		}, {
			"id": 445281,
			"name": "普宁市",
			"parentId": 445200
		}]
	}, {
		"id": 445300,
		"name": "云浮市",
		"parentId": 440,
		"children": [{
			"id": 445302,
			"name": "云城区",
			"parentId": 445300
		}, {
			"id": 445303,
			"name": "云安区",
			"parentId": 445300
		}, {
			"id": 445321,
			"name": "新兴县",
			"parentId": 445300
		}, {
			"id": 445322,
			"name": "郁南县",
			"parentId": 445300
		}, {
			"id": 445381,
			"name": "罗定市",
			"parentId": 445300
		}]
	}]
}, {
	"id": 450,
	"name": "广西壮族自治区",
	"children": [{
		"id": 450100,
		"name": "南宁市",
		"parentId": 450,
		"children": [{
			"id": 450102,
			"name": "兴宁区",
			"parentId": 450100
		}, {
			"id": 450103,
			"name": "青秀区",
			"parentId": 450100
		}, {
			"id": 450105,
			"name": "江南区",
			"parentId": 450100
		}, {
			"id": 450107,
			"name": "西乡塘区",
			"parentId": 450100
		}, {
			"id": 450108,
			"name": "良庆区",
			"parentId": 450100
		}, {
			"id": 450109,
			"name": "邕宁区",
			"parentId": 450100
		}, {
			"id": 450110,
			"name": "武鸣区",
			"parentId": 450100
		}, {
			"id": 450123,
			"name": "隆安县",
			"parentId": 450100
		}, {
			"id": 450124,
			"name": "马山县",
			"parentId": 450100
		}, {
			"id": 450125,
			"name": "上林县",
			"parentId": 450100
		}, {
			"id": 450126,
			"name": "宾阳县",
			"parentId": 450100
		}, {
			"id": 450127,
			"name": "横县",
			"parentId": 450100
		}]
	}, {
		"id": 450200,
		"name": "柳州市",
		"parentId": 450,
		"children": [{
			"id": 450202,
			"name": "城中区",
			"parentId": 450200
		}, {
			"id": 450203,
			"name": "鱼峰区",
			"parentId": 450200
		}, {
			"id": 450204,
			"name": "柳南区",
			"parentId": 450200
		}, {
			"id": 450205,
			"name": "柳北区",
			"parentId": 450200
		}, {
			"id": 450206,
			"name": "柳江区",
			"parentId": 450200
		}, {
			"id": 450222,
			"name": "柳城县",
			"parentId": 450200
		}, {
			"id": 450223,
			"name": "鹿寨县",
			"parentId": 450200
		}, {
			"id": 450224,
			"name": "融安县",
			"parentId": 450200
		}, {
			"id": 450225,
			"name": "融水苗族自治县",
			"parentId": 450200
		}, {
			"id": 450226,
			"name": "三江侗族自治县",
			"parentId": 450200
		}]
	}, {
		"id": 450300,
		"name": "桂林市",
		"parentId": 450,
		"children": [{
			"id": 450302,
			"name": "秀峰区",
			"parentId": 450300
		}, {
			"id": 450303,
			"name": "叠彩区",
			"parentId": 450300
		}, {
			"id": 450304,
			"name": "象山区",
			"parentId": 450300
		}, {
			"id": 450305,
			"name": "七星区",
			"parentId": 450300
		}, {
			"id": 450311,
			"name": "雁山区",
			"parentId": 450300
		}, {
			"id": 450312,
			"name": "临桂区",
			"parentId": 450300
		}, {
			"id": 450321,
			"name": "阳朔县",
			"parentId": 450300
		}, {
			"id": 450323,
			"name": "灵川县",
			"parentId": 450300
		}, {
			"id": 450324,
			"name": "全州县",
			"parentId": 450300
		}, {
			"id": 450325,
			"name": "兴安县",
			"parentId": 450300
		}, {
			"id": 450326,
			"name": "永福县",
			"parentId": 450300
		}, {
			"id": 450327,
			"name": "灌阳县",
			"parentId": 450300
		}, {
			"id": 450328,
			"name": "龙胜各族自治县",
			"parentId": 450300
		}, {
			"id": 450329,
			"name": "资源县",
			"parentId": 450300
		}, {
			"id": 450330,
			"name": "平乐县",
			"parentId": 450300
		}, {
			"id": 450331,
			"name": "荔浦县",
			"parentId": 450300
		}, {
			"id": 450332,
			"name": "恭城瑶族自治县",
			"parentId": 450300
		}]
	}, {
		"id": 450400,
		"name": "梧州市",
		"parentId": 450,
		"children": [{
			"id": 450403,
			"name": "万秀区",
			"parentId": 450400
		}, {
			"id": 450405,
			"name": "长洲区",
			"parentId": 450400
		}, {
			"id": 450406,
			"name": "龙圩区",
			"parentId": 450400
		}, {
			"id": 450421,
			"name": "苍梧县",
			"parentId": 450400
		}, {
			"id": 450422,
			"name": "藤县",
			"parentId": 450400
		}, {
			"id": 450423,
			"name": "蒙山县",
			"parentId": 450400
		}, {
			"id": 450481,
			"name": "岑溪市",
			"parentId": 450400
		}]
	}, {
		"id": 450500,
		"name": "北海市",
		"parentId": 450,
		"children": [{
			"id": 450502,
			"name": "海城区",
			"parentId": 450500
		}, {
			"id": 450503,
			"name": "银海区",
			"parentId": 450500
		}, {
			"id": 450512,
			"name": "铁山港区",
			"parentId": 450500
		}, {
			"id": 450521,
			"name": "合浦县",
			"parentId": 450500
		}]
	}, {
		"id": 450600,
		"name": "防城港市",
		"parentId": 450,
		"children": [{
			"id": 450602,
			"name": "港口区",
			"parentId": 450600
		}, {
			"id": 450603,
			"name": "防城区",
			"parentId": 450600
		}, {
			"id": 450621,
			"name": "上思县",
			"parentId": 450600
		}, {
			"id": 450681,
			"name": "东兴市",
			"parentId": 450600
		}]
	}, {
		"id": 450700,
		"name": "钦州市",
		"parentId": 450,
		"children": [{
			"id": 450702,
			"name": "钦南区",
			"parentId": 450700
		}, {
			"id": 450703,
			"name": "钦北区",
			"parentId": 450700
		}, {
			"id": 450721,
			"name": "灵山县",
			"parentId": 450700
		}, {
			"id": 450722,
			"name": "浦北县",
			"parentId": 450700
		}]
	}, {
		"id": 450800,
		"name": "贵港市",
		"parentId": 450,
		"children": [{
			"id": 450802,
			"name": "港北区",
			"parentId": 450800
		}, {
			"id": 450803,
			"name": "港南区",
			"parentId": 450800
		}, {
			"id": 450804,
			"name": "覃塘区",
			"parentId": 450800
		}, {
			"id": 450821,
			"name": "平南县",
			"parentId": 450800
		}, {
			"id": 450881,
			"name": "桂平市",
			"parentId": 450800
		}]
	}, {
		"id": 450900,
		"name": "玉林市",
		"parentId": 450,
		"children": [{
			"id": 450902,
			"name": "玉州区",
			"parentId": 450900
		}, {
			"id": 450903,
			"name": "福绵区",
			"parentId": 450900
		}, {
			"id": 450921,
			"name": "容县",
			"parentId": 450900
		}, {
			"id": 450922,
			"name": "陆川县",
			"parentId": 450900
		}, {
			"id": 450923,
			"name": "博白县",
			"parentId": 450900
		}, {
			"id": 450924,
			"name": "兴业县",
			"parentId": 450900
		}, {
			"id": 450981,
			"name": "北流市",
			"parentId": 450900
		}]
	}, {
		"id": 451000,
		"name": "百色市",
		"parentId": 450,
		"children": [{
			"id": 451002,
			"name": "右江区",
			"parentId": 451000
		}, {
			"id": 451021,
			"name": "田阳县",
			"parentId": 451000
		}, {
			"id": 451022,
			"name": "田东县",
			"parentId": 451000
		}, {
			"id": 451023,
			"name": "平果县",
			"parentId": 451000
		}, {
			"id": 451024,
			"name": "德保县",
			"parentId": 451000
		}, {
			"id": 451026,
			"name": "那坡县",
			"parentId": 451000
		}, {
			"id": 451027,
			"name": "凌云县",
			"parentId": 451000
		}, {
			"id": 451028,
			"name": "乐业县",
			"parentId": 451000
		}, {
			"id": 451029,
			"name": "田林县",
			"parentId": 451000
		}, {
			"id": 451030,
			"name": "西林县",
			"parentId": 451000
		}, {
			"id": 451031,
			"name": "隆林各族自治县",
			"parentId": 451000
		}, {
			"id": 451081,
			"name": "靖西市",
			"parentId": 451000
		}]
	}, {
		"id": 451100,
		"name": "贺州市",
		"parentId": 450,
		"children": [{
			"id": 451102,
			"name": "八步区",
			"parentId": 451100
		}, {
			"id": 451103,
			"name": "平桂区",
			"parentId": 451100
		}, {
			"id": 451121,
			"name": "昭平县",
			"parentId": 451100
		}, {
			"id": 451122,
			"name": "钟山县",
			"parentId": 451100
		}, {
			"id": 451123,
			"name": "富川瑶族自治县",
			"parentId": 451100
		}]
	}, {
		"id": 451200,
		"name": "河池市",
		"parentId": 450,
		"children": [{
			"id": 451202,
			"name": "金城江区",
			"parentId": 451200
		}, {
			"id": 451203,
			"name": "宜州区",
			"parentId": 451200
		}, {
			"id": 451221,
			"name": "南丹县",
			"parentId": 451200
		}, {
			"id": 451222,
			"name": "天峨县",
			"parentId": 451200
		}, {
			"id": 451223,
			"name": "凤山县",
			"parentId": 451200
		}, {
			"id": 451224,
			"name": "东兰县",
			"parentId": 451200
		}, {
			"id": 451225,
			"name": "罗城仫佬族自治县",
			"parentId": 451200
		}, {
			"id": 451226,
			"name": "环江毛南族自治县",
			"parentId": 451200
		}, {
			"id": 451227,
			"name": "巴马瑶族自治县",
			"parentId": 451200
		}, {
			"id": 451228,
			"name": "都安瑶族自治县",
			"parentId": 451200
		}, {
			"id": 451229,
			"name": "大化瑶族自治县",
			"parentId": 451200
		}]
	}, {
		"id": 451300,
		"name": "来宾市",
		"parentId": 450,
		"children": [{
			"id": 451302,
			"name": "兴宾区",
			"parentId": 451300
		}, {
			"id": 451321,
			"name": "忻城县",
			"parentId": 451300
		}, {
			"id": 451322,
			"name": "象州县",
			"parentId": 451300
		}, {
			"id": 451323,
			"name": "武宣县",
			"parentId": 451300
		}, {
			"id": 451324,
			"name": "金秀瑶族自治县",
			"parentId": 451300
		}, {
			"id": 451381,
			"name": "合山市",
			"parentId": 451300
		}]
	}, {
		"id": 451400,
		"name": "崇左市",
		"parentId": 450,
		"children": [{
			"id": 451402,
			"name": "江州区",
			"parentId": 451400
		}, {
			"id": 451421,
			"name": "扶绥县",
			"parentId": 451400
		}, {
			"id": 451422,
			"name": "宁明县",
			"parentId": 451400
		}, {
			"id": 451423,
			"name": "龙州县",
			"parentId": 451400
		}, {
			"id": 451424,
			"name": "大新县",
			"parentId": 451400
		}, {
			"id": 451425,
			"name": "天等县",
			"parentId": 451400
		}, {
			"id": 451481,
			"name": "凭祥市",
			"parentId": 451400
		}]
	}]
}, {
	"id": 460,
	"name": "海南省",
	"children": [{
		"id": 460100,
		"name": "海口市",
		"parentId": 460,
		"children": [{
			"id": 460105,
			"name": "秀英区",
			"parentId": 460100
		}, {
			"id": 460106,
			"name": "龙华区",
			"parentId": 460100
		}, {
			"id": 460107,
			"name": "琼山区",
			"parentId": 460100
		}, {
			"id": 460108,
			"name": "美兰区",
			"parentId": 460100
		}]
	}, {
		"id": 460200,
		"name": "三亚市",
		"parentId": 460,
		"children": [{
			"id": 460202,
			"name": "海棠区",
			"parentId": 460200
		}, {
			"id": 460203,
			"name": "吉阳区",
			"parentId": 460200
		}, {
			"id": 460204,
			"name": "天涯区",
			"parentId": 460200
		}, {
			"id": 460205,
			"name": "崖州区",
			"parentId": 460200
		}]
	}, {
		"id": 460300,
		"name": "三沙市",
		"parentId": 460,
		"children": [{
			"id": 460321,
			"name": "西沙群岛",
			"parentId": 460300
		}, {
			"id": 460322,
			"name": "南沙群岛",
			"parentId": 460300
		}, {
			"id": 460323,
			"name": "中沙群岛的岛礁及其海域",
			"parentId": 460300
		}]
	}, {
		"id": 460400,
		"name": "儋州市",
		"parentId": 460,
		"children": []
	}, {
		"id": 469001,
		"name": "五指山市",
		"parentId": 460,
		"children": []
	}, {
		"id": 469002,
		"name": "琼海市",
		"parentId": 460,
		"children": []
	}, {
		"id": 469005,
		"name": "文昌市",
		"parentId": 460,
		"children": []
	}, {
		"id": 469006,
		"name": "万宁市",
		"parentId": 460,
		"children": []
	}, {
		"id": 469007,
		"name": "东方市",
		"parentId": 460,
		"children": []
	}, {
		"id": 469021,
		"name": "定安县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469022,
		"name": "屯昌县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469023,
		"name": "澄迈县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469024,
		"name": "临高县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469025,
		"name": "白沙黎族自治县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469026,
		"name": "昌江黎族自治县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469027,
		"name": "乐东黎族自治县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469028,
		"name": "陵水黎族自治县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469029,
		"name": "保亭黎族苗族自治县",
		"parentId": 460,
		"children": []
	}, {
		"id": 469030,
		"name": "琼中黎族苗族自治县",
		"parentId": 460,
		"children": []
	}]
}, {
	"id": 500,
	"name": "重庆市",
	"children": [{
		"id": 500000,
		"name": "重庆市",
		"parentId": 500,
		"children": [{
			"id": 500101,
			"name": "万州区",
			"parentId": 500000
		}, {
			"id": 500102,
			"name": "涪陵区",
			"parentId": 500000
		}, {
			"id": 500103,
			"name": "渝中区",
			"parentId": 500000
		}, {
			"id": 500104,
			"name": "大渡口区",
			"parentId": 500000
		}, {
			"id": 500105,
			"name": "江北区",
			"parentId": 500000
		}, {
			"id": 500106,
			"name": "沙坪坝区",
			"parentId": 500000
		}, {
			"id": 500107,
			"name": "九龙坡区",
			"parentId": 500000
		}, {
			"id": 500108,
			"name": "南岸区",
			"parentId": 500000
		}, {
			"id": 500109,
			"name": "北碚区",
			"parentId": 500000
		}, {
			"id": 500110,
			"name": "綦江区",
			"parentId": 500000
		}, {
			"id": 500111,
			"name": "大足区",
			"parentId": 500000
		}, {
			"id": 500112,
			"name": "渝北区",
			"parentId": 500000
		}, {
			"id": 500113,
			"name": "巴南区",
			"parentId": 500000
		}, {
			"id": 500114,
			"name": "黔江区",
			"parentId": 500000
		}, {
			"id": 500115,
			"name": "长寿区",
			"parentId": 500000
		}, {
			"id": 500116,
			"name": "江津区",
			"parentId": 500000
		}, {
			"id": 500117,
			"name": "合川区",
			"parentId": 500000
		}, {
			"id": 500118,
			"name": "永川区",
			"parentId": 500000
		}, {
			"id": 500119,
			"name": "南川区",
			"parentId": 500000
		}, {
			"id": 500120,
			"name": "璧山区",
			"parentId": 500000
		}, {
			"id": 500151,
			"name": "铜梁区",
			"parentId": 500000
		}, {
			"id": 500152,
			"name": "潼南区",
			"parentId": 500000
		}, {
			"id": 500153,
			"name": "荣昌区",
			"parentId": 500000
		}, {
			"id": 500154,
			"name": "开州区",
			"parentId": 500000
		}, {
			"id": 500155,
			"name": "梁平区",
			"parentId": 500000
		}, {
			"id": 500156,
			"name": "武隆区",
			"parentId": 500000
		}, {
			"id": 500229,
			"name": "城口县",
			"parentId": 500000
		}, {
			"id": 500230,
			"name": "丰都县",
			"parentId": 500000
		}, {
			"id": 500231,
			"name": "垫江县",
			"parentId": 500000
		}, {
			"id": 500233,
			"name": "忠县",
			"parentId": 500000
		}, {
			"id": 500235,
			"name": "云阳县",
			"parentId": 500000
		}, {
			"id": 500236,
			"name": "奉节县",
			"parentId": 500000
		}, {
			"id": 500237,
			"name": "巫山县",
			"parentId": 500000
		}, {
			"id": 500238,
			"name": "巫溪县",
			"parentId": 500000
		}, {
			"id": 500240,
			"name": "石柱土家族自治县",
			"parentId": 500000
		}, {
			"id": 500241,
			"name": "秀山土家族苗族自治县",
			"parentId": 500000
		}, {
			"id": 500242,
			"name": "酉阳土家族苗族自治县",
			"parentId": 500000
		}, {
			"id": 500243,
			"name": "彭水苗族土家族自治县",
			"parentId": 500000
		}]
	}]
}, {
	"id": 510,
	"name": "四川省",
	"children": [{
		"id": 510100,
		"name": "成都市",
		"parentId": 510,
		"children": [{
			"id": 510104,
			"name": "锦江区",
			"parentId": 510100
		}, {
			"id": 510105,
			"name": "青羊区",
			"parentId": 510100
		}, {
			"id": 510106,
			"name": "金牛区",
			"parentId": 510100
		}, {
			"id": 510107,
			"name": "武侯区",
			"parentId": 510100
		}, {
			"id": 510108,
			"name": "成华区",
			"parentId": 510100
		}, {
			"id": 510112,
			"name": "龙泉驿区",
			"parentId": 510100
		}, {
			"id": 510113,
			"name": "青白江区",
			"parentId": 510100
		}, {
			"id": 510114,
			"name": "新都区",
			"parentId": 510100
		}, {
			"id": 510115,
			"name": "温江区",
			"parentId": 510100
		}, {
			"id": 510116,
			"name": "双流区",
			"parentId": 510100
		}, {
			"id": 510117,
			"name": "郫都区",
			"parentId": 510100
		}, {
			"id": 510121,
			"name": "金堂县",
			"parentId": 510100
		}, {
			"id": 510129,
			"name": "大邑县",
			"parentId": 510100
		}, {
			"id": 510131,
			"name": "蒲江县",
			"parentId": 510100
		}, {
			"id": 510132,
			"name": "新津县",
			"parentId": 510100
		}, {
			"id": 510181,
			"name": "都江堰市",
			"parentId": 510100
		}, {
			"id": 510182,
			"name": "彭州市",
			"parentId": 510100
		}, {
			"id": 510183,
			"name": "邛崃市",
			"parentId": 510100
		}, {
			"id": 510184,
			"name": "崇州市",
			"parentId": 510100
		}, {
			"id": 510185,
			"name": "简阳市",
			"parentId": 510100
		}]
	}, {
		"id": 510300,
		"name": "自贡市",
		"parentId": 510,
		"children": [{
			"id": 510302,
			"name": "自流井区",
			"parentId": 510300
		}, {
			"id": 510303,
			"name": "贡井区",
			"parentId": 510300
		}, {
			"id": 510304,
			"name": "大安区",
			"parentId": 510300
		}, {
			"id": 510311,
			"name": "沿滩区",
			"parentId": 510300
		}, {
			"id": 510321,
			"name": "荣县",
			"parentId": 510300
		}, {
			"id": 510322,
			"name": "富顺县",
			"parentId": 510300
		}]
	}, {
		"id": 510400,
		"name": "攀枝花市",
		"parentId": 510,
		"children": [{
			"id": 510402,
			"name": "东区",
			"parentId": 510400
		}, {
			"id": 510403,
			"name": "西区",
			"parentId": 510400
		}, {
			"id": 510411,
			"name": "仁和区",
			"parentId": 510400
		}, {
			"id": 510421,
			"name": "米易县",
			"parentId": 510400
		}, {
			"id": 510422,
			"name": "盐边县",
			"parentId": 510400
		}]
	}, {
		"id": 510500,
		"name": "泸州市",
		"parentId": 510,
		"children": [{
			"id": 510502,
			"name": "江阳区",
			"parentId": 510500
		}, {
			"id": 510503,
			"name": "纳溪区",
			"parentId": 510500
		}, {
			"id": 510504,
			"name": "龙马潭区",
			"parentId": 510500
		}, {
			"id": 510521,
			"name": "泸县",
			"parentId": 510500
		}, {
			"id": 510522,
			"name": "合江县",
			"parentId": 510500
		}, {
			"id": 510524,
			"name": "叙永县",
			"parentId": 510500
		}, {
			"id": 510525,
			"name": "古蔺县",
			"parentId": 510500
		}]
	}, {
		"id": 510600,
		"name": "德阳市",
		"parentId": 510,
		"children": [{
			"id": 510603,
			"name": "旌阳区",
			"parentId": 510600
		}, {
			"id": 510623,
			"name": "中江县",
			"parentId": 510600
		}, {
			"id": 510626,
			"name": "罗江县",
			"parentId": 510600
		}, {
			"id": 510681,
			"name": "广汉市",
			"parentId": 510600
		}, {
			"id": 510682,
			"name": "什邡市",
			"parentId": 510600
		}, {
			"id": 510683,
			"name": "绵竹市",
			"parentId": 510600
		}]
	}, {
		"id": 510700,
		"name": "绵阳市",
		"parentId": 510,
		"children": [{
			"id": 510703,
			"name": "涪城区",
			"parentId": 510700
		}, {
			"id": 510704,
			"name": "游仙区",
			"parentId": 510700
		}, {
			"id": 510705,
			"name": "安州区",
			"parentId": 510700
		}, {
			"id": 510722,
			"name": "三台县",
			"parentId": 510700
		}, {
			"id": 510723,
			"name": "盐亭县",
			"parentId": 510700
		}, {
			"id": 510725,
			"name": "梓潼县",
			"parentId": 510700
		}, {
			"id": 510726,
			"name": "北川羌族自治县",
			"parentId": 510700
		}, {
			"id": 510727,
			"name": "平武县",
			"parentId": 510700
		}, {
			"id": 510781,
			"name": "江油市",
			"parentId": 510700
		}]
	}, {
		"id": 510800,
		"name": "广元市",
		"parentId": 510,
		"children": [{
			"id": 510802,
			"name": "利州区",
			"parentId": 510800
		}, {
			"id": 510811,
			"name": "昭化区",
			"parentId": 510800
		}, {
			"id": 510812,
			"name": "朝天区",
			"parentId": 510800
		}, {
			"id": 510821,
			"name": "旺苍县",
			"parentId": 510800
		}, {
			"id": 510822,
			"name": "青川县",
			"parentId": 510800
		}, {
			"id": 510823,
			"name": "剑阁县",
			"parentId": 510800
		}, {
			"id": 510824,
			"name": "苍溪县",
			"parentId": 510800
		}]
	}, {
		"id": 510900,
		"name": "遂宁市",
		"parentId": 510,
		"children": [{
			"id": 510903,
			"name": "船山区",
			"parentId": 510900
		}, {
			"id": 510904,
			"name": "安居区",
			"parentId": 510900
		}, {
			"id": 510921,
			"name": "蓬溪县",
			"parentId": 510900
		}, {
			"id": 510922,
			"name": "射洪县",
			"parentId": 510900
		}, {
			"id": 510923,
			"name": "大英县",
			"parentId": 510900
		}]
	}, {
		"id": 511000,
		"name": "内江市",
		"parentId": 510,
		"children": [{
			"id": 511002,
			"name": "市中区",
			"parentId": 511000
		}, {
			"id": 511011,
			"name": "东兴区",
			"parentId": 511000
		}, {
			"id": 511024,
			"name": "威远县",
			"parentId": 511000
		}, {
			"id": 511025,
			"name": "资中县",
			"parentId": 511000
		}, {
			"id": 511083,
			"name": "隆昌市",
			"parentId": 511000
		}]
	}, {
		"id": 511100,
		"name": "乐山市",
		"parentId": 510,
		"children": [{
			"id": 511102,
			"name": "市中区",
			"parentId": 511100
		}, {
			"id": 511111,
			"name": "沙湾区",
			"parentId": 511100
		}, {
			"id": 511112,
			"name": "五通桥区",
			"parentId": 511100
		}, {
			"id": 511113,
			"name": "金口河区",
			"parentId": 511100
		}, {
			"id": 511123,
			"name": "犍为县",
			"parentId": 511100
		}, {
			"id": 511124,
			"name": "井研县",
			"parentId": 511100
		}, {
			"id": 511126,
			"name": "夹江县",
			"parentId": 511100
		}, {
			"id": 511129,
			"name": "沐川县",
			"parentId": 511100
		}, {
			"id": 511132,
			"name": "峨边彝族自治县",
			"parentId": 511100
		}, {
			"id": 511133,
			"name": "马边彝族自治县",
			"parentId": 511100
		}, {
			"id": 511181,
			"name": "峨眉山市",
			"parentId": 511100
		}]
	}, {
		"id": 511300,
		"name": "南充市",
		"parentId": 510,
		"children": [{
			"id": 511302,
			"name": "顺庆区",
			"parentId": 511300
		}, {
			"id": 511303,
			"name": "高坪区",
			"parentId": 511300
		}, {
			"id": 511304,
			"name": "嘉陵区",
			"parentId": 511300
		}, {
			"id": 511321,
			"name": "南部县",
			"parentId": 511300
		}, {
			"id": 511322,
			"name": "营山县",
			"parentId": 511300
		}, {
			"id": 511323,
			"name": "蓬安县",
			"parentId": 511300
		}, {
			"id": 511324,
			"name": "仪陇县",
			"parentId": 511300
		}, {
			"id": 511325,
			"name": "西充县",
			"parentId": 511300
		}, {
			"id": 511381,
			"name": "阆中市",
			"parentId": 511300
		}]
	}, {
		"id": 511400,
		"name": "眉山市",
		"parentId": 510,
		"children": [{
			"id": 511402,
			"name": "东坡区",
			"parentId": 511400
		}, {
			"id": 511403,
			"name": "彭山区",
			"parentId": 511400
		}, {
			"id": 511421,
			"name": "仁寿县",
			"parentId": 511400
		}, {
			"id": 511423,
			"name": "洪雅县",
			"parentId": 511400
		}, {
			"id": 511424,
			"name": "丹棱县",
			"parentId": 511400
		}, {
			"id": 511425,
			"name": "青神县",
			"parentId": 511400
		}]
	}, {
		"id": 511500,
		"name": "宜宾市",
		"parentId": 510,
		"children": [{
			"id": 511502,
			"name": "翠屏区",
			"parentId": 511500
		}, {
			"id": 511503,
			"name": "南溪区",
			"parentId": 511500
		}, {
			"id": 511521,
			"name": "宜宾县",
			"parentId": 511500
		}, {
			"id": 511523,
			"name": "江安县",
			"parentId": 511500
		}, {
			"id": 511524,
			"name": "长宁县",
			"parentId": 511500
		}, {
			"id": 511525,
			"name": "高县",
			"parentId": 511500
		}, {
			"id": 511526,
			"name": "珙县",
			"parentId": 511500
		}, {
			"id": 511527,
			"name": "筠连县",
			"parentId": 511500
		}, {
			"id": 511528,
			"name": "兴文县",
			"parentId": 511500
		}, {
			"id": 511529,
			"name": "屏山县",
			"parentId": 511500
		}]
	}, {
		"id": 511600,
		"name": "广安市",
		"parentId": 510,
		"children": [{
			"id": 511602,
			"name": "广安区",
			"parentId": 511600
		}, {
			"id": 511603,
			"name": "前锋区",
			"parentId": 511600
		}, {
			"id": 511621,
			"name": "岳池县",
			"parentId": 511600
		}, {
			"id": 511622,
			"name": "武胜县",
			"parentId": 511600
		}, {
			"id": 511623,
			"name": "邻水县",
			"parentId": 511600
		}, {
			"id": 511681,
			"name": "华蓥市",
			"parentId": 511600
		}]
	}, {
		"id": 511700,
		"name": "达州市",
		"parentId": 510,
		"children": [{
			"id": 511702,
			"name": "通川区",
			"parentId": 511700
		}, {
			"id": 511703,
			"name": "达川区",
			"parentId": 511700
		}, {
			"id": 511722,
			"name": "宣汉县",
			"parentId": 511700
		}, {
			"id": 511723,
			"name": "开江县",
			"parentId": 511700
		}, {
			"id": 511724,
			"name": "大竹县",
			"parentId": 511700
		}, {
			"id": 511725,
			"name": "渠县",
			"parentId": 511700
		}, {
			"id": 511781,
			"name": "万源市",
			"parentId": 511700
		}]
	}, {
		"id": 511800,
		"name": "雅安市",
		"parentId": 510,
		"children": [{
			"id": 511802,
			"name": "雨城区",
			"parentId": 511800
		}, {
			"id": 511803,
			"name": "名山区",
			"parentId": 511800
		}, {
			"id": 511822,
			"name": "荥经县",
			"parentId": 511800
		}, {
			"id": 511823,
			"name": "汉源县",
			"parentId": 511800
		}, {
			"id": 511824,
			"name": "石棉县",
			"parentId": 511800
		}, {
			"id": 511825,
			"name": "天全县",
			"parentId": 511800
		}, {
			"id": 511826,
			"name": "芦山县",
			"parentId": 511800
		}, {
			"id": 511827,
			"name": "宝兴县",
			"parentId": 511800
		}]
	}, {
		"id": 511900,
		"name": "巴中市",
		"parentId": 510,
		"children": [{
			"id": 511902,
			"name": "巴州区",
			"parentId": 511900
		}, {
			"id": 511903,
			"name": "恩阳区",
			"parentId": 511900
		}, {
			"id": 511921,
			"name": "通江县",
			"parentId": 511900
		}, {
			"id": 511922,
			"name": "南江县",
			"parentId": 511900
		}, {
			"id": 511923,
			"name": "平昌县",
			"parentId": 511900
		}]
	}, {
		"id": 512000,
		"name": "资阳市",
		"parentId": 510,
		"children": [{
			"id": 512002,
			"name": "雁江区",
			"parentId": 512000
		}, {
			"id": 512021,
			"name": "安岳县",
			"parentId": 512000
		}, {
			"id": 512022,
			"name": "乐至县",
			"parentId": 512000
		}]
	}, {
		"id": 513200,
		"name": "阿坝藏族羌族自治州",
		"parentId": 510,
		"children": [{
			"id": 513201,
			"name": "马尔康市",
			"parentId": 513200
		}, {
			"id": 513221,
			"name": "汶川县",
			"parentId": 513200
		}, {
			"id": 513222,
			"name": "理县",
			"parentId": 513200
		}, {
			"id": 513223,
			"name": "茂县",
			"parentId": 513200
		}, {
			"id": 513224,
			"name": "松潘县",
			"parentId": 513200
		}, {
			"id": 513225,
			"name": "九寨沟县",
			"parentId": 513200
		}, {
			"id": 513226,
			"name": "金川县",
			"parentId": 513200
		}, {
			"id": 513227,
			"name": "小金县",
			"parentId": 513200
		}, {
			"id": 513228,
			"name": "黑水县",
			"parentId": 513200
		}, {
			"id": 513230,
			"name": "壤塘县",
			"parentId": 513200
		}, {
			"id": 513231,
			"name": "阿坝县",
			"parentId": 513200
		}, {
			"id": 513232,
			"name": "若尔盖县",
			"parentId": 513200
		}, {
			"id": 513233,
			"name": "红原县",
			"parentId": 513200
		}]
	}, {
		"id": 513300,
		"name": "甘孜藏族自治州",
		"parentId": 510,
		"children": [{
			"id": 513301,
			"name": "康定市",
			"parentId": 513300
		}, {
			"id": 513322,
			"name": "泸定县",
			"parentId": 513300
		}, {
			"id": 513323,
			"name": "丹巴县",
			"parentId": 513300
		}, {
			"id": 513324,
			"name": "九龙县",
			"parentId": 513300
		}, {
			"id": 513325,
			"name": "雅江县",
			"parentId": 513300
		}, {
			"id": 513326,
			"name": "道孚县",
			"parentId": 513300
		}, {
			"id": 513327,
			"name": "炉霍县",
			"parentId": 513300
		}, {
			"id": 513328,
			"name": "甘孜县",
			"parentId": 513300
		}, {
			"id": 513329,
			"name": "新龙县",
			"parentId": 513300
		}, {
			"id": 513330,
			"name": "德格县",
			"parentId": 513300
		}, {
			"id": 513331,
			"name": "白玉县",
			"parentId": 513300
		}, {
			"id": 513332,
			"name": "石渠县",
			"parentId": 513300
		}, {
			"id": 513333,
			"name": "色达县",
			"parentId": 513300
		}, {
			"id": 513334,
			"name": "理塘县",
			"parentId": 513300
		}, {
			"id": 513335,
			"name": "巴塘县",
			"parentId": 513300
		}, {
			"id": 513336,
			"name": "乡城县",
			"parentId": 513300
		}, {
			"id": 513337,
			"name": "稻城县",
			"parentId": 513300
		}, {
			"id": 513338,
			"name": "得荣县",
			"parentId": 513300
		}]
	}, {
		"id": 513400,
		"name": "凉山彝族自治州",
		"parentId": 510,
		"children": [{
			"id": 513401,
			"name": "西昌市",
			"parentId": 513400
		}, {
			"id": 513422,
			"name": "木里藏族自治县",
			"parentId": 513400
		}, {
			"id": 513423,
			"name": "盐源县",
			"parentId": 513400
		}, {
			"id": 513424,
			"name": "德昌县",
			"parentId": 513400
		}, {
			"id": 513425,
			"name": "会理县",
			"parentId": 513400
		}, {
			"id": 513426,
			"name": "会东县",
			"parentId": 513400
		}, {
			"id": 513427,
			"name": "宁南县",
			"parentId": 513400
		}, {
			"id": 513428,
			"name": "普格县",
			"parentId": 513400
		}, {
			"id": 513429,
			"name": "布拖县",
			"parentId": 513400
		}, {
			"id": 513430,
			"name": "金阳县",
			"parentId": 513400
		}, {
			"id": 513431,
			"name": "昭觉县",
			"parentId": 513400
		}, {
			"id": 513432,
			"name": "喜德县",
			"parentId": 513400
		}, {
			"id": 513433,
			"name": "冕宁县",
			"parentId": 513400
		}, {
			"id": 513434,
			"name": "越西县",
			"parentId": 513400
		}, {
			"id": 513435,
			"name": "甘洛县",
			"parentId": 513400
		}, {
			"id": 513436,
			"name": "美姑县",
			"parentId": 513400
		}, {
			"id": 513437,
			"name": "雷波县",
			"parentId": 513400
		}]
	}]
}, {
	"id": 520,
	"name": "贵州省",
	"children": [{
		"id": 520100,
		"name": "贵阳市",
		"parentId": 520,
		"children": [{
			"id": 520102,
			"name": "南明区",
			"parentId": 520100
		}, {
			"id": 520103,
			"name": "云岩区",
			"parentId": 520100
		}, {
			"id": 520111,
			"name": "花溪区",
			"parentId": 520100
		}, {
			"id": 520112,
			"name": "乌当区",
			"parentId": 520100
		}, {
			"id": 520113,
			"name": "白云区",
			"parentId": 520100
		}, {
			"id": 520115,
			"name": "观山湖区",
			"parentId": 520100
		}, {
			"id": 520121,
			"name": "开阳县",
			"parentId": 520100
		}, {
			"id": 520122,
			"name": "息烽县",
			"parentId": 520100
		}, {
			"id": 520123,
			"name": "修文县",
			"parentId": 520100
		}, {
			"id": 520181,
			"name": "清镇市",
			"parentId": 520100
		}]
	}, {
		"id": 520200,
		"name": "六盘水市",
		"parentId": 520,
		"children": [{
			"id": 520201,
			"name": "钟山区",
			"parentId": 520200
		}, {
			"id": 520203,
			"name": "六枝特区",
			"parentId": 520200
		}, {
			"id": 520221,
			"name": "水城县",
			"parentId": 520200
		}, {
			"id": 520281,
			"name": "盘州市",
			"parentId": 520200
		}]
	}, {
		"id": 520300,
		"name": "遵义市",
		"parentId": 520,
		"children": [{
			"id": 520302,
			"name": "红花岗区",
			"parentId": 520300
		}, {
			"id": 520303,
			"name": "汇川区",
			"parentId": 520300
		}, {
			"id": 520304,
			"name": "播州区",
			"parentId": 520300
		}, {
			"id": 520322,
			"name": "桐梓县",
			"parentId": 520300
		}, {
			"id": 520323,
			"name": "绥阳县",
			"parentId": 520300
		}, {
			"id": 520324,
			"name": "正安县",
			"parentId": 520300
		}, {
			"id": 520325,
			"name": "道真仡佬族苗族自治县",
			"parentId": 520300
		}, {
			"id": 520326,
			"name": "务川仡佬族苗族自治县",
			"parentId": 520300
		}, {
			"id": 520327,
			"name": "凤冈县",
			"parentId": 520300
		}, {
			"id": 520328,
			"name": "湄潭县",
			"parentId": 520300
		}, {
			"id": 520329,
			"name": "余庆县",
			"parentId": 520300
		}, {
			"id": 520330,
			"name": "习水县",
			"parentId": 520300
		}, {
			"id": 520381,
			"name": "赤水市",
			"parentId": 520300
		}, {
			"id": 520382,
			"name": "仁怀市",
			"parentId": 520300
		}]
	}, {
		"id": 520400,
		"name": "安顺市",
		"parentId": 520,
		"children": [{
			"id": 520402,
			"name": "西秀区",
			"parentId": 520400
		}, {
			"id": 520403,
			"name": "平坝区",
			"parentId": 520400
		}, {
			"id": 520422,
			"name": "普定县",
			"parentId": 520400
		}, {
			"id": 520423,
			"name": "镇宁布依族苗族自治县",
			"parentId": 520400
		}, {
			"id": 520424,
			"name": "关岭布依族苗族自治县",
			"parentId": 520400
		}, {
			"id": 520425,
			"name": "紫云苗族布依族自治县",
			"parentId": 520400
		}]
	}, {
		"id": 520500,
		"name": "毕节市",
		"parentId": 520,
		"children": [{
			"id": 520502,
			"name": "七星关区",
			"parentId": 520500
		}, {
			"id": 520521,
			"name": "大方县",
			"parentId": 520500
		}, {
			"id": 520522,
			"name": "黔西县",
			"parentId": 520500
		}, {
			"id": 520523,
			"name": "金沙县",
			"parentId": 520500
		}, {
			"id": 520524,
			"name": "织金县",
			"parentId": 520500
		}, {
			"id": 520525,
			"name": "纳雍县",
			"parentId": 520500
		}, {
			"id": 520526,
			"name": "威宁彝族回族苗族自治县",
			"parentId": 520500
		}, {
			"id": 520527,
			"name": "赫章县",
			"parentId": 520500
		}]
	}, {
		"id": 520600,
		"name": "铜仁市",
		"parentId": 520,
		"children": [{
			"id": 520602,
			"name": "碧江区",
			"parentId": 520600
		}, {
			"id": 520603,
			"name": "万山区",
			"parentId": 520600
		}, {
			"id": 520621,
			"name": "江口县",
			"parentId": 520600
		}, {
			"id": 520622,
			"name": "玉屏侗族自治县",
			"parentId": 520600
		}, {
			"id": 520623,
			"name": "石阡县",
			"parentId": 520600
		}, {
			"id": 520624,
			"name": "思南县",
			"parentId": 520600
		}, {
			"id": 520625,
			"name": "印江土家族苗族自治县",
			"parentId": 520600
		}, {
			"id": 520626,
			"name": "德江县",
			"parentId": 520600
		}, {
			"id": 520627,
			"name": "沿河土家族自治县",
			"parentId": 520600
		}, {
			"id": 520628,
			"name": "松桃苗族自治县",
			"parentId": 520600
		}]
	}, {
		"id": 522300,
		"name": "黔西南布依族苗族自治州",
		"parentId": 520,
		"children": [{
			"id": 522301,
			"name": "兴义市",
			"parentId": 522300
		}, {
			"id": 522322,
			"name": "兴仁县",
			"parentId": 522300
		}, {
			"id": 522323,
			"name": "普安县",
			"parentId": 522300
		}, {
			"id": 522324,
			"name": "晴隆县",
			"parentId": 522300
		}, {
			"id": 522325,
			"name": "贞丰县",
			"parentId": 522300
		}, {
			"id": 522326,
			"name": "望谟县",
			"parentId": 522300
		}, {
			"id": 522327,
			"name": "册亨县",
			"parentId": 522300
		}, {
			"id": 522328,
			"name": "安龙县",
			"parentId": 522300
		}]
	}, {
		"id": 522600,
		"name": "黔东南苗族侗族自治州",
		"parentId": 520,
		"children": [{
			"id": 522601,
			"name": "凯里市",
			"parentId": 522600
		}, {
			"id": 522622,
			"name": "黄平县",
			"parentId": 522600
		}, {
			"id": 522623,
			"name": "施秉县",
			"parentId": 522600
		}, {
			"id": 522624,
			"name": "三穗县",
			"parentId": 522600
		}, {
			"id": 522625,
			"name": "镇远县",
			"parentId": 522600
		}, {
			"id": 522626,
			"name": "岑巩县",
			"parentId": 522600
		}, {
			"id": 522627,
			"name": "天柱县",
			"parentId": 522600
		}, {
			"id": 522628,
			"name": "锦屏县",
			"parentId": 522600
		}, {
			"id": 522629,
			"name": "剑河县",
			"parentId": 522600
		}, {
			"id": 522630,
			"name": "台江县",
			"parentId": 522600
		}, {
			"id": 522631,
			"name": "黎平县",
			"parentId": 522600
		}, {
			"id": 522632,
			"name": "榕江县",
			"parentId": 522600
		}, {
			"id": 522633,
			"name": "从江县",
			"parentId": 522600
		}, {
			"id": 522634,
			"name": "雷山县",
			"parentId": 522600
		}, {
			"id": 522635,
			"name": "麻江县",
			"parentId": 522600
		}, {
			"id": 522636,
			"name": "丹寨县",
			"parentId": 522600
		}]
	}, {
		"id": 522700,
		"name": "黔南布依族苗族自治州",
		"parentId": 520,
		"children": [{
			"id": 522701,
			"name": "都匀市",
			"parentId": 522700
		}, {
			"id": 522702,
			"name": "福泉市",
			"parentId": 522700
		}, {
			"id": 522722,
			"name": "荔波县",
			"parentId": 522700
		}, {
			"id": 522723,
			"name": "贵定县",
			"parentId": 522700
		}, {
			"id": 522725,
			"name": "瓮安县",
			"parentId": 522700
		}, {
			"id": 522726,
			"name": "独山县",
			"parentId": 522700
		}, {
			"id": 522727,
			"name": "平塘县",
			"parentId": 522700
		}, {
			"id": 522728,
			"name": "罗甸县",
			"parentId": 522700
		}, {
			"id": 522729,
			"name": "长顺县",
			"parentId": 522700
		}, {
			"id": 522730,
			"name": "龙里县",
			"parentId": 522700
		}, {
			"id": 522731,
			"name": "惠水县",
			"parentId": 522700
		}, {
			"id": 522732,
			"name": "三都水族自治县",
			"parentId": 522700
		}]
	}]
}, {
	"id": 530,
	"name": "云南省",
	"children": [{
		"id": 530100,
		"name": "昆明市",
		"parentId": 530,
		"children": [{
			"id": 530102,
			"name": "五华区",
			"parentId": 530100
		}, {
			"id": 530103,
			"name": "盘龙区",
			"parentId": 530100
		}, {
			"id": 530111,
			"name": "官渡区",
			"parentId": 530100
		}, {
			"id": 530112,
			"name": "西山区",
			"parentId": 530100
		}, {
			"id": 530113,
			"name": "东川区",
			"parentId": 530100
		}, {
			"id": 530114,
			"name": "呈贡区",
			"parentId": 530100
		}, {
			"id": 530115,
			"name": "晋宁区",
			"parentId": 530100
		}, {
			"id": 530124,
			"name": "富民县",
			"parentId": 530100
		}, {
			"id": 530125,
			"name": "宜良县",
			"parentId": 530100
		}, {
			"id": 530126,
			"name": "石林彝族自治县",
			"parentId": 530100
		}, {
			"id": 530127,
			"name": "嵩明县",
			"parentId": 530100
		}, {
			"id": 530128,
			"name": "禄劝彝族苗族自治县",
			"parentId": 530100
		}, {
			"id": 530129,
			"name": "寻甸回族彝族自治县",
			"parentId": 530100
		}, {
			"id": 530181,
			"name": "安宁市",
			"parentId": 530100
		}]
	}, {
		"id": 530300,
		"name": "曲靖市",
		"parentId": 530,
		"children": [{
			"id": 530302,
			"name": "麒麟区",
			"parentId": 530300
		}, {
			"id": 530303,
			"name": "沾益区",
			"parentId": 530300
		}, {
			"id": 530321,
			"name": "马龙县",
			"parentId": 530300
		}, {
			"id": 530322,
			"name": "陆良县",
			"parentId": 530300
		}, {
			"id": 530323,
			"name": "师宗县",
			"parentId": 530300
		}, {
			"id": 530324,
			"name": "罗平县",
			"parentId": 530300
		}, {
			"id": 530325,
			"name": "富源县",
			"parentId": 530300
		}, {
			"id": 530326,
			"name": "会泽县",
			"parentId": 530300
		}, {
			"id": 530381,
			"name": "宣威市",
			"parentId": 530300
		}]
	}, {
		"id": 530400,
		"name": "玉溪市",
		"parentId": 530,
		"children": [{
			"id": 530402,
			"name": "红塔区",
			"parentId": 530400
		}, {
			"id": 530403,
			"name": "江川区",
			"parentId": 530400
		}, {
			"id": 530422,
			"name": "澄江县",
			"parentId": 530400
		}, {
			"id": 530423,
			"name": "通海县",
			"parentId": 530400
		}, {
			"id": 530424,
			"name": "华宁县",
			"parentId": 530400
		}, {
			"id": 530425,
			"name": "易门县",
			"parentId": 530400
		}, {
			"id": 530426,
			"name": "峨山彝族自治县",
			"parentId": 530400
		}, {
			"id": 530427,
			"name": "新平彝族傣族自治县",
			"parentId": 530400
		}, {
			"id": 530428,
			"name": "元江哈尼族彝族傣族自治县",
			"parentId": 530400
		}]
	}, {
		"id": 530500,
		"name": "保山市",
		"parentId": 530,
		"children": [{
			"id": 530502,
			"name": "隆阳区",
			"parentId": 530500
		}, {
			"id": 530521,
			"name": "施甸县",
			"parentId": 530500
		}, {
			"id": 530523,
			"name": "龙陵县",
			"parentId": 530500
		}, {
			"id": 530524,
			"name": "昌宁县",
			"parentId": 530500
		}, {
			"id": 530581,
			"name": "腾冲市",
			"parentId": 530500
		}]
	}, {
		"id": 530600,
		"name": "昭通市",
		"parentId": 530,
		"children": [{
			"id": 530602,
			"name": "昭阳区",
			"parentId": 530600
		}, {
			"id": 530621,
			"name": "鲁甸县",
			"parentId": 530600
		}, {
			"id": 530622,
			"name": "巧家县",
			"parentId": 530600
		}, {
			"id": 530623,
			"name": "盐津县",
			"parentId": 530600
		}, {
			"id": 530624,
			"name": "大关县",
			"parentId": 530600
		}, {
			"id": 530625,
			"name": "永善县",
			"parentId": 530600
		}, {
			"id": 530626,
			"name": "绥江县",
			"parentId": 530600
		}, {
			"id": 530627,
			"name": "镇雄县",
			"parentId": 530600
		}, {
			"id": 530628,
			"name": "彝良县",
			"parentId": 530600
		}, {
			"id": 530629,
			"name": "威信县",
			"parentId": 530600
		}, {
			"id": 530630,
			"name": "水富县",
			"parentId": 530600
		}]
	}, {
		"id": 530700,
		"name": "丽江市",
		"parentId": 530,
		"children": [{
			"id": 530702,
			"name": "古城区",
			"parentId": 530700
		}, {
			"id": 530721,
			"name": "玉龙纳西族自治县",
			"parentId": 530700
		}, {
			"id": 530722,
			"name": "永胜县",
			"parentId": 530700
		}, {
			"id": 530723,
			"name": "华坪县",
			"parentId": 530700
		}, {
			"id": 530724,
			"name": "宁蒗彝族自治县",
			"parentId": 530700
		}]
	}, {
		"id": 530800,
		"name": "普洱市",
		"parentId": 530,
		"children": [{
			"id": 530802,
			"name": "思茅区",
			"parentId": 530800
		}, {
			"id": 530821,
			"name": "宁洱哈尼族彝族自治县",
			"parentId": 530800
		}, {
			"id": 530822,
			"name": "墨江哈尼族自治县",
			"parentId": 530800
		}, {
			"id": 530823,
			"name": "景东彝族自治县",
			"parentId": 530800
		}, {
			"id": 530824,
			"name": "景谷傣族彝族自治县",
			"parentId": 530800
		}, {
			"id": 530825,
			"name": "镇沅彝族哈尼族拉祜族自治县",
			"parentId": 530800
		}, {
			"id": 530826,
			"name": "江城哈尼族彝族自治县",
			"parentId": 530800
		}, {
			"id": 530827,
			"name": "孟连傣族拉祜族佤族自治县",
			"parentId": 530800
		}, {
			"id": 530828,
			"name": "澜沧拉祜族自治县",
			"parentId": 530800
		}, {
			"id": 530829,
			"name": "西盟佤族自治县",
			"parentId": 530800
		}]
	}, {
		"id": 530900,
		"name": "临沧市",
		"parentId": 530,
		"children": [{
			"id": 530902,
			"name": "临翔区",
			"parentId": 530900
		}, {
			"id": 530921,
			"name": "凤庆县",
			"parentId": 530900
		}, {
			"id": 530922,
			"name": "云县",
			"parentId": 530900
		}, {
			"id": 530923,
			"name": "永德县",
			"parentId": 530900
		}, {
			"id": 530924,
			"name": "镇康县",
			"parentId": 530900
		}, {
			"id": 530925,
			"name": "双江拉祜族佤族布朗族傣族自治县",
			"parentId": 530900
		}, {
			"id": 530926,
			"name": "耿马傣族佤族自治县",
			"parentId": 530900
		}, {
			"id": 530927,
			"name": "沧源佤族自治县",
			"parentId": 530900
		}]
	}, {
		"id": 532300,
		"name": "楚雄彝族自治州",
		"parentId": 530,
		"children": [{
			"id": 532301,
			"name": "楚雄市",
			"parentId": 532300
		}, {
			"id": 532322,
			"name": "双柏县",
			"parentId": 532300
		}, {
			"id": 532323,
			"name": "牟定县",
			"parentId": 532300
		}, {
			"id": 532324,
			"name": "南华县",
			"parentId": 532300
		}, {
			"id": 532325,
			"name": "姚安县",
			"parentId": 532300
		}, {
			"id": 532326,
			"name": "大姚县",
			"parentId": 532300
		}, {
			"id": 532327,
			"name": "永仁县",
			"parentId": 532300
		}, {
			"id": 532328,
			"name": "元谋县",
			"parentId": 532300
		}, {
			"id": 532329,
			"name": "武定县",
			"parentId": 532300
		}, {
			"id": 532331,
			"name": "禄丰县",
			"parentId": 532300
		}]
	}, {
		"id": 532500,
		"name": "红河哈尼族彝族自治州",
		"parentId": 530,
		"children": [{
			"id": 532501,
			"name": "个旧市",
			"parentId": 532500
		}, {
			"id": 532502,
			"name": "开远市",
			"parentId": 532500
		}, {
			"id": 532503,
			"name": "蒙自市",
			"parentId": 532500
		}, {
			"id": 532504,
			"name": "弥勒市",
			"parentId": 532500
		}, {
			"id": 532523,
			"name": "屏边苗族自治县",
			"parentId": 532500
		}, {
			"id": 532524,
			"name": "建水县",
			"parentId": 532500
		}, {
			"id": 532525,
			"name": "石屏县",
			"parentId": 532500
		}, {
			"id": 532527,
			"name": "泸西县",
			"parentId": 532500
		}, {
			"id": 532528,
			"name": "元阳县",
			"parentId": 532500
		}, {
			"id": 532529,
			"name": "红河县",
			"parentId": 532500
		}, {
			"id": 532530,
			"name": "金平苗族瑶族傣族自治县",
			"parentId": 532500
		}, {
			"id": 532531,
			"name": "绿春县",
			"parentId": 532500
		}, {
			"id": 532532,
			"name": "河口瑶族自治县",
			"parentId": 532500
		}]
	}, {
		"id": 532600,
		"name": "文山壮族苗族自治州",
		"parentId": 530,
		"children": [{
			"id": 532601,
			"name": "文山市",
			"parentId": 532600
		}, {
			"id": 532622,
			"name": "砚山县",
			"parentId": 532600
		}, {
			"id": 532623,
			"name": "西畴县",
			"parentId": 532600
		}, {
			"id": 532624,
			"name": "麻栗坡县",
			"parentId": 532600
		}, {
			"id": 532625,
			"name": "马关县",
			"parentId": 532600
		}, {
			"id": 532626,
			"name": "丘北县",
			"parentId": 532600
		}, {
			"id": 532627,
			"name": "广南县",
			"parentId": 532600
		}, {
			"id": 532628,
			"name": "富宁县",
			"parentId": 532600
		}]
	}, {
		"id": 532800,
		"name": "西双版纳傣族自治州",
		"parentId": 530,
		"children": [{
			"id": 532801,
			"name": "景洪市",
			"parentId": 532800
		}, {
			"id": 532822,
			"name": "勐海县",
			"parentId": 532800
		}, {
			"id": 532823,
			"name": "勐腊县",
			"parentId": 532800
		}]
	}, {
		"id": 532900,
		"name": "大理白族自治州",
		"parentId": 530,
		"children": [{
			"id": 532901,
			"name": "大理市",
			"parentId": 532900
		}, {
			"id": 532922,
			"name": "漾濞彝族自治县",
			"parentId": 532900
		}, {
			"id": 532923,
			"name": "祥云县",
			"parentId": 532900
		}, {
			"id": 532924,
			"name": "宾川县",
			"parentId": 532900
		}, {
			"id": 532925,
			"name": "弥渡县",
			"parentId": 532900
		}, {
			"id": 532926,
			"name": "南涧彝族自治县",
			"parentId": 532900
		}, {
			"id": 532927,
			"name": "巍山彝族回族自治县",
			"parentId": 532900
		}, {
			"id": 532928,
			"name": "永平县",
			"parentId": 532900
		}, {
			"id": 532929,
			"name": "云龙县",
			"parentId": 532900
		}, {
			"id": 532930,
			"name": "洱源县",
			"parentId": 532900
		}, {
			"id": 532931,
			"name": "剑川县",
			"parentId": 532900
		}, {
			"id": 532932,
			"name": "鹤庆县",
			"parentId": 532900
		}]
	}, {
		"id": 533100,
		"name": "德宏傣族景颇族自治州",
		"parentId": 530,
		"children": [{
			"id": 533102,
			"name": "瑞丽市",
			"parentId": 533100
		}, {
			"id": 533103,
			"name": "芒市",
			"parentId": 533100
		}, {
			"id": 533122,
			"name": "梁河县",
			"parentId": 533100
		}, {
			"id": 533123,
			"name": "盈江县",
			"parentId": 533100
		}, {
			"id": 533124,
			"name": "陇川县",
			"parentId": 533100
		}]
	}, {
		"id": 533300,
		"name": "怒江傈僳族自治州",
		"parentId": 530,
		"children": [{
			"id": 533301,
			"name": "泸水市",
			"parentId": 533300
		}, {
			"id": 533323,
			"name": "福贡县",
			"parentId": 533300
		}, {
			"id": 533324,
			"name": "贡山独龙族怒族自治县",
			"parentId": 533300
		}, {
			"id": 533325,
			"name": "兰坪白族普米族自治县",
			"parentId": 533300
		}]
	}, {
		"id": 533400,
		"name": "迪庆藏族自治州",
		"parentId": 530,
		"children": [{
			"id": 533401,
			"name": "香格里拉市",
			"parentId": 533400
		}, {
			"id": 533422,
			"name": "德钦县",
			"parentId": 533400
		}, {
			"id": 533423,
			"name": "维西傈僳族自治县",
			"parentId": 533400
		}]
	}]
}, {
	"id": 540,
	"name": "西藏自治区",
	"children": [{
		"id": 540100,
		"name": "拉萨市",
		"parentId": 540,
		"children": [{
			"id": 540102,
			"name": "城关区",
			"parentId": 540100
		}, {
			"id": 540103,
			"name": "堆龙德庆区",
			"parentId": 540100
		}, {
			"id": 540121,
			"name": "林周县",
			"parentId": 540100
		}, {
			"id": 540122,
			"name": "当雄县",
			"parentId": 540100
		}, {
			"id": 540123,
			"name": "尼木县",
			"parentId": 540100
		}, {
			"id": 540124,
			"name": "曲水县",
			"parentId": 540100
		}, {
			"id": 540126,
			"name": "达孜县",
			"parentId": 540100
		}, {
			"id": 540127,
			"name": "墨竹工卡县",
			"parentId": 540100
		}]
	}, {
		"id": 540200,
		"name": "日喀则市",
		"parentId": 540,
		"children": [{
			"id": 540202,
			"name": "桑珠孜区",
			"parentId": 540200
		}, {
			"id": 540221,
			"name": "南木林县",
			"parentId": 540200
		}, {
			"id": 540222,
			"name": "江孜县",
			"parentId": 540200
		}, {
			"id": 540223,
			"name": "定日县",
			"parentId": 540200
		}, {
			"id": 540224,
			"name": "萨迦县",
			"parentId": 540200
		}, {
			"id": 540225,
			"name": "拉孜县",
			"parentId": 540200
		}, {
			"id": 540226,
			"name": "昂仁县",
			"parentId": 540200
		}, {
			"id": 540227,
			"name": "谢通门县",
			"parentId": 540200
		}, {
			"id": 540228,
			"name": "白朗县",
			"parentId": 540200
		}, {
			"id": 540229,
			"name": "仁布县",
			"parentId": 540200
		}, {
			"id": 540230,
			"name": "康马县",
			"parentId": 540200
		}, {
			"id": 540231,
			"name": "定结县",
			"parentId": 540200
		}, {
			"id": 540232,
			"name": "仲巴县",
			"parentId": 540200
		}, {
			"id": 540233,
			"name": "亚东县",
			"parentId": 540200
		}, {
			"id": 540234,
			"name": "吉隆县",
			"parentId": 540200
		}, {
			"id": 540235,
			"name": "聂拉木县",
			"parentId": 540200
		}, {
			"id": 540236,
			"name": "萨嘎县",
			"parentId": 540200
		}, {
			"id": 540237,
			"name": "岗巴县",
			"parentId": 540200
		}]
	}, {
		"id": 540300,
		"name": "昌都市",
		"parentId": 540,
		"children": [{
			"id": 540302,
			"name": "卡若区",
			"parentId": 540300
		}, {
			"id": 540321,
			"name": "江达县",
			"parentId": 540300
		}, {
			"id": 540322,
			"name": "贡觉县",
			"parentId": 540300
		}, {
			"id": 540323,
			"name": "类乌齐县",
			"parentId": 540300
		}, {
			"id": 540324,
			"name": "丁青县",
			"parentId": 540300
		}, {
			"id": 540325,
			"name": "察雅县",
			"parentId": 540300
		}, {
			"id": 540326,
			"name": "八宿县",
			"parentId": 540300
		}, {
			"id": 540327,
			"name": "左贡县",
			"parentId": 540300
		}, {
			"id": 540328,
			"name": "芒康县",
			"parentId": 540300
		}, {
			"id": 540329,
			"name": "洛隆县",
			"parentId": 540300
		}, {
			"id": 540330,
			"name": "边坝县",
			"parentId": 540300
		}]
	}, {
		"id": 540400,
		"name": "林芝市",
		"parentId": 540,
		"children": [{
			"id": 540402,
			"name": "巴宜区",
			"parentId": 540400
		}, {
			"id": 540421,
			"name": "工布江达县",
			"parentId": 540400
		}, {
			"id": 540422,
			"name": "米林县",
			"parentId": 540400
		}, {
			"id": 540423,
			"name": "墨脱县",
			"parentId": 540400
		}, {
			"id": 540424,
			"name": "波密县",
			"parentId": 540400
		}, {
			"id": 540425,
			"name": "察隅县",
			"parentId": 540400
		}, {
			"id": 540426,
			"name": "朗县",
			"parentId": 540400
		}]
	}, {
		"id": 540500,
		"name": "山南市",
		"parentId": 540,
		"children": [{
			"id": 540502,
			"name": "乃东区",
			"parentId": 540500
		}, {
			"id": 540521,
			"name": "扎囊县",
			"parentId": 540500
		}, {
			"id": 540522,
			"name": "贡嘎县",
			"parentId": 540500
		}, {
			"id": 540523,
			"name": "桑日县",
			"parentId": 540500
		}, {
			"id": 540524,
			"name": "琼结县",
			"parentId": 540500
		}, {
			"id": 540525,
			"name": "曲松县",
			"parentId": 540500
		}, {
			"id": 540526,
			"name": "措美县",
			"parentId": 540500
		}, {
			"id": 540527,
			"name": "洛扎县",
			"parentId": 540500
		}, {
			"id": 540528,
			"name": "加查县",
			"parentId": 540500
		}, {
			"id": 540529,
			"name": "隆子县",
			"parentId": 540500
		}, {
			"id": 540530,
			"name": "错那县",
			"parentId": 540500
		}, {
			"id": 540531,
			"name": "浪卡子县",
			"parentId": 540500
		}]
	}, {
		"id": 542400,
		"name": "那曲地区",
		"parentId": 540,
		"children": [{
			"id": 542421,
			"name": "那曲县",
			"parentId": 542400
		}, {
			"id": 542422,
			"name": "嘉黎县",
			"parentId": 542400
		}, {
			"id": 542423,
			"name": "比如县",
			"parentId": 542400
		}, {
			"id": 542424,
			"name": "聂荣县",
			"parentId": 542400
		}, {
			"id": 542425,
			"name": "安多县",
			"parentId": 542400
		}, {
			"id": 542426,
			"name": "申扎县",
			"parentId": 542400
		}, {
			"id": 542427,
			"name": "索县",
			"parentId": 542400
		}, {
			"id": 542428,
			"name": "班戈县",
			"parentId": 542400
		}, {
			"id": 542429,
			"name": "巴青县",
			"parentId": 542400
		}, {
			"id": 542430,
			"name": "尼玛县",
			"parentId": 542400
		}, {
			"id": 542431,
			"name": "双湖县",
			"parentId": 542400
		}]
	}, {
		"id": 542500,
		"name": "阿里地区",
		"parentId": 540,
		"children": [{
			"id": 542521,
			"name": "普兰县",
			"parentId": 542500
		}, {
			"id": 542522,
			"name": "札达县",
			"parentId": 542500
		}, {
			"id": 542523,
			"name": "噶尔县",
			"parentId": 542500
		}, {
			"id": 542524,
			"name": "日土县",
			"parentId": 542500
		}, {
			"id": 542525,
			"name": "革吉县",
			"parentId": 542500
		}, {
			"id": 542526,
			"name": "改则县",
			"parentId": 542500
		}, {
			"id": 542527,
			"name": "措勤县",
			"parentId": 542500
		}]
	}]
}, {
	"id": 610,
	"name": "陕西省",
	"children": [{
		"id": 610100,
		"name": "西安市",
		"parentId": 610,
		"children": [{
			"id": 610102,
			"name": "新城区",
			"parentId": 610100
		}, {
			"id": 610103,
			"name": "碑林区",
			"parentId": 610100
		}, {
			"id": 610104,
			"name": "莲湖区",
			"parentId": 610100
		}, {
			"id": 610111,
			"name": "灞桥区",
			"parentId": 610100
		}, {
			"id": 610112,
			"name": "未央区",
			"parentId": 610100
		}, {
			"id": 610113,
			"name": "雁塔区",
			"parentId": 610100
		}, {
			"id": 610114,
			"name": "阎良区",
			"parentId": 610100
		}, {
			"id": 610115,
			"name": "临潼区",
			"parentId": 610100
		}, {
			"id": 610116,
			"name": "长安区",
			"parentId": 610100
		}, {
			"id": 610117,
			"name": "高陵区",
			"parentId": 610100
		}, {
			"id": 610118,
			"name": "鄠邑区",
			"parentId": 610100
		}, {
			"id": 610122,
			"name": "蓝田县",
			"parentId": 610100
		}, {
			"id": 610124,
			"name": "周至县",
			"parentId": 610100
		}]
	}, {
		"id": 610200,
		"name": "铜川市",
		"parentId": 610,
		"children": [{
			"id": 610202,
			"name": "王益区",
			"parentId": 610200
		}, {
			"id": 610203,
			"name": "印台区",
			"parentId": 610200
		}, {
			"id": 610204,
			"name": "耀州区",
			"parentId": 610200
		}, {
			"id": 610222,
			"name": "宜君县",
			"parentId": 610200
		}]
	}, {
		"id": 610300,
		"name": "宝鸡市",
		"parentId": 610,
		"children": [{
			"id": 610302,
			"name": "渭滨区",
			"parentId": 610300
		}, {
			"id": 610303,
			"name": "金台区",
			"parentId": 610300
		}, {
			"id": 610304,
			"name": "陈仓区",
			"parentId": 610300
		}, {
			"id": 610322,
			"name": "凤翔县",
			"parentId": 610300
		}, {
			"id": 610323,
			"name": "岐山县",
			"parentId": 610300
		}, {
			"id": 610324,
			"name": "扶风县",
			"parentId": 610300
		}, {
			"id": 610326,
			"name": "眉县",
			"parentId": 610300
		}, {
			"id": 610327,
			"name": "陇县",
			"parentId": 610300
		}, {
			"id": 610328,
			"name": "千阳县",
			"parentId": 610300
		}, {
			"id": 610329,
			"name": "麟游县",
			"parentId": 610300
		}, {
			"id": 610330,
			"name": "凤县",
			"parentId": 610300
		}, {
			"id": 610331,
			"name": "太白县",
			"parentId": 610300
		}]
	}, {
		"id": 610400,
		"name": "咸阳市",
		"parentId": 610,
		"children": [{
			"id": 610402,
			"name": "秦都区",
			"parentId": 610400
		}, {
			"id": 610403,
			"name": "杨陵区",
			"parentId": 610400
		}, {
			"id": 610404,
			"name": "渭城区",
			"parentId": 610400
		}, {
			"id": 610422,
			"name": "三原县",
			"parentId": 610400
		}, {
			"id": 610423,
			"name": "泾阳县",
			"parentId": 610400
		}, {
			"id": 610424,
			"name": "乾县",
			"parentId": 610400
		}, {
			"id": 610425,
			"name": "礼泉县",
			"parentId": 610400
		}, {
			"id": 610426,
			"name": "永寿县",
			"parentId": 610400
		}, {
			"id": 610427,
			"name": "彬县",
			"parentId": 610400
		}, {
			"id": 610428,
			"name": "长武县",
			"parentId": 610400
		}, {
			"id": 610429,
			"name": "旬邑县",
			"parentId": 610400
		}, {
			"id": 610430,
			"name": "淳化县",
			"parentId": 610400
		}, {
			"id": 610431,
			"name": "武功县",
			"parentId": 610400
		}, {
			"id": 610481,
			"name": "兴平市",
			"parentId": 610400
		}]
	}, {
		"id": 610500,
		"name": "渭南市",
		"parentId": 610,
		"children": [{
			"id": 610502,
			"name": "临渭区",
			"parentId": 610500
		}, {
			"id": 610503,
			"name": "华州区",
			"parentId": 610500
		}, {
			"id": 610522,
			"name": "潼关县",
			"parentId": 610500
		}, {
			"id": 610523,
			"name": "大荔县",
			"parentId": 610500
		}, {
			"id": 610524,
			"name": "合阳县",
			"parentId": 610500
		}, {
			"id": 610525,
			"name": "澄城县",
			"parentId": 610500
		}, {
			"id": 610526,
			"name": "蒲城县",
			"parentId": 610500
		}, {
			"id": 610527,
			"name": "白水县",
			"parentId": 610500
		}, {
			"id": 610528,
			"name": "富平县",
			"parentId": 610500
		}, {
			"id": 610581,
			"name": "韩城市",
			"parentId": 610500
		}, {
			"id": 610582,
			"name": "华阴市",
			"parentId": 610500
		}]
	}, {
		"id": 610600,
		"name": "延安市",
		"parentId": 610,
		"children": [{
			"id": 610602,
			"name": "宝塔区",
			"parentId": 610600
		}, {
			"id": 610603,
			"name": "安塞区",
			"parentId": 610600
		}, {
			"id": 610621,
			"name": "延长县",
			"parentId": 610600
		}, {
			"id": 610622,
			"name": "延川县",
			"parentId": 610600
		}, {
			"id": 610623,
			"name": "子长县",
			"parentId": 610600
		}, {
			"id": 610625,
			"name": "志丹县",
			"parentId": 610600
		}, {
			"id": 610626,
			"name": "吴起县",
			"parentId": 610600
		}, {
			"id": 610627,
			"name": "甘泉县",
			"parentId": 610600
		}, {
			"id": 610628,
			"name": "富县",
			"parentId": 610600
		}, {
			"id": 610629,
			"name": "洛川县",
			"parentId": 610600
		}, {
			"id": 610630,
			"name": "宜川县",
			"parentId": 610600
		}, {
			"id": 610631,
			"name": "黄龙县",
			"parentId": 610600
		}, {
			"id": 610632,
			"name": "黄陵县",
			"parentId": 610600
		}]
	}, {
		"id": 610700,
		"name": "汉中市",
		"parentId": 610,
		"children": [{
			"id": 610702,
			"name": "汉台区",
			"parentId": 610700
		}, {
			"id": 610721,
			"name": "南郑县",
			"parentId": 610700
		}, {
			"id": 610722,
			"name": "城固县",
			"parentId": 610700
		}, {
			"id": 610723,
			"name": "洋县",
			"parentId": 610700
		}, {
			"id": 610724,
			"name": "西乡县",
			"parentId": 610700
		}, {
			"id": 610725,
			"name": "勉县",
			"parentId": 610700
		}, {
			"id": 610726,
			"name": "宁强县",
			"parentId": 610700
		}, {
			"id": 610727,
			"name": "略阳县",
			"parentId": 610700
		}, {
			"id": 610728,
			"name": "镇巴县",
			"parentId": 610700
		}, {
			"id": 610729,
			"name": "留坝县",
			"parentId": 610700
		}, {
			"id": 610730,
			"name": "佛坪县",
			"parentId": 610700
		}]
	}, {
		"id": 610800,
		"name": "榆林市",
		"parentId": 610,
		"children": [{
			"id": 610802,
			"name": "榆阳区",
			"parentId": 610800
		}, {
			"id": 610803,
			"name": "横山区",
			"parentId": 610800
		}, {
			"id": 610822,
			"name": "府谷县",
			"parentId": 610800
		}, {
			"id": 610824,
			"name": "靖边县",
			"parentId": 610800
		}, {
			"id": 610825,
			"name": "定边县",
			"parentId": 610800
		}, {
			"id": 610826,
			"name": "绥德县",
			"parentId": 610800
		}, {
			"id": 610827,
			"name": "米脂县",
			"parentId": 610800
		}, {
			"id": 610828,
			"name": "佳县",
			"parentId": 610800
		}, {
			"id": 610829,
			"name": "吴堡县",
			"parentId": 610800
		}, {
			"id": 610830,
			"name": "清涧县",
			"parentId": 610800
		}, {
			"id": 610831,
			"name": "子洲县",
			"parentId": 610800
		}, {
			"id": 610881,
			"name": "神木市",
			"parentId": 610800
		}]
	}, {
		"id": 610900,
		"name": "安康市",
		"parentId": 610,
		"children": [{
			"id": 610902,
			"name": "汉滨区",
			"parentId": 610900
		}, {
			"id": 610921,
			"name": "汉阴县",
			"parentId": 610900
		}, {
			"id": 610922,
			"name": "石泉县",
			"parentId": 610900
		}, {
			"id": 610923,
			"name": "宁陕县",
			"parentId": 610900
		}, {
			"id": 610924,
			"name": "紫阳县",
			"parentId": 610900
		}, {
			"id": 610925,
			"name": "岚皋县",
			"parentId": 610900
		}, {
			"id": 610926,
			"name": "平利县",
			"parentId": 610900
		}, {
			"id": 610927,
			"name": "镇坪县",
			"parentId": 610900
		}, {
			"id": 610928,
			"name": "旬阳县",
			"parentId": 610900
		}, {
			"id": 610929,
			"name": "白河县",
			"parentId": 610900
		}]
	}, {
		"id": 611000,
		"name": "商洛市",
		"parentId": 610,
		"children": [{
			"id": 611002,
			"name": "商州区",
			"parentId": 611000
		}, {
			"id": 611021,
			"name": "洛南县",
			"parentId": 611000
		}, {
			"id": 611022,
			"name": "丹凤县",
			"parentId": 611000
		}, {
			"id": 611023,
			"name": "商南县",
			"parentId": 611000
		}, {
			"id": 611024,
			"name": "山阳县",
			"parentId": 611000
		}, {
			"id": 611025,
			"name": "镇安县",
			"parentId": 611000
		}, {
			"id": 611026,
			"name": "柞水县",
			"parentId": 611000
		}]
	}]
}, {
	"id": 620,
	"name": "甘肃省",
	"children": [{
		"id": 620100,
		"name": "兰州市",
		"parentId": 620,
		"children": [{
			"id": 620102,
			"name": "城关区",
			"parentId": 620100
		}, {
			"id": 620103,
			"name": "七里河区",
			"parentId": 620100
		}, {
			"id": 620104,
			"name": "西固区",
			"parentId": 620100
		}, {
			"id": 620105,
			"name": "安宁区",
			"parentId": 620100
		}, {
			"id": 620111,
			"name": "红古区",
			"parentId": 620100
		}, {
			"id": 620121,
			"name": "永登县",
			"parentId": 620100
		}, {
			"id": 620122,
			"name": "皋兰县",
			"parentId": 620100
		}, {
			"id": 620123,
			"name": "榆中县",
			"parentId": 620100
		}]
	}, {
		"id": 620200,
		"name": "嘉峪关市",
		"parentId": 620,
		"children": [{
			"id": 620201,
			"name": "嘉峪关市",
			"parentId": 620200
		}]
	}, {
		"id": 620300,
		"name": "金昌市",
		"parentId": 620,
		"children": [{
			"id": 620302,
			"name": "金川区",
			"parentId": 620300
		}, {
			"id": 620321,
			"name": "永昌县",
			"parentId": 620300
		}]
	}, {
		"id": 620400,
		"name": "白银市",
		"parentId": 620,
		"children": [{
			"id": 620402,
			"name": "白银区",
			"parentId": 620400
		}, {
			"id": 620403,
			"name": "平川区",
			"parentId": 620400
		}, {
			"id": 620421,
			"name": "靖远县",
			"parentId": 620400
		}, {
			"id": 620422,
			"name": "会宁县",
			"parentId": 620400
		}, {
			"id": 620423,
			"name": "景泰县",
			"parentId": 620400
		}]
	}, {
		"id": 620500,
		"name": "天水市",
		"parentId": 620,
		"children": [{
			"id": 620502,
			"name": "秦州区",
			"parentId": 620500
		}, {
			"id": 620503,
			"name": "麦积区",
			"parentId": 620500
		}, {
			"id": 620521,
			"name": "清水县",
			"parentId": 620500
		}, {
			"id": 620522,
			"name": "秦安县",
			"parentId": 620500
		}, {
			"id": 620523,
			"name": "甘谷县",
			"parentId": 620500
		}, {
			"id": 620524,
			"name": "武山县",
			"parentId": 620500
		}, {
			"id": 620525,
			"name": "张家川回族自治县",
			"parentId": 620500
		}]
	}, {
		"id": 620600,
		"name": "武威市",
		"parentId": 620,
		"children": [{
			"id": 620602,
			"name": "凉州区",
			"parentId": 620600
		}, {
			"id": 620621,
			"name": "民勤县",
			"parentId": 620600
		}, {
			"id": 620622,
			"name": "古浪县",
			"parentId": 620600
		}, {
			"id": 620623,
			"name": "天祝藏族自治县",
			"parentId": 620600
		}]
	}, {
		"id": 620700,
		"name": "张掖市",
		"parentId": 620,
		"children": [{
			"id": 620702,
			"name": "甘州区",
			"parentId": 620700
		}, {
			"id": 620721,
			"name": "肃南裕固族自治县",
			"parentId": 620700
		}, {
			"id": 620722,
			"name": "民乐县",
			"parentId": 620700
		}, {
			"id": 620723,
			"name": "临泽县",
			"parentId": 620700
		}, {
			"id": 620724,
			"name": "高台县",
			"parentId": 620700
		}, {
			"id": 620725,
			"name": "山丹县",
			"parentId": 620700
		}]
	}, {
		"id": 620800,
		"name": "平凉市",
		"parentId": 620,
		"children": [{
			"id": 620802,
			"name": "崆峒区",
			"parentId": 620800
		}, {
			"id": 620821,
			"name": "泾川县",
			"parentId": 620800
		}, {
			"id": 620822,
			"name": "灵台县",
			"parentId": 620800
		}, {
			"id": 620823,
			"name": "崇信县",
			"parentId": 620800
		}, {
			"id": 620824,
			"name": "华亭县",
			"parentId": 620800
		}, {
			"id": 620825,
			"name": "庄浪县",
			"parentId": 620800
		}, {
			"id": 620826,
			"name": "静宁县",
			"parentId": 620800
		}]
	}, {
		"id": 620900,
		"name": "酒泉市",
		"parentId": 620,
		"children": [{
			"id": 620902,
			"name": "肃州区",
			"parentId": 620900
		}, {
			"id": 620921,
			"name": "金塔县",
			"parentId": 620900
		}, {
			"id": 620922,
			"name": "瓜州县",
			"parentId": 620900
		}, {
			"id": 620923,
			"name": "肃北蒙古族自治县",
			"parentId": 620900
		}, {
			"id": 620924,
			"name": "阿克塞哈萨克族自治县",
			"parentId": 620900
		}, {
			"id": 620981,
			"name": "玉门市",
			"parentId": 620900
		}, {
			"id": 620982,
			"name": "敦煌市",
			"parentId": 620900
		}]
	}, {
		"id": 621000,
		"name": "庆阳市",
		"parentId": 620,
		"children": [{
			"id": 621002,
			"name": "西峰区",
			"parentId": 621000
		}, {
			"id": 621021,
			"name": "庆城县",
			"parentId": 621000
		}, {
			"id": 621022,
			"name": "环县",
			"parentId": 621000
		}, {
			"id": 621023,
			"name": "华池县",
			"parentId": 621000
		}, {
			"id": 621024,
			"name": "合水县",
			"parentId": 621000
		}, {
			"id": 621025,
			"name": "正宁县",
			"parentId": 621000
		}, {
			"id": 621026,
			"name": "宁县",
			"parentId": 621000
		}, {
			"id": 621027,
			"name": "镇原县",
			"parentId": 621000
		}]
	}, {
		"id": 621100,
		"name": "定西市",
		"parentId": 620,
		"children": [{
			"id": 621102,
			"name": "安定区",
			"parentId": 621100
		}, {
			"id": 621121,
			"name": "通渭县",
			"parentId": 621100
		}, {
			"id": 621122,
			"name": "陇西县",
			"parentId": 621100
		}, {
			"id": 621123,
			"name": "渭源县",
			"parentId": 621100
		}, {
			"id": 621124,
			"name": "临洮县",
			"parentId": 621100
		}, {
			"id": 621125,
			"name": "漳县",
			"parentId": 621100
		}, {
			"id": 621126,
			"name": "岷县",
			"parentId": 621100
		}]
	}, {
		"id": 621200,
		"name": "陇南市",
		"parentId": 620,
		"children": [{
			"id": 621202,
			"name": "武都区",
			"parentId": 621200
		}, {
			"id": 621221,
			"name": "成县",
			"parentId": 621200
		}, {
			"id": 621222,
			"name": "文县",
			"parentId": 621200
		}, {
			"id": 621223,
			"name": "宕昌县",
			"parentId": 621200
		}, {
			"id": 621224,
			"name": "康县",
			"parentId": 621200
		}, {
			"id": 621225,
			"name": "西和县",
			"parentId": 621200
		}, {
			"id": 621226,
			"name": "礼县",
			"parentId": 621200
		}, {
			"id": 621227,
			"name": "徽县",
			"parentId": 621200
		}, {
			"id": 621228,
			"name": "两当县",
			"parentId": 621200
		}]
	}, {
		"id": 622900,
		"name": "临夏回族自治州",
		"parentId": 620,
		"children": [{
			"id": 622901,
			"name": "临夏市",
			"parentId": 622900
		}, {
			"id": 622921,
			"name": "临夏县",
			"parentId": 622900
		}, {
			"id": 622922,
			"name": "康乐县",
			"parentId": 622900
		}, {
			"id": 622923,
			"name": "永靖县",
			"parentId": 622900
		}, {
			"id": 622924,
			"name": "广河县",
			"parentId": 622900
		}, {
			"id": 622925,
			"name": "和政县",
			"parentId": 622900
		}, {
			"id": 622926,
			"name": "东乡族自治县",
			"parentId": 622900
		}, {
			"id": 622927,
			"name": "积石山保安族东乡族撒拉族自治县",
			"parentId": 622900
		}]
	}, {
		"id": 623000,
		"name": "甘南藏族自治州",
		"parentId": 620,
		"children": [{
			"id": 623001,
			"name": "合作市",
			"parentId": 623000
		}, {
			"id": 623021,
			"name": "临潭县",
			"parentId": 623000
		}, {
			"id": 623022,
			"name": "卓尼县",
			"parentId": 623000
		}, {
			"id": 623023,
			"name": "舟曲县",
			"parentId": 623000
		}, {
			"id": 623024,
			"name": "迭部县",
			"parentId": 623000
		}, {
			"id": 623025,
			"name": "玛曲县",
			"parentId": 623000
		}, {
			"id": 623026,
			"name": "碌曲县",
			"parentId": 623000
		}, {
			"id": 623027,
			"name": "夏河县",
			"parentId": 623000
		}]
	}]
}, {
	"id": 630,
	"name": "青海省",
	"children": [{
		"id": 630100,
		"name": "西宁市",
		"parentId": 630,
		"children": [{
			"id": 630102,
			"name": "城东区",
			"parentId": 630100
		}, {
			"id": 630103,
			"name": "城中区",
			"parentId": 630100
		}, {
			"id": 630104,
			"name": "城西区",
			"parentId": 630100
		}, {
			"id": 630105,
			"name": "城北区",
			"parentId": 630100
		}, {
			"id": 630121,
			"name": "大通回族土族自治县",
			"parentId": 630100
		}, {
			"id": 630122,
			"name": "湟中县",
			"parentId": 630100
		}, {
			"id": 630123,
			"name": "湟源县",
			"parentId": 630100
		}]
	}, {
		"id": 630200,
		"name": "海东市",
		"parentId": 630,
		"children": [{
			"id": 630202,
			"name": "乐都区",
			"parentId": 630200
		}, {
			"id": 630203,
			"name": "平安区",
			"parentId": 630200
		}, {
			"id": 630222,
			"name": "民和回族土族自治县",
			"parentId": 630200
		}, {
			"id": 630223,
			"name": "互助土族自治县",
			"parentId": 630200
		}, {
			"id": 630224,
			"name": "化隆回族自治县",
			"parentId": 630200
		}, {
			"id": 630225,
			"name": "循化撒拉族自治县",
			"parentId": 630200
		}]
	}, {
		"id": 632200,
		"name": "海北藏族自治州",
		"parentId": 630,
		"children": [{
			"id": 632221,
			"name": "门源回族自治县",
			"parentId": 632200
		}, {
			"id": 632222,
			"name": "祁连县",
			"parentId": 632200
		}, {
			"id": 632223,
			"name": "海晏县",
			"parentId": 632200
		}, {
			"id": 632224,
			"name": "刚察县",
			"parentId": 632200
		}]
	}, {
		"id": 632300,
		"name": "黄南藏族自治州",
		"parentId": 630,
		"children": [{
			"id": 632321,
			"name": "同仁县",
			"parentId": 632300
		}, {
			"id": 632322,
			"name": "尖扎县",
			"parentId": 632300
		}, {
			"id": 632323,
			"name": "泽库县",
			"parentId": 632300
		}, {
			"id": 632324,
			"name": "河南蒙古族自治县",
			"parentId": 632300
		}]
	}, {
		"id": 632500,
		"name": "海南藏族自治州",
		"parentId": 630,
		"children": [{
			"id": 632521,
			"name": "共和县",
			"parentId": 632500
		}, {
			"id": 632522,
			"name": "同德县",
			"parentId": 632500
		}, {
			"id": 632523,
			"name": "贵德县",
			"parentId": 632500
		}, {
			"id": 632524,
			"name": "兴海县",
			"parentId": 632500
		}, {
			"id": 632525,
			"name": "贵南县",
			"parentId": 632500
		}]
	}, {
		"id": 632600,
		"name": "果洛藏族自治州",
		"parentId": 630,
		"children": [{
			"id": 632621,
			"name": "玛沁县",
			"parentId": 632600
		}, {
			"id": 632622,
			"name": "班玛县",
			"parentId": 632600
		}, {
			"id": 632623,
			"name": "甘德县",
			"parentId": 632600
		}, {
			"id": 632624,
			"name": "达日县",
			"parentId": 632600
		}, {
			"id": 632625,
			"name": "久治县",
			"parentId": 632600
		}, {
			"id": 632626,
			"name": "玛多县",
			"parentId": 632600
		}]
	}, {
		"id": 632700,
		"name": "玉树藏族自治州",
		"parentId": 630,
		"children": [{
			"id": 632701,
			"name": "玉树市",
			"parentId": 632700
		}, {
			"id": 632722,
			"name": "杂多县",
			"parentId": 632700
		}, {
			"id": 632723,
			"name": "称多县",
			"parentId": 632700
		}, {
			"id": 632724,
			"name": "治多县",
			"parentId": 632700
		}, {
			"id": 632725,
			"name": "囊谦县",
			"parentId": 632700
		}, {
			"id": 632726,
			"name": "曲麻莱县",
			"parentId": 632700
		}]
	}, {
		"id": 632800,
		"name": "海西蒙古族藏族自治州",
		"parentId": 630,
		"children": [{
			"id": 632801,
			"name": "格尔木市",
			"parentId": 632800
		}, {
			"id": 632802,
			"name": "德令哈市",
			"parentId": 632800
		}, {
			"id": 632821,
			"name": "乌兰县",
			"parentId": 632800
		}, {
			"id": 632822,
			"name": "都兰县",
			"parentId": 632800
		}, {
			"id": 632823,
			"name": "天峻县",
			"parentId": 632800
		}, {
			"id": 632824,
			"name": "冷湖行政区",
			"parentId": 632800
		}, {
			"id": 632825,
			"name": "大柴旦行政区",
			"parentId": 632800
		}, {
			"id": 632826,
			"name": "茫崖行政区",
			"parentId": 632800
		}]
	}]
}, {
	"id": 640,
	"name": "宁夏回族自治区",
	"children": [{
		"id": 640100,
		"name": "银川市",
		"parentId": 640,
		"children": [{
			"id": 640104,
			"name": "兴庆区",
			"parentId": 640100
		}, {
			"id": 640105,
			"name": "西夏区",
			"parentId": 640100
		}, {
			"id": 640106,
			"name": "金凤区",
			"parentId": 640100
		}, {
			"id": 640121,
			"name": "永宁县",
			"parentId": 640100
		}, {
			"id": 640122,
			"name": "贺兰县",
			"parentId": 640100
		}, {
			"id": 640181,
			"name": "灵武市",
			"parentId": 640100
		}]
	}, {
		"id": 640200,
		"name": "石嘴山市",
		"parentId": 640,
		"children": [{
			"id": 640202,
			"name": "大武口区",
			"parentId": 640200
		}, {
			"id": 640205,
			"name": "惠农区",
			"parentId": 640200
		}, {
			"id": 640221,
			"name": "平罗县",
			"parentId": 640200
		}]
	}, {
		"id": 640300,
		"name": "吴忠市",
		"parentId": 640,
		"children": [{
			"id": 640302,
			"name": "利通区",
			"parentId": 640300
		}, {
			"id": 640303,
			"name": "红寺堡区",
			"parentId": 640300
		}, {
			"id": 640323,
			"name": "盐池县",
			"parentId": 640300
		}, {
			"id": 640324,
			"name": "同心县",
			"parentId": 640300
		}, {
			"id": 640381,
			"name": "青铜峡市",
			"parentId": 640300
		}]
	}, {
		"id": 640400,
		"name": "固原市",
		"parentId": 640,
		"children": [{
			"id": 640402,
			"name": "原州区",
			"parentId": 640400
		}, {
			"id": 640422,
			"name": "西吉县",
			"parentId": 640400
		}, {
			"id": 640423,
			"name": "隆德县",
			"parentId": 640400
		}, {
			"id": 640424,
			"name": "泾源县",
			"parentId": 640400
		}, {
			"id": 640425,
			"name": "彭阳县",
			"parentId": 640400
		}]
	}, {
		"id": 640500,
		"name": "中卫市",
		"parentId": 640,
		"children": [{
			"id": 640502,
			"name": "沙坡头区",
			"parentId": 640500
		}, {
			"id": 640521,
			"name": "中宁县",
			"parentId": 640500
		}, {
			"id": 640522,
			"name": "海原县",
			"parentId": 640500
		}]
	}]
}, {
	"id": 650,
	"name": "新疆维吾尔自治区",
	"children": [{
		"id": 650100,
		"name": "乌鲁木齐市",
		"parentId": 650,
		"children": [{
			"id": 650102,
			"name": "天山区",
			"parentId": 650100
		}, {
			"id": 650103,
			"name": "沙依巴克区",
			"parentId": 650100
		}, {
			"id": 650104,
			"name": "新市区",
			"parentId": 650100
		}, {
			"id": 650105,
			"name": "水磨沟区",
			"parentId": 650100
		}, {
			"id": 650106,
			"name": "头屯河区",
			"parentId": 650100
		}, {
			"id": 650107,
			"name": "达坂城区",
			"parentId": 650100
		}, {
			"id": 650109,
			"name": "米东区",
			"parentId": 650100
		}, {
			"id": 650121,
			"name": "乌鲁木齐县",
			"parentId": 650100
		}]
	}, {
		"id": 650200,
		"name": "克拉玛依市",
		"parentId": 650,
		"children": [{
			"id": 650202,
			"name": "独山子区",
			"parentId": 650200
		}, {
			"id": 650203,
			"name": "克拉玛依区",
			"parentId": 650200
		}, {
			"id": 650204,
			"name": "白碱滩区",
			"parentId": 650200
		}, {
			"id": 650205,
			"name": "乌尔禾区",
			"parentId": 650200
		}]
	}, {
		"id": 650400,
		"name": "吐鲁番市",
		"parentId": 650,
		"children": [{
			"id": 650402,
			"name": "高昌区",
			"parentId": 650400
		}, {
			"id": 650421,
			"name": "鄯善县",
			"parentId": 650400
		}, {
			"id": 650422,
			"name": "托克逊县",
			"parentId": 650400
		}]
	}, {
		"id": 650500,
		"name": "哈密市",
		"parentId": 650,
		"children": [{
			"id": 650502,
			"name": "伊州区",
			"parentId": 650500
		}, {
			"id": 650521,
			"name": "巴里坤哈萨克自治县",
			"parentId": 650500
		}, {
			"id": 650522,
			"name": "伊吾县",
			"parentId": 650500
		}]
	}, {
		"id": 652300,
		"name": "昌吉回族自治州",
		"parentId": 650,
		"children": [{
			"id": 652301,
			"name": "昌吉市",
			"parentId": 652300
		}, {
			"id": 652302,
			"name": "阜康市",
			"parentId": 652300
		}, {
			"id": 652323,
			"name": "呼图壁县",
			"parentId": 652300
		}, {
			"id": 652324,
			"name": "玛纳斯县",
			"parentId": 652300
		}, {
			"id": 652325,
			"name": "奇台县",
			"parentId": 652300
		}, {
			"id": 652327,
			"name": "吉木萨尔县",
			"parentId": 652300
		}, {
			"id": 652328,
			"name": "木垒哈萨克自治县",
			"parentId": 652300
		}]
	}, {
		"id": 652700,
		"name": "博尔塔拉蒙古自治州",
		"parentId": 650,
		"children": [{
			"id": 652701,
			"name": "博乐市",
			"parentId": 652700
		}, {
			"id": 652702,
			"name": "阿拉山口市",
			"parentId": 652700
		}, {
			"id": 652722,
			"name": "精河县",
			"parentId": 652700
		}, {
			"id": 652723,
			"name": "温泉县",
			"parentId": 652700
		}]
	}, {
		"id": 652800,
		"name": "巴音郭楞蒙古自治州",
		"parentId": 650,
		"children": [{
			"id": 652801,
			"name": "库尔勒市",
			"parentId": 652800
		}, {
			"id": 652822,
			"name": "轮台县",
			"parentId": 652800
		}, {
			"id": 652823,
			"name": "尉犁县",
			"parentId": 652800
		}, {
			"id": 652824,
			"name": "若羌县",
			"parentId": 652800
		}, {
			"id": 652825,
			"name": "且末县",
			"parentId": 652800
		}, {
			"id": 652826,
			"name": "焉耆回族自治县",
			"parentId": 652800
		}, {
			"id": 652827,
			"name": "和静县",
			"parentId": 652800
		}, {
			"id": 652828,
			"name": "和硕县",
			"parentId": 652800
		}, {
			"id": 652829,
			"name": "博湖县",
			"parentId": 652800
		}]
	}, {
		"id": 652900,
		"name": "阿克苏地区",
		"parentId": 650,
		"children": [{
			"id": 652901,
			"name": "阿克苏市",
			"parentId": 652900
		}, {
			"id": 652922,
			"name": "温宿县",
			"parentId": 652900
		}, {
			"id": 652923,
			"name": "库车县",
			"parentId": 652900
		}, {
			"id": 652924,
			"name": "沙雅县",
			"parentId": 652900
		}, {
			"id": 652925,
			"name": "新和县",
			"parentId": 652900
		}, {
			"id": 652926,
			"name": "拜城县",
			"parentId": 652900
		}, {
			"id": 652927,
			"name": "乌什县",
			"parentId": 652900
		}, {
			"id": 652928,
			"name": "阿瓦提县",
			"parentId": 652900
		}, {
			"id": 652929,
			"name": "柯坪县",
			"parentId": 652900
		}]
	}, {
		"id": 653000,
		"name": "克孜勒苏柯尔克孜自治州",
		"parentId": 650,
		"children": [{
			"id": 653001,
			"name": "阿图什市",
			"parentId": 653000
		}, {
			"id": 653022,
			"name": "阿克陶县",
			"parentId": 653000
		}, {
			"id": 653023,
			"name": "阿合奇县",
			"parentId": 653000
		}, {
			"id": 653024,
			"name": "乌恰县",
			"parentId": 653000
		}]
	}, {
		"id": 653100,
		"name": "喀什地区",
		"parentId": 650,
		"children": [{
			"id": 653101,
			"name": "喀什市",
			"parentId": 653100
		}, {
			"id": 653121,
			"name": "疏附县",
			"parentId": 653100
		}, {
			"id": 653122,
			"name": "疏勒县",
			"parentId": 653100
		}, {
			"id": 653123,
			"name": "英吉沙县",
			"parentId": 653100
		}, {
			"id": 653124,
			"name": "泽普县",
			"parentId": 653100
		}, {
			"id": 653125,
			"name": "莎车县",
			"parentId": 653100
		}, {
			"id": 653126,
			"name": "叶城县",
			"parentId": 653100
		}, {
			"id": 653127,
			"name": "麦盖提县",
			"parentId": 653100
		}, {
			"id": 653128,
			"name": "岳普湖县",
			"parentId": 653100
		}, {
			"id": 653129,
			"name": "伽师县",
			"parentId": 653100
		}, {
			"id": 653130,
			"name": "巴楚县",
			"parentId": 653100
		}, {
			"id": 653131,
			"name": "塔什库尔干塔吉克自治县",
			"parentId": 653100
		}]
	}, {
		"id": 653200,
		"name": "和田地区",
		"parentId": 650,
		"children": [{
			"id": 653201,
			"name": "和田市",
			"parentId": 653200
		}, {
			"id": 653221,
			"name": "和田县",
			"parentId": 653200
		}, {
			"id": 653222,
			"name": "墨玉县",
			"parentId": 653200
		}, {
			"id": 653223,
			"name": "皮山县",
			"parentId": 653200
		}, {
			"id": 653224,
			"name": "洛浦县",
			"parentId": 653200
		}, {
			"id": 653225,
			"name": "策勒县",
			"parentId": 653200
		}, {
			"id": 653226,
			"name": "于田县",
			"parentId": 653200
		}, {
			"id": 653227,
			"name": "民丰县",
			"parentId": 653200
		}]
	}, {
		"id": 654000,
		"name": "伊犁哈萨克自治州",
		"parentId": 650,
		"children": [{
			"id": 654002,
			"name": "伊宁市",
			"parentId": 654000
		}, {
			"id": 654003,
			"name": "奎屯市",
			"parentId": 654000
		}, {
			"id": 654004,
			"name": "霍尔果斯市",
			"parentId": 654000
		}, {
			"id": 654021,
			"name": "伊宁县",
			"parentId": 654000
		}, {
			"id": 654022,
			"name": "察布查尔锡伯自治县",
			"parentId": 654000
		}, {
			"id": 654023,
			"name": "霍城县",
			"parentId": 654000
		}, {
			"id": 654024,
			"name": "巩留县",
			"parentId": 654000
		}, {
			"id": 654025,
			"name": "新源县",
			"parentId": 654000
		}, {
			"id": 654026,
			"name": "昭苏县",
			"parentId": 654000
		}, {
			"id": 654027,
			"name": "特克斯县",
			"parentId": 654000
		}, {
			"id": 654028,
			"name": "尼勒克县",
			"parentId": 654000
		}]
	}, {
		"id": 654200,
		"name": "塔城地区",
		"parentId": 650,
		"children": [{
			"id": 654201,
			"name": "塔城市",
			"parentId": 654200
		}, {
			"id": 654202,
			"name": "乌苏市",
			"parentId": 654200
		}, {
			"id": 654221,
			"name": "额敏县",
			"parentId": 654200
		}, {
			"id": 654223,
			"name": "沙湾县",
			"parentId": 654200
		}, {
			"id": 654224,
			"name": "托里县",
			"parentId": 654200
		}, {
			"id": 654225,
			"name": "裕民县",
			"parentId": 654200
		}, {
			"id": 654226,
			"name": "和布克赛尔蒙古自治县",
			"parentId": 654200
		}]
	}, {
		"id": 654300,
		"name": "阿勒泰地区",
		"parentId": 650,
		"children": [{
			"id": 654301,
			"name": "阿勒泰市",
			"parentId": 654300
		}, {
			"id": 654321,
			"name": "布尔津县",
			"parentId": 654300
		}, {
			"id": 654322,
			"name": "富蕴县",
			"parentId": 654300
		}, {
			"id": 654323,
			"name": "福海县",
			"parentId": 654300
		}, {
			"id": 654324,
			"name": "哈巴河县",
			"parentId": 654300
		}, {
			"id": 654325,
			"name": "青河县",
			"parentId": 654300
		}, {
			"id": 654326,
			"name": "吉木乃县",
			"parentId": 654300
		}]
	}, {
		"id": 659001,
		"name": "石河子市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659002,
		"name": "阿拉尔市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659003,
		"name": "图木舒克市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659004,
		"name": "五家渠市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659005,
		"name": "北屯市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659006,
		"name": "铁门关市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659007,
		"name": "双河市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659008,
		"name": "可克达拉市",
		"parentId": 650,
		"children": []
	}, {
		"id": 659009,
		"name": "昆玉市",
		"parentId": 650,
		"children": []
	}]
}, {
	"id": 710,
	"name": "台湾省",
	"children": [{
		"id": 710100,
		"name": "台北市",
		"parentId": 710,
		"children": [{
			"id": 710101,
			"name": "中正区",
			"parentId": 710100
		}, {
			"id": 710102,
			"name": "大同区",
			"parentId": 710100
		}, {
			"id": 710103,
			"name": "中山区",
			"parentId": 710100
		}, {
			"id": 710104,
			"name": "松山区",
			"parentId": 710100
		}, {
			"id": 710105,
			"name": "大安区",
			"parentId": 710100
		}, {
			"id": 710106,
			"name": "万华区",
			"parentId": 710100
		}, {
			"id": 710107,
			"name": "信义区",
			"parentId": 710100
		}, {
			"id": 710108,
			"name": "士林区",
			"parentId": 710100
		}, {
			"id": 710109,
			"name": "北投区",
			"parentId": 710100
		}, {
			"id": 710110,
			"name": "内湖区",
			"parentId": 710100
		}, {
			"id": 710111,
			"name": "南港区",
			"parentId": 710100
		}, {
			"id": 710112,
			"name": "文山区",
			"parentId": 710100
		}]
	}, {
		"id": 710200,
		"name": "高雄市",
		"parentId": 710,
		"children": [{
			"id": 710201,
			"name": "新兴区",
			"parentId": 710200
		}, {
			"id": 710202,
			"name": "前金区",
			"parentId": 710200
		}, {
			"id": 710203,
			"name": "苓雅区",
			"parentId": 710200
		}, {
			"id": 710204,
			"name": "盐埕区",
			"parentId": 710200
		}, {
			"id": 710205,
			"name": "鼓山区",
			"parentId": 710200
		}, {
			"id": 710206,
			"name": "旗津区",
			"parentId": 710200
		}, {
			"id": 710207,
			"name": "前镇区",
			"parentId": 710200
		}, {
			"id": 710208,
			"name": "三民区",
			"parentId": 710200
		}, {
			"id": 710209,
			"name": "左营区",
			"parentId": 710200
		}, {
			"id": 710210,
			"name": "楠梓区",
			"parentId": 710200
		}, {
			"id": 710211,
			"name": "小港区",
			"parentId": 710200
		}, {
			"id": 710242,
			"name": "仁武区",
			"parentId": 710200
		}, {
			"id": 710243,
			"name": "大社区",
			"parentId": 710200
		}, {
			"id": 710244,
			"name": "冈山区",
			"parentId": 710200
		}, {
			"id": 710245,
			"name": "路竹区",
			"parentId": 710200
		}, {
			"id": 710246,
			"name": "阿莲区",
			"parentId": 710200
		}, {
			"id": 710247,
			"name": "田寮区",
			"parentId": 710200
		}, {
			"id": 710248,
			"name": "燕巢区",
			"parentId": 710200
		}, {
			"id": 710249,
			"name": "桥头区",
			"parentId": 710200
		}, {
			"id": 710250,
			"name": "梓官区",
			"parentId": 710200
		}, {
			"id": 710251,
			"name": "弥陀区",
			"parentId": 710200
		}, {
			"id": 710252,
			"name": "永安区",
			"parentId": 710200
		}, {
			"id": 710253,
			"name": "湖内区",
			"parentId": 710200
		}, {
			"id": 710254,
			"name": "凤山区",
			"parentId": 710200
		}, {
			"id": 710255,
			"name": "大寮区",
			"parentId": 710200
		}, {
			"id": 710256,
			"name": "林园区",
			"parentId": 710200
		}, {
			"id": 710257,
			"name": "鸟松区",
			"parentId": 710200
		}, {
			"id": 710258,
			"name": "大树区",
			"parentId": 710200
		}, {
			"id": 710259,
			"name": "旗山区",
			"parentId": 710200
		}, {
			"id": 710260,
			"name": "美浓区",
			"parentId": 710200
		}, {
			"id": 710261,
			"name": "六龟区",
			"parentId": 710200
		}, {
			"id": 710262,
			"name": "内门区",
			"parentId": 710200
		}, {
			"id": 710263,
			"name": "杉林区",
			"parentId": 710200
		}, {
			"id": 710264,
			"name": "甲仙区",
			"parentId": 710200
		}, {
			"id": 710265,
			"name": "桃源区",
			"parentId": 710200
		}, {
			"id": 710266,
			"name": "那玛夏区",
			"parentId": 710200
		}, {
			"id": 710267,
			"name": "茂林区",
			"parentId": 710200
		}, {
			"id": 710268,
			"name": "茄萣区",
			"parentId": 710200
		}]
	}, {
		"id": 710300,
		"name": "台南市",
		"parentId": 710,
		"children": [{
			"id": 710301,
			"name": "中西区",
			"parentId": 710300
		}, {
			"id": 710302,
			"name": "东区",
			"parentId": 710300
		}, {
			"id": 710303,
			"name": "南区",
			"parentId": 710300
		}, {
			"id": 710304,
			"name": "北区",
			"parentId": 710300
		}, {
			"id": 710305,
			"name": "安平区",
			"parentId": 710300
		}, {
			"id": 710306,
			"name": "安南区",
			"parentId": 710300
		}, {
			"id": 710339,
			"name": "永康区",
			"parentId": 710300
		}, {
			"id": 710340,
			"name": "归仁区",
			"parentId": 710300
		}, {
			"id": 710341,
			"name": "新化区",
			"parentId": 710300
		}, {
			"id": 710342,
			"name": "左镇区",
			"parentId": 710300
		}, {
			"id": 710343,
			"name": "玉井区",
			"parentId": 710300
		}, {
			"id": 710344,
			"name": "楠西区",
			"parentId": 710300
		}, {
			"id": 710345,
			"name": "南化区",
			"parentId": 710300
		}, {
			"id": 710346,
			"name": "仁德区",
			"parentId": 710300
		}, {
			"id": 710347,
			"name": "关庙区",
			"parentId": 710300
		}, {
			"id": 710348,
			"name": "龙崎区",
			"parentId": 710300
		}, {
			"id": 710349,
			"name": "官田区",
			"parentId": 710300
		}, {
			"id": 710350,
			"name": "麻豆区",
			"parentId": 710300
		}, {
			"id": 710351,
			"name": "佳里区",
			"parentId": 710300
		}, {
			"id": 710352,
			"name": "西港区",
			"parentId": 710300
		}, {
			"id": 710353,
			"name": "七股区",
			"parentId": 710300
		}, {
			"id": 710354,
			"name": "将军区",
			"parentId": 710300
		}, {
			"id": 710355,
			"name": "学甲区",
			"parentId": 710300
		}, {
			"id": 710356,
			"name": "北门区",
			"parentId": 710300
		}, {
			"id": 710357,
			"name": "新营区",
			"parentId": 710300
		}, {
			"id": 710358,
			"name": "后壁区",
			"parentId": 710300
		}, {
			"id": 710359,
			"name": "白河区",
			"parentId": 710300
		}, {
			"id": 710360,
			"name": "东山区",
			"parentId": 710300
		}, {
			"id": 710361,
			"name": "六甲区",
			"parentId": 710300
		}, {
			"id": 710362,
			"name": "下营区",
			"parentId": 710300
		}, {
			"id": 710363,
			"name": "柳营区",
			"parentId": 710300
		}, {
			"id": 710364,
			"name": "盐水区",
			"parentId": 710300
		}, {
			"id": 710365,
			"name": "善化区",
			"parentId": 710300
		}, {
			"id": 710366,
			"name": "大内区",
			"parentId": 710300
		}, {
			"id": 710367,
			"name": "山上区",
			"parentId": 710300
		}, {
			"id": 710368,
			"name": "新市区",
			"parentId": 710300
		}, {
			"id": 710369,
			"name": "安定区",
			"parentId": 710300
		}]
	}, {
		"id": 710400,
		"name": "台中市",
		"parentId": 710,
		"children": [{
			"id": 710401,
			"name": "中区",
			"parentId": 710400
		}, {
			"id": 710402,
			"name": "东区",
			"parentId": 710400
		}, {
			"id": 710403,
			"name": "南区",
			"parentId": 710400
		}, {
			"id": 710404,
			"name": "西区",
			"parentId": 710400
		}, {
			"id": 710405,
			"name": "北区",
			"parentId": 710400
		}, {
			"id": 710406,
			"name": "北屯区",
			"parentId": 710400
		}, {
			"id": 710407,
			"name": "西屯区",
			"parentId": 710400
		}, {
			"id": 710408,
			"name": "南屯区",
			"parentId": 710400
		}, {
			"id": 710431,
			"name": "太平区",
			"parentId": 710400
		}, {
			"id": 710432,
			"name": "大里区",
			"parentId": 710400
		}, {
			"id": 710433,
			"name": "雾峰区",
			"parentId": 710400
		}, {
			"id": 710434,
			"name": "乌日区",
			"parentId": 710400
		}, {
			"id": 710435,
			"name": "丰原区",
			"parentId": 710400
		}, {
			"id": 710436,
			"name": "后里区",
			"parentId": 710400
		}, {
			"id": 710437,
			"name": "石冈区",
			"parentId": 710400
		}, {
			"id": 710438,
			"name": "东势区",
			"parentId": 710400
		}, {
			"id": 710439,
			"name": "和平区",
			"parentId": 710400
		}, {
			"id": 710440,
			"name": "新社区",
			"parentId": 710400
		}, {
			"id": 710441,
			"name": "潭子区",
			"parentId": 710400
		}, {
			"id": 710442,
			"name": "大雅区",
			"parentId": 710400
		}, {
			"id": 710443,
			"name": "神冈区",
			"parentId": 710400
		}, {
			"id": 710444,
			"name": "大肚区",
			"parentId": 710400
		}, {
			"id": 710445,
			"name": "沙鹿区",
			"parentId": 710400
		}, {
			"id": 710446,
			"name": "龙井区",
			"parentId": 710400
		}, {
			"id": 710447,
			"name": "梧栖区",
			"parentId": 710400
		}, {
			"id": 710448,
			"name": "清水区",
			"parentId": 710400
		}, {
			"id": 710449,
			"name": "大甲区",
			"parentId": 710400
		}, {
			"id": 710450,
			"name": "外埔区",
			"parentId": 710400
		}, {
			"id": 710451,
			"name": "大安区",
			"parentId": 710400
		}]
	}, {
		"id": 710600,
		"name": "南投县",
		"parentId": 710,
		"children": [{
			"id": 710614,
			"name": "南投市",
			"parentId": 710600
		}, {
			"id": 710615,
			"name": "中寮乡",
			"parentId": 710600
		}, {
			"id": 710616,
			"name": "草屯镇",
			"parentId": 710600
		}, {
			"id": 710617,
			"name": "国姓乡",
			"parentId": 710600
		}, {
			"id": 710618,
			"name": "埔里镇",
			"parentId": 710600
		}, {
			"id": 710619,
			"name": "仁爱乡",
			"parentId": 710600
		}, {
			"id": 710620,
			"name": "名间乡",
			"parentId": 710600
		}, {
			"id": 710621,
			"name": "集集镇",
			"parentId": 710600
		}, {
			"id": 710622,
			"name": "水里乡",
			"parentId": 710600
		}, {
			"id": 710623,
			"name": "鱼池乡",
			"parentId": 710600
		}, {
			"id": 710624,
			"name": "信义乡",
			"parentId": 710600
		}, {
			"id": 710625,
			"name": "竹山镇",
			"parentId": 710600
		}, {
			"id": 710626,
			"name": "鹿谷乡",
			"parentId": 710600
		}]
	}, {
		"id": 710700,
		"name": "基隆市",
		"parentId": 710,
		"children": [{
			"id": 710701,
			"name": "仁爱区",
			"parentId": 710700
		}, {
			"id": 710702,
			"name": "信义区",
			"parentId": 710700
		}, {
			"id": 710703,
			"name": "中正区",
			"parentId": 710700
		}, {
			"id": 710704,
			"name": "中山区",
			"parentId": 710700
		}, {
			"id": 710705,
			"name": "安乐区",
			"parentId": 710700
		}, {
			"id": 710706,
			"name": "暖暖区",
			"parentId": 710700
		}, {
			"id": 710707,
			"name": "七堵区",
			"parentId": 710700
		}]
	}, {
		"id": 710800,
		"name": "新竹市",
		"parentId": 710,
		"children": [{
			"id": 710801,
			"name": "东区",
			"parentId": 710800
		}, {
			"id": 710802,
			"name": "北区",
			"parentId": 710800
		}, {
			"id": 710803,
			"name": "香山区",
			"parentId": 710800
		}]
	}, {
		"id": 710900,
		"name": "嘉义市",
		"parentId": 710,
		"children": [{
			"id": 710901,
			"name": "东区",
			"parentId": 710900
		}, {
			"id": 710902,
			"name": "西区",
			"parentId": 710900
		}]
	}, {
		"id": 711100,
		"name": "新北市",
		"parentId": 710,
		"children": [{
			"id": 711130,
			"name": "万里区",
			"parentId": 711100
		}, {
			"id": 711131,
			"name": "金山区",
			"parentId": 711100
		}, {
			"id": 711132,
			"name": "板桥区",
			"parentId": 711100
		}, {
			"id": 711133,
			"name": "汐止区",
			"parentId": 711100
		}, {
			"id": 711134,
			"name": "深坑区",
			"parentId": 711100
		}, {
			"id": 711135,
			"name": "石碇区",
			"parentId": 711100
		}, {
			"id": 711136,
			"name": "瑞芳区",
			"parentId": 711100
		}, {
			"id": 711137,
			"name": "平溪区",
			"parentId": 711100
		}, {
			"id": 711138,
			"name": "双溪区",
			"parentId": 711100
		}, {
			"id": 711139,
			"name": "贡寮区",
			"parentId": 711100
		}, {
			"id": 711140,
			"name": "新店区",
			"parentId": 711100
		}, {
			"id": 711141,
			"name": "坪林区",
			"parentId": 711100
		}, {
			"id": 711142,
			"name": "乌来区",
			"parentId": 711100
		}, {
			"id": 711143,
			"name": "永和区",
			"parentId": 711100
		}, {
			"id": 711144,
			"name": "中和区",
			"parentId": 711100
		}, {
			"id": 711145,
			"name": "土城区",
			"parentId": 711100
		}, {
			"id": 711146,
			"name": "三峡区",
			"parentId": 711100
		}, {
			"id": 711147,
			"name": "树林区",
			"parentId": 711100
		}, {
			"id": 711148,
			"name": "莺歌区",
			"parentId": 711100
		}, {
			"id": 711149,
			"name": "三重区",
			"parentId": 711100
		}, {
			"id": 711150,
			"name": "新庄区",
			"parentId": 711100
		}, {
			"id": 711151,
			"name": "泰山区",
			"parentId": 711100
		}, {
			"id": 711152,
			"name": "林口区",
			"parentId": 711100
		}, {
			"id": 711153,
			"name": "芦洲区",
			"parentId": 711100
		}, {
			"id": 711154,
			"name": "五股区",
			"parentId": 711100
		}, {
			"id": 711155,
			"name": "八里区",
			"parentId": 711100
		}, {
			"id": 711156,
			"name": "淡水区",
			"parentId": 711100
		}, {
			"id": 711157,
			"name": "三芝区",
			"parentId": 711100
		}, {
			"id": 711158,
			"name": "石门区",
			"parentId": 711100
		}]
	}, {
		"id": 711200,
		"name": "宜兰县",
		"parentId": 710,
		"children": [{
			"id": 711214,
			"name": "宜兰市",
			"parentId": 711200
		}, {
			"id": 711215,
			"name": "头城镇",
			"parentId": 711200
		}, {
			"id": 711216,
			"name": "礁溪乡",
			"parentId": 711200
		}, {
			"id": 711217,
			"name": "壮围乡",
			"parentId": 711200
		}, {
			"id": 711218,
			"name": "员山乡",
			"parentId": 711200
		}, {
			"id": 711219,
			"name": "罗东镇",
			"parentId": 711200
		}, {
			"id": 711220,
			"name": "三星乡",
			"parentId": 711200
		}, {
			"id": 711221,
			"name": "大同乡",
			"parentId": 711200
		}, {
			"id": 711222,
			"name": "五结乡",
			"parentId": 711200
		}, {
			"id": 711223,
			"name": "冬山乡",
			"parentId": 711200
		}, {
			"id": 711224,
			"name": "苏澳镇",
			"parentId": 711200
		}, {
			"id": 711225,
			"name": "南澳乡",
			"parentId": 711200
		}]
	}, {
		"id": 711300,
		"name": "新竹县",
		"parentId": 710,
		"children": [{
			"id": 711314,
			"name": "竹北市",
			"parentId": 711300
		}, {
			"id": 711315,
			"name": "湖口乡",
			"parentId": 711300
		}, {
			"id": 711316,
			"name": "新丰乡",
			"parentId": 711300
		}, {
			"id": 711317,
			"name": "新埔镇",
			"parentId": 711300
		}, {
			"id": 711318,
			"name": "关西镇",
			"parentId": 711300
		}, {
			"id": 711319,
			"name": "芎林乡",
			"parentId": 711300
		}, {
			"id": 711320,
			"name": "宝山乡",
			"parentId": 711300
		}, {
			"id": 711321,
			"name": "竹东镇",
			"parentId": 711300
		}, {
			"id": 711322,
			"name": "五峰乡",
			"parentId": 711300
		}, {
			"id": 711323,
			"name": "横山乡",
			"parentId": 711300
		}, {
			"id": 711324,
			"name": "尖石乡",
			"parentId": 711300
		}, {
			"id": 711325,
			"name": "北埔乡",
			"parentId": 711300
		}, {
			"id": 711326,
			"name": "峨眉乡",
			"parentId": 711300
		}]
	}, {
		"id": 711400,
		"name": "桃园市",
		"parentId": 710,
		"children": [{
			"id": 711414,
			"name": "中坜区",
			"parentId": 711400
		}, {
			"id": 711415,
			"name": "平镇区",
			"parentId": 711400
		}, {
			"id": 711416,
			"name": "龙潭区",
			"parentId": 711400
		}, {
			"id": 711417,
			"name": "杨梅区",
			"parentId": 711400
		}, {
			"id": 711418,
			"name": "新屋区",
			"parentId": 711400
		}, {
			"id": 711419,
			"name": "观音区",
			"parentId": 711400
		}, {
			"id": 711420,
			"name": "桃园区",
			"parentId": 711400
		}, {
			"id": 711421,
			"name": "龟山区",
			"parentId": 711400
		}, {
			"id": 711422,
			"name": "八德区",
			"parentId": 711400
		}, {
			"id": 711423,
			"name": "大溪区",
			"parentId": 711400
		}, {
			"id": 711424,
			"name": "复兴区",
			"parentId": 711400
		}, {
			"id": 711425,
			"name": "大园区",
			"parentId": 711400
		}, {
			"id": 711426,
			"name": "芦竹区",
			"parentId": 711400
		}]
	}, {
		"id": 711500,
		"name": "苗栗县",
		"parentId": 710,
		"children": [{
			"id": 711519,
			"name": "竹南镇",
			"parentId": 711500
		}, {
			"id": 711520,
			"name": "头份市",
			"parentId": 711500
		}, {
			"id": 711521,
			"name": "三湾乡",
			"parentId": 711500
		}, {
			"id": 711522,
			"name": "南庄乡",
			"parentId": 711500
		}, {
			"id": 711523,
			"name": "狮潭乡",
			"parentId": 711500
		}, {
			"id": 711524,
			"name": "后龙镇",
			"parentId": 711500
		}, {
			"id": 711525,
			"name": "通霄镇",
			"parentId": 711500
		}, {
			"id": 711526,
			"name": "苑里镇",
			"parentId": 711500
		}, {
			"id": 711527,
			"name": "苗栗市",
			"parentId": 711500
		}, {
			"id": 711528,
			"name": "造桥乡",
			"parentId": 711500
		}, {
			"id": 711529,
			"name": "头屋乡",
			"parentId": 711500
		}, {
			"id": 711530,
			"name": "公馆乡",
			"parentId": 711500
		}, {
			"id": 711531,
			"name": "大湖乡",
			"parentId": 711500
		}, {
			"id": 711532,
			"name": "泰安乡",
			"parentId": 711500
		}, {
			"id": 711533,
			"name": "铜锣乡",
			"parentId": 711500
		}, {
			"id": 711534,
			"name": "三义乡",
			"parentId": 711500
		}, {
			"id": 711535,
			"name": "西湖乡",
			"parentId": 711500
		}, {
			"id": 711536,
			"name": "卓兰镇",
			"parentId": 711500
		}]
	}, {
		"id": 711700,
		"name": "彰化县",
		"parentId": 710,
		"children": [{
			"id": 711727,
			"name": "彰化市",
			"parentId": 711700
		}, {
			"id": 711728,
			"name": "芬园乡",
			"parentId": 711700
		}, {
			"id": 711729,
			"name": "花坛乡",
			"parentId": 711700
		}, {
			"id": 711730,
			"name": "秀水乡",
			"parentId": 711700
		}, {
			"id": 711731,
			"name": "鹿港镇",
			"parentId": 711700
		}, {
			"id": 711732,
			"name": "福兴乡",
			"parentId": 711700
		}, {
			"id": 711733,
			"name": "线西乡",
			"parentId": 711700
		}, {
			"id": 711734,
			"name": "和美镇",
			"parentId": 711700
		}, {
			"id": 711735,
			"name": "伸港乡",
			"parentId": 711700
		}, {
			"id": 711736,
			"name": "员林市",
			"parentId": 711700
		}, {
			"id": 711737,
			"name": "社头乡",
			"parentId": 711700
		}, {
			"id": 711738,
			"name": "永靖乡",
			"parentId": 711700
		}, {
			"id": 711739,
			"name": "埔心乡",
			"parentId": 711700
		}, {
			"id": 711740,
			"name": "溪湖镇",
			"parentId": 711700
		}, {
			"id": 711741,
			"name": "大村乡",
			"parentId": 711700
		}, {
			"id": 711742,
			"name": "埔盐乡",
			"parentId": 711700
		}, {
			"id": 711743,
			"name": "田中镇",
			"parentId": 711700
		}, {
			"id": 711744,
			"name": "北斗镇",
			"parentId": 711700
		}, {
			"id": 711745,
			"name": "田尾乡",
			"parentId": 711700
		}, {
			"id": 711746,
			"name": "埤头乡",
			"parentId": 711700
		}, {
			"id": 711747,
			"name": "溪州乡",
			"parentId": 711700
		}, {
			"id": 711748,
			"name": "竹塘乡",
			"parentId": 711700
		}, {
			"id": 711749,
			"name": "二林镇",
			"parentId": 711700
		}, {
			"id": 711750,
			"name": "大城乡",
			"parentId": 711700
		}, {
			"id": 711751,
			"name": "芳苑乡",
			"parentId": 711700
		}, {
			"id": 711752,
			"name": "二水乡",
			"parentId": 711700
		}]
	}, {
		"id": 711900,
		"name": "嘉义县",
		"parentId": 710,
		"children": [{
			"id": 711919,
			"name": "番路乡",
			"parentId": 711900
		}, {
			"id": 711920,
			"name": "梅山乡",
			"parentId": 711900
		}, {
			"id": 711921,
			"name": "竹崎乡",
			"parentId": 711900
		}, {
			"id": 711922,
			"name": "阿里山乡",
			"parentId": 711900
		}, {
			"id": 711923,
			"name": "中埔乡",
			"parentId": 711900
		}, {
			"id": 711924,
			"name": "大埔乡",
			"parentId": 711900
		}, {
			"id": 711925,
			"name": "水上乡",
			"parentId": 711900
		}, {
			"id": 711926,
			"name": "鹿草乡",
			"parentId": 711900
		}, {
			"id": 711927,
			"name": "太保市",
			"parentId": 711900
		}, {
			"id": 711928,
			"name": "朴子市",
			"parentId": 711900
		}, {
			"id": 711929,
			"name": "东石乡",
			"parentId": 711900
		}, {
			"id": 711930,
			"name": "六脚乡",
			"parentId": 711900
		}, {
			"id": 711931,
			"name": "新港乡",
			"parentId": 711900
		}, {
			"id": 711932,
			"name": "民雄乡",
			"parentId": 711900
		}, {
			"id": 711933,
			"name": "大林镇",
			"parentId": 711900
		}, {
			"id": 711934,
			"name": "溪口乡",
			"parentId": 711900
		}, {
			"id": 711935,
			"name": "义竹乡",
			"parentId": 711900
		}, {
			"id": 711936,
			"name": "布袋镇",
			"parentId": 711900
		}]
	}, {
		"id": 712100,
		"name": "云林县",
		"parentId": 710,
		"children": [{
			"id": 712121,
			"name": "斗南镇",
			"parentId": 712100
		}, {
			"id": 712122,
			"name": "大埤乡",
			"parentId": 712100
		}, {
			"id": 712123,
			"name": "虎尾镇",
			"parentId": 712100
		}, {
			"id": 712124,
			"name": "土库镇",
			"parentId": 712100
		}, {
			"id": 712125,
			"name": "褒忠乡",
			"parentId": 712100
		}, {
			"id": 712126,
			"name": "东势乡",
			"parentId": 712100
		}, {
			"id": 712127,
			"name": "台西乡",
			"parentId": 712100
		}, {
			"id": 712128,
			"name": "仑背乡",
			"parentId": 712100
		}, {
			"id": 712129,
			"name": "麦寮乡",
			"parentId": 712100
		}, {
			"id": 712130,
			"name": "斗六市",
			"parentId": 712100
		}, {
			"id": 712131,
			"name": "林内乡",
			"parentId": 712100
		}, {
			"id": 712132,
			"name": "古坑乡",
			"parentId": 712100
		}, {
			"id": 712133,
			"name": "莿桐乡",
			"parentId": 712100
		}, {
			"id": 712134,
			"name": "西螺镇",
			"parentId": 712100
		}, {
			"id": 712135,
			"name": "二仑乡",
			"parentId": 712100
		}, {
			"id": 712136,
			"name": "北港镇",
			"parentId": 712100
		}, {
			"id": 712137,
			"name": "水林乡",
			"parentId": 712100
		}, {
			"id": 712138,
			"name": "口湖乡",
			"parentId": 712100
		}, {
			"id": 712139,
			"name": "四湖乡",
			"parentId": 712100
		}, {
			"id": 712140,
			"name": "元长乡",
			"parentId": 712100
		}]
	}, {
		"id": 712400,
		"name": "屏东县",
		"parentId": 710,
		"children": [{
			"id": 712434,
			"name": "屏东市",
			"parentId": 712400
		}, {
			"id": 712435,
			"name": "三地门乡",
			"parentId": 712400
		}, {
			"id": 712436,
			"name": "雾台乡",
			"parentId": 712400
		}, {
			"id": 712437,
			"name": "玛家乡",
			"parentId": 712400
		}, {
			"id": 712438,
			"name": "九如乡",
			"parentId": 712400
		}, {
			"id": 712439,
			"name": "里港乡",
			"parentId": 712400
		}, {
			"id": 712440,
			"name": "高树乡",
			"parentId": 712400
		}, {
			"id": 712441,
			"name": "盐埔乡",
			"parentId": 712400
		}, {
			"id": 712442,
			"name": "长治乡",
			"parentId": 712400
		}, {
			"id": 712443,
			"name": "麟洛乡",
			"parentId": 712400
		}, {
			"id": 712444,
			"name": "竹田乡",
			"parentId": 712400
		}, {
			"id": 712445,
			"name": "内埔乡",
			"parentId": 712400
		}, {
			"id": 712446,
			"name": "万丹乡",
			"parentId": 712400
		}, {
			"id": 712447,
			"name": "潮州镇",
			"parentId": 712400
		}, {
			"id": 712448,
			"name": "泰武乡",
			"parentId": 712400
		}, {
			"id": 712449,
			"name": "来义乡",
			"parentId": 712400
		}, {
			"id": 712450,
			"name": "万峦乡",
			"parentId": 712400
		}, {
			"id": 712451,
			"name": "崁顶乡",
			"parentId": 712400
		}, {
			"id": 712452,
			"name": "新埤乡",
			"parentId": 712400
		}, {
			"id": 712453,
			"name": "南州乡",
			"parentId": 712400
		}, {
			"id": 712454,
			"name": "林边乡",
			"parentId": 712400
		}, {
			"id": 712455,
			"name": "东港镇",
			"parentId": 712400
		}, {
			"id": 712456,
			"name": "琉球乡",
			"parentId": 712400
		}, {
			"id": 712457,
			"name": "佳冬乡",
			"parentId": 712400
		}, {
			"id": 712458,
			"name": "新园乡",
			"parentId": 712400
		}, {
			"id": 712459,
			"name": "枋寮乡",
			"parentId": 712400
		}, {
			"id": 712460,
			"name": "枋山乡",
			"parentId": 712400
		}, {
			"id": 712461,
			"name": "春日乡",
			"parentId": 712400
		}, {
			"id": 712462,
			"name": "狮子乡",
			"parentId": 712400
		}, {
			"id": 712463,
			"name": "车城乡",
			"parentId": 712400
		}, {
			"id": 712464,
			"name": "牡丹乡",
			"parentId": 712400
		}, {
			"id": 712465,
			"name": "恒春镇",
			"parentId": 712400
		}, {
			"id": 712466,
			"name": "满州乡",
			"parentId": 712400
		}]
	}, {
		"id": 712500,
		"name": "台东县",
		"parentId": 710,
		"children": [{
			"id": 712517,
			"name": "台东市",
			"parentId": 712500
		}, {
			"id": 712518,
			"name": "绿岛乡",
			"parentId": 712500
		}, {
			"id": 712519,
			"name": "兰屿乡",
			"parentId": 712500
		}, {
			"id": 712520,
			"name": "延平乡",
			"parentId": 712500
		}, {
			"id": 712521,
			"name": "卑南乡",
			"parentId": 712500
		}, {
			"id": 712522,
			"name": "鹿野乡",
			"parentId": 712500
		}, {
			"id": 712523,
			"name": "关山镇",
			"parentId": 712500
		}, {
			"id": 712524,
			"name": "海端乡",
			"parentId": 712500
		}, {
			"id": 712525,
			"name": "池上乡",
			"parentId": 712500
		}, {
			"id": 712526,
			"name": "东河乡",
			"parentId": 712500
		}, {
			"id": 712527,
			"name": "成功镇",
			"parentId": 712500
		}, {
			"id": 712528,
			"name": "长滨乡",
			"parentId": 712500
		}, {
			"id": 712529,
			"name": "金峰乡",
			"parentId": 712500
		}, {
			"id": 712530,
			"name": "大武乡",
			"parentId": 712500
		}, {
			"id": 712531,
			"name": "达仁乡",
			"parentId": 712500
		}, {
			"id": 712532,
			"name": "太麻里乡",
			"parentId": 712500
		}]
	}, {
		"id": 712600,
		"name": "花莲县",
		"parentId": 710,
		"children": [{
			"id": 712615,
			"name": "花莲市",
			"parentId": 712600
		}, {
			"id": 712616,
			"name": "新城乡",
			"parentId": 712600
		}, {
			"id": 712618,
			"name": "秀林乡",
			"parentId": 712600
		}, {
			"id": 712619,
			"name": "吉安乡",
			"parentId": 712600
		}, {
			"id": 712620,
			"name": "寿丰乡",
			"parentId": 712600
		}, {
			"id": 712621,
			"name": "凤林镇",
			"parentId": 712600
		}, {
			"id": 712622,
			"name": "光复乡",
			"parentId": 712600
		}, {
			"id": 712623,
			"name": "丰滨乡",
			"parentId": 712600
		}, {
			"id": 712624,
			"name": "瑞穗乡",
			"parentId": 712600
		}, {
			"id": 712625,
			"name": "万荣乡",
			"parentId": 712600
		}, {
			"id": 712626,
			"name": "玉里镇",
			"parentId": 712600
		}, {
			"id": 712627,
			"name": "卓溪乡",
			"parentId": 712600
		}, {
			"id": 712628,
			"name": "富里乡",
			"parentId": 712600
		}]
	}, {
		"id": 712700,
		"name": "澎湖县",
		"parentId": 710,
		"children": [{
			"id": 712707,
			"name": "马公市",
			"parentId": 712700
		}, {
			"id": 712708,
			"name": "西屿乡",
			"parentId": 712700
		}, {
			"id": 712709,
			"name": "望安乡",
			"parentId": 712700
		}, {
			"id": 712710,
			"name": "七美乡",
			"parentId": 712700
		}, {
			"id": 712711,
			"name": "白沙乡",
			"parentId": 712700
		}, {
			"id": 712712,
			"name": "湖西乡",
			"parentId": 712700
		}]
	}]
}, {
	"id": 810,
	"name": "香港特别行政区",
	"children": [{
		"id": 810000,
		"name": "香港特别行政区",
		"parentId": 810,
		"children": [{
			"id": 810101,
			"name": "中西区",
			"parentId": 810000
		}, {
			"id": 810102,
			"name": "东区",
			"parentId": 810000
		}, {
			"id": 810103,
			"name": "九龙城区",
			"parentId": 810000
		}, {
			"id": 810104,
			"name": "观塘区",
			"parentId": 810000
		}, {
			"id": 810105,
			"name": "南区",
			"parentId": 810000
		}, {
			"id": 810106,
			"name": "深水埗区",
			"parentId": 810000
		}, {
			"id": 810107,
			"name": "湾仔区",
			"parentId": 810000
		}, {
			"id": 810108,
			"name": "黄大仙区",
			"parentId": 810000
		}, {
			"id": 810109,
			"name": "油尖旺区",
			"parentId": 810000
		}, {
			"id": 810110,
			"name": "离岛区",
			"parentId": 810000
		}, {
			"id": 810111,
			"name": "葵青区",
			"parentId": 810000
		}, {
			"id": 810112,
			"name": "北区",
			"parentId": 810000
		}, {
			"id": 810113,
			"name": "西贡区",
			"parentId": 810000
		}, {
			"id": 810114,
			"name": "沙田区",
			"parentId": 810000
		}, {
			"id": 810115,
			"name": "屯门区",
			"parentId": 810000
		}, {
			"id": 810116,
			"name": "大埔区",
			"parentId": 810000
		}, {
			"id": 810117,
			"name": "荃湾区",
			"parentId": 810000
		}, {
			"id": 810118,
			"name": "元朗区",
			"parentId": 810000
		}]
	}]
}, {
	"id": 820,
	"name": "澳门特别行政区",
	"children": [{
		"id": 820000,
		"name": "澳门特别行政区",
		"parentId": 820,
		"children": [{
			"id": 820101,
			"name": "澳门半岛",
			"parentId": 820000
		}, {
			"id": 820102,
			"name": "凼仔",
			"parentId": 820000
		}, {
			"id": 820103,
			"name": "路凼城",
			"parentId": 820000
		}, {
			"id": 820104,
			"name": "路环",
			"parentId": 820000
		}]
	}]
}];

/* harmony default export */ var util_city = (city);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/OrderDetail.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var OrderDetail = ({
  data: function data() {
    return {
      id: '',
      data: {},
      type: '',
      productList: [],
      form: {
        way: '', // 退货方式
        instructions: '', // 退货说明
        // 自行寄回
        consignee: '', //收货人
        consigneePhone: '', //收货人手机号
        consigneeAddress: '', //收货人地址
        // 上门取件
        sender: '', // 寄件人
        senderPhone: '', // 寄件人手机号
        senderArea: '', // 寄件人所在地区
        senderAddress: '' // 寄件人详细地址
      },
      options: [{ value: 1, label: '上门取件' }, { value: 2, label: '自行寄回' }],
      aggregateAddress: [], //总集地址
      myAddress: [],
      city: util_city,
      props: {
        label: 'name',
        value: 'id'
      }
    };
  },

  components: {},
  created: function created() {
    this.id = this.$route.params.id;
    this.detailOnline();
    // returnGoods 退货 barter 换货
    var type = this.$route.query.type;
    if (type) {
      this.type = type;
      this.getsAggregateAddress();
      this.getMyAddress();
    }
  },

  computed: {},
  mounted: function mounted() {},

  methods: {
    // 获取总集地址
    getsAggregateAddress: function getsAggregateAddress() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: '2fec51904d384887a819622a9975675b',
                  page: 1,
                  limit: 20
                });

              case 2:
                _ref = _context.sent;
                result = _ref.result;

                _this.aggregateAddress = result;
                if (result && result.length > 0) {
                  _this.$set(_this.form, 'consignee', result[0].id);
                  _this.$set(_this.form, 'consigneePhone', result[0].lw5lmjwlsaz0vzuu);
                  _this.$set(_this.form, 'consigneeAddress', result[0].fm0kblhuu2evs4rv);
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 获取我的地址
    getMyAddress: function getMyAddress() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
                  page: 1,
                  limit: 20,
                  keyword: '',
                  select_option: ''
                });

              case 2:
                _ref2 = _context2.sent;
                result = _ref2.result;

                _this2.myAddress = result;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeAddress: function changeAddress(e) {
      var obj = this.myAddress.find(function (el) {
        return el.id === e;
      });
      this.$set(this.form, 'senderPhone', obj.xejhteu0ub3fd3eh);
      this.$set(this.form, 'senderArea', obj.b3ccmzbfyzlwy9sc.map(function (el) {
        return el.id;
      }));
      this.$set(this.form, 'senderAddress', obj['9simp0sjii9s0m33']);
    },

    // 复制订单号
    copyToClipboard: function copyToClipboard() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var oInput;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 创建输入框元素
                oInput = document.createElement('input');
                // 将想要复制的值

                oInput.value = _this3.data['5rh34ajk852uufsx'];
                // 页面底部追加输入框
                document.body.appendChild(oInput);
                // 选中输入框
                oInput.select();
                // 执行浏览器复制命令
                document.execCommand('Copy');
                // 弹出复制成功信息
                _this3.$message({
                  message: '文本已复制到剪贴板',
                  type: 'success'
                });
                // 复制后移除输入框
                oInput.remove();

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    detailOnline: function detailOnline() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref3, result;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(platform["g" /* detailOnline */])({
                  form_head_uuid: "58a2be48484e436dbbb28fd778406de6",
                  id: _this4.id
                });

              case 2:
                _ref3 = _context4.sent;
                result = _ref3.result;

                _this4.data = result;
                _this4.children();

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    children: function children() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _ref4, result;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 20,
                  field_uuid: '00f98dceac054e8fb727092a99fc5a3d',
                  form_head_uuid: '25a23d706f0e465c9ad89c333a841459',
                  record_id: _this5.id
                });

              case 2:
                _ref4 = _context5.sent;
                result = _ref4.result;

                _this5.productList = result;

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    confirm: function confirm() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var params, form_head_uuid, productList, type, id, _form, way, instructions, sender, senderPhone, senderArea, senderAddress, consignee, consigneePhone, consigneeAddress;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {};
                form_head_uuid = '';
                productList = _this6.productList, type = _this6.type, id = _this6.data.id;
                _form = _this6.form, way = _form.way, instructions = _form.instructions, sender = _form.sender, senderPhone = _form.senderPhone, senderArea = _form.senderArea, senderAddress = _form.senderAddress, consignee = _form.consignee, consigneePhone = _form.consigneePhone, consigneeAddress = _form.consigneeAddress;

                if (way) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt('return', _this6.$message.error('\u8BF7\u9009\u62E9' + (type === 'returnGoods' ? '退' : '换') + '\u8D27\u65B9\u5F0F'));

              case 6:
                if (instructions) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt('return', _this6.$message.error('\u8BF7\u8F93\u5165' + (type === 'returnGoods' ? '退' : '换') + '\u8D27\u8BF4\u660E'));

              case 8:
                if (sender) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt('return', _this6.$message.error('请选择寄件人'));

              case 10:
                if (_this6.type === 'returnGoods') {
                  form_head_uuid = '30cfd060adfe11ee81ef0242321230b4';
                  params = {
                    irpxqkcdtusqiy2y: [id],
                    indtkil4tvvff0ie: way === 1 ? '99152472-0949-4a28-89fc-61e8ddffaac3' : '4baade9e-2402-4ffd-9d57-74c1abc800cc', // 退货方式 上门取件/自行寄回
                    ky4zxdehqi6ofpap: instructions, // 退货说明
                    // 上门取件
                    hkfwaidbg4mywpks: [sender], // 寄件人
                    tpqk8ilierx76okc: senderPhone, // 手机
                    h4taz2eavvajozrm: senderArea, // 所在地区
                    gw5nzk6ycd5osq1g: senderAddress, // 详细地址
                    // 自行寄回
                    '5ei3icz5dttawswz': [consignee], // 总集地址
                    d3q1oslyqeyggjei: consigneePhone, //联系方式
                    qc638rrzbxa1trrx: consigneeAddress, //地址
                    e7praxhjq8v5d8tr: productList.map(function (el) {
                      return {
                        tlztdbj3bxchs5vi: el.whfmbyuc1i2pavi4.map(function (el) {
                          return el.id;
                        }),
                        '6vxr6cjuplgkisse': el.mcuilzaudpe3shlc,
                        mbvjcurb6r0ckynw: el.mbvjcurb6r0ckynw
                      };
                    }) // 退货列表
                  };
                } else {
                  form_head_uuid = '01941b9eae0811ee879f0242321230b4';
                  params = {
                    a12n4mmhiv5zcziz: [id],
                    indtkil4tvvff0ie: way === 1 ? '99152472-0949-4a28-89fc-61e8ddffaac3' : '4baade9e-2402-4ffd-9d57-74c1abc800cc', // 退货方式 上门取件/自行寄回
                    ky4zxdehqi6ofpap: instructions, //换货说明
                    //上门取件
                    edx2y56vqrptfdk8: [sender], //寄件人
                    twlzszggqs0hlzoj: senderPhone, //手机
                    lx6cxkbpuo6osmry: senderArea, //所在地区
                    rgxdenukluveemcq: senderAddress, //详细地址
                    // 自行寄回
                    ildcp7argfzmpygt: [consignee], // 总集地址
                    axbtnlg6uvsm8ovd: consigneePhone, //联系方式
                    oa4tnu9d1wkvifsb: consigneeAddress, //地址
                    xixx4qsuefovkdiw: productList.map(function (el) {
                      return {
                        tlztdbj3bxchs5vi: el.whfmbyuc1i2pavi4.map(function (el) {
                          return el.id;
                        }),
                        '6vxr6cjuplgkisse': el.mcuilzaudpe3shlc,
                        me6d75ufdtk3amaq: el.me6d75ufdtk3amaq
                      };
                    }) // 换货列表
                  };
                }
                _context6.next = 13;
                return Object(platform["o" /* postOnline */])(extends_default()({
                  form_head_uuid: form_head_uuid
                }, params));

              case 13:
                _this6.$message({
                  message: '提交成功',
                  type: 'success'
                });
                setTimeout(function () {
                  _this6.$router.go(-1);
                }, 1000);

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287ab580","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/OrderDetail.vue
var OrderDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderDetail"},[(!_vm.type)?[_c('div',{staticClass:"title"},[_vm._v("收货信息")]),_vm._v(" "),_c('div',{staticClass:"address orderInfo"},[_c('div',[_c('span',[_vm._v("收货人：")]),_vm._v("\n        "+_vm._s(_vm.data['7gohkizhpuyntjkg'] && _vm.data['7gohkizhpuyntjkg'].length > 0
            ? _vm.data['7gohkizhpuyntjkg'][0].value
            : '')+"\n      ")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("联系方式：")]),_vm._v("\n        "+_vm._s(_vm.data['9hsjp14robmaesii'])+"\n      ")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("收货地址：")]),_vm._v("\n        "+_vm._s(_vm.data['3ysepdqjbyoaa9vv'] && _vm.data['3ysepdqjbyoaa9vv'].length > 0
            ? _vm.data['3ysepdqjbyoaa9vv'].map(function (el) { return el.value; }).join('')
            : '')+"\n        "+_vm._s(_vm.data.scb2igdb9zvhdqok)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("详细信息")]),_vm._v(" "),_c('div',{staticClass:"orderInfo"},[_c('div',[_c('span',[_vm._v("下单人：")]),_vm._v("\n        "+_vm._s(_vm.data.fnivxgmxe1bvqxol
            ? _vm.data.fnivxgmxe1bvqxol.map(function (el) { return el.value; }).join('/')
            : '')+"\n      ")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("下单科室：")]),_vm._v("\n        "+_vm._s(_vm.data.em9eprun6yuwfr7e && _vm.data.em9eprun6yuwfr7e.length > 0
            ? _vm.data.em9eprun6yuwfr7e[0].map(function (el) { return el.value; }).join('/')
            : '')+"\n      ")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("备注：")]),_vm._v("\n        "+_vm._s(_vm.data.r2fzg7pqwr8czptv)+"\n      ")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("总集备注：")]),_vm._v("\n        "+_vm._s(_vm.data['3o5b1cmlyxziweqz'])+"\n      ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n    商品清单\n    "),_c('span',[_vm._v("订单号："+_vm._s(_vm.data['5rh34ajk852uufsx'])+" ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("OG1+"),"alt":""},on:{"click":function($event){return _vm.copyToClipboard()}}})]),_vm._v(" "),_c('div',{staticClass:"cartTableHeader"},[_c('span',[_vm._v("商品信息")]),_vm._v(" "),(!_vm.type)?_c('span',[_vm._v("单价")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("数量")]),_vm._v(" "),(!_vm.type)?_c('span',[_vm._v("合计")]):_vm._e(),_vm._v(" "),(_vm.type)?_c('span',[_vm._v("\n      "+_vm._s(_vm.type === 'returnGoods' ? '退货' : '换货')+"数量\n    ")]):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.productList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderDetail"},[_c('img',{attrs:{"src":item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
              ? item['mnkt8dkjryhvdej3'][0].url
              : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
              item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'].length > 0
            )?_c('p',[_vm._v("\n            "+_vm._s(item['whfmbyuc1i2pavi4'][0].value)+"\n          ")]):_vm._e()]),_vm._v(" "),(!_vm.type)?_c('span',[_vm._v("\n          "+_vm._s(item.rojkudmmvpzinpar ? '￥' + item.rojkudmmvpzinpar : 0)+"\n        ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(item.mcuilzaudpe3shlc)+"\n          "+_vm._s(item.kq1qbbk7dulmlghs && !_vm.type ? ("(" + (item.kq1qbbk7dulmlghs) + ")") : '')+"\n        ")]),_vm._v(" "),(!_vm.type)?_c('span',[_vm._v("\n          "+_vm._s('￥' + item.nvbfzg88gv88hnt9 || 0)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.type)?_c('span',[(_vm.type === 'returnGoods')?_c('el-input-number',{attrs:{"type":"number","placeholder":"请输入","max":item.mcuilzaudpe3shlc,"controls":false},model:{value:(item.mbvjcurb6r0ckynw),callback:function ($$v) {_vm.$set(item, "mbvjcurb6r0ckynw", $$v)},expression:"item.mbvjcurb6r0ckynw"}}):_c('el-input-number',{attrs:{"type":"number","placeholder":"请输入","max":item.mcuilzaudpe3shlc,"controls":false},model:{value:(item.me6d75ufdtk3amaq),callback:function ($$v) {_vm.$set(item, "me6d75ufdtk3amaq", $$v)},expression:"item.me6d75ufdtk3amaq"}})],1):_vm._e()])])}),0),_vm._v(" "),(_vm.data.r2fzg7pqwr8czptv && !_vm.type)?_c('div',{staticClass:"remark"},[_c('div',{staticClass:"title"},[_vm._v("备注")]),_vm._v(" "),_c('span',[_vm._v("\n      "+_vm._s(_vm.data.r2fzg7pqwr8czptv)+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.type)?_c('el-form',{attrs:{"model":_vm.form,"label-width":"80px"}},[_c('div',{staticClass:"title"},[_vm._v("售后物流及状态")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":((_vm.type === 'returnGoods' ? '退货' : '换货') + "方式"),"required":""}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.form.way),callback:function ($$v) {_vm.$set(_vm.form, "way", $$v)},expression:"form.way"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":((_vm.type === 'returnGoods' ? '退货' : '换货') + "说明"),"required":""}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.instructions),callback:function ($$v) {_vm.$set(_vm.form, "instructions", $$v)},expression:"form.instructions"}})],1)],1)],1),_vm._v(" "),(_vm.form.way === 2)?[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"收货人"}},[_c('el-select',{attrs:{"disabled":"","placeholder":"请选择"},model:{value:(_vm.form.consignee),callback:function ($$v) {_vm.$set(_vm.form, "consignee", $$v)},expression:"form.consignee"}},_vm._l((_vm.aggregateAddress),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.dg3wysizdducq39m,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"联系方式"}},[_c('el-input',{attrs:{"disabled":"","placeholder":"请输入"},model:{value:(_vm.form.consigneePhone),callback:function ($$v) {_vm.$set(_vm.form, "consigneePhone", $$v)},expression:"form.consigneePhone"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"收货地址"}},[_c('el-input',{attrs:{"disabled":"","placeholder":"请输入"},model:{value:(_vm.form.consigneeAddress),callback:function ($$v) {_vm.$set(_vm.form, "consigneeAddress", $$v)},expression:"form.consigneeAddress"}})],1)],1)],1)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("寄件人信息")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"寄件人","required":""}},[_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":_vm.changeAddress},model:{value:(_vm.form.sender),callback:function ($$v) {_vm.$set(_vm.form, "sender", $$v)},expression:"form.sender"}},_vm._l((_vm.myAddress),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.mdbcej4opshigmrs,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"联系方式"}},[_c('el-input',{attrs:{"disabled":"","placeholder":"请输入"},model:{value:(_vm.form.senderPhone),callback:function ($$v) {_vm.$set(_vm.form, "senderPhone", $$v)},expression:"form.senderPhone"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"所在地区"}},[_c('el-cascader',{attrs:{"options":_vm.city,"props":_vm.props,"placeholder":"请选择","disabled":""},model:{value:(_vm.form.senderArea),callback:function ($$v) {_vm.$set(_vm.form, "senderArea", $$v)},expression:"form.senderArea"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"详细地址"}},[_c('el-input',{attrs:{"disabled":"","placeholder":"请输入"},model:{value:(_vm.form.senderAddress),callback:function ($$v) {_vm.$set(_vm.form, "senderAddress", $$v)},expression:"form.senderAddress"}})],1)],1)],1)],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer"},[(_vm.data.p6zxciihiw61mebe && !_vm.type)?_c('div',[_c('span',[_vm._v("订单金额：")]),_vm._v(_vm._s('￥' + _vm.data.p6zxciihiw61mebe)+"\n    ")]):(_vm.type)?_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.confirm()}}},[_vm._v("\n        "+_vm._s(_vm.type === 'returnGoods' ? '退货' : '换货')+"\n      ")])],1):_vm._e()])],2)}
var OrderDetail_staticRenderFns = []
var OrderDetail_esExports = { render: OrderDetail_render, staticRenderFns: OrderDetail_staticRenderFns }
/* harmony default export */ var client_OrderDetail = (OrderDetail_esExports);
// CONCATENATED MODULE: ./src/pages/client/OrderDetail.vue
function OrderDetail_injectStyle (ssrContext) {
  __webpack_require__("9PVX")
}
var OrderDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var OrderDetail___vue_template_functional__ = false
/* styles */
var OrderDetail___vue_styles__ = OrderDetail_injectStyle
/* scopeId */
var OrderDetail___vue_scopeId__ = "data-v-287ab580"
/* moduleIdentifier (server only) */
var OrderDetail___vue_module_identifier__ = null
var OrderDetail_Component = OrderDetail_normalizeComponent(
  OrderDetail,
  client_OrderDetail,
  OrderDetail___vue_template_functional__,
  OrderDetail___vue_styles__,
  OrderDetail___vue_scopeId__,
  OrderDetail___vue_module_identifier__
)

/* harmony default export */ var pages_client_OrderDetail = (OrderDetail_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/MyAddress.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MyAddress = ({
  data: function data() {
    return {
      form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
      addressList: [],
      dialogVisible: false,
      form: {},
      city: util_city,
      props: {
        label: 'name',
        value: 'id'
      }
    };
  },

  components: {},
  created: function created() {},

  computed: {},
  mounted: function mounted() {
    this.online();
  },

  methods: {
    online: function online() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var form_head_uuid, _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form_head_uuid = _this.form_head_uuid;
                _context.next = 3;
                return Object(platform["n" /* online */])({
                  page: 1,
                  limit: 100,
                  keyword: '',
                  select_option: '',
                  form_head_uuid: form_head_uuid
                });

              case 3:
                _ref = _context.sent;
                result = _ref.result;

                _this.addressList = result;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 删除地址
    delOnline: function delOnline(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;

                _this2.$confirm('是否确认删除该地址?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                  return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return Object(platform["e" /* delOnline */])({
                            form_head_uuid: form_head_uuid,
                            ids: [id]
                          });

                        case 2:
                          _this2.online();

                        case 3:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 编辑详情
    editOnline: function editOnline(data) {
      this.dialogVisible = true;
      if (data && data.id) {
        var form = JSON.parse(stringify_default()(data));
        var id = form.id,
            mdbcej4opshigmrs = form.mdbcej4opshigmrs,
            b3ccmzbfyzlwy9sc = form.b3ccmzbfyzlwy9sc,
            xejhteu0ub3fd3eh = form.xejhteu0ub3fd3eh;

        this.form = {
          '3ulvzh2pgygl0vga': form['3ulvzh2pgygl0vga'],
          id: id,
          mdbcej4opshigmrs: mdbcej4opshigmrs,
          xejhteu0ub3fd3eh: xejhteu0ub3fd3eh,
          '9simp0sjii9s0m33': form['9simp0sjii9s0m33'],
          b3ccmzbfyzlwy9sc: b3ccmzbfyzlwy9sc.map(function (el) {
            return el.id;
          })
        };
      } else {
        this.form = {};
      }
    },
    updateOnline: function updateOnline() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var form_head_uuid, form, validations, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, field, error;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                form_head_uuid = _this3.form_head_uuid, form = _this3.form;
                validations = [{ field: '3ulvzh2pgygl0vga', error: '请输入工号' }, { field: 'mdbcej4opshigmrs', error: '请输入联系人' }, { field: 'xejhteu0ub3fd3eh', error: '请输入联系电话' }, { field: 'b3ccmzbfyzlwy9sc', error: '请输入所在地区' }, { field: '9simp0sjii9s0m33', error: '请输入详细地址' }];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 5;
                _iterator = get_iterator_default()(validations);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 15;
                  break;
                }

                _ref3 = _step.value;
                field = _ref3.field, error = _ref3.error;

                if (form[field]) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt('return', _this3.$notify.error({ title: '提示', message: error }));

              case 12:
                _iteratorNormalCompletion = true;
                _context4.next = 7;
                break;

              case 15:
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 21:
                _context4.prev = 21;
                _context4.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context4.prev = 24;

                if (!_didIteratorError) {
                  _context4.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context4.finish(24);

              case 28:
                return _context4.finish(21);

              case 29:
                if (!_this3.form.id) {
                  _context4.next = 34;
                  break;
                }

                _context4.next = 32;
                return Object(platform["v" /* updateOnline */])(extends_default()({}, _this3.form, {
                  form_head_uuid: form_head_uuid
                }));

              case 32:
                _context4.next = 36;
                break;

              case 34:
                _context4.next = 36;
                return Object(platform["o" /* postOnline */])(extends_default()({}, _this3.form, {
                  form_head_uuid: form_head_uuid
                }));

              case 36:
                _this3.$notify({
                  title: "提示",
                  message: _this3.form.id ? '修改成功' : '新增成功',
                  type: "success"
                });
                _this3.dialogVisible = false;
                _this3.form = {};
                _this3.online();

              case 40:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a81bce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/MyAddress.vue
var MyAddress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myAddress"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.editOnline()}}},[_vm._v("\n      新增收货地址\n    ")]),_vm._v(" "),(_vm.addressList.length > 0)?_c('div',[_vm._v("\n      您已创建"),_c('span',[_vm._v(" "+_vm._s(_vm.addressList.length)+" ")]),_vm._v("个收货地址\n    ")]):_vm._e()],1),_vm._v(" "),_vm._l((_vm.addressList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',[_c('span',[_vm._v("工号：")]),_vm._v(_vm._s(item['3ulvzh2pgygl0vga']))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("联系人：")]),_vm._v(_vm._s(item.mdbcej4opshigmrs))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("联系方式：")]),_vm._v(_vm._s(item.xejhteu0ub3fd3eh))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("收货地址：")]),_vm._v("\n      "+_vm._s(item.b3ccmzbfyzlwy9sc && item.b3ccmzbfyzlwy9sc.length > 0
          ? item.b3ccmzbfyzlwy9sc.map(function (el) { return el.value; }).join('-')
          : '')+_vm._s(item['9simp0sjii9s0m33'])+"\n    ")]),_vm._v(" "),_c('img',{staticClass:"edit",attrs:{"src":__webpack_require__("/LjC"),"alt":""},on:{"click":function($event){return _vm.editOnline(item)}}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("q6r7"),"alt":""},on:{"click":function($event){return _vm.delOnline(item.id)}}})])}),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.dialogVisible,"width":"478px","show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"工号","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入工号"},model:{value:(_vm.form['3ulvzh2pgygl0vga']),callback:function ($$v) {_vm.$set(_vm.form, '3ulvzh2pgygl0vga', $$v)},expression:"form['3ulvzh2pgygl0vga']"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系人","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入联系人"},model:{value:(_vm.form.mdbcej4opshigmrs),callback:function ($$v) {_vm.$set(_vm.form, "mdbcej4opshigmrs", $$v)},expression:"form.mdbcej4opshigmrs"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系电话","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入联系电话"},model:{value:(_vm.form.xejhteu0ub3fd3eh),callback:function ($$v) {_vm.$set(_vm.form, "xejhteu0ub3fd3eh", $$v)},expression:"form.xejhteu0ub3fd3eh"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在地区","required":""}},[_c('el-cascader',{attrs:{"options":_vm.city,"props":_vm.props,"placeholder":"请选择省市区"},model:{value:(_vm.form.b3ccmzbfyzlwy9sc),callback:function ($$v) {_vm.$set(_vm.form, "b3ccmzbfyzlwy9sc", $$v)},expression:"form.b3ccmzbfyzlwy9sc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"详细地址","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入详细地址"},model:{value:(_vm.form['9simp0sjii9s0m33']),callback:function ($$v) {_vm.$set(_vm.form, '9simp0sjii9s0m33', $$v)},expression:"form['9simp0sjii9s0m33']"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.updateOnline()}}},[_vm._v("确定")])],1)],1)],2)}
var MyAddress_staticRenderFns = []
var MyAddress_esExports = { render: MyAddress_render, staticRenderFns: MyAddress_staticRenderFns }
/* harmony default export */ var client_MyAddress = (MyAddress_esExports);
// CONCATENATED MODULE: ./src/pages/client/MyAddress.vue
function MyAddress_injectStyle (ssrContext) {
  __webpack_require__("ZeaC")
}
var MyAddress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MyAddress___vue_template_functional__ = false
/* styles */
var MyAddress___vue_styles__ = MyAddress_injectStyle
/* scopeId */
var MyAddress___vue_scopeId__ = "data-v-08a81bce"
/* moduleIdentifier (server only) */
var MyAddress___vue_module_identifier__ = null
var MyAddress_Component = MyAddress_normalizeComponent(
  MyAddress,
  client_MyAddress,
  MyAddress___vue_template_functional__,
  MyAddress___vue_styles__,
  MyAddress___vue_scopeId__,
  MyAddress___vue_module_identifier__
)

/* harmony default export */ var pages_client_MyAddress = (MyAddress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/ChangePwd.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ChangePwd = ({
  data: function data() {
    return {
      form: {
        oldPwd: '',
        newPwd: '',
        againNewPwd: ""
      }
    };
  },

  components: {},
  created: function created() {},

  computed: {},
  mounted: function mounted() {},

  methods: {
    confirm: function confirm() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _form, oldPwd, newPwd, againNewPwd;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _form = _this.form, oldPwd = _form.oldPwd, newPwd = _form.newPwd, againNewPwd = _form.againNewPwd;

                if (oldPwd) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', _this.$api.msg('请输入旧密码'));

              case 3:
                if (newPwd) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', _this.$api.msg('请输入新密码'));

              case 5:
                if (againNewPwd) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', _this.$api.msg('请再次输入新密码'));

              case 7:
                if (!(newPwd !== againNewPwd)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', _this.$api.msg('两次密码输入不正确'));

              case 9:
                _context.next = 11;
                return Object(platform["b" /* changePwd */])({
                  oldpassword: oldPwd,
                  password: newPwd
                });

              case 11:
                return _context.abrupt('return', _this.$notify.success({
                  title: '提示',
                  message: '修改成功'
                }));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73089d41","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/ChangePwd.vue
var ChangePwd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changePwd"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"旧密码"}},[_c('el-input',{attrs:{"placeholder":"输入旧密码"},model:{value:(_vm.form.oldPwd),callback:function ($$v) {_vm.$set(_vm.form, "oldPwd", $$v)},expression:"form.oldPwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"新密码"}},[_c('el-input',{attrs:{"placeholder":"输入新密码"},model:{value:(_vm.form.newPwd),callback:function ($$v) {_vm.$set(_vm.form, "newPwd", $$v)},expression:"form.newPwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"确认新密码"}},[_c('el-input',{attrs:{"placeholder":"再次输入新密码"},model:{value:(_vm.form.againNewPwd),callback:function ($$v) {_vm.$set(_vm.form, "againNewPwd", $$v)},expression:"form.againNewPwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"size":"large"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v("确认")])],1)],1)],1)}
var ChangePwd_staticRenderFns = []
var ChangePwd_esExports = { render: ChangePwd_render, staticRenderFns: ChangePwd_staticRenderFns }
/* harmony default export */ var client_ChangePwd = (ChangePwd_esExports);
// CONCATENATED MODULE: ./src/pages/client/ChangePwd.vue
function ChangePwd_injectStyle (ssrContext) {
  __webpack_require__("UiAc")
}
var ChangePwd_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangePwd___vue_template_functional__ = false
/* styles */
var ChangePwd___vue_styles__ = ChangePwd_injectStyle
/* scopeId */
var ChangePwd___vue_scopeId__ = "data-v-73089d41"
/* moduleIdentifier (server only) */
var ChangePwd___vue_module_identifier__ = null
var ChangePwd_Component = ChangePwd_normalizeComponent(
  ChangePwd,
  client_ChangePwd,
  ChangePwd___vue_template_functional__,
  ChangePwd___vue_styles__,
  ChangePwd___vue_scopeId__,
  ChangePwd___vue_module_identifier__
)

/* harmony default export */ var pages_client_ChangePwd = (ChangePwd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/ReturnGoods.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ReturnGoods = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{
        name: "全部",
        form_head_uuid: "30cfd060adfe11ee81ef0242321230b4"
      }, { name: "审核中", form_head_uuid: "da5b79bf0c5e42bf9c21086558a3b35d" }, {
        name: "审核成功",
        form_head_uuid: "a208859626184a78a365637cab7eb8bc"
      }, {
        name: "审核失败",
        form_head_uuid: "a30bcbae0e9a44cbb63990644da739cc"
      }, {
        name: "已邮寄",
        form_head_uuid: "28712136e07547789bd205c4ce9e0962"
      }, {
        name: "验收中",
        form_head_uuid: "6b27a6c33c294e5198e53197cf37fd96"
      }, {
        name: "已验收",
        form_head_uuid: "8802255844c64e3e8492c64153abbae1"
      }, {
        name: "退货完成",
        form_head_uuid: "d1520d82d4a146bb9f0774e108861c23"
      }],
      form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20
    };
  },


  methods: {
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, page, limit, _ref, meta, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this.form_head_uuid, page = _this.page, limit = _this.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: page,
                  limit: limit,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref = _context2.sent;
                meta = _ref.meta;
                result = _ref.result;
                _context2.next = 8;
                return promise_default.a.all(result.map(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(el) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = extends_default.a;
                            _context.t1 = {};
                            _context.t2 = el;
                            _context.next = 5;
                            return _this.children(el.id);

                          case 5:
                            _context.t3 = _context.sent;
                            _context.t4 = {
                              children: _context.t3
                            };
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t4));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 8:
                _this.orderList = _context2.sent;

                _this.total = meta.total;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },

    // 获取子表数据
    children: function children(record_id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid, _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;
                _context3.next = 3;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 100,
                  field_uuid: "9aa0f944e2c64efbbb752b8314330d23",
                  form_head_uuid: form_head_uuid,
                  record_id: record_id
                });

              case 3:
                _ref3 = _context3.sent;
                result = _ref3.result;
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex: function changeIndex(form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },

    // 跳转到退货申请
    handleToReturnGoods: function handleToReturnGoods() {
      Object(util["d" /* otherSystemGetLoginToMeUrl */])('645c1772e59411eeaebb0242ac150003', 'fWqATRfis9uqvpDQ');
    },

    // 确认邮寄
    confirmMailing: function confirmMailing(item) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.page = 1;
                _context4.next = 3;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "b58f4973-d95c-4511-ba77-e44f67189c24",
                  form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
                  id: item.id,
                  type: 2
                });

              case 3:
                // this.getOrderList();
                _this3.$notify({
                  title: "提示",
                  message: "确认邮寄成功",
                  type: "success"
                });
                setTimeout(function () {
                  _this3.getOrderList();
                }, 2000);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },

    // 重新提交
    resubmit: function resubmit(item) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.page = 1;
                _context5.next = 3;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "8f0b304a-058c-4603-ba85-36aee3e452ed",
                  form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
                  id: item.id,
                  type: 2
                });

              case 3:
                _this4.$notify({
                  title: "提示",
                  message: "重新提交成功",
                  type: "success"
                });
                setTimeout(function () {
                  _this4.getOrderList();
                }, 2000);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    }
  },

  mounted: function mounted() {
    this.getOrderList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d53848","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/ReturnGoods.vue
var ReturnGoods_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.handleToReturnGoods()}}},[_vm._v("\n      新增退货申请\n    ")])],1),_vm._v(" "),_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderHeader"},[_c('span',{staticClass:"orderTime"},[_vm._v(_vm._s(item.xbqdlsk88vhorc0b))]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n            "+_vm._s('退货单编号：' + item['3pp6dg9j4ex79ook'])+"\n          ")])]),_vm._v(" "),_vm._l((item.children),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[_c('img',{attrs:{"src":order.bal0wugwwskobosz && order.bal0wugwwskobosz.length > 0
                ? order.bal0wugwwskobosz[0].url
                : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
                order.tlztdbj3bxchs5vi && order.tlztdbj3bxchs5vi.length > 0
              )?_c('p',{on:{"click":function($event){return _vm.navTo('/mall/goods/' + order.tlztdbj3bxchs5vi[0].id)}}},[_vm._v("\n              "+_vm._s(order.tlztdbj3bxchs5vi[0].value)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v(_vm._s('￥' + (order.u9h1eshiivxuuuc0 || 0)))]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v(_vm._s(order['mbvjcurb6r0ckynw'] || 0))]),_vm._v(" "),(idx === 0)?_c('span',{staticClass:"status"},[(
                item.qpfsvknudb8gbzee ===
                'ead617a0-f13a-49c6-b7d0-c18355f330c0'
              )?_c('img',{attrs:{"src":__webpack_require__("KctQ"),"alt":""}}):(
                item.qpfsvknudb8gbzee ===
                'f5d63c14-f8ee-4279-81f8-4d63ae88df9c'
              )?_c('img',{attrs:{"src":__webpack_require__("Et7L"),"alt":""}}):(
                item.qpfsvknudb8gbzee ===
                '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
              )?_c('img',{attrs:{"src":__webpack_require__("FPOz"),"alt":""}}):(
                item.qpfsvknudb8gbzee ===
                'fa14a408-0e3c-45dd-95d0-b8f5286fbb91'
              )?_c('img',{attrs:{"src":__webpack_require__("RtwJ"),"alt":""}}):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"orderfooter"},[(
              item['3u7sabpxxpxioiqz'] &&
              item.qpfsvknudb8gbzee === 'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc'
            )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.confirmMailing(item)}}},[_vm._v("\n            确认邮寄\n          ")]):_vm._e(),_vm._v(" "),(
              item.qpfsvknudb8gbzee === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
            )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.resubmit(item)}}},[_vm._v("\n            重新提交\n          ")]):_vm._e()],1)],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])])}
var ReturnGoods_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("数量")])])}]
var ReturnGoods_esExports = { render: ReturnGoods_render, staticRenderFns: ReturnGoods_staticRenderFns }
/* harmony default export */ var client_ReturnGoods = (ReturnGoods_esExports);
// CONCATENATED MODULE: ./src/pages/client/ReturnGoods.vue
function ReturnGoods_injectStyle (ssrContext) {
  __webpack_require__("uPKn")
}
var ReturnGoods_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ReturnGoods___vue_template_functional__ = false
/* styles */
var ReturnGoods___vue_styles__ = ReturnGoods_injectStyle
/* scopeId */
var ReturnGoods___vue_scopeId__ = "data-v-05d53848"
/* moduleIdentifier (server only) */
var ReturnGoods___vue_module_identifier__ = null
var ReturnGoods_Component = ReturnGoods_normalizeComponent(
  ReturnGoods,
  client_ReturnGoods,
  ReturnGoods___vue_template_functional__,
  ReturnGoods___vue_styles__,
  ReturnGoods___vue_scopeId__,
  ReturnGoods___vue_module_identifier__
)

/* harmony default export */ var pages_client_ReturnGoods = (ReturnGoods_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Barter.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Barter = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{
        name: "全部",
        form_head_uuid: "01941b9eae0811ee879f0242321230b4"
      }, { name: "审核中", form_head_uuid: "976291baa51a41559bfc6d41fa128aa2" }, {
        name: "审核成功",
        form_head_uuid: "b9f9e6e04e524515b85a530b38b7c1e2"
      }, {
        name: "审核失败",
        form_head_uuid: "5a7dfb24853a4408afc21d7b68e9f9fa"
      }, {
        name: "已邮寄",
        form_head_uuid: "bd4e90b15bbd494daf30148ea17f28bf"
      }, {
        name: "已验收",
        form_head_uuid: "97dba52f85eb40989c6b633c8163a092"
      }, {
        name: "配送中",
        form_head_uuid: "4d7d1203f6a54ff99d186122981b2756"
      }, {
        name: "确认收货",
        form_head_uuid: "0eb2e755c1e9492a9a6c5fd235029629"
      }],
      form_head_uuid: "01941b9eae0811ee879f0242321230b4",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      // 退货方式
      returnMethod: [{ label: '上门取件', value: '99152472-0949-4a28-89fc-61e8ddffaac3' }, { label: '自行寄回', value: '4baade9e-2402-4ffd-9d57-74c1abc800cc' }],
      merchandiseOrder: [],
      dialogVisible: false,
      form: {}
    };
  },


  methods: {
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, page, limit, _ref, meta, result, list;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this.form_head_uuid, page = _this.page, limit = _this.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: page,
                  limit: limit,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref = _context2.sent;
                meta = _ref.meta;
                result = _ref.result;
                _context2.next = 8;
                return promise_default.a.all(result.map(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(el) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = extends_default.a;
                            _context.t1 = {};
                            _context.t2 = el;
                            _context.next = 5;
                            return _this.children(el.id);

                          case 5:
                            _context.t3 = _context.sent;
                            _context.t4 = {
                              children: _context.t3
                            };
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t4));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 8:
                list = _context2.sent;

                _this.orderList = list;
                _this.total = meta.total;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },

    // 获取子表数据
    children: function children(record_id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid, _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;
                _context3.next = 3;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 100,
                  field_uuid: "01942404ae0811ee8b7d0242321230b4",
                  form_head_uuid: form_head_uuid,
                  record_id: record_id
                });

              case 3:
                _ref3 = _context3.sent;
                result = _ref3.result;
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex: function changeIndex(form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },

    // 跳转到换货申请
    handleToBarter: function handleToBarter() {
      Object(util["d" /* otherSystemGetLoginToMeUrl */])('90289196e59411ee8f230242ac150003', 'UvlkMQnzvibBsepj');
    },

    // 确认邮寄退货
    confirmedMailReturn: function confirmedMailReturn(_ref4) {
      var _this3 = this;

      var id = _ref4.id;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "4e515e73-30e2-4a5f-8d45-bf5b738200f6",
                  form_head_uuid: "01941b9eae0811ee879f0242321230b4",
                  id: id,
                  type: 2
                });

              case 2:
                _this3.$notify({
                  title: "提示",
                  message: "确认邮寄退货成功",
                  type: "success"
                });
                _this3.page = 1;
                setTimeout(function () {
                  _this3.getOrderList();
                }, 2000);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },

    // 重新提交
    resubmit: function resubmit(_ref5) {
      var _this4 = this;

      var id = _ref5.id;

      this.$confirm("确认要重新发起审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(platform["h" /* execButton */])({
                  button_uuid: "1b34a932-656e-4604-85dc-3614f20a2a42",
                  form_head_uuid: "01941b9eae0811ee879f0242321230b4",
                  id: id,
                  type: 2
                });

              case 2:
                _this4.$notify({
                  title: "提示",
                  message: "重新发起审核成功",
                  type: "success"
                });
                _this4.page = 1;
                setTimeout(function () {
                  _this4.getOrderList();
                }, 2000);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))).catch(function () {});
    }
  },

  mounted: function mounted() {
    this.getOrderList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6444d448","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Barter.vue
var Barter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.handleToBarter()}}},[_vm._v("\n      新增换货申请\n    ")])],1),_vm._v(" "),_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderHeader"},[_c('span',{staticClass:"orderTime"},[_vm._v(_vm._s(item.daivuh1o9jlphcxp))]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n            "+_vm._s('换货单编号：' + item['3pp6dg9j4ex79ook'])+"\n          ")])]),_vm._v(" "),_vm._l((item.children),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[_c('img',{attrs:{"src":order.bal0wugwwskobosz && order.bal0wugwwskobosz.length > 0
                ? order.bal0wugwwskobosz[0].url
                : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
                order.tlztdbj3bxchs5vi && order.tlztdbj3bxchs5vi.length > 0
              )?_c('p',[_vm._v("\n              "+_vm._s(order.tlztdbj3bxchs5vi[0].value)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v(_vm._s(order['me6d75ufdtk3amaq'] || 0))]),_vm._v(" "),(idx === 0)?_c('span',{staticClass:"status"},[(
                item.qpfsvknudb8gbzee ===
                'ead617a0-f13a-49c6-b7d0-c18355f330c0'
              )?_c('img',{attrs:{"src":__webpack_require__("KctQ"),"alt":""}}):(
                item.qpfsvknudb8gbzee ===
                'f5d63c14-f8ee-4279-81f8-4d63ae88df9c'
              )?_c('img',{attrs:{"src":__webpack_require__("Et7L"),"alt":""}}):(
                item.qpfsvknudb8gbzee ===
                '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
              )?_c('img',{attrs:{"src":__webpack_require__("FPOz"),"alt":""}}):(
                item.qpfsvknudb8gbzee ===
                'fa090b14-a3ee-4eac-89c2-32cfc12c5619'
              )?_c('img',{attrs:{"src":__webpack_require__("RtwJ"),"alt":""}}):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"orderfooter"},[(
              item.qpfsvknudb8gbzee ===
                'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc' &&
              item.indtkil4tvvff0ie ===
                '4baade9e-2402-4ffd-9d57-74c1abc800cc' &&
              item['3u7sabpxxpxioiqz']
            )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.confirmedMailReturn(item)}}},[_vm._v("\n            确认邮寄退货\n          ")]):_vm._e(),_vm._v(" "),(
              item.qpfsvknudb8gbzee === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
            )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.resubmit(item)}}},[_vm._v("\n            重新提交\n          ")]):_vm._e()],1)],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])])}
var Barter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v("换货数量")])])}]
var Barter_esExports = { render: Barter_render, staticRenderFns: Barter_staticRenderFns }
/* harmony default export */ var client_Barter = (Barter_esExports);
// CONCATENATED MODULE: ./src/pages/client/Barter.vue
function Barter_injectStyle (ssrContext) {
  __webpack_require__("asFA")
}
var Barter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Barter___vue_template_functional__ = false
/* styles */
var Barter___vue_styles__ = Barter_injectStyle
/* scopeId */
var Barter___vue_scopeId__ = "data-v-6444d448"
/* moduleIdentifier (server only) */
var Barter___vue_module_identifier__ = null
var Barter_Component = Barter_normalizeComponent(
  Barter,
  client_Barter,
  Barter___vue_template_functional__,
  Barter___vue_styles__,
  Barter___vue_scopeId__,
  Barter___vue_module_identifier__
)

/* harmony default export */ var pages_client_Barter = (Barter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Repair.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Repair = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{
        name: "全部",
        form_head_uuid: "067434d8ae9311eea8aa0242321230b4"
      }, { name: "审核中", form_head_uuid: "beaea547e2de4b1e8db0d1f443240e33" }, {
        name: "审核成功",
        form_head_uuid: "da07ce01fcb34202ac26c0a9ac6256e3"
      }, {
        name: "审核失败",
        form_head_uuid: "08656c93268a4802932daaac7078d63e"
      }, {
        name: "已邮寄",
        form_head_uuid: "9b6e3eab457941c8beb6b46f0a62e206"
      }, {
        name: "取件验收",
        form_head_uuid: "55a39a13a6074fd49f8fa08ecd312dfb"
      }, {
        name: "维修中",
        form_head_uuid: "b9ba63c28830497c93a66c229a81e3b0"
      }, {
        name: "总集已发货",
        form_head_uuid: "d6170e6130c34e89b1f5e25b53e67c75"
      }, {
        name: "确认收货",
        form_head_uuid: "c93be1c16fc64fdab8177903e4314d0f"
      }],
      form_head_uuid: "067434d8ae9311eea8aa0242321230b4",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20
    };
  },


  methods: {
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, page, limit, _ref, meta, result, list;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this.form_head_uuid, page = _this.page, limit = _this.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: page,
                  limit: limit,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref = _context2.sent;
                meta = _ref.meta;
                result = _ref.result;
                _context2.next = 8;
                return promise_default.a.all(result.map(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(el) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = extends_default.a;
                            _context.t1 = {};
                            _context.t2 = el;
                            _context.next = 5;
                            return _this.children(el.id);

                          case 5:
                            _context.t3 = _context.sent;
                            _context.t4 = {
                              children: _context.t3
                            };
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t4));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 8:
                list = _context2.sent;

                _this.orderList = list;
                _this.total = meta.total;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },

    // 获取子表数据
    children: function children(record_id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid, _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;
                _context3.next = 3;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 100,
                  field_uuid: "49da24a35fde43bdb527817494ec8524",
                  form_head_uuid: form_head_uuid,
                  record_id: record_id
                });

              case 3:
                _ref3 = _context3.sent;
                result = _ref3.result;
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex: function changeIndex(form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
      // this.getOrderByState(this.curIndex - 1);
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },
    handleToRepair: function handleToRepair() {
      Object(util["d" /* otherSystemGetLoginToMeUrl */])('b01a7096e59411ee8c5a0242ac150003', 'sg59YQ5afAL0wG45');
    }
  },

  mounted: function mounted() {
    // this.getOrderByState(-1);
    this.getOrderList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d6d67f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Repair.vue
var Repair_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.handleToRepair()}}},[_vm._v("\n      新增维修申请\n    ")])],1),_vm._v(" "),_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderHeader"},[_c('span',{staticClass:"orderTime"},[_vm._v(_vm._s(item.u6g7gjunacqjmudx))]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n            "+_vm._s('维修单编号：' + item['3pp6dg9j4ex79ook'])+"\n          ")])]),_vm._v(" "),_vm._l((item.children),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[(
              order['0ag6jxdaxesngyli'] &&
              order['0ag6jxdaxesngyli'].length > 0
            )?_c('img',{attrs:{"src":order['0ag6jxdaxesngyli'] &&
              order['0ag6jxdaxesngyli'].length > 0
                ? order['0ag6jxdaxesngyli'][0].url
                : '',"alt":"商品图片"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
                order.com1x9fiqphdkau6 && order.com1x9fiqphdkau6.length > 0
              )?_c('p',[_vm._v("\n              "+_vm._s(order.com1x9fiqphdkau6[0].value)+"\n            ")]):_vm._e()])])})],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])])}
var Repair_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")])])}]
var Repair_esExports = { render: Repair_render, staticRenderFns: Repair_staticRenderFns }
/* harmony default export */ var client_Repair = (Repair_esExports);
// CONCATENATED MODULE: ./src/pages/client/Repair.vue
function Repair_injectStyle (ssrContext) {
  __webpack_require__("WqWs")
}
var Repair_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Repair___vue_template_functional__ = false
/* styles */
var Repair___vue_styles__ = Repair_injectStyle
/* scopeId */
var Repair___vue_scopeId__ = "data-v-43d6d67f"
/* moduleIdentifier (server only) */
var Repair___vue_module_identifier__ = null
var Repair_Component = Repair_normalizeComponent(
  Repair,
  client_Repair,
  Repair___vue_template_functional__,
  Repair___vue_styles__,
  Repair___vue_scopeId__,
  Repair___vue_module_identifier__
)

/* harmony default export */ var pages_client_Repair = (Repair_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/ExtraStandard.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import {
//   getOrderByState,
//   deleteOrder,
//   confirmReceive,
//   pay,
//   sendComment,
// } from "../../api/client";



/* harmony default export */ var ExtraStandard = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      tagList: [{
        name: "全部",
        form_head_uuid: "f0bcaa65a87f40f2af4623b3e5e54299"
      }, { name: "审核中", form_head_uuid: "57bf9df042314749a434f57ac915ab8d" }, {
        name: "审核成功",
        form_head_uuid: "663539e2fdb548e38d479752087bed4a"
      }, {
        name: "审核失败",
        form_head_uuid: "eabde29c4e4c4db18e9901ebe3582819"
      }, {
        name: "维修完成",
        form_head_uuid: "6c748341ef2643758ebd3039d1e01d0c"
      }],
      form_head_uuid: "f0bcaa65a87f40f2af4623b3e5e54299",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20
    };
  },


  methods: {
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, page, limit, _ref, meta, result, list;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this.form_head_uuid, page = _this.page, limit = _this.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: page,
                  limit: limit,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref = _context2.sent;
                meta = _ref.meta;
                result = _ref.result;
                _context2.next = 8;
                return promise_default.a.all(result.map(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(el) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = extends_default.a;
                            _context.t1 = {};
                            _context.t2 = el;
                            _context.next = 5;
                            return _this.children(el.id);

                          case 5:
                            _context.t3 = _context.sent;
                            _context.t4 = {
                              children: _context.t3
                            };
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t4));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 8:
                list = _context2.sent;

                _this.orderList = list;
                _this.total = meta.total;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },

    // 获取子表数据
    children: function children(record_id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid, _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;
                _context3.next = 3;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 100,
                  field_uuid: "60852bd2d53d11eeb76c0242321230b4",
                  form_head_uuid: form_head_uuid,
                  record_id: record_id
                });

              case 3:
                _ref3 = _context3.sent;
                result = _ref3.result;
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex: function changeIndex(form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },
    handleToExtraStandard: function handleToExtraStandard() {
      Object(util["d" /* otherSystemGetLoginToMeUrl */])('c31f3136e59411ee97280242ac150003', 'GC7HrA6JngQXnJjW');
    }
  },

  mounted: function mounted() {
    this.getOrderList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e24cda","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/ExtraStandard.vue
var ExtraStandard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.handleToExtraStandard()}}},[_vm._v("\n      新增标外维修申请\n    ")])],1),_vm._v(" "),_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderHeader"},[_c('span',{staticClass:"orderTime"},[_vm._v(_vm._s(item.u6g7gjunacqjmudx))]),_vm._v(" "),_c('span',{staticClass:"orderId"},[_vm._v("\n            "+_vm._s('维修单编号：' + item['3pp6dg9j4ex79ook'])+"\n          ")])]),_vm._v(" "),_vm._l((item.children),function(order,idx){return _c('div',{key:idx,staticClass:"orderDetail"},[_c('div',{staticClass:"goodsName"},[_c('p',[_vm._v("\n              "+_vm._s(order.zk50hcofy4pvtckl)+"\n            ")])])])})],2)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})])])}
var ExtraStandard_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("数量")])])}]
var ExtraStandard_esExports = { render: ExtraStandard_render, staticRenderFns: ExtraStandard_staticRenderFns }
/* harmony default export */ var client_ExtraStandard = (ExtraStandard_esExports);
// CONCATENATED MODULE: ./src/pages/client/ExtraStandard.vue
function ExtraStandard_injectStyle (ssrContext) {
  __webpack_require__("Wyh/")
}
var ExtraStandard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExtraStandard___vue_template_functional__ = false
/* styles */
var ExtraStandard___vue_styles__ = ExtraStandard_injectStyle
/* scopeId */
var ExtraStandard___vue_scopeId__ = "data-v-13e24cda"
/* moduleIdentifier (server only) */
var ExtraStandard___vue_module_identifier__ = null
var ExtraStandard_Component = ExtraStandard_normalizeComponent(
  ExtraStandard,
  client_ExtraStandard,
  ExtraStandard___vue_template_functional__,
  ExtraStandard___vue_styles__,
  ExtraStandard___vue_scopeId__,
  ExtraStandard___vue_module_identifier__
)

/* harmony default export */ var pages_client_ExtraStandard = (ExtraStandard_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/qrcodejs2/qrcode.js
var qrcode = __webpack_require__("MJLE");
var qrcode_default = /*#__PURE__*/__webpack_require__.n(qrcode);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/wxPay.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // 生成二维码

/* harmony default export */ var wxPay = ({
  data: function data() {
    return {
      dialogVisible: false,
      timeOut: null,
      order_num: null
    };
  },

  props: {
    pay_amount: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  components: {},
  created: function created() {},

  computed: {},
  mounted: function mounted() {},

  methods: {
    open: function open() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var pay_amount, _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pay_amount = _this.pay_amount;
                _context.next = 3;
                return Object(platform["w" /* weiXinNativePay */])({
                  sign: "kePuTe",
                  goods_text: "科普特商城",
                  pay_amount: 0.01
                });

              case 3:
                _ref = _context.sent;
                result = _ref.result;

                _this.order_num = result.data.order_num;
                _this.GenerateQRcode(result.data.code_url);
                _this.getOrderStatus();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 生成二维码
    GenerateQRcode: function GenerateQRcode(val) {
      new qrcode_default.a("payQrcode", {
        // 此处的qrcode为上面div的id
        text: val,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: qrcode_default.a.CorrectLevel.H
      });
    },
    getOrderStatus: function getOrderStatus() {
      var _this2 = this;

      var order_num = this.order_num;

      this.timer = setInterval(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref3, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(platform["j" /* getOrderStatus */])({
                  order_num: order_num
                });

              case 2:
                _ref3 = _context2.sent;
                result = _ref3.result;

                if (result.data.status === 2) {
                  clearInterval(_this2.timer);
                  _this2.$notify({
                    title: "提示",
                    message: "支付成功",
                    type: "success"
                  });
                  _this2.dialogVisible = false;
                  setTimeout(function () {
                    _this2.$emit("wxPaySuccess");
                  }, 2000);
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      })), 3000);
    },
    handleClose: function handleClose() {
      clearInterval(this.timer);
      this.dialogVisible = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6310cb4b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wxPay.vue
var wxPay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"微信支付","visible":_vm.dialogVisible,"width":"30%","before-close":_vm.handleClose,"destroy-on-close":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"open":_vm.open}},[_c('div',{attrs:{"id":"payQrcode"}})])}
var wxPay_staticRenderFns = []
var wxPay_esExports = { render: wxPay_render, staticRenderFns: wxPay_staticRenderFns }
/* harmony default export */ var components_wxPay = (wxPay_esExports);
// CONCATENATED MODULE: ./src/components/wxPay.vue
function wxPay_injectStyle (ssrContext) {
  __webpack_require__("fS4/")
}
var wxPay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var wxPay___vue_template_functional__ = false
/* styles */
var wxPay___vue_styles__ = wxPay_injectStyle
/* scopeId */
var wxPay___vue_scopeId__ = "data-v-6310cb4b"
/* moduleIdentifier (server only) */
var wxPay___vue_module_identifier__ = null
var wxPay_Component = wxPay_normalizeComponent(
  wxPay,
  components_wxPay,
  wxPay___vue_template_functional__,
  wxPay___vue_styles__,
  wxPay___vue_scopeId__,
  wxPay___vue_module_identifier__
)

/* harmony default export */ var src_components_wxPay = (wxPay_Component.exports);

// EXTERNAL MODULE: ./node_modules/big.js/big.js
var big = __webpack_require__("gaXx");
var big_default = /*#__PURE__*/__webpack_require__.n(big);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/CreateOrder.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CreateOrder = ({
  data: function data() {
    return {
      form: "",
      organizationId: "",
      organizationList: [],
      organizationsLoading: false,
      organizationsFailed: false,
      addressList: [],
      id: "",
      remark: "",
      dialogVisible: false,
      address: {},
      city: util_city,
      props: {
        label: "name",
        value: "id"
      }
    };
  },

  components: {
    wxPay: src_components_wxPay
  },
  created: function created() {
    this.form = this.$route.query.form;
  },

  computed: {
    organizationFields: function organizationFields() {
      if (this.form === "cart") {
        return {
          uuid: "54a18789655a4e21b4012c1bd5cc1f49",
          department: "bxnagkndrgpdjpor",
          hospital: "svwuksfdbophogse"
        };
      }
      if (this.form === "regularPurchaseList") {
        return {
          uuid: "ee85e15782bf4d018ffbcf7edffb9f56",
          department: "bnjpfswlvbscxili",
          hospital: "otaqrpogcyeaupjr"
        };
      }
      return {
        uuid: "efde996a0a59494c8840daee4f627765",
        department: "iaivwxlaiefadgvj",
        hospital: "iefsmvsmqawxcmzx"
      };
    },
    selectedOrganization: function selectedOrganization() {
      var _this = this;

      return this.organizationList.find(function (item) {
        return item.id === _this.organizationId;
      });
    },
    hospitalPath: function hospitalPath() {
      var path = this.selectedOrganization ? this.selectedOrganization.path : [];
      return path.slice(0, 1).map(function (node) {
        return {
          id: node.id,
          name: node.name
        };
      });
    },
    commodityList: function commodityList() {
      return this.$store.state.commodityList;
    },
    number: function number() {
      return this.$store.state.number;
    },
    pay_amount: function pay_amount() {
      var _this2 = this;

      var money = 0;
      this.commodityList.forEach(function (el) {
        // 购物车
        if (_this2.form === "cart") {
          var num = new big_default.a(+el.tbdn8rpen3ijbiv2).times(+el.qajsmihzqxevgihj).toString();
          money = new big_default.a(money).plus(+num).toString();
        } else if (_this2.form === "regularPurchaseList") {
          var _num = new big_default.a(+el.mcuilzaudpe3shlc).times(+el.t9rtdu9o7iztvayy).toString();
          money = new big_default.a(money).plus(+_num).toString();
        } else {
          var _num2 = new big_default.a(+_this2.number).times(+el.f93blbqlvdtdt65v).toString();
          money = new big_default.a(money).plus(+_num2).toString();
        }
      });
      return +money;
    }
  },
  mounted: function mounted() {
    this.getAddressList();
    this.getOrganizations();
  },

  methods: {
    getOrganizations: function getOrganizations() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result, options, visit, selectedOrganizationExists;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.organizationsLoading = true;
                _this3.organizationsFailed = false;
                _context.prev = 2;
                _context.next = 5;
                return Object(platform["f" /* departments */])({
                  field_uuid: _this3.organizationFields.uuid
                });

              case 5:
                _ref = _context.sent;
                result = _ref.result;
                options = [];

                visit = function visit(items) {
                  items.forEach(function (item) {
                    var ids = item.id_path_array || item.idPathArray;
                    var names = item.name_path_array || item.namePathArray;
                    if (!Array.isArray(ids) || !ids.length || !Array.isArray(names) || ids.length !== names.length) {
                      throw new Error("组织路径缺失，请检查组织接口返回数据");
                    }
                    var path = ids.map(function (id, index) {
                      return {
                        id: id,
                        name: names[index]
                      };
                    });
                    if (path.some(function (node) {
                      return node.id == null || !node.name;
                    }) || String(path[path.length - 1].id) !== String(item.id)) {
                      throw new Error("组织路径无效");
                    }
                    options.push({
                      id: item.id,
                      departmentLabel: path.length > 1 ? path.slice(1).map(function (node) {
                        return node.name;
                      }).join(" / ") : "医院本级",
                      path: path
                    });
                    if (Array.isArray(item.children)) {
                      visit(item.children);
                    }
                  });
                };

                visit(Array.isArray(result) ? result : []);
                _this3.organizationList = options;
                selectedOrganizationExists = options.some(function (item) {
                  return String(item.id) === String(_this3.organizationId);
                });

                if (!selectedOrganizationExists) {
                  _this3.organizationId = options.length === 1 ? options[0].id : "";
                }
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);

                _this3.organizationsFailed = true;
                _this3.organizationList = [];
                _this3.organizationId = "";

              case 20:
                _context.prev = 20;

                _this3.organizationsLoading = false;
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[2, 15, 20, 23]]);
      }))();
    },
    showDialogVisible: function showDialogVisible() {
      this.dialogVisible = true;
      this.address = {};
    },
    addAddress: function addAddress() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var address, validations, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, field, error;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                address = _this4.address;
                validations = [{ field: "3ulvzh2pgygl0vga", error: "请输入工号" }, { field: "mdbcej4opshigmrs", error: "请输入联系人" }, { field: "xejhteu0ub3fd3eh", error: "请输入联系电话" }, { field: "b3ccmzbfyzlwy9sc", error: "请选择所在地区" }, { field: "9simp0sjii9s0m33", error: "请输入详细地址" }];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 5;
                _iterator = get_iterator_default()(validations);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 15;
                  break;
                }

                _ref2 = _step.value;
                field = _ref2.field, error = _ref2.error;

                if (address[field]) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", _this4.$notify.error({ title: "提示", message: error }));

              case 12:
                _iteratorNormalCompletion = true;
                _context2.next = 7;
                break;

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 21:
                _context2.prev = 21;
                _context2.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(21);

              case 29:
                _context2.next = 31;
                return Object(platform["o" /* postOnline */])(extends_default()({}, address, {
                  form_head_uuid: "0f5b2fde26c04882a5d6c5c885a30a3f"
                }));

              case 31:
                _this4.$notify({
                  title: "提示",
                  message: "新增成功",
                  type: "success"
                });
                _this4.dialogVisible = false;
                _this4.getAddressList();

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    getAddressList: function getAddressList() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref3, result;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(platform["n" /* online */])({
                  page: 1,
                  limit: 100,
                  keyword: "",
                  select_option: "",
                  form_head_uuid: "0f5b2fde26c04882a5d6c5c885a30a3f"
                });

              case 2:
                _ref3 = _context3.sent;
                result = _ref3.result;

                _this5.addressList = result;
                if (_this5.addressList.length > 0) {
                  _this5.id = _this5.addressList[0].id;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    changeAddress: function changeAddress(_ref4) {
      var id = _ref4.id;

      this.id = id;
    },

    // 微信支付
    handleWechatPay: function handleWechatPay() {
      var id = this.id;

      if (!this.selectedOrganization || !this.hospitalPath.length || this.organizationsLoading) {
        return this.$notify.error({
          title: "提示",
          message: "请选择下单科室"
        });
      }
      // 购物车
      if (!id) {
        return this.$notify({
          title: "提示",
          message: "请选择收货地址",
          type: "error"
        });
      }
      this.$refs.wxPay.dialogVisible = true;
    },

    // 提交订单
    createAnOrder: function createAnOrder() {
      var id = this.id;

      if (!this.selectedOrganization || !this.hospitalPath.length || this.organizationsLoading) {
        return this.$notify.error({
          title: "提示",
          message: "请选择下单科室"
        });
      }
      // 购物车
      if (!id) {
        return this.$notify({
          title: "提示",
          message: "请选择收货地址",
          type: "error"
        });
      }
      this.submitAnOrder();
    },
    submitAnOrder: function submitAnOrder() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var number, id, commodityList, form, organization, button_uuid, data, form_head_uuid, categoryMap, categoryGroups, loadingInstance, i, group, result;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                number = _this6.number, id = _this6.id, commodityList = _this6.commodityList, form = _this6.form;
                organization = _this6.selectedOrganization;

                if (!(!organization || !_this6.hospitalPath.length || _this6.organizationsLoading)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", _this6.$notify.error({
                  title: "提示",
                  message: "请选择下单科室"
                }));

              case 4:
                button_uuid = "";
                data = {};
                form_head_uuid = "";

                if (form === "cart") {
                  // 购物车
                  button_uuid = "625ddf61-caae-411f-8377-e40ef0976d4f";
                  data = {
                    ipfqvqscdmxi9c2j: id,
                    lmwc6txhr0ens39w: +new Date(),
                    fdaj8h2d6vindtaa: _this6.remark
                  };
                  form_head_uuid = "a6cf518450fb43289af179b8beb4b943";
                } else if (form === "regularPurchaseList") {
                  // 常购清单
                  data = {
                    biclfhzhbnslrm0a: id,
                    on1ursdhpyrlbgs6: +new Date(),
                    s3o1qgwo7qj43gt6: _this6.remark
                  };
                  button_uuid = "ef5e158f-4c8b-43af-a3ea-441fbed26911";
                  form_head_uuid = "d8334de005c511efb0750242321230b4";
                } else {
                  button_uuid = "d8119e52-097d-4bfb-8849-d50c09e7b8cf";
                  form_head_uuid = "1906dfc5e0ce4e7cb7d6324b06e6d470";
                  data = {
                    cta4eumu8zrwzabn: number,
                    q34wefmlbegp0lth: id,
                    otnacdfn3mngpxl8: _this6.remark
                  };
                }
                data[_this6.organizationFields.department] = [organization.path.map(function (node) {
                  return node.id;
                })];
                data[_this6.organizationFields.hospital] = [_this6.hospitalPath.map(function (node) {
                  return node.id;
                })];
                _context4.prev = 10;

                // 按分类对商品进行分组
                categoryMap = commodityList.reduce(function (map, item) {
                  var tags = [];
                  // 常购清单
                  if (form === "regularPurchaseList") {
                    tags = item.akwtnsppfazxxhpt || [];
                  } else if (form === 'cart') {
                    // 购物车
                    tags = item.ssjszickckaymdja || [];
                  } else {
                    tags = item.dzornqdwofgytboq || [];
                  }
                  var categoryId = tags.length > 0 ? tags[0].id : "未分类";
                  if (!map[categoryId]) {
                    map[categoryId] = [];
                  }
                  map[categoryId].push(item);
                  return map;
                }, {});

                // 将分组结果转换为数组格式

                categoryGroups = entries_default()(categoryMap).map(function (_ref5) {
                  var _ref6 = slicedToArray_default()(_ref5, 2),
                      categoryId = _ref6[0],
                      items = _ref6[1];

                  return {
                    categoryId: categoryId,
                    items: items
                  };
                });
                // 显示加载提示

                loadingInstance = _this6.$loading({
                  lock: true,
                  text: "正在提交订单...",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });
                _context4.prev = 14;
                i = 0;

              case 16:
                if (!(i < categoryGroups.length)) {
                  _context4.next = 37;
                  break;
                }

                group = categoryGroups[i];
                _context4.prev = 18;

                // 更新加载提示文本
                loadingInstance.text = "\u6B63\u5728\u63D0\u4EA4\u7B2C " + (i + 1) + "/" + categoryGroups.length + " \u4E2A\u5206\u7C7B\u7684\u8BA2\u5355...";
                if (form === "cart") {
                  data.lmwc6txhr0ens39w = +new Date();
                } else if (form === "regularPurchaseList") {
                  data.on1ursdhpyrlbgs6 = +new Date();
                }
                _context4.next = 23;
                return Object(platform["p" /* relationFieldButtonExc */])({
                  button_uuid: button_uuid,
                  data: data,
                  form_head_uuid: form_head_uuid,
                  ids: group.items.map(function (item) {
                    return item.id;
                  })
                });

              case 23:
                result = _context4.sent;

                console.log("\u5206\u7C7B " + group.categoryId + " \u8BA2\u5355\u63D0\u4EA4\u6210\u529F", result);

                // 如果不是最后一个分类，则等待2秒

                if (!(i < categoryGroups.length - 1)) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 28;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, 3000);
                });

              case 28:
                _context4.next = 34;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t0 = _context4["catch"](18);

                console.error("\u5206\u7C7B " + group.categoryId + " \u8BA2\u5355\u63D0\u4EA4\u5931\u8D25:", _context4.t0);
                throw _context4.t0;

              case 34:
                i++;
                _context4.next = 16;
                break;

              case 37:

                // 关闭加载提示
                loadingInstance.close();

                // 显示成功提示
                _this6.$notify({
                  title: "提示",
                  message: "提交订单成功",
                  type: "success"
                });

                // 更新购物车数量
                _context4.next = 41;
                return _this6.$store.dispatch("getCartQuantity");

              case 41:

                // 延迟跳转到商城首页
                setTimeout(function () {
                  _this6.$router.replace("/mall/show/index");
                }, 2000);
                _context4.next = 48;
                break;

              case 44:
                _context4.prev = 44;
                _context4.t1 = _context4["catch"](14);

                // 关闭加载提示
                loadingInstance.close();
                throw _context4.t1;

              case 48:
                _context4.next = 54;
                break;

              case 50:
                _context4.prev = 50;
                _context4.t2 = _context4["catch"](10);

                console.error("订单提交失败:", _context4.t2);
                _this6.$notify({
                  title: "错误",
                  message: "提交订单失败，请重试",
                  type: "error"
                });

              case 54:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[10, 50], [14, 44], [18, 30]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fbc1f86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/CreateOrder.vue
var CreateOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createOrder"},[_c('div',{staticClass:"title"},[_vm._v("选择下单科室")]),_vm._v(" "),_c('div',{staticClass:"organization"},[(_vm.organizationsLoading)?_c('div',{staticClass:"organization-status"},[_vm._v("正在加载科室…")]):(!_vm.organizationsFailed && !_vm.organizationList.length)?_c('div',{staticClass:"organization-status"},[_vm._v("\n      暂无可选科室\n    ")]):_c('div',{staticClass:"organization-list",attrs:{"role":"group","aria-label":"选择下单科室"}},_vm._l((_vm.organizationList),function(item){return _c('button',{key:item.id,staticClass:"organization-card",class:{ sel: _vm.organizationId === item.id },attrs:{"type":"button","aria-pressed":_vm.organizationId === item.id},on:{"click":function($event){_vm.organizationId = item.id}}},[_c('span',{staticClass:"organization-row"},[_c('span',{staticClass:"organization-label"},[_vm._v("科室：")]),_vm._v(_vm._s(item.departmentLabel)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"organization-row"},[_c('span',{staticClass:"organization-label"},[_vm._v("医院：")]),_vm._v(_vm._s(item.path[0].name)+"\n        ")])])}),0),_vm._v(" "),(_vm.organizationsFailed)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.getOrganizations}},[_vm._v("\n      加载失败，点击重试\n    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("选择收货地址")]),_vm._v(" "),_c('div',{staticClass:"address"},[_vm._l((_vm.addressList),function(item,index){return _c('div',{key:index,staticClass:"item",class:_vm.id === item.id ? 'sel' : '',on:{"click":function($event){return _vm.changeAddress(item)}}},[_c('div',[_c('span',[_vm._v("收货人：")]),_vm._v(_vm._s(item.mdbcej4opshigmrs))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("联系方式：")]),_vm._v(_vm._s(item.xejhteu0ub3fd3eh))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("收货地址：")]),_vm._v("\n        "+_vm._s(item.b3ccmzbfyzlwy9sc.map(function (el) { return el.value; }).join(''))+"\n        "+_vm._s(item['9simp0sjii9s0m33'])+"\n      ")])])}),_vm._v(" "),_c('div',{staticClass:"item add",on:{"click":_vm.showDialogVisible}},[_c('img',{attrs:{"src":__webpack_require__("Dgxh"),"alt":""}})])],2),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("商品清单")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.commodityList),function(item){return _c('li',{key:'order' + item.id},[(_vm.form === 'cart')?_c('div',{staticClass:"orderDetail"},[_c('img',{attrs:{"src":item['gdlu2l0z6a7sprky'] && item['gdlu2l0z6a7sprky'].length > 0
              ? item['gdlu2l0z6a7sprky'][0].url
              : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
              item['duovdnoapszqxeih'] && item['duovdnoapszqxeih'].length > 0
            )?_c('p',[_vm._v("\n            "+_vm._s(item['duovdnoapszqxeih'][0].value)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n          "+_vm._s(item.qajsmihzqxevgihj ? '￥' + item.qajsmihzqxevgihj : 0)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n          "+_vm._s(item.ycqgzdztcyhqnczy)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s(item.tbdn8rpen3ijbiv2)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s('￥' + item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj)+"\n        ")])]):(_vm.form === 'regularPurchaseList')?_c('div',{staticClass:"orderDetail"},[_c('img',{attrs:{"src":item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
              ? item['mnkt8dkjryhvdej3'][0].url
              : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
              item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'].length > 0
            )?_c('p',[_vm._v("\n            "+_vm._s(item['whfmbyuc1i2pavi4'][0].value)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n          "+_vm._s(item.t9rtdu9o7iztvayy ? '￥' + item.t9rtdu9o7iztvayy : 0)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s(item.mcuilzaudpe3shlc)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s(item.kq1qbbk7dulmlghs)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s('￥' + item.t9rtdu9o7iztvayy * (item.mcuilzaudpe3shlc || 1))+"\n        ")])]):_c('div',{staticClass:"orderDetail"},[_c('img',{attrs:{"src":item['in7kxcfnzrfwav2r'] && item['in7kxcfnzrfwav2r'].length > 0
              ? item['in7kxcfnzrfwav2r'][0].url
              : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(
              item['6qujfllbbkwsj6t1'] && item['6qujfllbbkwsj6t1'].length > 0
            )?_c('p',[_vm._v("\n            "+_vm._s(item['6qujfllbbkwsj6t1'][0].value)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n          "+_vm._s(item.f93blbqlvdtdt65v ? '￥' + item.f93blbqlvdtdt65v : 0)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n          "+_vm._s(item.y8cegh2yyvvqbzwo)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s(_vm.number)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_vm._v("\n          "+_vm._s('￥' + _vm.number * item.f93blbqlvdtdt65v)+"\n        ")])])])}),0),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n    合计 ："),_c('span',[_vm._v("￥"+_vm._s(_vm.pay_amount))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("客户备注")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入内容","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('el-button',{staticClass:"wechatPay",on:{"click":_vm.handleWechatPay}},[_vm._v("微信支付")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.createAnOrder}},[_vm._v("提交订单")])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.dialogVisible,"width":"478px","show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.address,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"工号","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入工号"},model:{value:(_vm.address['3ulvzh2pgygl0vga']),callback:function ($$v) {_vm.$set(_vm.address, '3ulvzh2pgygl0vga', $$v)},expression:"address['3ulvzh2pgygl0vga']"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系人","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入联系人"},model:{value:(_vm.address.mdbcej4opshigmrs),callback:function ($$v) {_vm.$set(_vm.address, "mdbcej4opshigmrs", $$v)},expression:"address.mdbcej4opshigmrs"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系电话","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入联系电话"},model:{value:(_vm.address.xejhteu0ub3fd3eh),callback:function ($$v) {_vm.$set(_vm.address, "xejhteu0ub3fd3eh", $$v)},expression:"address.xejhteu0ub3fd3eh"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在地区","required":""}},[_c('el-cascader',{attrs:{"options":_vm.city,"props":_vm.props,"placeholder":"请选择省市区"},model:{value:(_vm.address.b3ccmzbfyzlwy9sc),callback:function ($$v) {_vm.$set(_vm.address, "b3ccmzbfyzlwy9sc", $$v)},expression:"address.b3ccmzbfyzlwy9sc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"详细地址","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入详细地址"},model:{value:(_vm.address['9simp0sjii9s0m33']),callback:function ($$v) {_vm.$set(_vm.address, '9simp0sjii9s0m33', $$v)},expression:"address['9simp0sjii9s0m33']"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addAddress()}}},[_vm._v("确定")])],1)],1),_vm._v(" "),_c('wxPay',{ref:"wxPay",attrs:{"pay_amount":_vm.pay_amount},on:{"wxPaySuccess":_vm.submitAnOrder}})],1)}
var CreateOrder_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cartTableHeader"},[_c('span',[_vm._v("商品信息")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("单位")]),_vm._v(" "),_c('span',[_vm._v("数量")]),_vm._v(" "),_c('span',[_vm._v("合计")])])}]
var CreateOrder_esExports = { render: CreateOrder_render, staticRenderFns: CreateOrder_staticRenderFns }
/* harmony default export */ var client_CreateOrder = (CreateOrder_esExports);
// CONCATENATED MODULE: ./src/pages/client/CreateOrder.vue
function CreateOrder_injectStyle (ssrContext) {
  __webpack_require__("QHj+")
}
var CreateOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateOrder___vue_template_functional__ = false
/* styles */
var CreateOrder___vue_styles__ = CreateOrder_injectStyle
/* scopeId */
var CreateOrder___vue_scopeId__ = "data-v-8fbc1f86"
/* moduleIdentifier (server only) */
var CreateOrder___vue_module_identifier__ = null
var CreateOrder_Component = CreateOrder_normalizeComponent(
  CreateOrder,
  client_CreateOrder,
  CreateOrder___vue_template_functional__,
  CreateOrder___vue_styles__,
  CreateOrder___vue_scopeId__,
  CreateOrder___vue_module_identifier__
)

/* harmony default export */ var pages_client_CreateOrder = (CreateOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/CommodityApplication.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CommodityApplication = ({
  name: "MyOrder",
  components: {
    Popup: Popup["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      id: '',
      form_head_uuid: "d098b98521634ac7aac59d4d4ed249e6",
      orderList: [],
      keyword: '',
      //分页
      page: 1,
      total: 0,
      limit: 20,
      // 弹窗
      file: [],
      dialogVisible: false,
      action: 'https://api.ontuotu.com/api/general/upload',
      form: {},
      addressList: [],
      city: util_city,
      props: {
        label: 'name',
        value: 'id'
      },
      options: [{ label: "待总集复核", value: "a9aa18ff-1f2c-46a3-b816-1ed227d960b6" }, { label: "审批中", value: "52efb014-07cf-41ec-8407-13e151f95da6" }, { label: "审批成功", value: "7c970bbb-0744-4f99-813b-d7bd98188a71" }, { label: "审批驳回", value: "1a5b7046-c33d-42c1-92ef-35e5cea1a9a2" }]
    };
  },
  mounted: function mounted() {
    this.getOrderList();
    this.online();
    // this.relationRows()
  },

  methods: {
    findStatusLabel: function findStatusLabel(value) {
      if (value) {
        return this.options.find(function (item) {
          return item.value === value;
        }).label || '';
      } else {
        return '';
      }
    },
    online: function online() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(platform["n" /* online */])({
                  page: 1,
                  limit: 100,
                  keyword: '',
                  select_option: '',
                  form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f'
                });

              case 2:
                _ref = _context.sent;
                result = _ref.result;

                _this.addressList = result;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeAddress: function changeAddress(e) {
      var obj = this.addressList.find(function (item) {
        return item.id === e;
      });
      console.log(obj);
      this.form.etnsg3kbzcknkawr = obj.xejhteu0ub3fd3eh || '';
      this.form['5swsm1dvrchwdg3v'] = obj['9simp0sjii9s0m33'] || '';
      this.form.glhztcnef0v5zdcy = obj.b3ccmzbfyzlwy9sc.map(function (el) {
        return el.id;
      });
    },

    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, page, limit, _ref2, meta, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid, page = _this2.page, limit = _this2.limit;
                _context2.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: page,
                  limit: limit,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref2 = _context2.sent;
                meta = _ref2.meta;
                result = _ref2.result;

                _this2.orderList = result;
                _this2.total = meta.total;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    // 切换页数
    handleCurrentChange: function handleCurrentChange(page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },

    // 新增标外商品申请
    handleOpen: function handleOpen() {
      this.form = {};
      this.file = [];
      this.dialogVisible = true;
    },
    handleSuccess: function handleSuccess(_ref3) {
      var result = _ref3.result;

      this.file.push(result);
    },
    handleRemove: function handleRemove(file) {
      var i = this.file.findIndex(function (el) {
        return el.id === file.id;
      });
      this.file.splice(i, 1);
    },

    // 提交
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form, file, validations, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref4, field, error, form_head_uuid;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form = _this3.form, file = _this3.file;
                validations = [{ field: 'yweggjdjennwlx2b', error: '请输入商品名称' }, { field: 'wxym5do3isvbzeth', error: '请输入预计单价' }, { field: '2lcyfkgbyjmfmedh', error: '请输入数量' }, { field: 'g9llk5yvei0jvr6x', error: '请输入申请理由采购原因' }];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 5;
                _iterator = get_iterator_default()(validations);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 15;
                  break;
                }

                _ref4 = _step.value;
                field = _ref4.field, error = _ref4.error;

                if (form[field]) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", _this3.$notify.error({ title: '提示', message: error }));

              case 12:
                _iteratorNormalCompletion = true;
                _context3.next = 7;
                break;

              case 15:
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 21:
                _context3.prev = 21;
                _context3.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context3.prev = 24;

                if (!_didIteratorError) {
                  _context3.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context3.finish(24);

              case 28:
                return _context3.finish(21);

              case 29:
                form_head_uuid = _this3.form_head_uuid;

                if (file && file.length > 0) {
                  form.xrsnsamzcsuibskx = file.map(function (el) {
                    return el.id;
                  });
                }
                _context3.next = 33;
                return Object(platform["o" /* postOnline */])(extends_default()({
                  form_head_uuid: form_head_uuid
                }, _this3.form));

              case 33:
                _this3.dialogVisible = false;
                _this3.page = 1;
                _this3.getOrderList();

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00c05e58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/CommodityApplication.vue
var CommodityApplication_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.handleOpen()}}},[_vm._v("\n      新增标外商品申请\n    ")])],1),_vm._v(" "),(_vm.orderList && _vm.orderList.length > 0)?_c('div',{staticClass:"orderBox"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderDetail"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.findStatusLabel(item.mx1whh7fbp1ozmov))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"goodsName"},[_c('p',[_vm._v("\n              "+_vm._s(item.yweggjdjennwlx2b)+"\n            ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.okxizq5fy7x1v2pj))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.wxym5do3isvbzeth))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item['g9llk5yvei0jvr6x']))])])])}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 40, 80],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("CKJ6"),"alt":""}})]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增标外商品申请","visible":_vm.dialogVisible,"width":"800px","show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px","label-position":"left"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"收货人"}},[_c('el-select',{attrs:{"placeholder":"请选择","filterable":""},on:{"change":_vm.changeAddress},model:{value:(_vm.form.orac6eyyydzpco13),callback:function ($$v) {_vm.$set(_vm.form, "orac6eyyydzpco13", $$v)},expression:"form.orac6eyyydzpco13"}},_vm._l((_vm.addressList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.mdbcej4opshigmrs,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"联系方式"}},[_c('el-input',{attrs:{"disabled":"","placeholder":"请输入"},model:{value:(_vm.form.etnsg3kbzcknkawr),callback:function ($$v) {_vm.$set(_vm.form, "etnsg3kbzcknkawr", $$v)},expression:"form.etnsg3kbzcknkawr"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"所在地区"}},[_c('el-cascader',{attrs:{"disabled":"","options":_vm.city,"props":_vm.props,"placeholder":"请选择省市区"},model:{value:(_vm.form.glhztcnef0v5zdcy),callback:function ($$v) {_vm.$set(_vm.form, "glhztcnef0v5zdcy", $$v)},expression:"form.glhztcnef0v5zdcy"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"详细地址"}},[_c('el-input',{attrs:{"disabled":"","placeholder":"请输入"},model:{value:(_vm.form['5swsm1dvrchwdg3v']),callback:function ($$v) {_vm.$set(_vm.form, '5swsm1dvrchwdg3v', $$v)},expression:"form['5swsm1dvrchwdg3v']"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"商品名称","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.yweggjdjennwlx2b),callback:function ($$v) {_vm.$set(_vm.form, "yweggjdjennwlx2b", $$v)},expression:"form.yweggjdjennwlx2b"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"品牌名称"}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form['2uxq3bkljctevagu']),callback:function ($$v) {_vm.$set(_vm.form, '2uxq3bkljctevagu', $$v)},expression:"form['2uxq3bkljctevagu']"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"规格要求"}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.okxizq5fy7x1v2pj),callback:function ($$v) {_vm.$set(_vm.form, "okxizq5fy7x1v2pj", $$v)},expression:"form.okxizq5fy7x1v2pj"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"预计单价","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入","type":"number"},model:{value:(_vm.form.wxym5do3isvbzeth),callback:function ($$v) {_vm.$set(_vm.form, "wxym5do3isvbzeth", $$v)},expression:"form.wxym5do3isvbzeth"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"数量","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入","type":"number"},model:{value:(_vm.form['2lcyfkgbyjmfmedh']),callback:function ($$v) {_vm.$set(_vm.form, '2lcyfkgbyjmfmedh', $$v)},expression:"form['2lcyfkgbyjmfmedh']"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"详细要求(购买链接)"}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form['5wzakr37o7owu4qj']),callback:function ($$v) {_vm.$set(_vm.form, '5wzakr37o7owu4qj', $$v)},expression:"form['5wzakr37o7owu4qj']"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"申请理由采购原因","required":""}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.g9llk5yvei0jvr6x),callback:function ($$v) {_vm.$set(_vm.form, "g9llk5yvei0jvr6x", $$v)},expression:"form.g9llk5yvei0jvr6x"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"商品图片"}},[_c('div',{staticClass:"fileList"},[_vm._l((_vm.file),function(item,index){return _c('div',{key:index,staticClass:"fileItem"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.handleRemove(item)}}},[_c('img',{attrs:{"src":__webpack_require__("vmxF"),"alt":""}})]),_vm._v(" "),_c('img',{staticClass:"url",attrs:{"src":item.url,"alt":""}})])}),_vm._v(" "),_c('div',{staticClass:"fileItem"},[_c('el-upload',{attrs:{"action":_vm.action,"list-type":"picture-card","on-remove":_vm.handleRemove,"file-list":_vm.file,"show-file-list":false,"on-success":_vm.handleSuccess}},[_c('i',{staticClass:"el-icon-plus"})])],1)],2)])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("确定")])],1)],1)],1)}
var CommodityApplication_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderTableHeader"},[_c('span',[_vm._v("状态")]),_vm._v(" "),_c('span',[_vm._v("商品名称")]),_vm._v(" "),_c('span',[_vm._v("规格要求")]),_vm._v(" "),_c('span',[_vm._v("预计单价")]),_vm._v(" "),_c('span',[_vm._v("申请理由采购原因")])])}]
var CommodityApplication_esExports = { render: CommodityApplication_render, staticRenderFns: CommodityApplication_staticRenderFns }
/* harmony default export */ var client_CommodityApplication = (CommodityApplication_esExports);
// CONCATENATED MODULE: ./src/pages/client/CommodityApplication.vue
function CommodityApplication_injectStyle (ssrContext) {
  __webpack_require__("H/82")
}
var CommodityApplication_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CommodityApplication___vue_template_functional__ = false
/* styles */
var CommodityApplication___vue_styles__ = CommodityApplication_injectStyle
/* scopeId */
var CommodityApplication___vue_scopeId__ = "data-v-00c05e58"
/* moduleIdentifier (server only) */
var CommodityApplication___vue_module_identifier__ = null
var CommodityApplication_Component = CommodityApplication_normalizeComponent(
  CommodityApplication,
  client_CommodityApplication,
  CommodityApplication___vue_template_functional__,
  CommodityApplication___vue_styles__,
  CommodityApplication___vue_scopeId__,
  CommodityApplication___vue_module_identifier__
)

/* harmony default export */ var pages_client_CommodityApplication = (CommodityApplication_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Satisfaction.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Satisfaction = ({
  data: function data() {
    return {
      data: [],
      field_list_view: []
    };
  },

  components: {},
  created: function created() {},

  computed: {
    user: function user() {
      return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    }
  },
  mounted: function mounted() {
    this.online();
    this.structure();
  },

  methods: {
    online: function online() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(platform["n" /* online */])({
                  form_head_uuid: '6cc861f99a644963a1fb694b63be2c14',
                  needpage: false,
                  page: 1,
                  limit: 1000,
                  eg9dwtvttwtizeoe: _this.user.id + ''
                  // filters: [
                  //   {
                  //     key: 'eg9dwtvttwtizeoe',
                  //     value: this.user.id + ''
                  //   }
                  //   //   eg9dwtvttwtizeoe: this.member.id + ''
                  // ]
                });

              case 2:
                _ref = _context.sent;
                result = _ref.result;

                //   console.log(result);
                _this.data = result;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    structure: function structure() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(platform["s" /* structure */])('6cc861f99a644963a1fb694b63be2c14');

              case 2:
                _ref2 = _context2.sent;
                result = _ref2.result;

                _this2.field_list_view = result.field_list_view.filter(function (item) {
                  return item.field_type !== 'remark' && !item.field_extend_json.hidden;
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleAdd: function handleAdd() {
      window.open('https://paas.ontuotu.com/#/270ab0c29e5411ee9b8b0242321230b4/preview/6cc861f99a644963a1fb694b63be2c14?eg9dwtvttwtizeoe=' + this.user.id, '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e758140c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Satisfaction.vue
var Satisfaction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"satisfaction"},[_c('div',{staticClass:"add"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.handleAdd()}}},[_vm._v("\n      新增满意度评价\n    ")])],1),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"item"},[_vm._l((_vm.field_list_view),function(field,idx){return [(idx < 3)?_c('div',{key:idx},[_c('span',[_vm._v(_vm._s(field.field_txt)+"：")]),_vm._v(_vm._s(item[field.field_name] || '- -')+"\n      ")]):_vm._e()]})],2)})],2)}
var Satisfaction_staticRenderFns = []
var Satisfaction_esExports = { render: Satisfaction_render, staticRenderFns: Satisfaction_staticRenderFns }
/* harmony default export */ var client_Satisfaction = (Satisfaction_esExports);
// CONCATENATED MODULE: ./src/pages/client/Satisfaction.vue
function Satisfaction_injectStyle (ssrContext) {
  __webpack_require__("8lGJ")
}
var Satisfaction_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Satisfaction___vue_template_functional__ = false
/* styles */
var Satisfaction___vue_styles__ = Satisfaction_injectStyle
/* scopeId */
var Satisfaction___vue_scopeId__ = "data-v-e758140c"
/* moduleIdentifier (server only) */
var Satisfaction___vue_module_identifier__ = null
var Satisfaction_Component = Satisfaction_normalizeComponent(
  Satisfaction,
  client_Satisfaction,
  Satisfaction___vue_template_functional__,
  Satisfaction___vue_styles__,
  Satisfaction___vue_scopeId__,
  Satisfaction___vue_module_identifier__
)

/* harmony default export */ var pages_client_Satisfaction = (Satisfaction_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Wechat.vue
//
//
//
//
//
//

/* harmony default export */ var Wechat = ({
  data: function data() {
    return {};
  },

  components: {},
  created: function created() {},

  computed: {},
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66342bca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Wechat.vue
var Wechat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Wechat_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat"},[_c('img',{attrs:{"src":__webpack_require__("b3fX"),"alt":""}})])}]
var Wechat_esExports = { render: Wechat_render, staticRenderFns: Wechat_staticRenderFns }
/* harmony default export */ var client_Wechat = (Wechat_esExports);
// CONCATENATED MODULE: ./src/pages/client/Wechat.vue
function Wechat_injectStyle (ssrContext) {
  __webpack_require__("a2m0")
}
var Wechat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Wechat___vue_template_functional__ = false
/* styles */
var Wechat___vue_styles__ = Wechat_injectStyle
/* scopeId */
var Wechat___vue_scopeId__ = "data-v-66342bca"
/* moduleIdentifier (server only) */
var Wechat___vue_module_identifier__ = null
var Wechat_Component = Wechat_normalizeComponent(
  Wechat,
  client_Wechat,
  Wechat___vue_template_functional__,
  Wechat___vue_styles__,
  Wechat___vue_scopeId__,
  Wechat___vue_module_identifier__
)

/* harmony default export */ var pages_client_Wechat = (Wechat_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/store/mutation-types.js
var mutation_types = __webpack_require__("Du/2");

// CONCATENATED MODULE: ./src/config/axios-client.js






// axios 配置
axios_default.a.defaults.timeout = 5000;
axios_default.a.defaults.baseURL = 'http://localhost:3000';

// http request 拦截器
axios_default.a.interceptors.request.use(function (config) {
    if (store["a" /* default */].state.clientToken) {
        config.headers.Authorization = 'Bearer ' + store["a" /* default */].state.clientToken;
    }
    return config;
}, function (err) {
    return promise_default.a.reject(err);
});

// http response 拦截器
axios_default.a.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // 401 清除token信息并跳转到登录页面
                store["a" /* default */].commit(mutation_types["b" /* CLIENT_LOGOUT */]);
                client.replace({
                    path: 'login',
                    query: { redirect: client.currentRoute.fullPath }
                });
        }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return promise_default.a.reject(error.response.data);
});

/* harmony default export */ var axios_client = (axios_default.a);
// CONCATENATED MODULE: ./src/api/client.js



//用户登录
function client_login(data) {
	var res = axios_client.post('/api/user/login', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//用户注册
function signup(data) {
	var res = axios_client.post('/api/user/signup', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//得到类目
function getTypes() {
	var res = axios_client.get('/api/admin/getType');
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//获得不同类目的商品
function client_getGoodsList(typeId) {
	var res = axios_client.get('/api/mall/getGoodsByType?typeId=' + typeId);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//获得商品详情页信息
function getGoodsInfo(id) {
	var res = axios_client.get('/api/mall/getGoodsInfo?id=' + id);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//获得商品详情页问答区数据
function getGoodsMsg(id) {
	var res = axios_client.get('/api/mall/getGoodsMsg?id=' + id);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//发送商品msg
function askGoodsMsg(data) {
	var res = axios_client.post('/api/mall/askGoodsMsg', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//加入购物车
function addOrder(data) {
	var res = axios_client.post('/api/mall/addOrder', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//获得用户订单列表
function getOrderByState(state, token) {
	var res = axios_client.get('/api/mall/getOrderByState?state=' + state + '&token=' + token);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//删除订单
function client_deleteOrder(id) {
	var res = axios_client.delete('/api/mall/deleteOrder?id=' + id);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//确认收货
function confirmReceive(id) {
	var res = axios_client.get('/api/mall/confirmReceive?id=' + id);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//确认付款
function pay(id) {
	var res = axios_client.get('/api/mall/pay?id=' + id);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//获得用户资料
function getUserData(token) {
	var res = axios_client.get('/api/user/data?token=' + token);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//更改用户资料
function client_updateUserData(data) {
	var res = axios_client.post('/api/user/updateUserData', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//更改用户密码
function client_updatePwd(data) {
	var res = axios_client.post('/api/user/updatePwd', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//结算购物车
function client_settleAccounts(data) {
	var res = axios_client.post('/api/mall/settleAccounts', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//发送评价
function sendComment(data) {
	var res = axios_client.post('/api/mall/sendComment', data);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve();
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//获得商品评论
function getComment(goodsId) {
	var res = axios_client.get('/api/mall/getGoodsComment?goodsId=' + goodsId);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}

//关键词搜索商品
function searchGoods() {
	var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	var res = axios_client.get('/api/mall/searchGoods?keyword=' + keyword);
	return new promise_default.a(function (resolve, reject) {
		res.then(function (result) {
			if (result.status === 200) {
				return result.data;
			} else {
				reject(result.status);
			}
		}).then(function (json) {
			if (json.code === 0) {
				resolve(json.data);
			} else {
				reject(json.message);
			}
		}).catch(function (e) {
			reject(e.toString());
		});
	});
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/MyData.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MyData = ({
  name: "MyData",
  components: {
    Popup: Popup["a" /* default */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(["clientToken"])),
  data: function data() {
    return {
      id: "",
      headimg: "",
      email: "",
      nickname: "",
      recipient: "",
      address: "",
      phone: "",
      popupShow: false,
      oldPwd: "",
      newPwd: "",
      confirmPwd: ""
    };
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])({
    setClientName: "SET_CLIENT_NAME"
  }), {
    updateUserData: function updateUserData() {
      var _this = this;

      var res = client_updateUserData({
        id: this.id,
        nickname: this.nickname,
        recipient: this.recipient,
        address: this.address,
        phone: this.phone
      });
      res.then(function () {
        alert("修改成功!");
        _this.setClientName(_this.nickname);
      }).catch(function (e) {
        alert(e);
      });
    },
    closePopup: function closePopup() {
      this.popupShow = false;
    },
    showPopup: function showPopup() {
      this.popupShow = true;
    },
    updatePwd: function updatePwd() {
      var _this2 = this;

      if (this.newPwd !== this.confirmPwd) {
        alert("两次输入的密码不一致！");
        return;
      }
      var res = client_updatePwd({
        id: this.id,
        oldPwd: this.oldPwd,
        newPwd: this.newPwd,
        confirmPwd: this.confirmPwd
      });
      res.then(function () {
        _this2.oldPwd = "";
        _this2.newPwd = "";
        _this2.confirmPwd = "";
        _this2.closePopup();
        alert("修改密码成功!");
      }).catch(function (e) {
        alert(e);
      });
    }
  }),

  mounted: function mounted() {
    // const res = getUserData(this.clientToken);
    // res
    // .then((data)=>{
    //   this.id = data.id;
    //   this.headimg = data.headimg;
    //   this.email = data.email;
    //   this.nickname = data.nickname;
    //   this.recipient = data.recipient;
    //   this.address = data.address;
    //   this.phone = data.phone;
    // })
    // .catch((e)=>{
    //   alert(e)
    // })
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a386ed1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/MyData.vue
var MyData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyData"},[_c('ul',[_c('li',[_c('span',[_vm._v("账号")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.email))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("昵称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nickname),expression:"nickname"}],attrs:{"type":"text"},domProps:{"value":(_vm.nickname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nickname=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("收件人")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.recipient),expression:"recipient"}],attrs:{"type":"text"},domProps:{"value":(_vm.recipient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.recipient=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("收件地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"long",attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("联系电话")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],attrs:{"type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('span',[_vm._v("密码")]),_vm._v(" "),_c('button',{on:{"click":_vm.showPopup}},[_vm._v("修改密码")])])]),_vm._v(" "),_c('button',{staticClass:"saveBtn",on:{"click":_vm.updateUserData}},[_vm._v("保存")]),_vm._v(" "),_c('Popup',{directives:[{name:"show",rawName:"v-show",value:(_vm.popupShow),expression:"popupShow"}],attrs:{"title":"修改密码"},on:{"popupClose":_vm.closePopup}},[_c('div',{staticClass:"popupContent",attrs:{"slot":"popupContent"},slot:"popupContent"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPwd),expression:"oldPwd"}],attrs:{"type":"password","placeholder":"请输入原密码"},domProps:{"value":(_vm.oldPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPwd=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPwd),expression:"newPwd"}],attrs:{"type":"password","placeholder":"请输入新密码"},domProps:{"value":(_vm.newPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPwd=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPwd),expression:"confirmPwd"}],attrs:{"type":"password","placeholder":"请再次输入新密码"},domProps:{"value":(_vm.confirmPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPwd=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.updatePwd}},[_vm._v("确认修改")])])])],1)}
var MyData_staticRenderFns = []
var MyData_esExports = { render: MyData_render, staticRenderFns: MyData_staticRenderFns }
/* harmony default export */ var client_MyData = (MyData_esExports);
// CONCATENATED MODULE: ./src/pages/client/MyData.vue
function MyData_injectStyle (ssrContext) {
  __webpack_require__("gRm8")
}
var MyData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MyData___vue_template_functional__ = false
/* styles */
var MyData___vue_styles__ = MyData_injectStyle
/* scopeId */
var MyData___vue_scopeId__ = "data-v-a386ed1a"
/* moduleIdentifier (server only) */
var MyData___vue_module_identifier__ = null
var MyData_Component = MyData_normalizeComponent(
  MyData,
  client_MyData,
  MyData___vue_template_functional__,
  MyData___vue_styles__,
  MyData___vue_scopeId__,
  MyData___vue_module_identifier__
)

/* harmony default export */ var pages_client_MyData = (MyData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Cart.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from "vuex";


/* harmony default export */ var Cart = ({
  name: "Cart",
  components: {
    NumberInput: NumberInput["a" /* default */]
  },
  computed: {
    totalAmount: function totalAmount() {
      var amount = 0;
      this.orderList.map(function (item, index) {
        amount += item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj;
      });
      return amount;
    }
  },
  data: function data() {
    return {
      form_head_uuid: "a6cf518450fb43289af179b8beb4b943",
      order: {},
      orderList: [],
      checkAll: false,
      isIndeterminate: false
    };
  },
  created: function created() {
    this.$store.dispatch('getCartQuantity');
  },


  methods: {
    // 全选
    handleCheckAllChange: function handleCheckAllChange() {
      var _this = this;

      this.orderList = this.orderList.map(function (item) {
        return extends_default()({}, item, {
          checked: _this.checkAll
        });
      });
      if (this.checkAll) this.isIndeterminate = false;
    },

    // 单选
    handleCheckedChange: function handleCheckedChange() {
      var checkedItemsCount = this.orderList.filter(function (item) {
        return item.checked;
      }).length;
      var isAllChecked = checkedItemsCount === this.orderList.length;
      this.isIndeterminate = checkedItemsCount > 0 && !isAllChecked;
      this.checkAll = isAllChecked;
    },

    // 获取购物车列表
    getShoppingCartList: function getShoppingCartList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var form_head_uuid, _ref, result;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form_head_uuid = _this2.form_head_uuid;
                _context.next = 3;
                return Object(platform["n" /* online */])({
                  page: 1,
                  limit: 100,
                  keyword: "",
                  select_option: "",
                  form_head_uuid: form_head_uuid
                });

              case 3:
                _ref = _context.sent;
                result = _ref.result;

                if (result.length > 0) {
                  _this2.orderList = result.map(function (el) {
                    return extends_default()({}, el, {
                      checked: false
                    });
                  });
                } else {
                  _this2.orderList = [];
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    numberChange: function numberChange(item) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var form_head_uuid, id;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_head_uuid = _this3.form_head_uuid;
                id = item.id;
                _context2.next = 4;
                return Object(platform["v" /* updateOnline */])({
                  id: id,
                  form_head_uuid: form_head_uuid,
                  tbdn8rpen3ijbiv2: item.tbdn8rpen3ijbiv2
                });

              case 4:
                _this3.$store.dispatch('getCartQuantity');

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    deleteOrder: function deleteOrder(orderId) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var form_head_uuid;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                form_head_uuid = _this4.form_head_uuid;
                _context3.next = 3;
                return Object(platform["e" /* delOnline */])({
                  form_head_uuid: form_head_uuid,
                  ids: [orderId]
                });

              case 3:
                _this4.getShoppingCartList();
                _this4.$store.dispatch('getCartQuantity');

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },
    settleAccounts: function settleAccounts() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var commodityList;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commodityList = _this5.orderList.filter(function (el) {
                  return el.checked;
                });

                if (!(commodityList && commodityList.length > 0)) {
                  _context4.next = 6;
                  break;
                }

                _this5.$store.commit('setData', {
                  commodityList: commodityList
                });
                _this5.$router.push('/mall/createOrder?form=cart');
                _context4.next = 7;
                break;

              case 6:
                return _context4.abrupt("return", _this5.$notify.error({
                  title: '提示',
                  message: '您还没有选择商品'
                }));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  },

  mounted: function mounted() {
    this.getShoppingCartList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1467ffb5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Cart.vue
var Cart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Cart"},[_c('div',{staticClass:"title"},[_vm._v("购物车")]),_vm._v(" "),(_vm.orderList.length > 0)?_c('div',[_c('div',{staticClass:"cartTableHeader"},[_c('span',[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleCheckAllChange},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}})],1),_vm._v(" "),_c('span',[_vm._v("商品信息")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("单位")]),_vm._v(" "),_c('span',[_vm._v("数量")]),_vm._v(" "),_c('span',[_vm._v("操作")])]),_vm._v(" "),_c('ul',{staticClass:"orderList"},_vm._l((_vm.orderList),function(item){return _c('li',{key:'order' + item.id},[_c('div',{staticClass:"orderDetail"},[_c('el-checkbox',{on:{"change":_vm.handleCheckedChange},model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}}),_vm._v(" "),_c('img',{attrs:{"src":item['gdlu2l0z6a7sprky'] && item['gdlu2l0z6a7sprky'].length > 0
                ? item['gdlu2l0z6a7sprky'][0].url
                : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(item.duovdnoapszqxeih && item.duovdnoapszqxeih.length > 0)?_c('p',{on:{"click":function($event){return _vm.navTo('/mall/goods/' + item.duovdnoapszqxeih[0].id)}}},[_vm._v("\n              "+_vm._s(item.duovdnoapszqxeih[0].value)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n            "+_vm._s(item.qajsmihzqxevgihj ? '￥' + item.qajsmihzqxevgihj : 0)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n            "+_vm._s(item.ycqgzdztcyhqnczy)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_c('NumberInput',{attrs:{"initNum":item.tbdn8rpen3ijbiv2,"min":1,"max":99999},on:{"changeHandle":function($event){return _vm.numberChange(item)}},model:{value:(item.tbdn8rpen3ijbiv2),callback:function ($$v) {_vm.$set(item, "tbdn8rpen3ijbiv2", $$v)},expression:"item.tbdn8rpen3ijbiv2"}})],1),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.deleteOrder(item.id)}}},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("fcOW"),"alt":""}})])],1)])}),0),_vm._v(" "),_c('div',{staticClass:"cartFooter"},[_c('button',{on:{"click":_vm.settleAccounts}},[_vm._v("下单")])])]):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("R37o"),"alt":""}})])])}
var Cart_staticRenderFns = []
var Cart_esExports = { render: Cart_render, staticRenderFns: Cart_staticRenderFns }
/* harmony default export */ var client_Cart = (Cart_esExports);
// CONCATENATED MODULE: ./src/pages/client/Cart.vue
function Cart_injectStyle (ssrContext) {
  __webpack_require__("PugO")
}
var Cart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Cart___vue_template_functional__ = false
/* styles */
var Cart___vue_styles__ = Cart_injectStyle
/* scopeId */
var Cart___vue_scopeId__ = "data-v-1467ffb5"
/* moduleIdentifier (server only) */
var Cart___vue_module_identifier__ = null
var Cart_Component = Cart_normalizeComponent(
  Cart,
  client_Cart,
  Cart___vue_template_functional__,
  Cart___vue_styles__,
  Cart___vue_scopeId__,
  Cart___vue_module_identifier__
)

/* harmony default export */ var pages_client_Cart = (Cart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/RegularPurchaseList.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from "vuex";


/* harmony default export */ var RegularPurchaseList = ({
  name: "Cart",
  components: {
    NumberInput: NumberInput["a" /* default */]
  },
  computed: {
    // totalAmount () {
    //   let amount = 0;
    //   this.orderList.map((item, index) => {
    //     amount += item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj;
    //   });
    //   return amount;
    // },
  },
  data: function data() {
    return {
      form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
      order: {},
      regularPurchaseList: [],
      checkAll: false,
      isIndeterminate: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getRegularPurchaseList();
  },

  methods: {
    // 新增分组
    addGroup: function addGroup() {
      var _this = this;

      this.$prompt('分组名称', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
          var value = _ref2.value;
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!value) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 3;
                  return Object(platform["o" /* postOnline */])({
                    form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
                    izclrsecwsxu9yfg: value
                  });

                case 3:
                  _this.$message({
                    type: 'success',
                    message: '创建成功'
                  });
                  _this.getRegularPurchaseList();

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    delGroup: function delGroup(_ref3) {
      var _this2 = this;

      var id = _ref3.id;

      this.$confirm('是否确认删除该分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(platform["e" /* delOnline */])({
                  form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
                  ids: [id]
                });

              case 2:
                _this2.getRegularPurchaseList();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      })));
    },

    // 获取订单列表
    getRegularPurchaseList: function getRegularPurchaseList() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var form_head_uuid, _ref5, result, list;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                form_head_uuid = _this3.form_head_uuid;
                _context4.next = 3;
                return Object(platform["n" /* online */])({
                  form_head_uuid: form_head_uuid,
                  page: 1,
                  limit: 1000,
                  keyword: "",
                  select_option: ""
                });

              case 3:
                _ref5 = _context4.sent;
                result = _ref5.result;
                _context4.next = 7;
                return promise_default.a.all(result.map(function () {
                  var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(el) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.t0 = extends_default.a;
                            _context3.t1 = {};
                            _context3.t2 = el;
                            _context3.next = 5;
                            return _this3.children(el.id);

                          case 5:
                            _context3.t3 = _context3.sent;
                            _context3.t4 = {
                              vil3pydur6d8qauy: _context3.t3
                            };
                            return _context3.abrupt("return", (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t4));

                          case 8:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x2) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 7:
                list = _context4.sent;

                _this3.regularPurchaseList = list;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },

    // 获取子表数据
    children: function children(record_id) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var form_head_uuid, _ref7, result;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                form_head_uuid = _this4.form_head_uuid;
                _context5.next = 3;
                return Object(platform["d" /* children */])({
                  page: 1,
                  limit: 100,
                  field_uuid: "2190d51416b84722902efd1a5ee39dca",
                  form_head_uuid: form_head_uuid,
                  record_id: record_id
                });

              case 3:
                _ref7 = _context5.sent;
                result = _ref7.result;
                return _context5.abrupt("return", result.map(function (el) {
                  return extends_default()({}, el, { checked: false });
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },

    // 数量切换
    numberChange: function numberChange(item, id) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var obj, form_head_uuid;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                obj = JSON.parse(stringify_default()(item));

                delete obj.checked;
                obj.mnkt8dkjryhvdej3 = obj.mnkt8dkjryhvdej3.map(function (el) {
                  return el.id;
                });
                obj.whfmbyuc1i2pavi4 = obj.whfmbyuc1i2pavi4.map(function (el) {
                  return el.id;
                });
                form_head_uuid = _this5.form_head_uuid;
                _context6.next = 7;
                return Object(platform["v" /* updateOnline */])({
                  id: id,
                  form_head_uuid: form_head_uuid,
                  vil3pydur6d8qauy: [obj]
                });

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },

    // 删除常购清单
    deleteOrder: function deleteOrder(orderId) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var form_head_uuid;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                form_head_uuid = _this6.form_head_uuid;
                _context7.next = 3;
                return Object(platform["e" /* delOnline */])({
                  form_head_uuid: 'd833435e05c511ef80bc0242321230b4',
                  ids: [orderId]
                });

              case 3:
                _this6.getRegularPurchaseList();

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    navTo: function navTo(route) {
      this.$router.push(route);
    },
    settleAccounts: function settleAccounts() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var commodityList;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commodityList = _this7.regularPurchaseList.reduce(function (accumulator, el) {
                  var checkedItems = el.vil3pydur6d8qauy.filter(function (item) {
                    return item.checked;
                  });
                  return accumulator.concat(checkedItems);
                }, []);

                if (!(commodityList.length === 0)) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return", _this7.$notify.error({
                  title: '提示',
                  message: '您还没有选择商品'
                }));

              case 3:
                _this7.$store.commit('setData', {
                  commodityList: commodityList
                });
                _this7.$router.push('/mall/createOrder?form=regularPurchaseList');

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d1b892b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/RegularPurchaseList.vue
var RegularPurchaseList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Cart"},[_c('div',{staticClass:"title"},[_vm._v("\n    常购清单\n    "),_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":_vm.addGroup}},[_vm._v("新增分组")])],1),_vm._v(" "),(_vm.regularPurchaseList.length > 0)?_c('div',[_vm._m(0),_vm._v(" "),_vm._l((_vm.regularPurchaseList),function(order,idx){return _c('ul',{key:idx,staticClass:"group"},[_c('div',{staticClass:"group_title"},[_c('div',[_vm._v(_vm._s(order.izclrsecwsxu9yfg))]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.delGroup(order)}}},[_vm._v("删除")])]),_vm._v(" "),_vm._l((order.vil3pydur6d8qauy),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"orderDetail"},[_c('el-checkbox',{model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}}),_vm._v(" "),_c('img',{attrs:{"src":item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
                ? item['mnkt8dkjryhvdej3'][0].url
                : '',"alt":"商品图片"}}),_vm._v(" "),_c('div',{staticClass:"goodsName"},[(item.whfmbyuc1i2pavi4 && item.whfmbyuc1i2pavi4.length > 0)?_c('p',{on:{"click":function($event){return _vm.navTo('/mall/goods/' + item.whfmbyuc1i2pavi4[0].id)}}},[_vm._v("\n              "+_vm._s(item.whfmbyuc1i2pavi4[0].value)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n            "+_vm._s(item.t9rtdu9o7iztvayy ? '￥' + item.t9rtdu9o7iztvayy : 0)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"unitPrice"},[_vm._v("\n            "+_vm._s(item.kq1qbbk7dulmlghs)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"num"},[_c('NumberInput',{attrs:{"initNum":item.mcuilzaudpe3shlc,"min":1,"max":99},on:{"changeHandle":function($event){return _vm.numberChange(item, order.id)}},model:{value:(item.mcuilzaudpe3shlc),callback:function ($$v) {_vm.$set(item, "mcuilzaudpe3shlc", $$v)},expression:"item.mcuilzaudpe3shlc"}})],1),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.deleteOrder(item.id)}}},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("fcOW"),"alt":""}})])],1)])})],2)}),_vm._v(" "),_c('div',{staticClass:"cartFooter"},[_c('button',{on:{"click":_vm.settleAccounts}},[_vm._v("下单")])])],2):_c('p',{staticClass:"emptyTips"},[_c('img',{attrs:{"src":__webpack_require__("R37o"),"alt":""}})])])}
var RegularPurchaseList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cartTableHeader"},[_c('span'),_vm._v(" "),_c('span',[_vm._v("商品信息")]),_vm._v(" "),_c('span',[_vm._v("单价")]),_vm._v(" "),_c('span',[_vm._v("单位")]),_vm._v(" "),_c('span',[_vm._v("数量")]),_vm._v(" "),_c('span',[_vm._v("操作")])])}]
var RegularPurchaseList_esExports = { render: RegularPurchaseList_render, staticRenderFns: RegularPurchaseList_staticRenderFns }
/* harmony default export */ var client_RegularPurchaseList = (RegularPurchaseList_esExports);
// CONCATENATED MODULE: ./src/pages/client/RegularPurchaseList.vue
function RegularPurchaseList_injectStyle (ssrContext) {
  __webpack_require__("/HYd")
}
var RegularPurchaseList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RegularPurchaseList___vue_template_functional__ = false
/* styles */
var RegularPurchaseList___vue_styles__ = RegularPurchaseList_injectStyle
/* scopeId */
var RegularPurchaseList___vue_scopeId__ = "data-v-3d1b892b"
/* moduleIdentifier (server only) */
var RegularPurchaseList___vue_module_identifier__ = null
var RegularPurchaseList_Component = RegularPurchaseList_normalizeComponent(
  RegularPurchaseList,
  client_RegularPurchaseList,
  RegularPurchaseList___vue_template_functional__,
  RegularPurchaseList___vue_styles__,
  RegularPurchaseList___vue_scopeId__,
  RegularPurchaseList___vue_module_identifier__
)

/* harmony default export */ var pages_client_RegularPurchaseList = (RegularPurchaseList_Component.exports);

// EXTERNAL MODULE: ./src/pages/ErrorPage.vue + 2 modules
var ErrorPage = __webpack_require__("Duuk");

// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("Av7u");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// CONCATENATED MODULE: ./src/router/client.js















 // 订单详情
 // 收货地址
 // 修改密码
 //退货申请
 //换货申请
 //维修申请
 //标外维修
 //标外维修
 //标外商品申请
 //标外商品申请
 //标外商品申请






vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: "/",
    redirect: "/mall"
  }, {
    path: "/login",
    name: "MallLogin",
    component: pages_client_MallLogin
  }, {
    path: "/mall",
    name: "Mall",
    component: pages_client_Mall,
    redirect: "/mall/show",
    children: [{
      path: "show",
      name: "MallShow",
      component: pages_client_MallShow,
      redirect: "/mall/show/index",
      children: [{
        path: "index",
        name: "MallIndex",
        component: pages_client_MallIndex,
        meta: {
          requireLogin: false
        }
      }, {
        path: "goodsList/:typeId/:keyword",
        name: "GoodsList",
        component: pages_client_GoodsList,
        meta: {
          requireLogin: true
        }
      }]
    }, {
      path: "goods/:id",
      name: "GoodsDetail",
      component: pages_client_GoodsDetail,
      meta: {
        requireLogin: true
      }
    }, {
      path: "cart",
      name: "Cart",
      component: pages_client_Cart,
      meta: {
        requireLogin: true
      }
    }, {
      path: "regularPurchaseList",
      name: "RegularPurchaseList",
      component: pages_client_RegularPurchaseList,
      meta: {
        requireLogin: true
      }
    }, {
      path: "createOrder",
      name: "CreateOrder",
      component: pages_client_CreateOrder,
      meta: {
        requireLogin: true
      }
    }, {
      path: "orderDetail/:id",
      name: "OrderDetail",
      component: pages_client_OrderDetail,
      meta: {
        requireLogin: true
      }
    }, {
      path: "personal",
      name: "Personal",
      component: pages_client_Personal,
      redirect: "/mall/personal/cart",
      children: [{
        path: "myData",
        name: "MyData",
        component: pages_client_MyData,
        meta: {
          requireLogin: true
        }
      }, {
        path: "myOrder",
        name: "MyOrder",
        component: pages_client_MyOrder,
        meta: {
          requireLogin: true,
          keepAlive: true
        }
      }, {
        path: "Purchase",
        name: "Purchase",
        component: pages_client_Purchase,
        meta: {
          requireLogin: true,
          keepAlive: true
        }
      }, {
        path: "Shelves",
        name: "Shelves",
        component: pages_client_Shelves,
        meta: {
          requireLogin: true,
          keepAlive: true
        }
      }, {
        path: "myAddress",
        name: "MyAddress",
        component: pages_client_MyAddress,
        meta: {
          requireLogin: true
        }
      }, {
        path: "changePwd",
        name: "ChangePwd",
        component: pages_client_ChangePwd,
        meta: {
          requireLogin: true
        }
      }, {
        path: "returnGoods",
        name: "ReturnGoods",
        component: pages_client_ReturnGoods,
        meta: {
          requireLogin: true
        }
      }, {
        path: "barter",
        name: "Barter",
        component: pages_client_Barter,
        meta: {
          requireLogin: true
        }
      }, {
        path: "repair",
        name: "Repair",
        component: pages_client_Repair,
        meta: {
          requireLogin: true
        }
      }, {
        path: "extraStandard",
        name: "ExtraStandard",
        component: pages_client_ExtraStandard,
        meta: {
          requireLogin: true
        }
      }, {
        path: "commodityApplication",
        name: "CommodityApplication",
        component: pages_client_CommodityApplication,
        meta: {
          requireLogin: true
        }
      }, {
        path: "satisfaction",
        name: "Satisfaction",
        component: pages_client_Satisfaction,
        meta: {
          requireLogin: true
        }
      }, {
        path: "wechat",
        name: "Wechat",
        component: pages_client_Wechat,
        meta: {
          requireLogin: true
        }
      }]
    }]
  }, {
    path: "*",
    name: "ErrorPage",
    component: ErrorPage["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

//登录拦截
var cacheBackFrom = ["GoodsDetail"]; // 从这些页面返回时不刷新 page-a
router.beforeEach(function (to, from, next) {
  console.log(to.name, from.name);
  if (['GoodsDetail', 'MyOrder'].includes(to.name)) {
    from.meta.keepAlive = true;
    from.meta._keepKey = 'MyOrder-static'; // same key = keep cached
  } else {
    from.meta.keepAlive = false;
    from.meta._keepKey = 'MyOrder-' + Date.now(); // new key = force refresh
  }
  if (to.meta.requireLogin) {
    if (store["a" /* default */].state.clientToken) {
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

/* harmony default export */ var client = __webpack_exports__["a"] = (router);

/***/ }),

/***/ "RtwJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ywc.92f6e5d.svg";

/***/ }),

/***/ "SQjz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "STan":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T8fr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UiAc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vc6v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vh3w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WqWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wyh/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZOCR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZeaC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a2m0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a6Aw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ajUH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "asFA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b3fX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wechatCode.9d8a43f.jpg";

/***/ }),

/***/ "b9+s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cbiT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxNk":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyANCiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiDQogd2lkdGg9IjEzcHgiIGhlaWdodD0iMTJweCI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiICBmaWxsPSJyZ2IoMjIyLCA4MywgMjkpIg0KIGQ9Ik0xMi45MzcsMi45NzkgTDExLjA4OCw2Ljg1OSBMMTEuMDgwLDYuODc0IEMxMC45OTQsNy4wNDUgMTAuODIyLDcuMTcwIDEwLjYxNSw3LjE4NCBMNC4yNzEsNy41MjggTDQuMzcwLDguMzU5IEM0LjQwNyw4LjUwMCA0LjU1MSw4LjYxMSA0LjcwMyw4LjYzNCBMMTAuMzQzLDguNjM0IEMxMC42NTMsOC42MzQgMTAuOTA0LDguODg0IDEwLjkwNCw5LjE5MSBDMTAuOTA0LDkuNDk4IDEwLjY1Miw5Ljc0NiAxMC4zNDMsOS43NDYgTDQuMjM0LDkuNzQ2IEMzLjc3MCw5Ljc0NiAzLjM4Niw5LjQxMCAzLjMxNSw4Ljk3MSBMMi40MzIsMS42NjkgTDIuNDA0LDEuNDI5IEwyLjQwMCwxLjM5NiBDMi4zNzAsMS4yMzQgMi4yMDMsMS4xMTAgMi4wMzMsMS4wOTcgTDAuNTY0LDEuMDk3IEMwLjI1NCwxLjA5NyAwLjAwNCwwLjg0OCAwLjAwNCwwLjU0MSBDMC4wMDQsMC4yMzQgMC4yNTUsLTAuMDE1IDAuNTY0LC0wLjAxNSBMMi41NjgsLTAuMDE1IEMyLjk5MCwtMC4wMDIgMy4zNDIsMC4yODkgMy40NDIsMC42ODAgTDMuNTgzLDEuODU3IEwxMi4zMzUsMS44NTcgQzEyLjM2OCwxLjg1OSAxMi40MDAsMS44NjMgMTIuNDMxLDEuODY5IEMxMi45NTIsMS45NjggMTMuMTA4LDIuNTQ5IDEyLjkzNywyLjk3OSBaTTUuMTYxLDEwLjQzMSBDNS41OTQsMTAuNDMxIDUuOTQ2LDEwLjc4MCA1Ljk0NiwxMS4yMDkgQzUuOTQ2LDExLjYzOSA1LjU5NCwxMS45ODcgNS4xNjEsMTEuOTg3IEM0LjcyNywxMS45ODcgNC4zNzYsMTEuNjM5IDQuMzc2LDExLjIwOSBDNC4zNzYsMTAuNzgwIDQuNzI3LDEwLjQzMSA1LjE2MSwxMC40MzEgWk05LjY4NCwxMC41MzUgQzkuOTI3LDEwLjY3NCAxMC4wNzYsMTAuOTMxIDEwLjA3NiwxMS4yMDkgQzEwLjA3NiwxMS40ODggOS45MjcsMTEuNzQ0IDkuNjg0LDExLjg4MyBDOS40NDEsMTIuMDIyIDkuMTQxLDEyLjAyMiA4Ljg5OSwxMS44ODMgQzguNjU2LDExLjc0NCA4LjUwNiwxMS40ODggOC41MDYsMTEuMjA5IEM4LjUwNiwxMC45MzEgOC42NTYsMTAuNjc0IDguODk5LDEwLjUzNSBDOS4xNDEsMTAuMzk3IDkuNDQxLDEwLjM5NyA5LjY4NCwxMC41MzUgWiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "eOq7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.94fd048.jpg";

/***/ }),

/***/ "eXGj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fEcW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fS4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcOW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "g/q1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ysh.9f760da.svg";

/***/ }),

/***/ "gRm8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iWlE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAAXNSR0IArs4c6QAAAX9JREFUOE+t1D9IV1EUwPHvV6E/Q0MgEoFTUGHh0NTgUFOLgUvi0BQN0mQtbqFNgZDgKGVjhE0N4lCDq6A4GS5ROEglDuUoHH9HrvJ8Jj9//Lxw4XLfu593zrv3HiNiFegDPqlDtNmMiLfAXeBW9ga61o5pLo6Ii8A28FqdaBss6Bfginr7rMCxjLAN7C9weT/lEuEdYBm4qa63AkfES+Cxer0K5vgXMKlOnhaMiA7gOzCrvjoES5QfgB61vwXwATAPXFN/1MEnwEyjX1V/nwaNiDmgS72f79fBHuAn8FSdbQZGRDewAYyo74+BJe1vuTHNsMrzTeCG+u8kcBoYLOj5xlG6UHqOD3rO5fgcsKT+OfjAkZRLhA+Bz+Un5+611P4HXgK2gGfqu5a0+qZUDvkLYBTobALmGcwD/fXElKtARGS0w41qtKDmbmYhSSTn1tW8WUfasZRr4BvgObCo3itg1syPwM7+3dXd6ppm4CMg6+WUOl7AXiAr04o6UI9wD/bKgRKxFWwgAAAAAElFTkSuQmCC"

/***/ }),

/***/ "jQEI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kfLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/util/util.js
var util = __webpack_require__("yt7g");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Popup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Popup = ({
  name: 'Popup',
  props: {
    title: {
      type: String,
      default: '提示信息'
    }
  },
  data: function data() {
    return {
      show: false,
      windowWidth: Object(util["b" /* getClientSize */])().width,
      windowHeight: Object(util["b" /* getClientSize */])().height
    };
  },

  methods: {
    closePopup: function closePopup() {
      this.$emit('popupClose');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04993f58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popup.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PopupWrapper",style:({width:_vm.windowWidth+'px',height:_vm.windowHeight+'px',lineHeight:_vm.windowHeight+'px'}),on:{"click":function($event){$event.stopPropagation();return _vm.closePopup.apply(null, arguments)}}},[_c('div',{staticClass:"Popup",on:{"click":function($event){$event.stopPropagation();return (function (){}).apply(null, arguments)}}},[_c('div',{staticClass:"popupHeader"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"closeBtn",on:{"click":_vm.closePopup}},[_c('i',{staticClass:"iconfont icon-close"})])]),_vm._v(" "),_c('div',{staticClass:"popupBody"},[_vm._t("popupContent")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Popup = (esExports);
// CONCATENATED MODULE: ./src/components/Popup.vue
function injectStyle (ssrContext) {
  __webpack_require__("Vc6v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04993f58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Popup,
  components_Popup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Popup = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kvyp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/article.6bb3507.svg";

/***/ }),

/***/ "mLep":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBoZWlnaHQ9IjMwMCIgbm9kZS1pZD0iMSIgc2lsbHl2Zz0idHJ1ZSIgdGVtcGxhdGUtaGVpZ2h0PSIzMDAiIHRlbXBsYXRlLXdpZHRoPSI1MDAiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDUwMCAzMDAiIHdpZHRoPSI1MDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzIG5vZGUtaWQ9IjMzIj48bGluZWFyR3JhZGllbnQgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGlkPSLmnKrlkb3lkI3nmoTmuJDlj5hfNTAiIG5vZGUtaWQ9IjUiIHNwcmVhZE1ldGhvZD0icGFkIiB4MT0iMjUwIiB4Mj0iMjUwIiB5MT0iMjg0LjIyIiB5Mj0iMTkxLjIyIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmY5ZWYiIHN0b3Atb3BhY2l0eT0iMCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC4xNyIgc3RvcC1jb2xvcj0iI2ZlZjhlZiIgc3RvcC1vcGFjaXR5PSIwLjAyIj48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjMyIiBzdG9wLWNvbG9yPSIjZmJmNWVlIiBzdG9wLW9wYWNpdHk9IjAuMDYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNDYiIHN0b3AtY29sb3I9IiNmNWYxZWMiIHN0b3Atb3BhY2l0eT0iMC4xNCI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMC42IiBzdG9wLWNvbG9yPSIjZWRlYmVhIiBzdG9wLW9wYWNpdHk9IjAuMjYiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuNzQiIHN0b3AtY29sb3I9IiNlM2UyZTciIHN0b3Atb3BhY2l0eT0iMC40Ij48L3N0b3A+PHN0b3Agb2Zmc2V0PSIwLjg3IiBzdG9wLWNvbG9yPSIjZDZkOGU0IiBzdG9wLW9wYWNpdHk9IjAuNTgiPjwvc3RvcD48c3RvcCBvZmZzZXQ9IjAuOTkiIHN0b3AtY29sb3I9IiNjOGNkZTAiIHN0b3Atb3BhY2l0eT0iMC43OSI+PC9zdG9wPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2M3Y2NlMCIgc3RvcC1vcGFjaXR5PSIwLjgiPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBub2RlLWlkPSI5MCI+PHBhdGggZD0iTSA4NC40MyAxNjIuNzggQyA4MC45NCAxNjAuNDkgNzMuMzUgMTUzLjUzIDcyLjg4IDE1MS41NSBMIDczLjI0IDE1MS40NiBDIDczLjI0IDE1MS40NiA3My4yNCAxNDkuNjkgNzIuODcgMTQ5LjY5IEMgNzIuNTAgMTQ5LjY5IDYwLjU1IDE1Mi40OSA2MC41NSAxNTIuNDkgTCA2MS4wNSAxNTQuNDkgTCA2MS4yOSAxNTQuNDMgQyA1OS43OSAxNTcuMjQgNTUuMTkgMTY2LjA5IDU0Ljk1IDE2OS42MCBMIDU0LjY3IDE3My44MCBDIDU1Ljc4IDE3My4yOSA1Ny4wMiAxNzMuMTMgNTguMjIgMTczLjMzIEMgNjAuMDkgMTczLjcwIDYyLjE0IDE3Ny4zMyA3MC4yMiAxNzMuODAgQyA3MS41MSAxNzMuMzkgNzIuODggMTczLjI3IDc0LjIyIDE3My40MyBDIDc2LjkzIDE3My42MiA3Ny45NSAxNzAuODIgODAuMzggMTcwLjgyIEMgODIuODEgMTcwLjgyIDgzLjkzIDE3MC40NSA4NC43NiAxNjkuNjEgQyA4NS41OSAxNjguNzcgODYuOTEgMTY4Ljc3IDg3LjY1IDE2Ny44NCBDIDg4LjM5IDE2Ni45MSA4OC4wMCAxNjUuMTEgODQuNDMgMTYyLjc4IFoiIGZpbGw9IiNjN2NjZTAiIGZpbGwtb3BhY2l0eT0iMC44IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIxIiBub2RlLWlkPSI1OCIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSIyNy42NCIgdGFyZ2V0LXdpZHRoPSIzMy43MiIgdGFyZ2V0LXg9IjU0LjY3IiB0YXJnZXQteT0iMTQ5LjY5Ij48L3BhdGg+PHBhdGggZD0iTSA4My44MiAxNjIuNzggQyA4MC4zMyAxNjAuNDkgNzIuNzQgMTUzLjUzIDcyLjI3IDE1MS41NSBMIDcyLjYzIDE1MS40NiBDIDcyLjYzIDE1MS40NiA3Mi42MyAxNDkuNjkgNzIuMjYgMTQ5LjY5IEMgNzEuODkgMTQ5LjY5IDU5Ljk0IDE1Mi40OSA1OS45NCAxNTIuNDkgTCA2MC40NCAxNTQuNDkgTCA2MC42OCAxNTQuNDMgQyA1OS4xOCAxNTcuMjQgNTQuNTggMTY2LjA5IDU0LjM0IDE2OS42MCBMIDU0LjA2IDE3My44MCBDIDU1LjE3IDE3My4yOSA1Ni40MSAxNzMuMTMgNTcuNjEgMTczLjMzIEMgNTkuNDggMTczLjcwIDYxLjUzIDE3Ny4zMyA2OS42MSAxNzMuODAgQyA3MC45MCAxNzMuMzkgNzIuMjcgMTczLjI3IDczLjYxIDE3My40MyBDIDc2LjMyIDE3My42MiA3Ny4zNCAxNzAuODIgNzkuNzcgMTcwLjgyIEMgODIuMjAgMTcwLjgyIDgzLjMyIDE3MC40NSA4NC4xNSAxNjkuNjEgQyA4NC45OCAxNjguNzcgODYuMzAgMTY4Ljc3IDg3LjA0IDE2Ny44NCBDIDg3Ljc4IDE2Ni45MSA4Ny4zNyAxNjUuMTEgODMuODIgMTYyLjc4IFoiIGZpbGw9IiNlMmU0ZWQiIGZpbGwtb3BhY2l0eT0iMC44IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIxIiBub2RlLWlkPSI2MCIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSIyNy42NCIgdGFyZ2V0LXdpZHRoPSIzMy43MTk5OTciIHRhcmdldC14PSI1NC4wNiIgdGFyZ2V0LXk9IjE0OS42OSI+PC9wYXRoPjwvZz48ZyBub2RlLWlkPSI5MSI+PHBhdGggZD0iTSAzNjIuNTYgNjQuMjEgTCAzNjUuMDAgNjUuNDAgQyAzNjUuMDAgNjUuNDAgMzYwLjczIDcwLjk0IDM2My43NSA3My4xNiBDIDM2Ni43NyA3NS4zOCAzNjkuOTcgNzUuNzkgMzczLjE0IDY5LjU1IEwgMzc1LjM5IDcwLjU1IEMgMzc1LjM5IDcwLjU1IDM2Ny4xNiA4OC45NSAzNjcuMTAgOTEuMjEgQyAzNjMuNjUgOTAuNjggMzYwLjMxIDg5LjYyIDM1Ny4xOSA4OC4wNyBDIDM1NC44NiA4Ni45MiAzNTIuNjIgODUuNjAgMzUwLjQ3IDg0LjE0IFoiIGZpbGw9IiNjN2NjZTAiIGZpbGwtb3BhY2l0eT0iMC44IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIyIiBub2RlLWlkPSI2NSIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSIyNyIgdGFyZ2V0LXdpZHRoPSIyNC45MjAwMTMiIHRhcmdldC14PSIzNTAuNDciIHRhcmdldC15PSI2NC4yMSI+PC9wYXRoPjxwYXRoIGQ9Ik0gMzYyLjEzIDYzLjU5IEwgMzY0LjU1IDY0Ljc4IEMgMzY0LjU1IDY0Ljc4IDM2MC4yOCA3MC4zMiAzNjMuMzAgNzIuNTQgQyAzNjYuMzIgNzQuNzYgMzY5LjUyIDc1LjE3IDM3Mi42OSA2OC45MyBMIDM3NC45NCA2OS45MyBDIDM3NC45NCA2OS45MyAzNjYuNzEgODguMzMgMzY2LjY1IDkwLjU5IEMgMzYzLjIwIDkwLjA2IDM1OS44NiA4OS4wMCAzNTYuNzQgODcuNDUgQyAzNTQuNDEgODYuMjkgMzUyLjE1IDg0Ljk3IDM1MC4wMCA4My41MCBaIiBmaWxsPSIjZTJlNGVkIiBmaWxsLW9wYWNpdHk9IjAuOCIgZmlsbC1ydWxlPSJub256ZXJvIiBncm91cC1pZD0iMiIgbm9kZS1pZD0iNjciIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMjYuOTk5OTk2IiB0YXJnZXQtd2lkdGg9IjI0Ljk0MDAwMiIgdGFyZ2V0LXg9IjM1MCIgdGFyZ2V0LXk9IjYzLjU5Ij48L3BhdGg+PC9nPjxnIG5vZGUtaWQ9IjkyIj48cGF0aCBkPSJNIDEwMy43NCA4Ny44MiBMIDExMi4yMSA3OC4yOSBMIDExNS4wMSA3Ni43MiBDIDExNS4wMSA3Ni43MiAxMTYuNzYgODAuMTkgMTIxLjU1IDc3LjQ0IEMgMTI2LjM0IDc0LjY5IDEyNC41NSA3MS4zNCAxMjQuNTUgNzEuMzQgTCAxMjkuMDYgNzEuMjAgTCAxNDAuMDYgNzIuNzkgQyAxNDAuMDYgNzIuNzkgMTQwLjU0IDgwLjA4IDE0MC4wNiA4MC4yMyBDIDEzOS41OCA4MC4zOCAxMzMuMDYgNzkuOTYgMTMzLjA2IDc5Ljk2IEMgMTMzLjA2IDc5Ljk2IDE0MC44NSA5OC4zMiAxNDAuNjAgOTguMzMgQyAxNDAuMzUgOTguMzQgMTIxLjAwIDEwNi4wMCAxMjAuOTIgMTA1Ljg4IEMgMTIwLjg0IDEwNS43NiAxMTUuOTIgODguMzkgMTE1LjkyIDg4LjM5IEwgMTEwLjU4IDkzLjg0IFoiIGZpbGw9IiNjN2NjZTAiIGZpbGwtb3BhY2l0eT0iMC44IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGdyb3VwLWlkPSIzIiBub2RlLWlkPSI3MiIgc3Ryb2tlPSJub25lIiB0YXJnZXQtaGVpZ2h0PSIzNC44MDAwMDMiIHRhcmdldC13aWR0aD0iMzcuMTEwMDEiIHRhcmdldC14PSIxMDMuNzQiIHRhcmdldC15PSI3MS4yIj48L3BhdGg+PHBhdGggZD0iTSAxMDIuNzkgODcuNTUgTCAxMTEuMjUgNzguMDAgTCAxMTQuMDUgNzYuNDMgQyAxMTQuMDUgNzYuNDMgMTE1LjgwIDc5LjkwIDEyMC41OSA3Ny4xNSBDIDEyNS4zOCA3NC40MCAxMjMuNTkgNzEuMDUgMTIzLjU5IDcxLjA1IEwgMTI4LjEwIDcwLjkxIEwgMTM5LjEwIDcyLjUwIEMgMTM5LjEwIDcyLjUwIDEzOS41OCA3OS43OSAxMzkuMTAgNzkuOTQgQyAxMzguNjIgODAuMDkgMTMyLjEwIDc5LjY3IDEzMi4xMCA3OS42NyBDIDEzMi4xMCA3OS42NyAxMzkuODkgOTguMDMgMTM5LjY0IDk4LjA0IEMgMTM5LjM5IDk4LjA1IDEyMC4wMCAxMDUuNzUgMTIwLjAwIDEwNS42MSBDIDEyMC4wMCAxMDUuNDcgMTE1LjAwIDg4LjEyIDExNS4wMCA4OC4xMiBMIDEwOS42NiA5My41NyBaIiBmaWxsPSIjZTJlNGVkIiBmaWxsLW9wYWNpdHk9IjAuOCIgZmlsbC1ydWxlPSJub256ZXJvIiBncm91cC1pZD0iMyIgbm9kZS1pZD0iNzQiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMzQuODM5OTk2IiB0YXJnZXQtd2lkdGg9IjM3LjEiIHRhcmdldC14PSIxMDIuNzkiIHRhcmdldC15PSI3MC45MSI+PC9wYXRoPjwvZz48ZyBub2RlLWlkPSI5MyI+PHBhdGggZD0iTSA0MDAuOTMgMTQxLjkyIEMgNDAxLjA5IDE0MS43OCA0MTUuOTMgMTMzLjkyIDQxNi42NCAxMzMuOTIgQyA0MTYuNjQgMTMzLjkyIDQyMC45MSAxMzkuNDMgNDIxLjY0IDE0MC41NiBDIDQyMi4zNyAxNDEuNjkgNDIzLjM4IDE0Mi45NiA0MjMuMzggMTQyLjk2IEwgNDE2LjgwIDE0OC41NCBMIDQxMy4wNyAxNDUuODYgTCA0MTMuNjMgMTUwLjU2IEwgNDA1LjIxIDE1My44NCBaIiBmaWxsPSIjYzdjY2UwIiBmaWxsLW9wYWNpdHk9IjAuOCIgZmlsbC1ydWxlPSJub256ZXJvIiBncm91cC1pZD0iNCIgbm9kZS1pZD0iNzkiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMTkuOTE5OTk4IiB0YXJnZXQtd2lkdGg9IjIyLjQ1MDAxMiIgdGFyZ2V0LXg9IjQwMC45MyIgdGFyZ2V0LXk9IjEzMy45MiI+PC9wYXRoPjxwYXRoIGQ9Ik0gNDAwLjUyIDE0MS45NCBDIDQwMC42OCAxNDEuODAgNDE1LjUyIDEzMy45NCA0MTYuMjMgMTMzLjk0IEMgNDE2LjIzIDEzMy45NCA0MjAuNTAgMTM5LjQ1IDQyMS4yMyAxNDAuNTggQyA0MjEuOTYgMTQxLjcxIDQyMi45NyAxNDIuOTggNDIyLjk3IDE0Mi45OCBMIDQxNi4zOSAxNDguNTYgTCA0MTIuNjYgMTQ1Ljg4IEwgNDEzLjIyIDE1MC41OCBMIDQwNC44MCAxNTMuODYgWiIgZmlsbD0iI2UyZTRlZCIgZmlsbC1vcGFjaXR5PSIwLjgiIGZpbGwtcnVsZT0ibm9uemVybyIgZ3JvdXAtaWQ9IjQiIG5vZGUtaWQ9IjgxIiBzdHJva2U9Im5vbmUiIHRhcmdldC1oZWlnaHQ9IjE5LjkxOTk5OCIgdGFyZ2V0LXdpZHRoPSIyMi40NTAwMTIiIHRhcmdldC14PSI0MDAuNTIiIHRhcmdldC15PSIxMzMuOTQiPjwvcGF0aD48L2c+PHBhdGggZD0iTSAzOTYuMDAgMjM3LjcyIEMgMzk2LjAwIDI2My40MCAzMzAuNjMgMjg0LjIyIDI1MC4wMCAyODQuMjIgQyAxNjkuMzcgMjg0LjIyIDEwNC4wMCAyNjMuNDAgMTA0LjAwIDIzNy43MiBDIDEwNC4wMCAyMTIuMDQgMTY5LjM3IDE5MS4yMiAyNTAuMDAgMTkxLjIyIEMgMzMwLjYzIDE5MS4yMiAzOTYuMDAgMjEyLjA0IDM5Ni4wMCAyMzcuNzIgWiIgZmlsbD0idXJsKCPmnKrlkb3lkI3nmoTmuJDlj5hfNTApIiBmaWxsLXJ1bGU9Im5vbnplcm8iIG5vZGUtaWQ9Ijg0IiBzdHJva2U9Im5vbmUiIHRhcmdldC1oZWlnaHQ9IjkzIiB0YXJnZXQtd2lkdGg9IjI5MiIgdGFyZ2V0LXg9IjEwNCIgdGFyZ2V0LXk9IjE5MS4yMiI+PC9wYXRoPjxwYXRoIGQ9Ik0gMjkwLjcwIDc5LjI3IEMgMjc2LjI1IDU0LjA3IDI0NC41MCA0NC43MiAyMTguNzAgNTguMDcgQyAxOTIuODkgNzEuNDMgMTgyLjE4IDEwMi43MyAxOTQuNDEgMTI5LjA5IEMgMjA2LjYzIDE1NS40NSAyMzcuNDUgMTY3LjUwIDI2NC4zMSAxNTYuNDMgTCAyOTcuNjkgMjE5Ljg5IEMgMjk5LjY5IDIyMy4zMyAzMDYuMzYgMjI0Ljc4IDMxMC42NCAyMjIuMDMgQyAzMTQuMDMgMjE5Ljk5IDMxNS4yMCAyMTUuNjMgMzEzLjI5IDIxMi4xNyBMIDI3Ni44NSAxNDkuMTcgQyAyOTguMzQgMTMyLjY0IDMwNC4yNiAxMDIuNzUgMjkwLjcwIDc5LjI3IFogTSAyNjMuNTkgMTQwLjc0IEMgMjQ5LjY3IDE0OC43OCAyMzIuMjcgMTQ3LjYzIDIxOS41MiAxMzcuODQgQyAyMDYuNzcgMTI4LjA1IDIwMS4xNyAxMTEuNTQgMjA1LjM0IDk2LjAxIEMgMjA5LjUxIDgwLjQ5IDIyMi42MyA2OS4wMCAyMzguNTcgNjYuOTIgQyAyNTQuNTEgNjQuODMgMjcwLjE0IDcyLjU2IDI3OC4xNiA4Ni40OSBDIDI4OS4wMyAxMDUuNTEgMjgyLjUyIDEyOS43MyAyNjMuNTkgMTQwLjc0IFoiIGZpbGw9IiNjN2NjZTAiIGZpbGwtcnVsZT0ibm9uemVybyIgbm9kZS1pZD0iODYiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMTgwLjA1ODQzIiB0YXJnZXQtd2lkdGg9IjEzMy4wMTY4MyIgdGFyZ2V0LXg9IjE4Mi4xODM2NCIgdGFyZ2V0LXk9IjQ0LjcyMTU3NyI+PC9wYXRoPjxwYXRoIGQ9Ik0gMjg3LjA4IDc5LjI3IEMgMjcyLjYzIDU0LjA3IDI0MC44OCA0NC43MiAyMTUuMDggNTguMDcgQyAxODkuMjcgNzEuNDMgMTc4LjU2IDEwMi43MyAxOTAuNzkgMTI5LjA5IEMgMjAzLjAxIDE1NS40NSAyMzMuODMgMTY3LjUwIDI2MC42OSAxNTYuNDMgTCAyOTcuMTMgMjE5LjQzIEMgMjk5LjEyIDIyMi44OSAzMDMuNTUgMjI0LjA4IDMwNy4wMSAyMjIuMDkgQyAzMTAuNDcgMjIwLjEwIDMxMS42NiAyMTUuNjcgMzA5LjY3IDIxMi4yMSBMIDI3My4yMyAxNDkuMjEgQyAyOTQuNzQgMTMyLjY3IDMwMC42NyAxMDIuNzYgMjg3LjA4IDc5LjI3IFogTSAyNjAuMDAgMTQwLjc0IEMgMjQ2LjA4IDE0OC43OCAyMjguNjggMTQ3LjYzIDIxNS45MyAxMzcuODQgQyAyMDMuMTggMTI4LjA1IDE5Ny41OCAxMTEuNTQgMjAxLjc1IDk2LjAxIEMgMjA1LjkyIDgwLjQ5IDIxOS4wNCA2OS4wMCAyMzQuOTggNjYuOTIgQyAyNTAuOTIgNjQuODMgMjY2LjU1IDcyLjU2IDI3NC41NyA4Ni40OSBDIDI4NS40NCAxMDUuNTEgMjc4LjkzIDEyOS43MyAyNjAuMDAgMTQwLjc0IFoiIGZpbGw9IiNlMmU0ZWQiIGZpbGwtcnVsZT0ibm9uemVybyIgbm9kZS1pZD0iODgiIHN0cm9rZT0ibm9uZSIgdGFyZ2V0LWhlaWdodD0iMTc5LjM2MjE3IiB0YXJnZXQtd2lkdGg9IjEzMy4xMDAxMSIgdGFyZ2V0LXg9IjE3OC41NjM2NCIgdGFyZ2V0LXk9IjQ0LjcyMTU3NyI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),

/***/ "nqGY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyANCiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiDQogd2lkdGg9IjIwcHgiIGhlaWdodD0iMjFweCI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiICBmaWxsPSJyZ2IoMjU1LCAyNTUsIDI1NSkiDQogZD0iTTguNTcxLDAuNTA3IEMxMS44NDMsMC41MDcgMTQuODI5LDIuMzcxIDE2LjI2Niw1LjMxMSBDMTcuNzAyLDguMjUxIDE3LjMzOCwxMS43NTMgMTUuMzI3LDE0LjMzNCBDMTUuMzc2LDE0LjM2NSAxNS40MjMsMTQuNDA1IDE1LjQ2NiwxNC40NDkgTDE5LjY5NCwxOC42NzcgQzIwLjEwMCwxOS4wOTcgMjAuMDk0LDE5Ljc2NSAxOS42ODEsMjAuMTc4IEMxOS4yNjgsMjAuNTkwIDE4LjYwMCwyMC41OTYgMTguMTgwLDIwLjE5MSBMMTMuOTUyLDE1Ljk2MyBDMTMuOTA5LDE1LjkyMCAxMy44NzAsMTUuODczIDEzLjgzNCwxNS44MjMgQzEwLjg4MCwxOC4xMjYgNi43NzIsMTguMjQzIDMuNjkzLDE2LjExMCBDMC42MTQsMTMuOTc3IC0wLjcyMiwxMC4wOTAgMC4zOTYsNi41MTUgQzEuNTE0LDIuOTQwIDQuODI1LDAuNTA2IDguNTcxLDAuNTA3IEw4LjU3MSwwLjUwNyBaTTguNTcxLDIuNjQ4IEM1LjAyNCwyLjY0OCAyLjE0OSw1LjUyMyAyLjE0OSw5LjA3MCBDMi4xNDksMTIuNjE3IDUuMDI0LDE1LjQ5MyA4LjU3MSwxNS40OTMgQzEyLjExOCwxNS40OTMgMTQuOTk0LDEyLjYxNyAxNC45OTQsOS4wNzAgQzE0Ljk5NCw1LjUyMyAxMi4xMTgsMi42NDggOC41NzEsMi42NDggTDguNTcxLDIuNjQ4IFoiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "o6eR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ouXj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p35m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q6r7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "s78B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s8b1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Radio.vue
//
//
//
//
//
//
//

/* harmony default export */ var Radio = ({
  name: 'Radio',
  props: ['radioName', 'radioVal', 'initVal'],
  data: function data() {
    return {
      selectedVal: ''
    };
  },

  methods: {
    changeRadio: function changeRadio(radioVal) {
      this.$emit('input', radioVal);
    }
  },
  mounted: function mounted() {
    if (this.initVal !== '' && this.radioVal === this.initVal) {
      this.$refs.radio.setAttribute("checked", "checked");
    }
  },

  watch: {
    initVal: function initVal(newVal, oldVal) {
      if (this.initVal !== '' && this.radioVal === this.initVal) {
        this.$refs.radio.setAttribute("checked", "checked");
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596b2cae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radio.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"Radio"},[_c('input',{ref:"radio",attrs:{"name":_vm.radioName,"type":"radio"},domProps:{"value":_vm.radioVal},on:{"change":function($event){return _vm.changeRadio(_vm.radioVal)}}}),_vm._v(" "),_c('span',{staticClass:"tipsBox"},[_vm._t("tips")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Radio = (esExports);
// CONCATENATED MODULE: ./src/components/Radio.vue
function injectStyle (ssrContext) {
  __webpack_require__("a6Aw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-596b2cae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Radio,
  components_Radio,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Radio = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vmxF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAC99JREFUeF7tnQuWnDgMRWFl6aws6ZVNZ2VMuwIdmirgycg/fOuc+UaAedJFkgEzDvxkBaZpehuGIfz1Y7VR+O+afx/z4P7M//wYx3H5fzWPu4qxjVWMouJBzFD8msGoeKTmob2HLcZx/G3esqMNAGTH2TcG49UZvwPK60AAkI0uMxj/dXSRXJ8qoGwcDyCzIJ1ljCP+gWSlDoAMwzBNU6jDQ5/B758CgBJ6tN4jAjgOI6B7SLoGBDiky2PXkHQLCHBIcCxG3ULSJSCdz1SZyFgZ/+zxBmOvgEyxUdLxduEO/M/ezr87QCitLoV4d5B0BYgzHOvnmZbnnC5FX6KNw3Njns+LdVVqAYg9KgMYoWlt7oE/pwtEV1mkG0AcguM2MzkOWnSTRXoCJDxfFVtq3AaOJWFehKSbLNITILEzV7e9Wl6c7r6tLuuquwtALlwtb5c5ti3XBW0AxN6/6lvMVy99g2uWMS88PZrxa4dtZuvq9Sk1KZI8g2xeU43tAZqJNAaaRYFw8QpT68lfH04CCO9WZAkSDrJ6ND/8a4q3Il0BAQxitrAC7j2jCyCAUTgsOPxWATdQLgNycaoQ16JASgUug3IJkAtThClFYd8osFbgEiTRgAAHUdiQAtGQRAECHA2FBkNdFIh6PMYMCHAQcQ0rYM4kJkCAo+HQYOiLAiZIZECYrSLCbqSA/ByZBZDYp2FvpCunchMF5H5EAsSxtFovxd/cG3k3CY5WT2N5js9rBUwpi6iAXM0ezb6m2mo03Xnc8wU7nOIVWKQscgqIQ/aQSL2zQzm3NAo4xOZpw64AEps9yBpp4oK9bhSYpin6derx8xHgI0EP//AKoWcHxsso4KnABUgOK5xUgFBWeXqffZ0qcOE2xGEvcgZITHl1Wtedni0GKBChQGTFkxcQSqsIz7KJmwLTJyURO9uteHYzSCSNZI8I77CJnwKRvUg2QOg9/HzNniIUiOxFdi/srhmE8irCo2zirkBEmQUg7l5gh9UqEFFm7TbqRxnEevOlp4XWqg0OBvZQwLoQXhZA8A0KtKoAgLTqOcadRQEAySIzB2lVAQBp1XOMO4sCAJJFZg7SqgIA0qrnGHcWBeyA7A0r8hGULGfJQVDgRAHzo1CnL0xtDwggBGHDCgBIw85j6OkVAJD0GnOEhhUAkIadx9DTKwAg6TXmCA0rkB6QIE7EF2rDg4+WX/i6LAvLWRRr39b6gGE445/W07Z+Ldc8i2Ud0AyU9TVIM+kx42KbehSImR3N8f4RgNQTI12PBEBs7ieD2PRq3hpAbC4EEJtezVsDiM2FAGLTq3lrALG5EEBsejVvDSA2FwKITa/mrQHE5kIAsenVvDWA2FwIIDa9mrcGEJsLAcSmV/PWAGJzIYDY9GreGkBsLgQQm17NWwOIzYUAYtOreWsAsbkQQGx6NW8NIDYXAohNr+atAcTmQgCx6dW8NYDYXAggNr2atwYQmwv5UpVNr+atAcTmQgCx6dW8NYDYXAggNr2atwYQmwsBxKZX89YAYnMhgNj0at4aQGwuBBCbXs1bA4jNhQBi06t5awCxuTAZIPOid2GRsvD7E/42juNv2/B8recxvQ3D8KOWMYUzzKkVgNhiyh2QlbNDIG5/j09YW1fds53Sa+uTwChyw7SEVgBiiyZXQGaHK8ufuh737JTFoNj9+tHZ/mP+vJRWohbfTqnnlRVdA3WapgDHq8zxlEnGcTSv9xoZiKGsW0q9s1246nF0sFJaAchZCHz/c7eAiBDe7dgngWhZrzhLFimpVcSxQ++YfOnc5AeYmz1LMIRN3II0QvhcwWjSJEcwlNQq4tgAYks6u02wWl4tO0gOiKHOX5+U20VjT1dDeeWuFYDYot0tGEo6/SAQQz+kTBoAyEHc5MiqPZRYZBDx4lTyYkIGEZ00m5FBnvVy04QSSw9GMsizVvQgevy4aUUG0UX3nsWixBK1p8R6FooMQgb5UgBAAES5lrqVDcxiKXL/taHE0rWixHqtFU36RhemeW1QvbQuWTaQQXQHkkF0rcggZBApWsggkkzHRmQQXcSSWpFBdD+RQcggUrSQQSSZyCAOMi0zScXuGZFBbF50m7EpWTbQpOtOBxBdK0osSiwpWiixJJkosRxkosTaEZFHTZ6F4U66TpybVpRYuuiUWJRYUrRQYkkyUWI5yESJ1VKJ5XllYBZLx6ekVpRYup9cV6so6XSmeXWnA4iuFYDQg0jR4llp7B2wylkszxMng0ixRg9CDyIHitvUJSWWrDkvTOlSPT5H4JbZyCC68iW1ogfR/QQg9CBStHheSOlBJMkfRpRYBbQig+iik0HIIFK0kEEkmbiT7iATs1jMYslhRIklS+VXjlJi6aJTYlFiSdFCiSXJRInlIBMlFiWWHEaUWLJUlFi6VAeW02eBadmRZ+osefNr75z5wtSzMvQgBkIA5KVYbgtZHIDLqiYbcdwe6TiKfzLId3XIIGSQbwoACICcFRCUWGcKrf6cEosSSwkXzzjZOx4l1rMyzGIp0fnXxk0rMoguOjcKX2tFk75toB1fiyCD6IC6XRWZ5tVFJ4PoWpFByCBStNCDSDIdG3GjUBexpFZkEN1PZBAyiBQtZBBJJjKIg0yPXZBBnpVkmpdp3i8FAARAlIsts1iKStwH0VU6s+RRk+8K8SzWc8TQpJ9RtPpzz+arZNnAfRDd6QCia8UsFrNYUrR4Xkj3DkiTTpNOk36AI4AACIAAyPAm5WznmRl6EF11ehBdK3oQehApWnrtQVzvQzCLJcXaw6ikVmQQ3U8AQgaRooUMIsl0bFTyqkgPojuQDKJrRQYhg0jRQgaRZCKDOMhED7IjYo33QcggZBCJeTKIJBMZxEEmMggZRA4j1wz26qg8zfusCk26HJ9+ay2VnttnFkt3OoDoWrlewZnm1YUvqRWA6H4CEJp0KVpo0iWZaNIdZKJJp0mXw8g1g9Gka7pTYmk6BSvXAC1ZV9Ok604HEF0rAKEHkaKFHkSS6bQH+f35JPcvw67ePxcND9sk/ZVc6eUgsxXTigyih5t3BglvE4Zv76m/XIBYvgeYa0zFtAIQNTyde5BwWEMfkiUQ5zFZgjH5t0EW95TSCkAKAjIH5NmnqF0zl3K6YlBkg3YFSXatRC2+yUoPokSZwebACdmDcBWMe3X/xzAMYVzhn9l/ubUCEN3Fya/kszPCiB7BVyoI15LMDzCGsquaMc2Zd5mwSDouAKkIEH0oWOZSAEB0pZNnEH0oWOZSAEB0pQFE1+o2lgCiuxJAdK1uYwkguisBRNfqNpYAorsSQHStbmMJILorAUTX6jaWAKK7EkB0rW5jCSC6KwFE1+o2lgCiuxJAdK1uYwkguisBRNfqNpYAorsSQHStbmMJILorAUTX6jaWvQNieXsOQG4T9vqJRACSJU5yre5uAcT1G4W6i7AsqYDhTcZlmP0CMgxDtldMSwYFx/6ngHURC+/lofZ8kSuDWFfLyHJ1IEDrUCCivAoDz/IWaC5ALAsULF4ji9QRv8lHEZE97gVIOJsIEcgiyUOz/AEis0e2PjVLBpkBMTXqs+uypNHyYdLnCCI/JBTEynbxzAlITJmVLZX2GaJlzzpi5moZcLYLZwuAAEnZOHY/+pw5wnKw4aJp/uVYD2sZVDZALpRZy1jDsjN/cqyba/YYG8gKXCirsmePcMCsgEQ261vx3x8Dz7DAtOx1DE8VuJo1vq7on44/PZijQdaDzYBY74kcne4jqzjqwa58Ffgx7y6qlHoxlGy9R5ESazloxJSvr9vYW5MK5Ow9SgMSO6PVpGMZtIsC2bNHkR5klUU8Sy0XD7CTahUoAkdRQBL0I9V6l4FdUqAYHMUBmSGJucN+SXE2bkaBbHfM9xTJPov1aiCxz+M042YGGqNA0cxRtEkHkph46WqbKuCoosRau51M0hUEeydb1WsOVZRYW6UApUtQqskaa/WrBISp4K4AKd6IH6ldNSAbUMJjC16PLHQVgRWe7OMDpY8av9BHSlVNmgDkRZ8S/tfynE/4d8BRPZ7Xbv2F3vDMXMgWRb7aG3va/wNnWwduXklj7QAAAABJRU5ErkJggg=="

/***/ }),

/***/ "wEm3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAAH9JREFUOE/t1LEJQkEQhOHvYrUFtZbXh/ZhATagnQjWYvBOMTKzhpUDDQTlPF/6Np75WWbYTRHRY4kOV5ww0TbnFBHbJ2iDO3aYtXHk1Gj4Kh9B9SRLawfMscYNxz/qv7xAC6wGgepL/6YY66/n9Olo95jWrW+KXEAZpf5Bb+QB3wUoJ9YBEhsAAAAASUVORK5CYII="

/***/ }),

/***/ "yLoF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yt7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getClientSize;
/* unused harmony export getScrollWidth */
/* harmony export (immutable) */ __webpack_exports__["a"] = backToTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = getLocalItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = setLocalItem;
/* unused harmony export getSessionItem */
/* unused harmony export setSessionItem */
/* unused harmony export decode */
/* unused harmony export convertTime */
/* unused harmony export shuffle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return otherSystemGetLoginToMeUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_platform__ = __webpack_require__("zqHT");





//获取屏幕宽高
function getClientSize() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    return {
        width: w,
        height: h
    };
}

//获取滚动条宽度
function getScrollWidth() {
    var noScroll = void 0,
        scroll = void 0,
        oDiv = document.createElement("DIV");
    oDiv.style.cssText = "position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;";
    noScroll = document.body.appendChild(oDiv).clientWidth;
    oDiv.style.overflowY = "scroll";
    scroll = oDiv.clientWidth;
    document.body.removeChild(oDiv);
    return noScroll - scroll;
}

//回到顶部
function backToTop() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 0) {
        window.requestAnimationFrame(backToTop);
        window.scrollTo(0, scrollTop - scrollTop / 5);
    }
}

//取本地储存数据
function getLocalItem(key) {
    var value = void 0;
    try {
        value = localStorage.getItem(key);
    } catch (ex) {
        // 开发环境下提示error
        if (__DEV__) {
            console.error("localStorage.getItem报错, ", ex.message);
        }
    } finally {
        return value;
    }
}

//设置本地储存数据
function setLocalItem(key, value) {
    try {
        // ios safari 无痕模式下，直接使用 localStorage.setItem 会报错
        localStorage.setItem(key, value);
    } catch (ex) {
        // 开发环境下提示 error
        if (__DEV__) {
            console.error("localStorage.setItem报错, ", ex.message);
        }
    }
}

//取会话储存数据
function getSessionItem(key) {
    var value = void 0;
    try {
        value = sessionStorage.getItem(key);
    } catch (ex) {
        // 开发环境下提示error
        if (__DEV__) {
            console.error("sessionStorage.getItem报错, ", ex.message);
        }
    } finally {
        return value;
    }
}

//设置会话储存数据
function setSessionItem(key, value) {
    try {
        // ios safari 无痕模式下，直接使用 sessionStorage.setItem 会报错
        sessionStorage.setItem(key, value);
    } catch (ex) {
        // 开发环境下提示 error
        if (__DEV__) {
            console.error("sessionStorage.setItem报错, ", ex.message);
        }
    }
}

//Unicode转中文汉字
function decode(str) {
    str = str.replace(/(\\u)(\w{1,4})/gi, function ($0) {
        return String.fromCharCode(parseInt(escape($0).replace(/(%5Cu)(\w{1,4})/g, "$2"), 16));
    });
    str = str.replace(/(&#x)(\w{1,4});/gi, function ($0) {
        return String.fromCharCode(parseInt(escape($0).replace(/(%26%23x)(\w{1,4})(%3B)/g, "$2"), 16));
    });
    str = str.replace(/(&#)(\d{1,6});/gi, function ($0) {
        return String.fromCharCode(parseInt(escape($0).replace(/(%26%23)(\d{1,6})(%3B)/g, "$2")));
    });

    return str;
}

//转化为00:00时间格式
function convertTime(seconds) {
    return [parseInt(seconds / 60 % 60), parseInt(seconds % 60)].join(":").replace(/\b(\d)\b/g, "0$1");
}

function shuffle(arr) {
    for (var i = arr.length - 1; i >= 0; i--) {
        var randomIndex = Math.floor(Math.random() * (i + 1));
        var itemAtIndex = arr[randomIndex];
        arr[randomIndex] = arr[i];
        arr[i] = itemAtIndex;
    }
    return arr;
}

var otherSystemGetLoginToMeUrl = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(key, iv) {
        var k, client, login_data, message, encrypted, _ref2, result, pc_login_url, url, baseURL;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        console.log(key, iv);
                        // 密钥和初始化向量应该是随机生成的，这里为了示例简单使用固定的字符串
                        k = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Utf8.parse(key);

                        iv = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Utf8.parse(iv);
                        client = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : "";

                        console.log(client);
                        login_data = {
                            account: client.phone,
                            time: Math.floor(Date.now() / 1000)
                        };
                        // 需要加密的数据

                        message = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(login_data);
                        // 使用AES加密

                        encrypted = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.encrypt(message, k, {
                            iv: iv
                        });
                        _context.next = 10;
                        return Object(__WEBPACK_IMPORTED_MODULE_4__api_platform__["k" /* getOtherSystemGetLoginToMeUrl */])({
                            key: key,
                            login_data: encrypted.toString()
                        });

                    case 10:
                        _ref2 = _context.sent;
                        result = _ref2.result;
                        pc_login_url = result.data.url.pc_login_url.split("#")[1];
                        url = new URL(window.location.href);
                        baseURL = "";

                        if (url.hostname === "192.168.89.251") {
                            baseURL = "http://192.168.89.251:9301/#";
                        } else if (url.hostname === "192.178.0.89") {
                            baseURL = "http://192.178.0.89:9301/#";
                        } else {
                            baseURL = "http://admin.hzkpt.com/#";
                        }
                        console.log(pc_login_url);

                        window.open(baseURL + pc_login_url, "_blank");

                    case 18:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function otherSystemGetLoginToMeUrl(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),

/***/ "zqHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./src/store/index.js + 4 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./src/router/client.js + 105 modules
var client = __webpack_require__("RSUS");

// CONCATENATED MODULE: ./src/util/request.js



// import { ElNotification } from "element-plus";



// 创建axios的实例
var url = new URL(window.location.href);
var baseURL = "";
if (url.hostname === "192.168.89.251") {
  baseURL = "http://192.168.89.250:8888";
} else if (url.hostname === "192.178.0.89") {
  baseURL = "http://192.178.0.89:8888";
} else {
  baseURL = "https://api.ontuotu.com";
}
var service = axios_default.a.create({
  baseURL: baseURL,
  timeout: 60000 // 超时时间
});
function isRichText(str) {
  var htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
  return htmlTagPattern.test(str);
}
function isFirstCharacter(str) {
  var firstChar = str.substr(0, 1);
  return firstChar === "/";
}
function initUrl(objectFile) {
  for (var key in objectFile) {
    var value = objectFile[key];

    if (Array.isArray(value) && value.length > 0) {
      objectFile[key] = value.map(function (item) {
        if (item && item.url) {
          item.url = "" + baseURL + (isFirstCharacter(item.url) ? "" : "/") + item.url;
        }
        return item;
      });
    } else if (isRichText(value)) {
      objectFile[key] = value.replace(/(<img\s+[^>]*src=")([^"]+)(")/g, function (match, p1, p2, p3) {
        var newSrc = baseURL + "/" + p2.split("/").pop();
        return "" + p1 + newSrc + p3;
      });
    }
  }
}
var request_reduiceLogin = function reduiceLogin() {
  sessionStorage.clear();
  localStorage.clear();
  client["a" /* default */].push("/login");
};

service.interceptors.request.use(function (config) {
  var token = localStorage.getItem("clientToken");
  var temporarilyToken = store["a" /* default */].state.temporarilyToken;
  config.headers.Authorization = "Bearer " + (token || temporarilyToken);
  return config;
}, function (error) {
  return promise_default.a.reject(error);
});
// 响应拦截
service.interceptors.response.use(function (response) {
  // 请求成功
  var res = response.data;
  if (res instanceof Blob) {
    return res;
  } else if (res.status !== "success") {
    element_ui_common["Notification"].error({
      title: "请求错误",
      message: res.errMsg,
      duration: 0
    });
    return promise_default.a.reject(new Error(res.message || "Error"));
  } else {
    if (["192.168.89.251", "192.178.0.89"].includes(url.hostname)) {
      if (res.result && Array.isArray(res.result)) {
        res.result.map(function (el) {
          initUrl(el);
          return el;
        });
      } else if (typeof_default()(res.result) === "object") {
        initUrl(res.result);
      }
    }
    return res;
  }
}, function (err) {
  var errMsg = "";
  var status = err.response.status;
  if (status) {
    switch (status) {
      case 400:
        errMsg = err.response.data.err_msg;
        break;
      case 401:
        errMsg = "登录状态失效，请重新登录";
        request_reduiceLogin();
        break;
      case 403:
        errMsg = err.response.data.err_msg;
        break;
      case 408:
        errMsg = "请求超时";
        break;
      case 500:
        errMsg = "服务器内部错误";
        break;
      case 501:
        errMsg = "服务未实现";
        break;
      case 502:
        errMsg = "网关错误";
        break;
      case 503:
        errMsg = "服务不可用";
        break;
      case 504:
        errMsg = "网关超时";
        break;
      case 505:
        errMsg = "HTTP版本不受支持";
        break;
      default:
        errMsg = err.response.data.err_msg;
        break;
    }
    element_ui_common["Notification"].error({
      title: "请求错误",
      message: errMsg
    });
  } else {
    errMsg = err;
  }
  store["a" /* default */].commit("hideLoading");
  return promise_default.a.reject(errMsg);
});

/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/api/platform.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return platform_departments; });
/* unused harmony export getUserHasCompany */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return platform_login; });
/* unused harmony export getUToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return platform_online; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return platform_relationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return platform_detailOnline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return platform_updateOnline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return platform_children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return platform_relationFieldButtonExc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return platform_delOnline; });
/* unused harmony export buttons */
/* unused harmony export getFormList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return platform_execButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return platform_postOnline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return platform_changePwd; });
/* unused harmony export relationRows */
/* unused harmony export getQueryDataByFilterDefault */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return platform_getOtherSystemGetLoginToMeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return platform_structure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return platform_getFormRowApproveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return platform_setApproveClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return platform_weiXinNativePay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return platform_getOrderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return platform_todolist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return platform_todolistShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return platform_checktodo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return platform_approveAllowApprovalBatchAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return platform_getQueueText; });


var platform_departments = function departments(params) {
  return request.get("/api/platform/organizations/departments", { params: params });
};

var platform_getUserHasCompany = function getUserHasCompany() {
  return request.post("/api/platform/authright/getUserHasCompany");
};

var platform_login = function login(data) {
  return request.post("/api/platform/auth/login", data);
};
// 取用户token
var platform_getUToken = function getUToken(data) {
  return request.post("/api/appsheets/sheetapi/getUToken", data);
};
// 获取列表数据
var platform_online = function online(params) {
  return request.get("/api/platform/forms/online", { params: params });
};

// 关联记录
var platform_relationOptions = function relationOptions(data) {
  return request.post("/api/platform/forms/relationOptions", data);
};

// 获取详情数据
var platform_detailOnline = function detailOnline(data) {
  return request.post("/api/platform/forms/detailOnline", data);
};

// 更新详情数据
var platform_updateOnline = function updateOnline(data) {
  return request.post("/api/platform/forms/updateOnline", data);
};

// 获取子表数据
var platform_children = function children(params) {
  return request.get("/api/platform/forms/children", { params: params });
};

var platform_relationFieldButtonExc = function relationFieldButtonExc(data) {
  return request.post("/api/platform/forms/relationFieldButtonExc", data);
};

// 删除数据
var platform_delOnline = function delOnline(data) {
  return request.post("/api/platform/forms/delOnline", data);
};

var platform_buttons = function buttons(data) {
  return request.post("/api/platform/forms/buttons", data);
};

var platform_getFormList = function getFormList(data) {
  return request.post("/api/appsheets/sheetapi/getFormList", data);
};

var platform_execButton = function execButton(data) {
  return request.post("/api/platform/configs/execButton", data);
};

var platform_postOnline = function postOnline(data) {
  return request.post("/api/platform/forms/online", data);
};

// 修改密码
var platform_changePwd = function changePwd(data) {
  return request.post("/api/platform/authright/changePwd", data);
};

// 获取关联记录
var platform_relationRows = function relationRows(data) {
  return request.post("/api/platform/forms/relationRows", data);
};

var platform_getQueryDataByFilterDefault = function getQueryDataByFilterDefault(data) {
  return request.post("/api/platform/forms/getQueryDataByFilterDefault", data);
};

var platform_getOtherSystemGetLoginToMeUrl = function getOtherSystemGetLoginToMeUrl(data) {
  return request.post("/api/general/sso/getOtherSystemGetLoginToMeUrl", data);
};

var platform_structure = function structure(form_head_uuid, params) {
  return request.get("/api/platform/forms/structure/" + form_head_uuid, params);
};

//根据SHEET API创建数据时，返回的"表单行数据ID"，进行获取审批数据。
var platform_getFormRowApproveList = function getFormRowApproveList(data) {
  return request.post("/api/appsheets/sheetapi/getFormRowApproveList", data);
};

// 审批流程 - 撤回审批
var platform_setApproveClose = function setApproveClose(data) {
  return request.post("/api/appsheets/sheetapi/setApproveClose", data);
};
//微信native支付
var platform_weiXinNativePay = function weiXinNativePay(data) {
  return request.post("/api/general/otherPay/weiXinNativePay", data);
};

// 获取订单状态
var platform_getOrderStatus = function getOrderStatus(data) {
  return request.post("/api/general/otherPay/getOrderStatus", data);
};

// 获取代办列表
var platform_todolist = function todolist(data) {
  return request.post("/api/platform/todolist/index", data);
};

var platform_todolistShow = function todolistShow(data) {
  return request.post("/api/platform/todolist/show", data);
};

var platform_checktodo = function checktodo(data) {
  return request.post("/api/platform/todolist/checktodo", data);
};

// 批量审批
var platform_approveAllowApprovalBatchAction = function approveAllowApprovalBatchAction(data) {
  return request.post("/api/platform/todolist/approveAllowApprovalBatchAction", data);
};

var platform_getQueueText = function getQueueText(data) {
  return request.post("/api/general/getQueueText", data);
};

// api/general/getQueueText

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.43693cd8b27ed5a2a35b.20260928_185725.js